import type { MessageCatalog } from "./pt-BR";

export const en: MessageCatalog = {
  "crm.demoAt": "Demo date",
  "crm.demoHint": "Set the demo date separately from the next contact. Local time.",
  "crm.demoMissing": "Demo date not set",
  "crm.notScheduled": "Not scheduled",
  "crm.demoCleared": "Demo date cleared.",
  "crm.saved": "Changes saved. History updated.",
  "crm.refresh": "Refresh list",
  "crm.refreshing": "Refreshing…",
  "crm.views": "CRM views",
  "crm.view.all": "All leads",
  "crm.view.new": "New requests",
  "crm.view.demos": "Scheduled demos",
  "crm.view.overdue": "Overdue",
  "crm.clearFilters": "Clear filters",
  "crm.pageCount": "Leads on this page: {count}",
  "crm.updated": "Updated",
  "users.emptyFilter": "No users match these filters.",
  "users.views": "User views",
  "users.view.all": "All",
  "users.view.active": "Active",
  "users.view.pending": "Pending invitations",
  "users.view.inactive": "Inactive",
  "users.count": "{count} of {total} users in this list",
  "crm.late": "Overdue",
  "crm.nav": "CRM · Leads",
  "crm.title": "Leads and demonstrations",
  "crm.description":
    "Follow up on landing requests, prepare the demonstration and record the next step.",
  "crm.inbox": "Demo requests",
  "crm.inboxHint":
    "From the first conversation to the pilot. Each request has an owner and a history.",
  "crm.contact": "Contact",
  "crm.company": "Company",
  "crm.status": "Stage",
  "crm.owner": "Owner",
  "crm.unassigned": "Unassigned",
  "crm.nextContact": "Next contact",
  "crm.received": "Received",
  "crm.search": "Search name, email or company",
  "crm.searchAction": "Search",
  "crm.allStages": "All stages",
  "crm.allOwners": "All owners",
  "crm.mine": "My leads",
  "crm.overdue": "Overdue contact",
  "crm.emptyTitle": "No requests in this list",
  "crm.emptyBody":
    "Requests received from the form appear here. Check the filters or wait for the first contact.",
  "crm.pagination": "Lead pages",
  "crm.firstPage": "First page",
  "crm.nextPage": "Next page",
  "crm.detail": "Demo request",
  "crm.language": "Contact language",
  "crm.source": "Source",
  "crm.sourceLanding": "Landing · Request a demo",
  "crm.request": "What the company wants to improve",
  "crm.contactAcknowledged":
    "Contact requested through the form, acknowledging use of the details for the demonstration. No marketing subscription.",
  "crm.readOnly": "You can view this lead. Changes require CRM management permission.",
  "crm.history": "Recent activity",
  "crm.historyHint":
    "Up to the latest 100 records. Changing a stage or adding a note does not send messages.",
  "crm.visitor": "Landing visitor",
  "crm.ownerChanged": "Owner updated.",
  "crm.followUpCleared": "Contact reminder removed.",
  "crm.followUp": "Follow-up",
  "crm.keepOwner": "Keep current owner",
  "crm.assignMe": "Assign to me",
  "crm.unassign": "Leave unassigned",
  "crm.localTime": "Date and time in your timezone. Won or lost removes the reminder.",
  "crm.note": "Follow-up note",
  "crm.saving": "Saving…",
  "crm.save": "Save follow-up",
  "crm.conflict":
    "This lead changed. Your update was not saved. Load the current version and review it before saving again.",
  "crm.reload": "Load current version",
  "crm.stage.NEW": "New",
  "crm.stage.CONTACTED": "Contacted",
  "crm.stage.QUALIFIED": "Qualified",
  "crm.stage.DEMO_SCHEDULED": "Demo scheduled",
  "crm.stage.DEMO_COMPLETED": "Demo completed",
  "crm.stage.PILOT": "Pilot",
  "crm.stage.WON": "Won",
  "crm.stage.LOST": "Lost",
  "crm.activity.RECEIVED": "Request received.",
  "crm.activity.UPDATED": "Follow-up updated.",
  "crm.activity.NOTE": "Note added.",

  "calc.form.individualDiagnostic":
    "Without a pricing method, this mode is a tax diagnostic. The fiscal total is neither the purchase cash cost nor a listing price. For a listing price based only on acquisition, use Spreadsheet and the commercial template. Individual pricing options with TR include the sale and require the rules for that operation.",
  "research.resolution.supplierDeclarationCorrection":
    "Check and correct IPI and IPI Valor in columns N and O of the supplier spreadsheet, then import the file again. Internet research cannot change the supplier declaration; this correction does not require another paid search.",
  "wb.issue.MISSING_VALUE.required.title": "Required value missing: {field}",
  "wb.issue.MISSING_VALUE.required.hint":
    "Fill in the required cell in the original spreadsheet and upload the file again. This row cannot be calculated until it is corrected; no value is filled in by default.",
  "lotSim.file.addToQueue": "Add spreadsheets to the queue",
  "rulesets.publish.rootImpact":
    "This is the first publication, with no earlier version to compare. Review the rule total and included proposals; there is no count of additions or changes against an earlier base.",
  "rulesets.publish.rootBase": "No earlier version",
  "rulesets.publish.comparison": "Version comparison",
  "rulesets.publish.technicalImpact": "Technical diff entries (not rule totals)",
  "lotOps.researchCalculated":
    "The {count} results in this run were calculated using published rules from version {version}. Review of other research evidence does not block these saved results.",
  "research.publishedRule.separate":
    "A published rule is linked to this research. The link does not automatically certify search evidence or change earlier calculations.",
  "research.publishedRule.open": "View published rule · {version}",
  "research.publishedRule.evidence": "Evidence from this research",
  "rulesets.publish.ruleImpact": "Changes grouped by rule",
  "rulesets.publish.unparsedImpact":
    "Some technical changes could not be grouped by rule. The totals above include identified rules only; also review the complete technical difference before publishing.",
  "priceComposition.ipi.unconfirmed":
    "Unconfirmed composition: keep pending, without a final quote",
  "priceComposition.fiscalContext":
    "Fiscal preview on {date} · rules {version}. The runner validates the execution again; this preview creates no rules.",
  "priceComposition.fiscalTitle": "Acquisition and publication per unit",
  "priceComposition.fiscalSt": "Additional ICMS-ST",
  "priceComposition.fiscalFcp": "Additional FCP",
  "priceComposition.acquisition": "Acquisition",
  "priceComposition.listing": "Publication",
  "priceComposition.status": "Status",
  "priceComposition.calculated": "Calculated with published rules",
  "uploadCatalog.title": "Link a supplier fiscal catalog (optional)",
  "uploadCatalog.hint":
    "Explicitly select supplier, revision and date. Matching uses supplier SKU and reviewed classification, preserves repeated rows and records its source. The catalog supplies no IPI, photos or rule approval.",
  "uploadCatalog.supplier": "Registered supplier",
  "uploadCatalog.revision": "Active fiscal workbook revision",
  "uploadCatalog.date": "Link effective date",
  "uploadCatalog.choose": "Select",
  "uploadCatalog.apply": "Use this link for import",
  "uploadCatalog.active": "Link selected. Row checks appear in the preview.",
  "uploadCatalog.inactive": "No link applied: fiscal facts come from the uploaded workbook.",
  "uploadCatalog.remove": "Remove link",
  "uploadCatalog.error":
    "Suppliers or catalogs could not be loaded. Retry before applying the link.",
  "priceComposition.title": "Received price composition",
  "priceComposition.ipi": "What does column M contain?",
  "priceComposition.ipi.add": "Separate IPI: add the amount in column O",
  "priceComposition.ipi.included": "IPI included: remove the exact amount in column O",
  "priceComposition.tr": "Take rate in the received price",
  "priceComposition.tr.apply": "No TR: apply the declared rate at the end",
  "priceComposition.tr.included": "TR included: recover the basis and recalculate publication",
  "priceComposition.tr.keep": "Published price: preserve after reconciling every component",
  "priceComposition.scope":
    "Applies to all rows except the overrides below. The lot rate is explicit; an override may state a different rate.",
  "priceComposition.order":
    "Order: undo included TR → remove included IPI → calculate additional taxes → publish. Embedded ST, FCP or charges require a breakdown; they are never deducted by assumption.",
  "priceComposition.example":
    "Example: price 110 with declared IPI 10 → principal 100 → acquisition before ST/FCP 110 → publication 125 with 12% TR.",
  "priceComposition.mixed": "Mixed list: declare row overrides",
  "priceComposition.row": "Excel row {row}",
  "priceComposition.rowRate": "Row rate as a fraction (0.12 = 12%); blank uses the lot",
  "priceComposition.remove": "Remove override",
  "priceComposition.excelRow": "Excel row (from 2)",
  "priceComposition.addRow": "Add override",
  "priceComposition.preview": "Commercial preview (up to 25 rows)",
  "priceComposition.received": "Received",
  "priceComposition.rowHeader": "Row",
  "priceComposition.principal": "Principal excluding IPI/TR",
  "priceComposition.ipiAmount": "Declared IPI",
  "priceComposition.subtotal": "Subtotal before ST/FCP",
  "priceComposition.publication": "Publication before ST/FCP",
  "priceComposition.previewHint":
    "Exact values read by the server. This preview does not confirm ST/FCP or fiscal authority. Final results depend on current rules and appear in the execution detail.",
  "jamerson.format": "Excel (.xlsx) · 15 columns",
  "jamerson.steps.label": "How to import products",
  "jamerson.steps.download.title": "Download the template",
  "jamerson.steps.download.body": "A blank file, ready for your products.",
  "jamerson.steps.fill.title": "Enter your products",
  "jamerson.steps.fill.body": "Add quantities, prices and fiscal data.",
  "jamerson.steps.review.title": "Review and calculate",
  "jamerson.steps.review.body": "Confirm the commercial inputs before calculating.",
  "jamerson.title": "Product spreadsheet",
  "jamerson.download": "Download Excel template",
  "jamerson.downloadHint":
    "Enter your products in the TaxChannel template. Keep all 15 headers on the first row, in their original order.",
  "jamerson.uploadBody":
    "Upload your completed spreadsheet to review the data. Confirm the supplier, commercial unit, price composition and take rate before starting the calculation.",
  "jamerson.guide": "How to enter prices and fiscal data",
  "jamerson.help.price.title": "Preço NF (Produtos) UNITÁRIO: goods price with embedded taxes",
  "jamerson.help.price.body":
    "Enter the goods price per commercial unit, before additional IPI and ST. Own ICMS and PIS/COFINS are already within this principal: the calculation breaks them out without adding them again.",
  "jamerson.help.ipi.title": "IPI and ST: additions separate from the goods price",
  "jamerson.field.supplierIpiRate": "IPI rate declared by the supplier",
  "jamerson.field.supplierIpiAmount": "IPI declared by the supplier per commercial unit",
  "jamerson.help.ipi.body":
    "For an industry supplier, enter the declared rate in IPI (for example, 6.5% or 0.065) and its amount per commercial unit in IPI Valor. These values are checked as supplier declarations. Applicable ST is calculated separately according to the transaction and its fiscal qualification.",
  "jamerson.help.origin.title": "N/ I is the goods origin; UF is the route",
  "jamerson.help.origin.body":
    "Enter Nacional, Importada or fiscal code 0–8 in N/ I for each product. UF ORIGEM and UF DESTINO are the purchase states, such as MG and SP. A state does not replace the product's fiscal origin.",
  "jamerson.help.quantity.title": "Caixa and price must use the same commercial unit",
  "jamerson.help.quantity.body":
    "Caixa states how many commercial units are purchased at the stated Preço NF. Declare the unit below, such as CX or UN. The system multiplies price by quantity once; it never converts cartons into pieces automatically.",
  "jamerson.help.takeRate.title": "Take rate per lot, applied after acquisition cost",
  "jamerson.help.takeRate.body":
    "Enter the TR on screen, including 0% when that is your decision. Listing price = acquisition cost ÷ (1 − TR). Cost includes goods and acquisition additions; future resale taxes depend on the buyer and belong to a later step.",
  "jamerson.help.includedPrice.title": "If your price already includes IPI, ST or take rate",
  "jamerson.help.includedPrice.body":
    "Declare whether column M includes IPI and/or TR. The IPI amount in O is retained. Embedded ST/FCP/charges require a confirmed breakdown; preserving publication requires reconciliation.",
  "jamerson.required":
    "Required for each product: NCM, N/ I, UF ORIGEM, UF DESTINO, Caixa and Preço NF. Industry suppliers also require IPI and IPI Valor, including zero when declared.",
  "jamerson.optional":
    "Category, brand, family, SKU, description, EAN and weight are metadata and may be blank. Keep all 15 columns even when their cells are empty.",
  "jamerson.mappingLocked":
    "Template verified: fixed headers and columns; route comes from each row. Blank N/ I cells may use the goods origin declared below.",
  "jamerson.goodsOrigin": "Goods origin for empty cells",
  "jamerson.goodsOrigin.perRow": "Use N/ I from each row",
  "jamerson.goodsOrigin.hint":
    "Explicit declaration for blank N/ I cells. Populated spreadsheet values take precedence, including different origins.",
  "jamerson.regimeFromSettings":
    "The BackChannel regime comes from the fiscal configuration valid on the calculation date.",
  "jamerson.inputsIncomplete":
    "Complete {count} row(s) before submitting: {fields}. Correct the indicated cells or declare applicable values in the fields above. The upload has not been confirmed yet.",
  "jamerson.submit": "Validate and calculate",
  "jamerson.submitHint":
    "Complete the commercial inputs before submitting. This confirmation starts calculation; automatic research handles missing fiscal coverage.",
  "jamerson.supplier": "Supplier for this lot",
  "jamerson.supplierRequired": "Select industry or distributor",
  "jamerson.supplierHint":
    "Confirm one profile that applies to every row. Upload separate lots for products with different supplier profiles. Industry suppliers require both IPI fields for every product.",
  "jamerson.declarationHint":
    "Confirm the unit used for Caixa and price. If the price contains previous ST, separate that composition before using the template. The BackChannel regime comes from fiscal settings.",
  "jamerson.takeRate.title": "Take rate for this lot",
  "jamerson.takeRate.hint":
    "Enter 0% up to less than 100%. No TR is assumed. Applies to the lot unless a row explicitly overrides it.",
  "jamerson.takeRate.scope":
    "Listing = acquisition cost ÷ (1 − TR). This step calculates the acquisition for resale; the sale destination and taxes are handled when a buyer exists.",
  "wb.issue.TEMPLATE_HEADER_MISMATCH.title": "Column {column} does not match the product template",
  "wb.issue.TEMPLATE_HEADER_MISMATCH.hint":
    "Download the Excel template above and copy your products without renaming, moving, duplicating or adding columns. Keep all 15 headers on row 1. Correct the indicated column and upload it again.",
  "wb.issue.TEMPLATE_SHEET_COUNT.title": "The template requires one visible input sheet",
  "wb.issue.TEMPLATE_SHEET_COUNT.hint":
    "Use the Excel template above with one populated, visible sheet. Additional sheets must be entirely empty; hiding a populated sheet does not resolve the issue. Save and upload again.",
  "wb.issue.TEMPLATE_MAPPING_MISMATCH.title":
    "The configuration does not match the template's fixed columns",
  "wb.issue.TEMPLATE_MAPPING_MISMATCH.hint":
    "Upload the Excel template above again. Keep all 15 headers in their original order and the purchase route in each row; the mapping is applied automatically.",
  "argonAcceptance.title": "Argon synthetic acceptance",
  "argonAcceptance.summary":
    "Prepare three cases using synthetic data. Execution follows separately through the protected workflow.",
  "argonAcceptance.prepared": "Admission registered",
  "argonAcceptance.executionSeparate":
    "Admission registered. Check execution through the protected workflow.",
  "argonAcceptance.copyHelp": "Copy the ID to continue through the authorized workflow.",
  "argonAcceptance.available": "Available balance for the test",
  "argonAcceptance.executionLimit": "Execution limit",
  "argonAcceptance.campaign": "Campaign",
  "argonAcceptance.acceptanceId": "Acceptance ID",
  "argonAcceptance.unknown": "Unavailable",
  "argonAcceptance.prepare": "Prepare acceptance",
  "argonAcceptance.preparing": "Preparing…",
  "argonAcceptance.retry": "Repeat the same request",
  "argonAcceptance.boundary":
    "Preparing does not call the model, change limits or publish fiscal rules.",
  "argonAcceptance.uncertain":
    "Preparation was not confirmed. Refresh the status before repeating; a manual retry keeps the same request.",
  "argonAcceptance.contextChanged":
    "The campaign changed while the previous preparation was unconfirmed. Review the earlier request before preparing another.",
  "argonAcceptance.status.CAN_ADMIT": "Available to prepare",
  "argonAcceptance.status.ALREADY_ADMITTED": "Admission registered",
  "argonAcceptance.status.MAINTENANCE": "Under maintenance",
  "argonAcceptance.status.RESEARCH_DISABLED": "Research not configured",
  "argonAcceptance.status.RESEARCH_PAUSED": "Research paused",
  "argonAcceptance.status.NO_VERIFIED_CAMPAIGN": "Awaiting verified campaign",
  "argonAcceptance.status.BUDGET_UNAVAILABLE": "Preparation unavailable",
  "argonAcceptance.reason.CAN_ADMIT": "A verified campaign is available to prepare this request.",
  "argonAcceptance.reason.ALREADY_ADMITTED":
    "An admission already exists. Check execution through the protected workflow.",
  "argonAcceptance.reason.MAINTENANCE":
    "Preparation is blocked during maintenance. Refresh the status after it ends.",
  "argonAcceptance.reason.RESEARCH_DISABLED":
    "Research has not been configured for this environment.",
  "argonAcceptance.reason.RESEARCH_PAUSED": "Research is paused. Preparation remains blocked.",
  "argonAcceptance.reason.NO_VERIFIED_CAMPAIGN":
    "No verified campaign is available for this request.",
  "argonAcceptance.reason.BUDGET_UNAVAILABLE":
    "Another request cannot be prepared using the current campaign. Review its balance and existing reservations.",

  "common.costPending": "Pending",
  "research.blocked.ARGON_COST_BOUND_UNAVAILABLE":
    "AI search costs are pending. Deterministic IOB can continue.",
  "research.deferral.ARGON_COST_BOUND_UNAVAILABLE":
    "Automatic research is waiting for a cost estimate.",
  "research.lanes.unavailable.UNQUALIFIED": "AI search is waiting for a cost estimate.",
  "productImages.activation.ARGON_COST_BOUND_UNAVAILABLE":
    "AI search costs are pending. This plan stays paused.",
  "webResearch.preview.costPending":
    "AI search costs are pending. Review the plan; paid work stays blocked.",
  "productImages.candidateStatus.PENDING_REVIEW": "Pending review",
  "productImages.candidateStatus.REVIEWED_ACCEPTED_CANDIDATE": "Reviewed candidate accepted",
  "productImages.candidateStatus.REVIEWED_REJECTED": "Candidate rejected",
  "productImages.originalGtin": "Original catalog GTIN",
  "productImages.reviewedGtin": "Reviewed GTIN",
  "productImages.reviewedVariant": "Reviewed variant",
  "productImages.reviewedSize": "Reviewed size or contents",
  "productImages.reviewedPackaging": "Reviewed packaging",
  "productImages.identityReviewId": "Identity review identifier",
  "productImages.openIdentityEvidence": "Open public identity evidence",
  "productImages.identityOriginalPreserved":
    "This review preserves the original GTIN, leaves fiscal classification unchanged and does not publish an image.",
  "productImages.reviewIdentity": "Review identity for image research",
  "productImages.identityReviewHelp":
    "Record a human decision supported by a public source for this product and revision. Enter the exact variant, size and packaging; a name or brand alone does not establish identity.",
  "productImages.gtinCheckHint":
    "Use 8, 12, 13 or 14 digits with a valid check digit. It will not be corrected automatically.",
  "productImages.identityEvidenceUrl": "Public identity source (HTTPS)",
  "productImages.identityEvidenceConfirmation":
    "I checked the GTIN, variant, size and packaging against the stated public source. This decision is specific to this product and does not represent fiscal approval.",
  "productImages.invalidIdentityReview":
    "Check the GTIN and check digit, variant, size, packaging, public HTTPS URL and reason of at least 10 characters.",
  "productImages.identityReviewRecorded":
    "Identity review recorded. Select it explicitly when preparing new research.",
  "productImages.recordIdentityReview": "Record identity review",
  "productImages.identityReviews": "Reviewed public identity",
  "productImages.pinnedIdentity": "Identity pinned to this research",
  "productImages.noPinnedIdentity":
    "No identity review is pinned to the current research. Insufficient original data keeps the product pending.",
  "productImages.identityReviewHistory": "View recorded reviews for this product",
  "productImages.selectedIdentity": "Identity used in new research",
  "productImages.originalIdentity": "Use original catalog data",
  "productImages.selectIdentityHelp":
    "A recorded review is used only when selected here. Missing or conflicting data stays pending; no automatic association is made.",
  "webResearch.kind.LOCATE_APPLIANCE_PRODUCT": "Locate public product identity",
  "webResearch.scope.APPLIANCE_PRODUCTS.short": "Products without NCM",
  "webResearch.kind.LOCATE_PRODUCT_IMAGE": "Locate public product image",
  "webResearch.scope.PRODUCT_IMAGES.short": "Public product images · separate from fiscal research",

  // Public image research: candidate-only overlay, explicit rights review, no publication.
  "productImages.title": "Product images",
  "productImages.currentPreserved":
    "The catalog image is preserved. Generated illustrations and search candidates never replace it.",
  "productImages.scope":
    "Generate clearly labeled synthetic illustrations or inspect public candidates. Neither changes the catalog image or approves tax data.",
  "productImages.generateIllustrations": "Generate product illustrations",
  "productImages.generateIllustrationsHelp":
    "Creates synthetic, category-level illustrations with Vertex Imagen. It does not search the web or require a human review for each product. The original catalog image remains unchanged; an illustration is not proof of exact SKU identity. A verified campaign and all existing spend limits are still required to run.",
  "productImages.illustrationCount": "Number of illustrations",
  "productImages.illustrationCountHelp":
    "The first N eligible product rows without a saved illustration or unresolved paid attempt, ordered by stable product ID. The default selects the first 100.",
  "productImages.illustrationMaximumCost": "Maximum model cost (USD)",
  "productImages.illustrationPrice":
    "Model price: $0.02 per generated image; storage and data transfer are billed separately.",
  "productImages.illustrationCostConfirmation":
    "I authorize a maximum model cost of {amount} for this batch.",
  "productImages.invalidIllustrationJob":
    "Enter a whole number from 1 to 50,000 and confirm the displayed maximum cost.",
  "productImages.illustrationJobRecorded":
    "Illustration job recorded. Generation starts only when the verified campaign and spend limits allow it.",
  "productImages.queueIllustrations": "Queue illustrations",
  "productImages.syntheticIllustrationLabel": "AI-generated product illustration",
  "productImages.syntheticIllustrationDisclosure":
    "Illustrative only; not a photograph of the exact product and not evidence of SKU identity. The catalog image is unchanged.",
  "productImages.syntheticIllustrationAlt": "Synthetic category-level product illustration",
  "productImages.illustrationUnavailable": "The saved illustration could not be loaded.",
  "productImages.illustrationLoading": "Loading generated illustration…",
  "productImages.jobMode": "Job type",
  "productImages.jobMode.SEARCH": "Public image search",
  "productImages.jobMode.GENERATE_ILLUSTRATION": "Synthetic illustration generation",
  "productImages.organizationRequired":
    "This view requires one authorized organization in the session. Ask an administrator for the correct context.",
  "productImages.createJob": "Prepare research for this product",
  "productImages.createPausedHelp":
    "Preparation records paused research for this revision. Execution requires explicit activation, a verified budget campaign and an enabled service.",
  "productImages.budgetUsd": "Research limit (USD)",
  "productImages.budgetHint":
    "Use a decimal point. The limit is not confirmed spend and does not guarantee an image count.",
  "productImages.callLimit": "Research call limit",
  "productImages.officialHosts": "Established official domains (optional)",
  "productImages.hostsHint":
    "Up to 20 domains, separated by lines or commas. Include only domains with an established manufacturer relationship; a brand does not establish that relationship.",
  "productImages.identityReviewRef": "Public identity review reference",
  "productImages.identityReviewReason": "Public identity review reason",
  "productImages.publicIdentityConfirmation":
    "I reviewed and confirm that the selected name, brand, GTIN and attributes may be used in public-source queries.",
  "productImages.invalidJob":
    "Check the positive budget, call limit, domains, and review reference and reason (at least 10 characters).",
  "productImages.jobRecorded":
    "Research recorded. Check activation status; this record does not imply an image result.",
  "productImages.recordPausedJob": "Record paused research",
  "productImages.saving": "Recording…",
  "productImages.writeUnconfirmed":
    "The response is unconfirmed. The request data and key are retained; retrying repeats the same action without creating another request.",
  "productImages.retrySame": "Repeat the same request",
  "productImages.resumeJob": "Bind campaign and resume",
  "productImages.resumeHelp":
    "Resuming may execute paid queries when server controls allow. It requires a verified campaign; it does not increase the budget or release unknown costs.",
  "productImages.costReviewHelp":
    "A paid image attempt has an unresolved financial outcome or missing saved asset. This product stays held; retrying cannot repeat the charge or release that reservation.",
  "productImages.campaignId": "Verified budget campaign",
  "productImages.resumeReason": "Resume reason",
  "productImages.resumeConfirmation":
    "I confirm that the campaign was verified and authorize resuming within the recorded limits and server controls.",
  "productImages.invalidResume":
    "Enter a valid campaign identifier and a reason of at least 10 characters.",
  "productImages.resumeRecorded":
    "Resume request recorded. Research status indicates whether execution was admitted.",
  "productImages.confirmResume": "Confirm campaign and resume",
  "productImages.newTab": "Opens in a new tab",
  "productImages.notEstablished": "Not established",
  "productImages.candidateTitle": "Candidate {number}",
  "productImages.candidateUnpublished":
    "Candidate for review; it does not replace or publish the product image.",
  "productImages.publicIdentity": "Identity found in the public source",
  "productImages.confidence": "Research-reported confidence",
  "productImages.confidence.EXACT": "Reported exact match",
  "productImages.confidence.PARTIAL": "Partial match",
  "productImages.confidence.UNCERTAIN": "Uncertain match",
  "productImages.matchField.gtin": "GTIN match",
  "productImages.matchField.variant": "Variant match",
  "productImages.matchField.size": "Size match",
  "productImages.matchField.packaging": "Packaging match",
  "productImages.match.EXACT": "Exact (reported)",
  "productImages.match.MISMATCH": "Mismatch",
  "productImages.match.NOT_ESTABLISHED": "Not established",
  "productImages.sourceKind": "Reported source type",
  "productImages.sourceKind.OFFICIAL_MANUFACTURER": "Reported official manufacturer source",
  "productImages.sourceKind.OTHER_PUBLIC": "Other public source",
  "productImages.httpVerification": "Page and image verification",
  "productImages.http.PUBLIC_HTTP_VERIFIED": "Public HTTP retrievals recorded",
  "productImages.http.NOT_VERIFIED": "Not verified",
  "productImages.openSource": "Open public source page",
  "productImages.openPublicImage": "Open image at public source",
  "productImages.noQuote": "No evidence excerpt recorded",
  "productImages.sourceRights": "Source usage claim",
  "productImages.rights.UNKNOWN":
    "Usage rights are unknown. Finding an image publicly does not grant a license.",
  "productImages.rights.SOURCE_LICENSE_CLAIM":
    "The source claims a license; this claim still requires independent human review.",
  "productImages.openRightsClaim": "Open claim evidence",
  "productImages.reviewRecorded": "Candidate review recorded",
  "productImages.reviewDecision": "Candidate decision",
  "productImages.reviewDecision.ACCEPT_CANDIDATE": "Accept as candidate without publishing",
  "productImages.reviewDecision.REJECT_CANDIDATE": "Reject candidate",
  "productImages.reviewReason": "Review reason",
  "productImages.reviewedAt": "Reviewed",
  "productImages.reviewer": "Reviewer",
  "productImages.license": "Reviewed license or usage authorization",
  "productImages.scopeOfUse": "Authorized usage scope",
  "productImages.rightsEvidenceUrl": "Usage-review evidence URL",
  "productImages.openReviewedRights": "Open reviewed usage evidence",
  "productImages.reviewNotPublication":
    "The decision remains a candidate review. No image was published or replaced.",
  "productImages.reviewCandidate": "Review candidate and usage evidence",
  "productImages.acceptBlocked":
    "Acceptance requires a unique GTIN, exact GTIN, variant, size and packaging matches, exact confidence and HTTP verification. Uncertainty remains pending.",
  "productImages.chooseDecision": "Select a decision",
  "productImages.reviewConfirmation":
    "I reviewed identity and usage authorization. This decision accepts only the candidate and does not publish the image.",
  "productImages.invalidReview":
    "Check the decision, reason (at least 10 characters) and, for acceptance, public evidence, license and usage scope.",
  "productImages.recordReview": "Record candidate review",
  "productImages.candidateAudit": "Candidate provenance and receipts",
  "productImages.candidateId": "Candidate identifier",
  "productImages.identityHash": "Pinned identity SHA-256",
  "productImages.candidateCreatedAt": "Candidate recorded",
  "productImages.retrievedAt": "Sources retrieved",
  "productImages.imageHash": "Image SHA-256",
  "productImages.pageHash": "Page SHA-256",
  "productImages.imageBytes": "Verified image bytes",
  "productImages.imageType": "Verified image format",
  "productImages.targetStatus": "This product’s status",
  "productImages.targetStatus.PENDING": "Pending",
  "productImages.targetStatus.IN_PROGRESS": "Researching",
  "productImages.targetStatus.DONE": "Research complete; publication separate",
  "productImages.targetStatus.FAILED": "Research interrupted",
  "productImages.targetStatus.BLOCKED_IDENTITY": "Identity pending",
  "productImages.checkpoint": "Retained research result",
  "productImages.checkpointRetained": "Durable receipt available",
  "productImages.noCheckpoint": "No confirmed receipt",
  "productImages.targetFailed":
    "Research for this product was interrupted. Check status and receipts before requesting another attempt.",
  "productImages.noJob": "No image research is recorded for this product and revision.",
  "productImages.candidates": "Research candidates",
  "productImages.noCandidates": "No confirmed candidates",
  "productImages.noCandidatesHelp":
    "Pending, blocked or empty research does not mean an image was found or qualified.",
  "productImages.overlayAudit": "Retained identity and status",
  "productImages.targetErrorCode": "Technical interruption code",
  "productImages.jobTitle": "Recorded research",
  "productImages.jobStatus.BLOCKED": "Blocked",
  "productImages.jobStatus.PENDING": "Pending",
  "productImages.jobStatus.IN_PROGRESS": "Running",
  "productImages.jobStatus.COMPLETED": "Complete without publication",
  "productImages.jobStatus.PARTIAL": "Partial result",
  "productImages.jobCreatedAt": "Research recorded",
  "productImages.jobProgress": "Whole-job status",
  "productImages.jobProgressValue":
    "{done} complete · {pending} pending · {failed} interrupted · {total} products total",
  "productImages.jobCountsScope":
    "Totals describe the whole research job. This product’s status is shown separately.",
  "productImages.jobAudit": "Research identifiers",
  "productImages.jobId": "Research identifier",
  "productImages.sweepId": "Execution identifier",
  "productImages.activation.FEATURE_DISABLED":
    "Image research is disabled in this environment. Recorded results remain available.",
  "productImages.activation.BUDGET_CAMPAIGN_REQUIRED":
    "A verified budget campaign still needs to be bound.",
  "productImages.activation.CAMPAIGN_UNAVAILABLE":
    "The bound campaign is unavailable or unverified.",
  "productImages.activation.SWEEP_PAUSED": "Execution is paused.",
  "productImages.activation.BUDGET_EXHAUSTED":
    "The available budget is exhausted; resuming does not increase the limit.",
  "productImages.activation.IDENTITY_REVIEW_REQUIRED":
    "Public identity still requires explicit review.",
  "productImages.activation.IMAGE_MODEL_PRICE_UNQUALIFIED":
    "The Imagen model price is not qualified for this campaign.",
  "productImages.activation.PRODUCT_NAME_REQUIRED":
    "A product name is required to generate an illustration.",
  "productImages.issue.MISSING_GTIN": "GTIN missing; the image remains pending.",
  "productImages.issue.GTIN_CONFLICT":
    "GTIN is shared or duplicated; no image is mapped automatically.",
  "productImages.issue.MISSING_PUBLIC_NAME":
    "Public product name is not established for the query.",
  "productImages.issue.VARIANT_NOT_ESTABLISHED": "The exact variant is not established.",
  "productImages.issue.SIZE_NOT_ESTABLISHED": "The exact size is not established.",
  "productImages.issue.PACKAGING_NOT_ESTABLISHED": "The exact packaging is not established.",
  "productImages.issue.NO_PUBLIC_CANDIDATE": "No public candidate was found in this attempt.",
  "productImages.issue.UNSAFE_URL": "A URL was refused by public-source controls.",
  "productImages.issue.HTTP_VERIFICATION_FAILED":
    "Public page or image retrieval could not be verified.",
  "productImages.issue.RIGHTS_EVIDENCE_REQUIRED": "Usage authorization evidence is still required.",
  "productImages.issue.MANUFACTURER_NOT_ESTABLISHED":
    "The manufacturer relationship is not established.",
  "productImages.issue.EXISTING_IMAGE_PRESERVED": "The existing image is preserved.",

  // Product catalog: immutable source revisions, declarations and explicit supplier SKU maps.
  "productCatalog.title": "Products",
  "productCatalog.description":
    "Search catalog records, source revisions and supplier declarations.",
  "productCatalog.product": "Product",
  "productCatalog.catalog": "Catalog",
  "productCatalog.chooseCatalog": "Select a catalog",
  "productCatalog.internalCode": "Internal product code",
  "productCatalog.brand": "Declared brand",
  "productCatalog.gtin": "GTIN / EAN",
  "productCatalog.classification": "Classification",
  "productCatalog.declared": "Declared source data",
  "productCatalog.reviewed": "Reviewed classification",
  "productCatalog.unreviewed": "Classification not yet reviewed",
  "productCatalog.scope":
    "The catalog retains declared product data. Classification review does not qualify fiscal rules, prices or the supplier’s tax eligibility.",
  "productCatalog.classificationScope":
    "Original values remain preserved. An NCM/CEST review is separate from qualification of the rules, operation and parties.",
  "productCatalog.searchLabel": "Search products",
  "productCatalog.searchPlaceholder": "Name, internal code, GTIN, brand or NCM",
  "productCatalog.manage": "Import and associate",
  "productCatalog.pinnedRevision": "Pinned revision · {version}",
  "productCatalog.noActiveRevision": "No active revision",
  "productCatalog.openCurrent": "Open current revision",
  "productCatalog.tableCaption": "Products in the selected revision",
  "productCatalog.noResults": "No products match this search",
  "productCatalog.noResultsHelp": "Try another name or identifier in this revision.",
  "productCatalog.empty": "No catalog available",
  "productCatalog.emptyHelp":
    "An operator with management permission can import the prepared files and activate a revision after reviewing its source.",
  "productCatalog.catalogUnavailable": "The requested catalog is unavailable to this session.",
  "productCatalog.revisionMismatch":
    "This product does not belong to the pinned revision. Return to the list and open a row in this revision.",
  "productCatalog.unnamed": "Product name not recorded",
  "productCatalog.notRecorded": "Not recorded",
  "productCatalog.issues": "Import issues",
  "productCatalog.noImportIssues": "No import warnings recorded",
  "productCatalog.noMerge":
    "Repeated rows remain separate. GTIN, name or brand do not establish a supplier SKU mapping.",
  "productCatalog.imagesPending": "Images pending",
  "productCatalog.imagesHelp": "This revision does not yet contain qualified product images.",
  "productCatalog.provenance": "Source and audit",
  "productCatalog.revisionId": "Exact revision",
  "productCatalog.sourceRow": "Source sheet and row",
  "productCatalog.worksheetPart": "Worksheet file part",
  "productCatalog.sourceHash": "Declared source-file SHA-256",
  "productCatalog.rowHash": "Source-row SHA-256",
  "productCatalog.sourceReference": "Source / document reference",
  "productCatalog.reason": "Recorded reason",
  "productCatalog.reviewedAt": "Reviewed at",
  "productCatalog.reviewer": "Reviewer",
  "productCatalog.validFrom": "Valid from",
  "productCatalog.validTo": "Valid until · optional",
  "productCatalog.openEnded": "No declared end date",
  "productCatalog.retryOriginal": "Retry the original request",
  "productCatalog.recordAnother": "Record another",
  "productCatalog.writeUnknown":
    "The response was not confirmed. Inputs are locked; retry sends the same request to recover its result.",
  "productCatalog.import.title": "Import a prepared revision",
  "productCatalog.import.help":
    "Select the manifest and JSONL rows produced by the local catalog preparer. Declared values and identifiers are preserved.",
  "productCatalog.import.preparation":
    "Local preparation must record INTERNAL_PRODUCT_CODE, the worksheet, cells and digests. Activation does not make this data approved fiscal rules.",
  "productCatalog.import.target": "Revision destination",
  "productCatalog.import.newCatalog": "Create a new catalog",
  "productCatalog.import.name": "New catalog name",
  "productCatalog.import.manifestFile": "Manifest · manifest.json",
  "productCatalog.import.rowsFile": "Prepared rows · rows.jsonl",
  "productCatalog.import.validate": "Validate files locally",
  "productCatalog.import.rows": "Manifest rows",
  "productCatalog.import.worksheet": "Declared worksheet",
  "productCatalog.import.sourceDigest": "Source digest declared in the manifest",
  "productCatalog.import.rowsDigest": "Prepared-rows SHA-256",
  "productCatalog.import.bytes": "Canonical UTF-8 bytes",
  "productCatalog.import.validated":
    "Row structure, order, count, bytes and digest match the manifest.",
  "productCatalog.import.upload": "Upload draft in batches of 100 rows",
  "productCatalog.import.uploading": "Uploading batches…",
  "productCatalog.import.resume": "Resume using the same requests",
  "productCatalog.import.progress": "{received} of {total} rows acknowledged by the server",
  "productCatalog.import.resumeHelp":
    "Closing pauses after the current batch. To resume in this session, select and validate the same files again; the original requests are reused.",
  "productCatalog.import.activationHelp":
    "Review the source and record a reason. Activation makes this revision searchable and preserves earlier revisions. Issues and duplicates remain visible.",
  "productCatalog.import.activate": "Activate the reviewed source revision",
  "productCatalog.import.activated": "Catalog revision {version} activated",
  "productCatalog.import.finished":
    "Revision activated. Close this panel to browse products, or reopen it to prepare another import.",
  "productCatalog.import.storageWarning":
    "Resume metadata could not be saved in this session. Keep this panel open until upload and activation finish.",
  "productCatalog.import.error.size":
    "Files exceed the local limit of 1 MiB for the manifest or 128 MiB for the rows.",
  "productCatalog.import.error.manifest":
    "The manifest does not match the supported prepared format. Review it with the local preparer.",
  "productCatalog.import.error.row":
    "Invalid JSONL or inconsistent source position at line {row}. This validation sent no rows.",
  "productCatalog.import.error.count":
    "The row count or acknowledged sequence does not match the manifest. The draft remains inactive.",
  "productCatalog.import.error.digest":
    "Canonical row bytes or SHA-256 differ from the manifest. Regenerate both files from the same source.",
  "productCatalog.supplier.create": "Create supplier record",
  "productCatalog.supplier.name": "Declared supplier name",
  "productCatalog.supplier.externalId": "External supplier reference · optional",
  "productCatalog.supplier.scope":
    "The operator declares the supplier. Brand, product manufacturer and internal code do not determine its tax profile.",
  "productCatalog.supplier.createdUnknown":
    "Record created without a verified tax profile. Declare a profile separately with its source and period.",
  "productCatalog.supplier.choose": "Select a declared supplier",
  "productCatalog.supplier.declare": "Declare supplier profile",
  "productCatalog.supplier.profile": "Declared profile",
  "productCatalog.supplier.profile.UNKNOWN": "Unknown / unverified",
  "productCatalog.supplier.profile.INDUSTRY": "Declared industry",
  "productCatalog.supplier.profile.DISTRIBUTOR": "Declared distributor",
  "productCatalog.supplier.currentDeclaration": "Current declared profile: {profile}",
  "productCatalog.supplier.saveDeclaration": "Record declaration and source",
  "productCatalog.supplier.declarationSaved":
    "Declaration saved as DECLARED. It does not establish eligibility for a benefit, IPI treatment or prior ST.",
  "productCatalog.binding.title": "Associate supplier with revision",
  "productCatalog.binding.help":
    "A source association with an exact revision. A supplier SKU requires a separate individual mapping in the product detail.",
  "productCatalog.binding.requiresRevision":
    "Select and load an active revision to record this association.",
  "productCatalog.binding.save": "Record revision association",
  "productCatalog.binding.saved":
    "Association recorded. It does not automatically create a supplier SKU mapping.",
  "productCatalog.link.title": "Map a declared supplier SKU",
  "productCatalog.link.help":
    "Explicitly record which supplier SKU identifies this product in this revision. Supply a source and period; do not infer it from name, GTIN, brand or internal code.",
  "productCatalog.link.supplierSku": "Supplier SKU · explicitly declared",
  "productCatalog.link.save": "Record mapping and source",
  "productCatalog.link.saved": "Explicit mapping recorded",
  "productCatalog.field.status": "Declared status",
  "productCatalog.field.sku": "Internal product code",
  "productCatalog.field.name": "Declared name",
  "productCatalog.field.family": "Declared family",
  "productCatalog.field.brand": "Declared brand",
  "productCatalog.field.model": "Declared model",
  "productCatalog.field.gtinRaw": "Original GTIN",
  "productCatalog.field.gtin": "Normalized GTIN",
  "productCatalog.field.ncmRaw": "Original NCM",
  "productCatalog.field.ncm": "Normalized NCM",
  "productCatalog.field.ncmExtension": "Declared NCM extension",
  "productCatalog.field.cestRaw": "Original CEST",
  "productCatalog.field.cest": "Normalized CEST",
  "productCatalog.field.unit": "Declared commercial unit",
  "productCatalog.field.unitPriceRaw": "Original unit price",
  "productCatalog.field.unitPrice": "Normalized unit price",
  "productCatalog.field.availableStockRaw": "Original available stock",
  "productCatalog.field.availableStock": "Normalized available stock",
  "productCatalog.field.netWeightRaw": "Original net weight",
  "productCatalog.field.grossWeightRaw": "Original gross weight",
  "productCatalog.field.heightRaw": "Original height",
  "productCatalog.field.widthRaw": "Original width",
  "productCatalog.field.depthRaw": "Original depth",
  "productCatalog.field.goodsOriginRaw": "Declared goods origin",
  "productCatalog.field.characteristics": "Declared characteristics",
  "productCatalog.field.includedAtRaw": "Source inclusion value",
  "productCatalog.field.updatedAtRaw": "Source update value",
  "productCatalog.issue.MISSING_SKU": "Internal code missing",
  "productCatalog.issue.MISSING_NAME": "Name missing",
  "productCatalog.issue.IDENTIFIER_FORMAT_UNKNOWN": "Identifier format unknown",
  "productCatalog.issue.NUMERIC_IDENTIFIER_UNSAFE": "Numeric identifier may have lost precision",
  "productCatalog.issue.INVALID_NCM": "Invalid source NCM",
  "productCatalog.issue.NCM_EXTENSION_PRESENT": "NCM extension requires review",
  "productCatalog.issue.INVALID_CEST": "Invalid source CEST",
  "productCatalog.issue.INVALID_GTIN": "Invalid source GTIN",
  "productCatalog.issue.GTIN_SHARED": "GTIN shared by different internal codes",
  "productCatalog.issue.SKU_REPEATED": "Internal code repeated across rows",
  "productCatalog.issue.FORMULA_NOT_EVALUATED": "Formula not evaluated",
  "productCatalog.issue.PRICE_UNPARSEABLE": "Price could not be parsed",
  "productCatalog.issue.STOCK_UNPARSEABLE": "Stock could not be parsed",

  "calculationMemory.title": "Calculation memory",
  "calculationMemory.intro":
    "Formulas and dependencies reconstructed from this item’s immutable records and pinned ruleset.",
  "calculationMemory.qualification":
    "This memory explains the saved record. This view does not perform legal qualification or establish fiscal applicability.",
  "calculationMemory.loading": "Loading item memory…",
  "calculationMemory.legacy":
    "Memory is unavailable for this record. Required original data or immutable trace is missing.",
  "calculationMemory.error": "Could not load item memory.",
  "calculationMemory.retry": "Try again",
  "calculationMemory.status.AVAILABLE": "Memory available",
  "calculationMemory.status.PARTIAL": "Partial memory",
  "calculationMemory.status.UNAVAILABLE": "Memory unavailable",
  "calculationMemory.cardStatus.CALCULATED": "Calculated",
  "calculationMemory.cardStatus.DECLARED": "Declared",
  "calculationMemory.cardStatus.EXEMPT": "Exempt in saved record",
  "calculationMemory.cardStatus.OUTSIDE_SCOPE": "Outside this record’s scope",
  "calculationMemory.cardStatus.PENDING": "Pending",
  "calculationMemory.formula": "Formula",
  "calculationMemory.substitution": "Substitution",
  "calculationMemory.raw": "Unrounded result",
  "calculationMemory.result": "Step result",
  "calculationMemory.stored": "Stored value",
  "calculationMemory.rounding": "Rounding",
  "calculationMemory.roundingScale": "{scale} decimal places · {mode}",
  "calculationMemory.roundingNone": "No rounding at this step",
  "calculationMemory.dependencies": "Depends on",
  "calculationMemory.none": "None",
  "calculationMemory.unit": "Unit",
  "calculationMemory.unit.BRL": "BRL · Brazilian reais",
  "calculationMemory.unit.RATE": "Decimal fraction (1 = 100%)",
  "calculationMemory.unit.COUNT": "Quantity",
  "calculationMemory.unavailableValue": "Unavailable",
  "calculationMemory.source": "Record source",
  "calculationMemory.source.INPUT": "Original input",
  "calculationMemory.source.PINNED_RULE": "Pinned rule",
  "calculationMemory.source.STORED_TRACE": "Stored trace",
  "calculationMemory.source.DECLARED_REGIME": "Declared regime",
  "calculationMemory.trace": "Trace steps: {sequences}",
  "calculationMemory.blockers": "Blockers and limits",
  "calculationMemory.basis": "Basis and quantity",
  "calculationMemory.basisDetail": "{quantity} × {unit} · source: {source} · amounts: {scope}",
  "calculationMemory.inputBasis": "Original price",
  "calculationMemory.normalizedBasis": "Normalized basis",
  "calculationMemory.extension": "Input multiplier",
  "calculationMemory.aggregation": "Aggregation multiplier",
  "calculationMemory.binding": "Pinned version",
  "calculationMemory.evidence": "Saved evidence",
  "calculationMemory.rule": "Saved rule",
  "calculationMemory.recordedSource": "Recorded source",
  "calculationMemory.provenance": "Pinned rules and evidence",
  "calculationMemory.provenanceHint":
    "Links and hashes belong to the saved record; they do not represent a fresh source verification.",
  "calculationMemory.GOODS": "Goods",
  "calculationMemory.OWN_ICMS_DISPLAYED": "Displayed own ICMS",
  "calculationMemory.FEDERAL_BASE": "Federal basis",
  "calculationMemory.PIS": "PIS",
  "calculationMemory.COFINS": "COFINS",
  "calculationMemory.IPI": "IPI",
  "calculationMemory.ST_SEED": "ST seed",
  "calculationMemory.MVA": "Applied MVA",
  "calculationMemory.ST_BASE": "ST basis",
  "calculationMemory.ST_GROSS_DEBIT": "Gross ST debit",
  "calculationMemory.ST_OWN_DEDUCTION": "Own ICMS deduction",
  "calculationMemory.ST_NET": "Net ST",
  "calculationMemory.ACQUISITION_FISCAL": "Fiscal acquisition",
  "lotMap.field.base_preco": "Purchase price composition",
  "wb.field.base_preco": "Purchase price composition",
  // Explicit import formats and supplier declarations.
  "importTemplate.title": "Import templates",
  "lotDeclaration.title": "Commercial declarations for blank cells",
  "lotDeclaration.otherInputs": "transaction inputs",
  "lotDeclaration.pendingInputs":
    "{count} rows stay out of the calculation until reviewed: {fields}. The import preserves those rows and their reasons.",
  "lotDeclaration.preflightPending":
    "Checking the workbook's commercial and tax inputs. Confirmation will be available after the check.",
  "lotDeclaration.hint":
    "Declare only what is confirmed for every row in this sheet. A populated cell takes precedence, including UNKNOWN. The import record preserves the declaration source.",
  "lotDeclaration.amountBasis": "The selected cost is",
  "lotDeclaration.commercialUnit": "Declared commercial unit",
  "lotDeclaration.unitPlaceholder": "E.g. EA, box of 12 units",
  "lotDeclaration.priceBasis": "Composition of the selected cost",
  "lotDeclaration.purchaseStStatus": "Purchase ST status",
  "lotDeclaration.pisCofinsRegime": "Declared PIS/COFINS regime",
  "lotDeclaration.option.UNKNOWN": "Unconfirmed / requires review",
  "lotDeclaration.option.UNIT": "Price per commercial unit",
  "lotDeclaration.option.LINE_TOTAL": "Line total, already extended",
  "lotDeclaration.option.GOODS_BEFORE_IPI_ST": "Goods before additional IPI and ST",
  "lotDeclaration.option.ACQUISITION_INCLUDES_TAXES": "Acquisition including taxes",
  "lotDeclaration.option.NEW": "No declaration of prior ST",
  "lotDeclaration.option.PRIOR_ST_INCLUDED": "Prior ST included: internal distributor purchase",
  "lotDeclaration.option.INVOICE_RETAINED": "ST withheld on the invoice",
  "lotDeclaration.option.CUMULATIVE": "Cumulative",
  "lotDeclaration.option.NON_CUMULATIVE": "Non-cumulative",
  "lotDeclaration.review":
    "A tax-inclusive price and invoice-withheld ST need price composition and evidence before calculation. A commercial percentage is neither MVA nor an approved tax rate. Do not apply a condition confirmed for some products to the entire sheet.",
  "importTemplate.xlsx": "Download Excel",
  "importTemplate.csv": "Download CSV",
  "importTemplate.txt": "Download TXT",
  "importTemplate.hint":
    "Text identifiers, separate price and quantity. Excel includes a guide; CSV and TXT use UTF-8 and semicolons. Declare the fiscal assumptions before calculating.",
  "importTemplate.supplierFallback": "Declared supplier type for rows without that information",
  "importTemplate.supplierPerRow": "Use each row’s information",
  "importTemplate.industry": "Industry or equivalent",
  "importTemplate.distributor": "Ordinary distributor / reseller",
  "importTemplate.supplierFallbackHint":
    "Fills empty cells only. Unknown or conflicting values require review. A declaration does not prove IPI, withholding or prior ST.",
  "lotMap.field.situacao_st_compra": "Purchase ST status",
  "lotMap.field.preco_venda": "Sale price",
  "lotMap.field.uf_destino_venda": "Buyer state",
  "lotMap.field.tipo_comprador": "Buyer ICMS profile",
  "lotMap.field.regime_pis_cofins": "Declared PIS/COFINS regime",
  "lotMap.field.deposito": "Warehouse / stock line",
  "lotMap.field.validade": "Stock expiry date",
  "wb.field.situacao_st_compra": "Purchase ST status",
  "wb.field.preco_venda": "Sale price",
  "wb.field.uf_destino_venda": "Buyer state",
  "wb.field.tipo_comprador": "Buyer ICMS profile",
  "wb.field.regime_pis_cofins": "Declared PIS/COFINS regime",
  "wb.field.deposito": "Warehouse / stock line",
  "wb.field.validade": "Stock expiry date",
  // Supplier snapshot: declarations and engine output remain independent.
  "supplierCard.title": "Supplier and prior ST",
  "supplierCard.intro": "Saved inputs and the engine response for this line.",
  "supplierCard.declarations": "Declared inputs",
  "supplierCard.returned": "Returned by the engine",
  "supplierCard.type": "Declared supplier type",
  "supplierCard.type.INDUSTRY": "Industry",
  "supplierCard.type.DISTRIBUTOR": "Ordinary distributor",
  "supplierCard.priorSt": "Prior ST included in the price",
  "supplierCard.priorSt.true": "Declared as previously paid",
  "supplierCard.priorSt.false": "Prior payment not confirmed",
  "supplierCard.unknown": "Not recorded · unknown",
  "supplierCard.stStatus": "Returned ST treatment",
  "supplierCard.stStatus.PREVIOUSLY_PAID": "Previously paid",
  "supplierCard.stStatus.CURRENT_RULE": "Rule selected for this calculation",
  "supplierCard.stStatus.PENDING": "Pending review",
  "supplierCard.returnedProfile": "Returned supplier profile",
  "supplierCard.returnedPriorSt": "Engine prior-ST flag: {value}",
  "supplierCard.inputSource.calculation": "Source: saved calculation input",
  "supplierCard.inputSource.task": "Source: saved lot-row input",
  "supplierCard.inputUnavailable": "Original input unavailable in this record",
  "supplierCard.mappedColumn":
    "Mapped column: {cell}. The raw cell text was not retained; a file-level declaration may apply.",
  "supplierCard.resultSource": "Source: saved engine response",
  "supplierCard.legacyUnknown": "No supplier profile was recorded in this result.",
  "supplierCard.qualification":
    "These are transaction declarations and stored calculation results, not a verified supplier register or proof of prior withholding. Missing fields remain unknown; supplier type alone does not establish an exemption or legal eligibility.",

  "operation.research.providerBudgetBlocked":
    "A provider or budget-reservation limit blocked this lookup. The missing evidence remains pending.",

  "operation.research.optIn": "Research and qualify this operation",
  "operation.research.rollout":
    "Optional governed research. Missing evidence stays pending; automatic full product qualification is not available yet.",
  "operation.research.legacyScope":
    "Estimate from the selected published version. Product, party and current legal applicability have not been newly qualified. This is not a final quote.",

  "operation.research.billingPending":
    "Paid research awaits verified billing and an active campaign with an enforced total budget.",

  "operation.research.saved": "Saved immutable revision {revision}",

  "research.family.IPI": "IPI",
  "research.family.FCP": "FCP",
  "research.family.PIS": "PIS",
  "research.family.COFINS": "COFINS",
  "research.origin.OPERATION": "Operation",

  "operation.research.PENDING": "Tax research pending.",
  "operation.research.DISABLED": "Research has not started for all pending data.",
  "operation.research.REVIEW_REQUIRED": "Tax data awaiting review.",
  "operation.research.RECALCULABLE": "Data is available to recalculate in a new revision.",
  "operation.research.gaps": "Pending items to review: {count}.",
  "operation.research.failed": "A research request failed; the data remains pending.",
  "operation.research.cancelled": "A research request was cancelled; the data remains pending.",
  "operation.research.notFound":
    "A research request found no evidence for this transaction. This does not mean an exemption or zero tax.",
  "operation.research.capacityPending":
    "Research has pending work because of capacity or cost limits.",
  "operation.research.costPending": "The maximum query cost still needs to be confirmed.",
  "operation.research.budgetPending": "Research awaits available monthly budget.",
  "operation.research.activationPending": "Research is disabled, paused or awaiting authorization.",
  "operation.research.evidencePending":
    "The sources and whether they cover this transaction still need checking.",
  "operation.research.otherBlocker": "A pending item needs tax review.",
  "operation.research.missingDetails": "View pending data",
  "operation.research.next.PENDING": "Use Refresh research to follow the result.",
  "operation.research.next.DISABLED": "Ask the tax owner to check what is needed to start.",
  "operation.research.next.REVIEW_REQUIRED":
    "Send this reference to the tax owner to review the data.",
  "operation.research.next.RECALCULABLE":
    "Select a new published version and use Issue new revision.",
  "operation.research.handoff":
    "Tax review needs the product and transaction documents to check the sources, parties and transaction date.",
  "operation.research.reference": "Revision reference:",
  "operation.research.details": "About this research",
  "operation.research.immutable":
    "Revision {revision} · version {version}. New evidence never changes this issued result.",
  "operation.research.scope":
    "Current search covers ICMS/ST evidence. IPI, FCP and contributions require qualified sources and conditions; NCM and CEST do not establish the complete product profile.",
  "operation.research.refresh": "Refresh research",
  "operation.research.refreshError":
    "The current state could not be confirmed. The last result remains unchanged.",
  "operation.research.version": "Published version for the new revision",
  "operation.research.chooseVersion": "Select a version",
  "operation.research.recalculate": "Issue new revision",

  "spCoverage.selectionChanged":
    "The selection changed or was rejected before work was created. Refresh the snapshot, clear the selection and choose current gaps. No retry with a new key is needed.",

  "spCoverage.workspaceTitle": "Qualify, prioritize and research",
  "spCoverage.workspaceHelp":
    "Choose a direction and UF. Review six qualification checks and select real gaps for bounded research.",

  "spCoverage.title": "São Paulo route coverage",
  "spCoverage.priority": "Commercial priority · São Paulo",
  "spCoverage.intro":
    "See what supports each route, what still needs proof, and the next research needed.",
  "spCoverage.hub": "Operating hub",
  "spCoverage.esLater": "Espírito Santo in the next phase",
  "spCoverage.direction": "Operation direction",
  "spCoverage.inbound": "Purchase · ALL → SP",
  "spCoverage.outbound": "Sale · SP → ALL",
  "spCoverage.asOf": "Tax date",
  "spCoverage.ncm": "Filter by NCM",
  "spCoverage.allProducts": "All published products",
  "spCoverage.ncmHint": "Enter all 8 digits to filter.",
  "spCoverage.refresh": "Refresh snapshot",
  "spCoverage.stale":
    "Refresh failed. The last confirmed snapshot is shown; new submissions are blocked.",
  "spCoverage.published": "Published version",
  "spCoverage.noBase": "No published base",
  "spCoverage.observed": "Snapshot confirmed",
  "spCoverage.scopeWarning":
    "Current scope: published rule candidates. Without qualified product and profile scope, source currency and test receipts, no route can be declared complete.",
  "spCoverage.shortStatus.COMPLETE": "Complete",
  "spCoverage.shortStatus.PARTIAL": "Partial",
  "spCoverage.shortStatus.MISSING": "No rule",
  "spCoverage.shortStatus.BLOCKED": "Blocked",
  "spCoverage.shortStatus.RUNNING": "Running",
  "spCoverage.status.COMPLETE": "Complete",
  "spCoverage.status.PARTIAL": "Partial",
  "spCoverage.status.MISSING": "No candidate rule",
  "spCoverage.status.BLOCKED": "Blocked",
  "spCoverage.status.RUNNING": "Running",
  "spCoverage.routes": "Routes by UF",
  "spCoverage.chooseRoute": "Select a UF to inspect its qualification checks and gaps.",
  "spCoverage.candidateRules": "candidates",
  "spCoverage.qualification": "Coverage checks",
  "spCoverage.underlying": "Tax qualification:",
  "spCoverage.check.DECLARED_PRODUCT_SCOPE": "Declared products and profiles",
  "spCoverage.check.APPLICABLE_RULES": "Candidate rules on this date",
  "spCoverage.check.SOURCE_PROVENANCE": "Documents and provenance",
  "spCoverage.check.SOURCE_CURRENTNESS": "Current source version",
  "spCoverage.check.SUPPLIER_CASES": "Industry and reseller cases",
  "spCoverage.check.VALIDATION_RECEIPTS": "Validation and test receipts",
  "spCoverage.reason.PRODUCT_PROFILE_SCOPE_NOT_QUALIFIED":
    "The product, CEST and profile universe is not yet qualified for this route.",
  "spCoverage.reason.PUBLISHED_CANDIDATES_FOR_ROUTE_DATE_ONLY":
    "Published candidate rules exist. Their count does not prove applicability to every product or profile.",
  "spCoverage.reason.NO_PUBLISHED_ICMS_CANDIDATE_FOR_ROUTE_DATE":
    "No published ICMS candidate was found for this route and date.",
  "spCoverage.reason.IMMUTABLE_REFERENCES_REQUIRE_DOCUMENT_VERIFICATION":
    "Immutable hashed references exist. The document and its applicability still need verification.",
  "spCoverage.reason.NO_BOUND_SOURCE_REFERENCE":
    "No immutable document reference is bound to this route’s candidates.",
  "spCoverage.reason.CURRENT_PRIMARY_SOURCE_VERSION_NOT_ATTESTED":
    "Rule validity does not prove the latest primary source version was checked.",
  "spCoverage.reason.INDUSTRY_AND_RESELLER_CASES_NOT_ATTESTED":
    "Industry and distributor/reseller cases lack receipts, including ST and IPI where applicable.",
  "spCoverage.reason.ROUTE_PRODUCT_PROFILE_TEST_RECEIPTS_NOT_AVAILABLE":
    "Validation receipts for the full route × product × profile scope are unavailable.",
  "spCoverage.products": "candidate products",
  "spCoverage.boundRefs": "bound references",
  "spCoverage.sources": "registered sources",
  "spCoverage.degraded": "degraded",
  "spCoverage.gaps": "Gaps observed in calculations",
  "spCoverage.gapHelp":
    "Select up to 10 real gaps. A route with no observed gaps can still be incomplete.",
  "spCoverage.noGap":
    "No calculation gaps are recorded in this snapshot. This does not prove coverage.",
  "spCoverage.active": "queued or running",
  "spCoverage.gapStatus.OPEN": "Available for research",
  "spCoverage.gapStatus.RESEARCHING": "Research in progress",
  "spCoverage.gapStatus.NO_RULE_FOUND": "No rule found · review",
  "spCoverage.gapStatus.RULE_FOUND": "Result awaiting review",
  "spCoverage.gapStatus.RESOLVED": "Resolved",
  "spCoverage.gapStatus.DISMISSED": "Dismissed",
  "spCoverage.bounded":
    "Sample limited to 50 records per route. Totals include the rest. Selection is blocked when the active research list is truncated.",
  "spCoverage.batch": "Research selected gaps",
  "spCoverage.selected": "{count} of 10 gaps selected",
  "spCoverage.batchHelp":
    "Uses the existing agent workflow with current budgets and pauses. Matching active requests are joined.",
  "spCoverage.permission": "Research execution and calculation read permissions are required.",
  "spCoverage.dispatcher":
    "The dispatcher is not configured in this instance. Coverage remains readable.",
  "spCoverage.estimating": "Checking cost and limits…",
  "spCoverage.estimateError": "Could not verify cost and limits. Submission remains blocked.",
  "spCoverage.requests": "estimated requests",
  "spCoverage.lane.AVAILABLE": "available",
  "spCoverage.lane.PAUSED": "paused",
  "spCoverage.lane.BUDGET": "budget limit",
  "spCoverage.lane.DAILY_CAP": "daily cap",
  "spCoverage.lane.DISABLED": "disabled",
  "spCoverage.launch": "Start bounded batch",
  "spCoverage.launching": "Submitting batch…",
  "spCoverage.retryBatch": "Check / retry with the same key",
  "spCoverage.clear": "Clear selection",
  "spCoverage.finishRetry": "Resolve the pending submission before changing scope.",
  "spCoverage.uncertain":
    "A submission was not confirmed. The sequence stopped. Retry with the same key; do not start an equivalent batch.",
  "spCoverage.receipt":
    "Confirmed: {created} created · {joined} joined · {reused} results reused · {deferred} deferred.",
  "spCoverage.noAutoPublish":
    "Finished research does not mean complete coverage. This action approves or publishes no rule.",
  "spCoverage.activity": "Route research and results",
  "spCoverage.review": "awaiting review",
  "spCoverage.failed": "failed or cancelled",
  "spCoverage.research.QUEUED": "Queued",
  "spCoverage.research.RUNNING": "Running",
  "spCoverage.research.FOUND": "Found · review",
  "spCoverage.research.NOT_FOUND": "No result",
  "spCoverage.research.NEEDS_REVIEW": "Review needed",
  "spCoverage.research.FAILED": "Failed",
  "spCoverage.research.CANCELLED": "Cancelled",
  "spCoverage.provenance": "Version, validity and documents",
  "spCoverage.provenanceHelp":
    "Sample of published candidates and bound hashes. This does not replace primary source verification.",
  "spCoverage.openDate": "no end date",
  "spCoverage.boundedRules": "Sample limited to the first 10 rules and 5 references per rule.",
  "spCoverage.referenceTitle": "Published base reference",
  "spCoverage.referenceHelp":
    "The map below counts UF mentions in rules. It does not represent complete purchase or sale route coverage.",

  "operation.pricing.strategy": "Sale price",
  "operation.pricing.fixed": "Fixed price",
  "operation.pricing.tr": "Calculate by TR · SP → SP → SP",
  "operation.pricing.spHub": "Calculate by TR · all states → SP → all states",
  "operation.pricing.spHubScope":
    "SP-hub TR requires the BackChannel centre in SP. Supplier and customer may be in any Brazilian state.",
  "operation.pricing.spHubHint":
    "Enter 0 to less than 100%, up to 6 decimal places. Any supplier/customer state, with the centre in SP. Requires qualified purchase ST, IPI, FCP and fiscal rules; route support does not establish fiscal coverage.",
  "operation.pricing.stBasis": "Purchase ST basis",
  "operation.pricing.stBasis.RESOLVED_NON_ST": "Selected acquisition rule does not calculate ST",
  "operation.pricing.stBasis.PRIOR_ST_INCLUDED":
    "Previously paid ST declared as included in the purchase price",
  "operation.pricing.stBasis.DECLARED_INVOICE_ST":
    "Positive retained ST declared from the supplier invoice",
  "operation.pricing.stBasis.RESOLVED_SENDER_ST":
    "Computed ST with qualified sender responsibility",
  "operation.pricing.netTarget": "Target contribution · all states → SP → all states",
  "operation.pricing.targetRate": "Target contribution / sale (%)",
  "operation.pricing.netHint":
    "Earnings contribution after the operation’s qualified taxes, purchase credits and declared expenses. This is not a cash or final-company-profit target. The centre must be SP.",
  "operation.pricing.netExpensesHint":
    "Enter all three expense line totals, using zero explicitly when no expense applies. Editing an expense clears the old net quote.",
  "operation.pricing.expensesRequired":
    "Declare all three expense totals before calculating a contribution target. Enter zero explicitly when applicable.",
  "operation.pricing.invalidTargetRate":
    "Enter a contribution target from 0 to less than 100%, up to 6 decimal places.",
  "operation.pricing.netScope":
    "Contribution-target pricing requires the BackChannel centre in SP.",
  "operation.pricing.achievedMargin": "Calculated contribution / sale",
  "operation.pricing.targetDifference": "Difference from target · rounded to cents",
  "operation.pricing.netFormula":
    "Nearest-cent earnings contribution after the qualified operation taxes, purchase credits and declared expenses. Credits carried forward remain assets; customer ST is pass-through. No ST recovery or undeclared taxes/expenses are assumed.",
  "commercial.grossProfitMargin": "Gross profit / GMV · partial",
  "commercial.purchaseGoodsBase": "Goods value before IPI/ST",
  "commercial.purchaseFederalBase": "PIS/COFINS base · acquisition",
  "commercial.purchaseIcmsCredit": "ICMS credit · acquisition",
  "commercial.purchaseSt": "ST retained / due on acquisition",
  "commercial.saleFederalBase": "PIS/COFINS base · sale",
  "commercial.saleOwnIcms": "Own ICMS debit · sale",
  "operation.pricing.rate": "TR on sale (%)",
  "operation.pricing.hint":
    "Enter 0 to less than 100%, up to 6 decimal places. Available for internal SP purchases and sales.",
  "operation.pricing.scope": "TR pricing requires the supplier, establishment and customer in SP.",
  "operation.pricing.invalidRate": "Enter TR from 0 to less than 100%, up to 6 decimal places.",
  "operation.pricing.costBasis": "Purchase invoice cost",
  "operation.pricing.saleLineValue": "Calculated sale · line total",
  "operation.pricing.unitApproximation": "Approximate unit sale · reference only",
  "operation.pricing.formula":
    "Sale = invoice cost ÷ (1 − TR), rounded to cents. The line total is authoritative. TR is not net margin; sale taxes and expenses reduce contribution.",
  "operation.pricing.review": "Review fiscal prerequisites before calculating the price.",
  "errors.OPERATION_PRICING_UNRESOLVED":
    "Price is pending. Resolve the following prerequisites and calculate again.",
  "operation.pricing.blocker.INPUT_INVALID":
    "Check the route supported by the selected TR mode, supplier type and TR.",
  "operation.pricing.blocker.PURCHASE_RULE_PENDING": "The acquisition rule or value is unresolved.",
  "operation.pricing.blocker.PURCHASE_IPI_PENDING":
    "The industrial acquisition IPI treatment is missing.",
  "operation.pricing.blocker.PURCHASE_FCP_PENDING":
    "Acquisition FCP-ST is unknown or not accounted for in the fiscal cost.",
  "operation.pricing.blocker.PURCHASE_ST_PENDING":
    "Confirm ST status and amounts retained on the supplier invoice.",
  "operation.pricing.blocker.SALE_RULE_PENDING": "The sale fiscal rule is missing or ambiguous.",
  "operation.pricing.blocker.MONETARY_LIMIT":
    "The calculated cost or price exceeds the monetary limit.",
  "operation.pricing.blocker.FEDERAL_TAXES_PENDING":
    "Federal taxes or purchase credits are unresolved for the net target.",
  "operation.pricing.blocker.SALE_FCP_PENDING":
    "Destination FCP is unknown; qualify the sale before solving a net target.",
  "operation.pricing.blocker.NET_TARGET_UNREACHABLE":
    "The requested contribution target has no verified positive cent-rounded solution.",
  "operation.pricing.blocker.PRICING_PRECISION_LIMIT":
    "The target is reachable, but the bounded cent search cannot certify its nearest-cent price. Adjust the target or request a qualified precision review.",
  "autonomousResearch.scope.phase": "SP phase · ALL → SP → ALL",
  "autonomousResearch.scope.planned":
    "{count} routes planned by the policy. Fiscal coverage is not accredited.",
  "autonomousResearch.scope.control":
    "This boundary controls only new autonomous scheduler work. Manual research, other automations, earlier leases and queues, and external IOB retain their own flows.",
  "autonomousResearch.scope.recorded": "Scope recorded for the selected run",
  "autonomousResearch.scope.unknown": "Previous run scope unknown",
  "autonomousResearch.scope.noRun": "No run recorded yet",
  "autonomousResearch.scope.future":
    "ES requires a reviewed change and renewed acceptance; zero gaps never advances the phase automatically.",
  "workbookDrafts.open": "Review fiscal extract",
  "workbookDrafts.continue": "Review retained rows",
  "workbookDrafts.title": "Fiscal row review",
  "workbookDrafts.description":
    "Select rows from a retained extract and organize evidence for review.",
  "workbookDrafts.extractId": "Retained extract ID",
  "workbookDrafts.extractHint": "Use the receipt ID returned when retaining the fiscal JSON.",
  "workbookDrafts.loadExtract": "Open extract",
  "workbookDrafts.loading": "Loading fiscal review…",
  "workbookDrafts.working": "Working…",
  "workbookDrafts.retry": "Try again",
  "workbookDrafts.error":
    "Could not complete this action. Check the details and connection, then try again.",
  "workbookDrafts.denied": "Your access does not allow you to view this row and evidence review.",
  "workbookDrafts.notFound": "Extract, draft or document not found in this environment.",
  "workbookDrafts.unavailable":
    "The review service is temporarily unavailable. Try again to verify the outcome.",
  "workbookDrafts.invalidId": "Enter a valid ID to continue.",
  "workbookDrafts.invalidReceipt": "A valid retained fiscal receipt without conflicts is required.",
  "workbookDrafts.sourceTitle": "Extract provenance",
  "workbookDrafts.extractHash": "Extract SHA-256",
  "workbookDrafts.parentHash": "Declared workbook SHA-256",
  "workbookDrafts.profile": "Fiscal profile",
  "workbookDrafts.extractorVersion": "Extractor version",
  "workbookDrafts.parentVerification": "Workbook verification",
  "workbookDrafts.layoutVerification": "Mapping verification",
  "workbookDrafts.legalValidity": "Legal validity",
  "workbookDrafts.effectiveFrom": "Effective from",
  "workbookDrafts.effectiveTo": "Effective to",
  "workbookDrafts.nullDate": "Not established",
  "workbookDrafts.origin": "Origin",
  "workbookDrafts.status": "Status",
  "workbookDrafts.workbook": "Workbook",
  "workbookDrafts.nonExecutable": "Unavailable for calculations",
  "workbookDrafts.noProposal": "No associated proposal",
  "workbookDrafts.rowsTitle": "Rows for review",
  "workbookDrafts.rowsHint":
    "Select each purchase or sale ST row you want to review. Replicas of the same row are grouped; references and rows without typed observations are excluded from this selection.",
  "workbookDrafts.noRows": "This extract contains no eligible rows for this review.",
  "workbookDrafts.selectionCount": "{count} rows selected",
  "workbookDrafts.selectRow": "Select {block}, row {row}",
  "workbookDrafts.row": "Row",
  "workbookDrafts.block": "Fiscal block",
  "workbookDrafts.observations": "Source observations",
  "workbookDrafts.locators": "Source locators",
  "workbookDrafts.recordHash": "Row SHA-256",
  "workbookDrafts.previewDrafts": "Review selection",
  "workbookDrafts.previewTitle": "Draft preview",
  "workbookDrafts.batchHash": "Reviewed selection SHA-256",
  "workbookDrafts.batchCounts": "{selected} rows selected · {blocked} blocked drafts",
  "workbookDrafts.previewNoWrites": "This preview has not retained any drafts.",
  "workbookDrafts.confirmDrafts":
    "I confirm these rows for retention as blocked drafts. Provenance remains declared, legal validity remains unknown, and no rule will be approved or published.",
  "workbookDrafts.commitDrafts": "Retain blocked drafts",
  "workbookDrafts.savedDrafts": "Selection retained for review",
  "workbookDrafts.savedCounts": "{created} new drafts · {reused} already retained",
  "workbookDrafts.verificationFailed":
    "Could not confirm that the retained details match. Refresh the record before continuing.",
  "workbookDrafts.retainedTitle": "Retained drafts",
  "workbookDrafts.noDrafts": "No drafts have been retained for this extract.",
  "workbookDrafts.refresh": "Refresh list",
  "workbookDrafts.readOnly":
    "Your access allows you to view these rows. This profile cannot retain drafts or links.",
  "workbookDrafts.openDraft": "Open draft",
  "workbookDrafts.detailTitle": "Draft detail",
  "workbookDrafts.chooseDraft":
    "Open a retained draft to review its provenance and linked evidence.",
  "workbookDrafts.draftId": "Draft ID",
  "workbookDrafts.createdAt": "Retained at",
  "workbookDrafts.createdBy": "Retained by",
  "workbookDrafts.blockers": "Pending fiscal review",
  "workbookDrafts.trustNotice":
    "Drafts remain blocked and unavailable for calculations. Retaining rows or linking evidence does not approve or publish rules.",
  "workbookDrafts.linksTitle": "Linked evidence",
  "workbookDrafts.noLinks": "No evidence has been linked to this draft.",
  "workbookDrafts.evidenceTitle": "Link evidence for review",
  "workbookDrafts.evidenceId": "Evidence document ID",
  "workbookDrafts.evidenceHint":
    "Open an approved document from a registered tier-1 source and select an exact locator from its verified content.",
  "workbookDrafts.loadEvidence": "Open document",
  "workbookDrafts.evidenceNotApproved":
    "Linking requires an approved document from a registered tier-1 source. Review the document in the evidence workspace.",
  "workbookDrafts.evidenceHash": "Content SHA-256",
  "workbookDrafts.evidenceSource": "Registered source",
  "workbookDrafts.evidenceReview": "Document review",
  "workbookDrafts.locator": "Exact locator",
  "workbookDrafts.locatorPosition": "Characters {start} to {end}",
  "workbookDrafts.locatorCount": "{count} locators loaded",
  "workbookDrafts.moreLocators": "Load more locators",
  "workbookDrafts.noLocators": "No verified locators in the loaded pages.",
  "workbookDrafts.purpose": "Evidence purpose",
  "workbookDrafts.choosePurpose": "Select a purpose",
  "workbookDrafts.previewLink": "Review link",
  "workbookDrafts.linkPreviewTitle": "Link preview",
  "workbookDrafts.linkHash": "Reviewed link SHA-256",
  "workbookDrafts.confirmLink":
    "I confirm this document, exact locator and purpose for recording a review link. The draft remains blocked and legal validity remains unknown.",
  "workbookDrafts.commitLink": "Retain review link",
  "workbookDrafts.linkSaved": "Link retained for review",
  "workbookDrafts.linkTrust":
    "Document approval and the source registry tier do not establish legal authority for this row. Linking preserves every draft blocker.",
  "workbookDrafts.authorityAssessment": "Legal authority for this row",
  "workbookDrafts.reviewAtLink": "Document review when linked",
  "workbookDrafts.sourceTier": "Source registry tier",
  "workbookDrafts.tierOne": "Tier 1",
  "workbookDrafts.variantHash": "Declared variant SHA-256",
  "workbookDrafts.formulaHash": "Formula SHA-256",
  "workbookDrafts.contentHash": "Omitted text SHA-256",
  "workbookDrafts.cacheTitle": "Stored formula result",
  "workbookDrafts.block.PURCHASE_ST": "Purchase · ST",
  "workbookDrafts.block.SALE_ST": "Sale · ST",
  "workbookDrafts.status.BLOCKED": "Blocked for fiscal use",
  "workbookDrafts.legal.UNKNOWN": "Unknown",
  "workbookDrafts.provenance.DECLARED_UNVERIFIED": "Declared; unverified",
  "workbookDrafts.provenance.DECLARED_PROFILE_MAPPING": "Declared profile mapping",
  "workbookDrafts.authority.UNASSESSED": "Unassessed",
  "workbookDrafts.linkStatus.RECORDED_FOR_REVIEW": "Recorded for review",
  "workbookDrafts.documentReview.APPROVED": "Document approved",
  "workbookDrafts.boolean.true": "Yes",
  "workbookDrafts.boolean.false": "No",
  "workbookDrafts.blocker.SOURCE_PROVENANCE_DECLARED":
    "Declared provenance; workbook and mapping remain unverified",
  "workbookDrafts.blocker.OFFICIAL_EVIDENCE_REQUIRED":
    "Official evidence must corroborate this row",
  "workbookDrafts.blocker.LEGAL_INTERVAL_UNKNOWN": "Legal effective interval is unknown",
  "workbookDrafts.blocker.CLASSIFICATION_UNRESOLVED": "Fiscal classification unresolved",
  "workbookDrafts.blocker.PRODUCT_SCOPE_UNRESOLVED": "Product applicability unresolved",
  "workbookDrafts.blocker.ROUTE_SCOPE_UNRESOLVED": "Route applicability unresolved",
  "workbookDrafts.blocker.SUPPLIER_TAX_CONDITIONS_UNRESOLVED": "Supplier tax conditions unresolved",
  "workbookDrafts.blocker.COVERAGE_COMPARISON_REQUIRED":
    "Comparison with existing fiscal coverage required",
  "workbookDrafts.blocker.MISSING_VALUE": "Source values are missing",
  "workbookDrafts.blocker.UNKNOWN_UNIT": "Some decimal units are unknown",
  "workbookDrafts.blocker.FORMULA_NOT_EXECUTED": "Formula retained as a digest; not executed",
  "workbookDrafts.blocker.CACHE_UNAVAILABLE": "Stored formula result unavailable",
  "workbookDrafts.purpose.CLASSIFICATION": "Fiscal classification",
  "workbookDrafts.purpose.ST_APPLICABILITY": "ST applicability",
  "workbookDrafts.purpose.MVA": "MVA",
  "workbookDrafts.purpose.ROUTE_SCOPE": "Route applicability",
  "workbookDrafts.purpose.LEGAL_INTERVAL": "Legal effective interval",
  "workbookDrafts.purpose.OTHER_FISCAL": "Other fiscal subject",
  "workbookDrafts.field.sourceKey": "Source identifier",
  "workbookDrafts.field.originUf": "Declared origin state",
  "workbookDrafts.field.ncmVariant": "Declared NCM and variant",
  "workbookDrafts.field.ncmScope": "Declared NCM or prefix",
  "workbookDrafts.field.cest": "Declared CEST",
  "workbookDrafts.field.originalMva": "Declared original MVA",
  "workbookDrafts.field.destinationInternalRate": "Declared destination internal rate",
  "workbookDrafts.field.appliedMvaObservation": "Declared applied MVA",
  "workbookDrafts.field.treatmentText": "Fiscal treatment text",
  "workbookDrafts.field.legalReferenceText": "Legal reference text",
  "workbookDrafts.field.destinationUf": "Declared destination state",
  "workbookDrafts.field.mvaObservation": "Declared MVA",
  "workbookDrafts.field.stApplicabilityDeclaration": "ST applicability declaration",
  "workbookDrafts.field.productScopeText": "Product scope text",
  "workbookDrafts.unit.EXCEL_FRACTION": "Excel fraction",
  "workbookDrafts.unit.PERCENT": "Percent",
  "workbookDrafts.unit.UNKNOWN": "Unknown unit",
  "workbookDrafts.kind.NCM": "Declared NCM",
  "workbookDrafts.kind.NCM_VARIANT": "NCM and variant",
  "workbookDrafts.kind.CEST": "Declared CEST",
  "workbookDrafts.kind.UF": "Declared state",
  "workbookDrafts.kind.DECIMAL": "Source decimal",
  "workbookDrafts.kind.BOOLEAN": "Yes/no declaration",
  "workbookDrafts.kind.HASH_ONLY": "Digest only; text omitted",
  "workbookDrafts.kind.MISSING": "Missing value",
  "workbookDrafts.kind.FORMULA": "Unexecuted formula",
  "workbookDrafts.cache.ABSENT": "No stored result",
  "workbookDrafts.cache.EMPTY": "Stored result is empty",
  "workbookDrafts.cache.VALUE": "Stored result; formula not executed",
  "workbookDrafts.normalizedText": "Normalized excerpt on this page",
  "workbookDrafts.evidenceSearch": "Find approved documents",
  "workbookDrafts.evidenceSearchHint":
    "Find an approved document and check its title and publisher before selecting it.",
  "workbookDrafts.evidenceSearchPlaceholder": "Search documents",
  "workbookDrafts.evidenceSearchAction": "Search",
  "workbookDrafts.evidenceSearchResults": "{count} approved documents in this list",
  "workbookDrafts.noEvidenceResults": "No approved documents found. Adjust your search.",
  "workbookDrafts.chooseEvidence": "Select document",
  "workbookDrafts.evidencePublisher": "Publisher",
  "workbookDrafts.evidenceById": "Open by ID",
  "workbookDrafts.moreEvidence": "Load more documents",
  "workbookDrafts.evidenceDocument": "Evidence document",
  "fiscalExtract.open": "Retain fiscal JSON",
  "fiscalExtract.title": "Fiscal extract admission",
  "fiscalExtract.reset": "Clear",
  "fiscalExtract.preview": "Preview JSON",
  "fiscalExtract.working": "Working…",
  "fiscalExtract.retain": "Retain as NEW",
  "fiscalExtract.limits":
    "Paste only the permitted fiscal JSON extract. This flow does not open the XLSX or verify its hash or layout. Legal validity remains unknown; no rule is approved or published.",
  "fiscalExtract.json": "Fiscal JSON (extract object)",
  "fiscalExtract.hint":
    "Versioned profile COMMERCIAL_FISCAL_PARAMETERS_V1 · maximum 256 KB. Free text and formulas must be digests; commercial data is rejected.",
  "fiscalExtract.error":
    "Could not validate or retain this JSON. Check its contract, selection, permissions and connection, then preview again.",
  "fiscalExtract.saved": "Extract retained as NEW",
  "fiscalExtract.previewTitle": "Review the JSON preview",
  "fiscalExtract.hash": "Extract SHA-256",
  "fiscalExtract.counts": "Selected observations",
  "fiscalExtract.countValues":
    "Typed fiscal rows: {fiscal} · without typed data: {unknown} · geographic references: {geographic} · replicas: {duplicates}",
  "fiscalExtract.valid":
    "JSON selection is valid for retention. Official evidence, source provenance, legal validity and product applicability still require review.",
  "fiscalExtract.blocked":
    "Retention blocked: correct the layout, range, type or conflicting replica diagnostics.",
  "fiscalExtract.diagnostics": "Row diagnostics",
  "fiscalExtract.confirm":
    "I confirm that this JSON contains only the permitted fiscal selection, without commercial data. I understand that the workbook hash and mapping are declared and unverified.",
  "fiscalExtract.savedBody":
    "A non-executable JSON receipt was retained. No approved evidence document, proposal or rule was created. Receipt:",
  "fiscalExtract.diagnostic.LAYOUT_MAPPING_INVALID":
    "Declared header mapping does not match the profile",
  "fiscalExtract.diagnostic.PROFILE_RANGE_INVALID": "Sheet or row is outside the permitted profile",
  "fiscalExtract.diagnostic.DUPLICATE_LOCATOR": "Repeated source locator",
  "fiscalExtract.diagnostic.CELL_TYPE_INVALID": "Cell type does not match the permitted column",
  "fiscalExtract.diagnostic.MISSING_VALUE": "Value missing",
  "fiscalExtract.diagnostic.UNKNOWN_UNIT": "Decimal unit is unknown",
  "fiscalExtract.diagnostic.FREE_TEXT_NOT_RETAINED": "Free text retained only as digest",
  "fiscalExtract.diagnostic.FORMULA_NOT_EXECUTED": "Formula retained only as digest; not executed",
  "fiscalExtract.diagnostic.CACHE_UNAVAILABLE": "No usable formula cache",
  "fiscalExtract.diagnostic.ALIAS_CONFLICT": "Replica sheets disagree",

  "operation.federal.title": "Operation PIS/COFINS",
  "operation.federal.regime": "Regime declared for this simulation",
  "operation.federal.unknown": "Not stated / pending",
  "operation.federal.cumulative": "Cumulative",
  "operation.federal.nonCumulative": "Non-cumulative",
  "operation.federal.creditEligibility": "Credit eligibility for this acquisition",
  "operation.federal.eligible": "Eligible acquisition, per fiscal review",
  "operation.federal.ineligible": "No credit entitlement",
  "operation.federal.catalog": "Resolve from legal catalog",
  "operation.federal.stBasis":
    "Fiscal review confirms PIS/COFINS on sale value when entry ST closes the internal resale.",
  "operation.federal.declarationHint":
    "Operator declarations for this simulation. BackChannel’s regime remains unaccredited; confirm regime, product classification and credit eligibility with the fiscal owner. Simples Nacional is outside this calculation.",
  "operation.federal.calculatedScope":
    "PIS/COFINS included under the declarations and sources below. ST recovery is not assessed; FCP is included only when tracked. This simulation does not certify the company regime.",
  "operation.federal.fiscalTotals":
    "These ICMS/IPI memory totals retain their original scope. PIS/COFINS appear separately and enter the commercial view only when calculated.",
  "operation.federal.base": "Base excluding own ICMS",
  "operation.federal.pending.FISCAL_LEGS_PENDING":
    "PIS/COFINS await resolution of the purchase and sale fiscal legs.",
  "operation.federal.pending.REGIME_UNKNOWN":
    "State the PIS/COFINS regime validated by the fiscal owner.",
  "operation.federal.pending.PROFILE_PENDING":
    "The product profile needs fiscal confirmation; no rate has been assumed.",
  "operation.federal.pending.CREDIT_ELIGIBILITY_UNKNOWN":
    "Credit eligibility for this acquisition is unconfirmed. No assumed credit has been deducted.",
  "operation.federal.pending.ST_RESALE_BASIS_UNKNOWN":
    "The federal base of the internal resale closed by entry ST needs confirmation.",
  "operation.federal.pending.POST_2026_REGIME":
    "From 2027, this PIS/COFINS calculation awaits the CBS transition. No previous rates have been applied.",
  "operation.federal.pending.PURCHASE_OWN_ICMS_UNKNOWN":
    "Distributor purchase with prior ST: highlighted own ICMS is missing to determine the federal credit base.",
  "operation.federal.pending.RATE_RULE_AMBIGUOUS":
    "Conflicting published federal rules cover this route; review required.",
  "commercial.federalPurchaseCredit": "Purchase PIS/COFINS credit",
  "commercial.federalSaleDebit": "Sale PIS/COFINS debit",
  "commercial.federalCarryover": "PIS/COFINS credit carryover · asset",
  "overview.issue.purchaseCreditBasePending": "Purchase credit base unconfirmed",
  "issueHelp.purchaseCreditBasePending":
    "The price includes prior ST, but no qualified fiscal breakdown establishes the PIS/COFINS credit base. Review the fiscal base before using net cost or margin.",
  "calcTrace.step.SUPPLIER_CREDIT_BASE_PENDING": "Purchase credit base pending",
  "supplier.type": "Supplier type",
  "supplier.choose": "Select supplier type",
  "supplier.legacy": "Keep previous calculation · undeclared",
  "supplier.industry": "Industry",
  "supplier.distributor": "Ordinary supplier / distributor",
  "supplier.hint":
    "An ordinary distributor does not charge manufacturer IPI. An industrial-equivalent establishment requires its own assessment.",
  "supplier.priorSt": "Prior ST paid and included in the price?",
  "supplier.stUnknown": "Unverified · review invoice",
  "supplier.stConfirmed": "Yes · prior withholding confirmed",
  "supplier.stNotConfirmed": "Not confirmed",
  "supplier.stHint":
    "Confirmation applies only to an internal purchase with current ST applicability. Interstate purchases require invoice withholding analysis; there is no automatic exemption.",
  "supplier.templateHint":
    "Set tipo_fornecedor to INDUSTRY or DISTRIBUTOR. For an internal distributor, st_pago_anteriormente=TRUE confirms prior ST included in the price; FALSE or blank does not confirm withholding. A current applicable rule is still required.",
  "lotMap.field.tipo_fornecedor": "Supplier type · INDUSTRY or DISTRIBUTOR",
  "lotMap.field.st_pago_anteriormente": "Prior ST included · TRUE or FALSE",
  "wb.field.tipo_fornecedor": "supplier type",
  "wb.field.st_pago_anteriormente": "prior ST paid",
  "overview.issue.purchaseStStatusPending": "Purchase ST requires confirmation",
  "issueHelp.purchaseStStatusPending":
    "Review the invoice and current rule: a distributor does not imply an ST exemption; prior withholding is confirmed only on an internal route with applicable ST.",
  "calcTrace.step.DISTRIBUTOR_IPI_NOT_CHARGED": "Ordinary distributor · no manufacturer IPI",
  "calcTrace.step.SUPPLIER_ST_PREVIOUSLY_PAID": "Prior ST included in price",
  "calcTrace.step.SUPPLIER_ST_PENDING": "ST withholding confirmation pending",
  "monetary.inputCost": "Goods cost",
  "monetary.resultBasisHint":
    "For UNIT or LINE_TOTAL inputs, calculated taxes and costs are line totals. In the previous format they are per unit. The editable cost retains the declared input basis.",
  "lotMap.field.custo_original": "Original declared cost",
  "monetary.amountBrl": "Amount (R$)",
  "monetary.lotCostTotal": "Total lot cost (including quantities)",
  "monetary.tableHint":
    "Amounts follow the basis shown on each row: line total or per unit in the previous format.",
  "monetary.unitShort": "Per unit",
  "monetary.totalShort": "Line total",

  "monetary.templateHint":
    "In the template, set base_valor to UNIT or LINE_TOTAL and unidade_comercial to UN, BOX, etc. UNIT requires quantity; do not enter pre-calculated taxes.",
  "calcTrace.step.COMMERCIAL_FIXED_COSTS_EXTENDED": "Fixed costs per commercial unit × quantity",

  "monetary.basis": "Amount basis",
  "monetary.unit": "Price per commercial unit · up to 6 decimals",
  "monetary.total": "Line goods total",
  "monetary.legacy": "Previous format · per-unit calculation",
  "monetary.commercialUnit": "Commercial unit (UN, BOX…)",
  "monetary.totalCost": "Total goods cost (R$)",
  "monetary.lineQuantity": "Line result · commercial quantity {quantity}",
  "monetary.result": "Total fiscal line cost",
  "monetary.lineUnit": "BRL per line",
  "monetary.hint":
    "Unit price is multiplied by quantity before line rounding. A line total is not multiplied again. BOX is the commercial unit; pack contents are not inferred.",
  "lotMap.field.base_valor": "Amount basis · UNIT or LINE_TOTAL",
  "lotMap.field.unidade_comercial": "Commercial unit",
  "wb.field.base_valor": "amount basis",
  "wb.field.unidade_comercial": "commercial unit",
  "calcTrace.step.MONETARY_BASIS_NORMALIZED": "Line total normalized",

  "commercial.editConditions": "Edit commercial terms and expenses",
  "commercial.upfront": "Upfront",
  "commercial.days": "{count} days",
  "commercial.title": "Commercial view",
  "commercial.subtitle": "Cash flow and P&L for the same operation, with credit reconciliation.",
  "commercial.transaction": "Transaction type",
  "commercial.buySell": "Buy / sell",
  "commercial.status": "Status",
  "commercial.simulation": "Simulation · partial",
  "commercial.supplierName": "Original seller",
  "commercial.customerName": "Final buyer",
  "commercial.partyLocation": "{name} · State: {uf}",
  "commercial.category": "Category",
  "commercial.supplierPaymentDays": "Supplier payment term (days)",
  "commercial.customerPaymentDays": "Buyer payment term (days)",
  "commercial.paymentPlaceholder": "0 = upfront",
  "commercial.paymentHint":
    "Terms are informational. This view does not forecast cash dates or calculate interest from payment terms.",
  "commercial.expenses": "Commercial expenses for the operation",
  "commercial.expensesHint":
    "Enter line totals in R$, including zero when there is no expense. These are not unit prices or tax rates.",
  "commercial.scope":
    "Partial subtotal: PIS/COFINS are pending or outside this simulation. FCP is included only when tracked by the rule. Contribution and margin are not the complete final result.",
  "commercial.cashFlow": "Cash flow",
  "commercial.cashHint": "Payments and receipts; unused credits do not become cash.",
  "commercial.profitLoss": "P&L · earnings",
  "commercial.earningsHint": "Cost net of credits and sale taxes before credit offset.",
  "commercial.salesPrice": "Sales price",
  "commercial.cashTaxes": "(−) Sale tax cash outflow · partial",
  "commercial.netRevenue": "(=) Net revenue · partial",
  "commercial.acquisitionPrice": "(−) Acquisition price",
  "commercial.grossProfit": "(=) Gross profit · partial",
  "commercial.operations": "Operating expenses",
  "commercial.commission": "Third-party commission",
  "commercial.financing": "Credit advance cost",
  "commercial.contribution": "(=) Contribution before bonuses · partial",
  "commercial.creditBalance": "Unused tax credit · asset",
  "commercial.gmv": "Gross revenue (GMV excluding pass-through ST)",
  "commercial.earningsTaxes": "(−) Sale tax expense · partial",
  "commercial.cogs": "(−) Cost of goods sold",
  "commercial.margin": "Contribution / GMV · partial",
  "commercial.cashTaxesTitle": "Taxes and credits",
  "commercial.icmsPayable": "ICMS payable",
  "commercial.difalFcp": "Sale DIFAL and FCP",
  "commercial.customerSt": "Customer ST/FCP · pass-through",
  "commercial.pisCofins": "PIS/COFINS",
  "commercial.pending": "Pending",
  "commercial.stRecovery": "ST recovery",
  "commercial.notAssessed": "Not assessed",
  "commercial.creditHint":
    "Unused credits are assets. ST recovery requires assessment and procedure; it has not been added to cash or profit.",
  "commercial.acquisition": "Acquisition",
  "commercial.purchaseInvoice": "Acquisition including IPI/ST",
  "commercial.purchaseCredit": "(−) Included purchase tax credits",
  "commercial.netInventory": "(=) Net inventory · partial",
  "commercial.sales": "Sale",
  "commercial.salesInvoice": "(=) Sale invoice total",
  "commercial.expensesPending":
    "Complete all three expenses to calculate contribution. Explicitly enter zero when there is no cost.",
  "commercial.unsaved": "Unsaved commercial simulation",
  "commercial.hideInputs": "Collapse fiscal inputs",
  "commercial.editInputs": "Edit purchase and sale",

  "operation.supplierType": "Supplier type",
  "operation.supplierType.industry": "Industry or industrial-equivalent",
  "operation.supplierType.distributor": "Distributor / ordinary reseller",
  "operation.supplierType.hint":
    "Industry: IPI and ST follow the rule. Ordinary reseller: no manufacturer IPI; state the purchase ST situation.",
  "operation.valueBasis": "Entered values",
  "operation.valueBasis.unit": "Unit prices",
  "operation.valueBasis.total": "Operation totals",
  "operation.quantity": "Commercial-unit quantity",
  "operation.quantity.hint":
    "Use the same purchase and sale unit. Prices keep up to six decimals before multiplication.",
  "operation.purchaseUnitValue": "Purchase per unit, before IPI and ST (BRL)",
  "operation.saleUnitValue": "Sale per unit, before pass-through ST (BRL)",
  "operation.invalid.supplierType": "Select the supplier type.",
  "operation.invalid.quantity": "Enter a whole quantity from 1 to 999,999,999.",
  "operation.invalid.precision":
    "Check the amounts: up to six unit-price decimals, two total decimals and within the monetary limit.",
  "operation.stPreviouslyPaid":
    "The invoice confirms prior ST included in the price, with no new charge on this internal purchase.",
  "operation.stPreviouslyPaid.short": "Prior ST included in the price",
  "operation.distributor.internalHint":
    "Confirm prior ST only with invoice support. Without confirmation, an ST product remains under review.",
  "operation.distributor.interstateHint":
    "For interstate purchases, enter the invoice ST withheld for the destination. Distributor status still requires checking anticipation.",
  "operation.issue.purchase_ipi_pending":
    "The industrial purchase IPI treatment is unresolved. Missing information does not establish a zero rate.",
  "operation.issue.purchase_fcp_pending":
    "Purchase FCP-ST is unknown or has not been accounted for in the cost.",
  "operation.ipiPending": "IPI treatment pending",
  "operation.issue.purchase_st_status_pending":
    "Confirm purchase ST: invoice withholding or prior ST on an internal purchase.",
  "operation.commercialSummary": "Commercial summary",
  "operation.closedSalePrice": "Entered sale price, including invoice ST/FCP when applicable.",
  "operation.showFiscalDetails": "View taxes, credits and calculation details",
  "operation.unitExtended": "Unit price × quantity",
  "operation.distributorIpi": "No new reseller IPI charge",
  "calcTrace.step.BASE_SELECTED": "Base cost selected",
  "calcTrace.step.RULE_SELECTED": "Rule selected",
  "calcTrace.step.RULE_NOT_SELECTED": "Rule not found",
  "calcTrace.step.TAX_EXEMPT": "Tax exempt",
  "calcTrace.step.TAX_EXCLUDED": "Not stated by this rule",
  "calcTrace.step.IPI_CALCULATED": "IPI calculated",
  "calcTrace.step.ICMS_ST_CALCULATED": "ICMS-ST calculated",
  "calcTrace.step.ICMS_ST_MVA_ADJUSTMENT": "MVA adjustment",
  "calcTrace.step.ICMS_ST_NOT_APPLICABLE": "ICMS-ST does not apply",
  "calcTrace.step.ICMS_STANDARD_CALCULATED": "Own ICMS calculated",
  "calcTrace.step.PIS_CALCULATED": "PIS calculated",
  "calcTrace.step.COFINS_CALCULATED": "COFINS calculated",
  "calcTrace.step.ISS_CALCULATED": "ISS calculated",
  "calcTrace.step.OPERATIONAL_COST_CALCULATED": "Operational cost calculated",
  "calcTrace.step.COMMERCIAL_FEE_CALCULATED": "Commercial fee calculated",
  "calcTrace.step.OPERATIONAL_COST_NOT_CONFIGURED": "Operational cost not configured",
  "calcTrace.step.COMMERCIAL_FEE_NOT_CONFIGURED": "Commercial fee not configured",
  "calcTrace.step.TOTAL_CALCULATED": "Fiscal landed cost calculated",
  "calcTrace.step.FCP_CALCULATED": "FCP calculated",
  "calcTrace.step.FCP_NOT_APPLICABLE": "FCP does not apply",
  "calcTrace.step.FCP_NOT_TRACKED": "FCP not tracked",
  "calcTrace.step.PIS_COFINS_RATE_SELECTED": "PIS/COFINS rates selected",
  "calcTrace.step.PIS_COFINS_NOT_TRACKED": "PIS/COFINS not tracked",
  "calcTrace.step.SALE_PRICE_CALCULATED": "Sale price calculated",
  "calcTrace.step.PIS_ON_SALE_CALCULATED": "PIS on the sale calculated",
  "calcTrace.step.COFINS_ON_SALE_CALCULATED": "COFINS on the sale calculated",
  "calcTrace.step.MARGIN_CALCULATED": "Margin calculated",
  "calcTrace.step.NET_SALE_PRICE_CALCULATED": "Net-margin sale price calculated",
  "calcTrace.step.NET_SALE_LEG_INVALID": "Sale leg invalid",
  "calcTrace.step.NET_MARGIN_UNREACHABLE": "Net margin unreachable",
  "calcTrace.step.PURCHASE_OWN_ICMS_CALCULATED": "Purchase own ICMS calculated",
  "calcTrace.step.PURCHASE_OWN_ICMS_NOT_TRACKED": "Purchase own ICMS not tracked",
  "calcTrace.step.PURCHASE_PIS_COFINS_CALCULATED": "Purchase PIS/COFINS calculated",
  "calcTrace.step.PURCHASE_PIS_COFINS_NOT_TRACKED": "Purchase PIS/COFINS not tracked",
  "calcTrace.step.TR_SALE_PRICE_CALCULATED": "Sale price (cost + TR) calculated",
  "calcTrace.step.TR_SALE_LEG_CALCULATED": "Sale leg (cost + TR) calculated",
  "calcTrace.step.TR_SALE_IMPORTED_INTERSTATE_RATE":
    "Imported goods interstate rate on the TR sale (4%)",
  "calcTrace.step.NET_SALE_IMPORTED_INTERSTATE_RATE":
    "Imported goods interstate rate on the net-margin sale (4%)",
  "calcTrace.step.ICMS_IMPORTED_INTERSTATE_RATE": "Imported goods interstate rate (4%)",
  "calcTrace.step.ICMS_GENERAL_RULE_APPLIED": "General ICMS rule applied",
  "calcTrace.step.ICMS_DESTINATION_ST_DERIVED": "Destination ICMS-ST derived",
  "calcTrace.step.ICMS_ST_FCP_IN_ALQ_INTRA": "FECP inside the internal rate of the adjusted MVA",
  "calcTrace.step.ICMS_ST_SENDER_WITHHOLDING": "ST withheld by the sender",
  "calcTrace.step.PURCHASE_OWN_ICMS_STATUTORY_RATE": "Statutory interstate rate of the own ICMS",
  "calcTrace.step.RESALE_PURCHASE_CALCULATED": "Resale purchase calculated",
  "calcTrace.step.RESALE_SALE_CALCULATED": "Resale sale calculated",
  "calcTrace.step.RESALE_MARGIN_CALCULATED": "Resale margin calculated",
  "calcTrace.step.RESALE_MARGIN_PENDING": "Resale margin pending",
  "calcTrace.step.PIS_COFINS_PROFILE_RESOLVED": "PIS/COFINS profile resolved",
  "calcTrace.result.NOT_TRACKED": "not tracked",
  "calcTrace.result.NOT_CONFIGURED": "not configured",
  "calcTrace.result.NOT_CALCULATED": "not calculated",
  "calcTrace.result.NOT_PRICED": "not priced",
  "lotOps.fixedInput": "Fixed route configured for the file",
  "lotOps.inferredBySheet": "Inferred by the sheet",
  "lotOps.editedInput": "Corrected value; in the file: {value}",
  "lotOps.finding": "Finding",
  "lotOps.missingFields": "Missing fields",
  "lotOps.detailDescription": "Results, coverage and the fiscal memory of every row.",
  "lotOps.today": "Today’s operations",
  "lotOps.live": "Updates automatically",
  "lotOps.lotsToday": "Lots today",
  "lotOps.rowsCalculated": "Rows calculated",
  "lotOps.rowsReview": "Rows in review",
  "lotOps.taxRecorded": "Recorded tax",
  "lotOps.researchRunning": "Research running",
  "lotOps.summaryScope":
    "All {count} lots today. Calculated values × quantity; scenarios are independent alternatives.",
  "lotOps.summaryLimited": "More lots exist in this period.",
  "lotOps.upload": "Upload spreadsheets",
  "lotOps.scenarios.one": "1 scenario from this workbook",
  "lotOps.scenarios.other": "{count} scenarios from one workbook",
  "lotOps.independentScenarios": "Alternatives; do not add them together",
  "lotOps.open": "Open",
  "lotOps.export": "Export CSV",
  "lotOps.exportExcel": "Download commercial Excel",
  "lotOps.exportLimit": "Export limited to 20,000 rows.",
  "lotOps.recalculateHelp": "Open record and choose a new ruleset to recalculate",
  "lotOps.actions": "Actions",
  "lotOps.eta": "~{minutes} min remaining",
  "lotOps.etaWaiting": "Estimating time remaining",
  "lotOps.dynamic": "Route per row",
  "lotOps.allRoutes": "All routes",
  "lotOps.excluded": "Excluded rows",
  "lotOps.totalIpi": "Total IPI",
  "lotOps.totalSt": "Total ICMS-ST",
  "lotOps.totalLanded": "Total landed cost",
  "lotOps.coverage": "Coverage",
  "lotOps.quantityTotals": "Quantity-weighted amounts; calculated rows only.",
  "lotStory.title": "From purchase to price",
  "lotStory.basis": "Lot values weighted by quantity · {rows} of {total} rows calculated",
  "lotStory.loading": "Adding up the lot rows…",
  "lotStory.purchase": "Purchase cost",
  "lotStory.purchaseTaxes": "Purchase taxes",
  "lotStory.otherTaxes": "other taxes {value}",
  "lotStory.landed": "Landed cost",
  "lotStory.sale": "Sale price",
  "lotStory.margin": "Net margin",
  "lotStory.notPriced": "Not calculated",
  "lotStory.onSale": "On the sale:",
  "lotStory.pisCofinsUntracked": "PIS/COFINS not tracked for this regime",
  "lotStory.credits": "credits {value}",
  "lotStory.saleSt": "ICMS-ST/FCP-ST on the sale invoices {value}",
  "lotStory.invoices.title": "Purchase vs sale invoices:",
  "lotStory.invoices.body": "purchase {purchase} · sale {sale} · gross difference {difference}",
  "lotStory.invoices.pisCofinsNet": "PIS/COFINS payable (sale − purchase credit) {value}",
  "lotStory.invoices.discounted":
    "With the sheet discount (display only, does not change the tax base): Final buyer value {saleFinal} ({saleDiscount}) · Final seller value {purchaseFinal} ({purchaseDiscount}) · net difference {net}",
  "lotStory.invoices.discount.with": "discount {pct} · {cell}",
  "lotStory.invoices.discount.none": "no discount",
  "lotStory.invoices.discount.hint":
    "Commercial discount read from the sheet. If it is unconditional (on the invoice), it reduces the ICMS and PIS/COFINS base; that needs owner confirmation, so here it only appears in the totals.",
  "lotStory.priceHint":
    "To see the sale price, PIS/COFINS on the sale and the margin, use Recalculate lot and pick a Sale price method.",
  "lotStory.notTracked": "not tracked",
  "lotStory.column.pis": "PIS on sale",
  "lotStory.column.cofins": "COFINS on sale",
  "lotStory.column.icmsSale": "ICMS on sale",
  "lotStory.column.saleSt": "ICMS-ST/FCP-ST on sale",
  "lotStory.column.saleStHint": "ICMS-ST + FCP-ST on the sale invoice (workbook column AU).",
  "lotStory.column.saleStFcpUntracked": "FCP-ST not tracked",
  "lotStory.column.buyerInvoice": "Buyer invoice",
  "lotStory.done": "Lot calculated",
  "lotStory.doneReview": "Lot calculated with rows to review",
  "lotStory.rows.one": "{count} row",
  "lotStory.rows.other": "{count} rows",
  "lotStory.in": "in {duration}",
  "lotStory.seconds": "{count} s",
  "lotStory.minutesSeconds": "{minutes} min {seconds} s",
  "lotStory.calculated": "{count} calculated",
  "lotStory.toReview": "{count} to review",
  "lotStory.excluded": "{count} excluded",
  "lotStory.coverage": "coverage today {value}",
  "lotStory.coverageStale":
    "Current published rule coverage includes {covered} rows; this record calculated {calculated}. Recalculation still checks the operation’s fiscal qualification.",
  "lotStory.rules": "rules {version}",
  "lotStory.date": "tax date {date}",
  "lotStory.next.title": "Next steps",
  "lotStory.next.export": "Download commercial Excel",
  "lotStory.next.exportBody": "Every row, with taxes, price, PIS/COFINS and the rule behind each.",
  "lotStory.next.share": "Copy lot link",
  "lotStory.next.shareBody":
    "So a colleague with access opens this same result, with its pinned record.",
  "lotStory.next.review.one": "Review {count} row",
  "lotStory.next.review.other": "Review {count} rows",
  "lotStory.next.reviewBody":
    "Filters the table to the rows that need review, with the reason for each.",
  "lotStory.next.research.one": "Research {count} gap",
  "lotStory.next.research.other": "Research {count} gaps",
  "lotStory.next.researchBody":
    "Route and NCM pairs with no published rule: the agent looks for web evidence to review.",
  "lotStory.linkCopied": "Lot link copied",
  "lotStory.linkManual": "Copy the lot link",
  "lotStory.row.title": "This row's story",
  "lotStory.row.base": "Cost",
  "lotStory.row.otherTaxes": "Other taxes",
  "lotStory.row.icmsSale": "ICMS on sale",
  "lotStory.row.credits": "Credits",
  "lotStory.row.costBasis": "Landed cost (price basis)",
  "lotStory.row.onSale": "On the sale, per unit",
  "lotStory.row.notPriced":
    "Price and margin not calculated: the lot ran without a Sale price method.",
  "lotStory.row.unusable":
    "This row has no usable amounts: no value is shown until the review is resolved.",
  "lotStory.compare.match": "Same",
  "lotStory.compare.difference": "Different",
  "lotStory.compare.pending": "Not calculated",
  "lotStory.compare.allMatch": "· all the same as the file",
  "lotStory.compare.differs": "· {count} difference(s) from the file",
  "lotStory.outside.title": "Outside the landed cost:",
  "lotStory.outside.ownIcms": "purchase own ICMS {value}",
  "lotStory.outside.pisCofins": "purchase PIS/COFINS (outside the ICMS base) {value} · {treatment}",
  "lotStory.outside.treatment.CREDIT": "credit (non-cumulative)",
  "lotStory.outside.treatment.INFORMATIONAL": "information (no credit in this regime)",
  "lotStory.outside.treatment.MIXED": "credit or information, by each row's regime",
  "lotStory.outside.pisCofinsUntracked":
    "purchase PIS/COFINS not tracked: choose the PIS/COFINS regime when you recalculate the lot",
  "lotStory.outside.untrackedRows.one": "{count} row without a PIS/COFINS regime",
  "lotStory.outside.untrackedRows.other": "{count} rows without a PIS/COFINS regime",
  "lotStory.outside.burdenNeeded.one":
    "Rule needed: {count} internal-route row has no base reduction stated by its rule. The own ICMS used the nominal rate; if a reduction applies (e.g. RICMS/SP Annex II art. 39), it must be published in the rule.",
  "lotStory.outside.burdenNeeded.other":
    "Rule needed: {count} internal-route rows have no base reduction stated by their rule. The own ICMS used the nominal rate; if a reduction applies (e.g. RICMS/SP Annex II art. 39), it must be published in the rule.",
  "lotStory.row.outside": "Outside the landed cost (not added to the cost)",
  "lotStory.row.ownIcms": "Purchase own ICMS",
  "lotStory.row.notInCost": "not in the cost",
  "lotStory.row.buyerInvoice":
    "Buyer's sale invoice = {price} + ICMS-ST {st} + FCP-ST {fcp} = {total}",
  "lotStory.row.ownIcmsFormula": "{base} × {rate}",
  "lotStory.row.ownIcmsReduced": "reduced base {base} × {nominal} = {rate} burden · {reference}",
  "lotStory.row.pisCofins": "Purchase PIS/COFINS (outside the ICMS base)",
  "lotStory.row.pisCofinsFormula": "({base} − own ICMS {icms}) × {rate}",
  "lotStory.row.pisCofinsCredit": "credit (non-cumulative)",
  "lotStory.row.pisCofinsInfo": "information",
  "lotStory.row.pisCofinsUntracked": "not tracked: choose the lot's PIS/COFINS regime",
  "lotStory.row.burdenNeeded":
    "Rule needed: this internal route's rule states no base reduction; the own ICMS used the nominal rate.",
  "lotStory.row.ownIcmsStatutory":
    "Statutory interstate rate of the own ICMS (purchase without ST): {reference}.",
  "lotStory.row.burdenExpired":
    "The rule's effective burden is outside its validity on this date; the own ICMS used the nominal rate.",
  "lotOps.partialTotals": "Partial subtotal: outstanding rows are excluded.",
  "lotOps.byNcm": "Tax by NCM",
  "lotOps.byRoute": "Tax by route",
  "lotOps.reviewReasons": "What needs review",
  "lotOps.fixHint": "Select a reason to see affected rows.",
  "lotOps.fixCost": "Correct the file’s cost or mapping",
  "lotOps.fixClassification": "Review NCM, CEST and classification",
  "lotOps.fixProfile": "Confirm the treatment from the product and recalculate",
  "lotOps.fixRule": "Research and review the rule; publish before recalculating",
  "lotOps.rowCount": "{count} rows",
  "lotOps.rowCountCalculated": "{calculated} of {count} rows calculated",
  "lotOps.resultCount": "{count} results",
  "lotOps.waitingResults": "Results appear as chunks finish.",
  "lotOps.unavailable": "Value unavailable",
  "lotOps.research": "Fiscal research for this spreadsheet",
  "lotOps.webUnverified":
    "Research collects candidate evidence. Research verification and rule publication are separate steps; their respective states appear below.",
  "lotOps.allResearch": "View research",
  "lotOps.noResearch": "No linked research. Use “Search with agent” to investigate gaps.",
  "lotOps.noGaps": "No coverage gaps in this ruleset.",
  "lotOps.rowResearch": "Research for this row",
  "lotOps.sourceRow": "File row {row}",
  "lotOps.sourceUnavailable": "Source coordinates were not recorded for this lot.",
  "lotOps.ruleUnavailable": "No deterministic rule matched this row.",
  "lotOps.anyOrigin": "The rule accepts any origin; its destination defines scope.",
  "lotOps.stepInputs": "Inputs and precision of each step",
  "lotOps.compare": "Compare with workbook values",
  "lotOps.fileValue": "Workbook",
  "lotOps.calculatedValue": "Calculated",
  "lotOps.noComparison": "No comparison columns were mapped in this workbook.",
  "lotOps.tableHint": "Per-unit amounts · open a row for the calculation tape",
  "lotOps.inTape": "View tape",
  "lotOps.warning.short": "Warning",
  "lotOps.warning.coverageNeedsReview":
    "Review rule {rule}: it states an interstate ICMS rate of {stated} for any origin, but Res. SF 22/89 sets {expected} for this route. Amounts are unchanged.",
  "lotOps.warningRows": "Calculated with warning",
  "lotOps.group.base": "Base",
  "lotOps.group.ipi": "IPI",
  "lotOps.group.own": "Own ICMS",
  "lotOps.group.st": "ICMS-ST",
  "lotOps.group.landedAmount": "Fiscal cost (BRL)",
  "lotOps.stBaseAmount": "ST base (BRL)",
  "lotOps.group.landed": "Landed / unit",
  "lotOps.group.workbookCost": "Cost as in the workbook",
  "lotOps.workbookCostFormula": "Goods + IPI + ST",
  "lotOps.workbookCostHint":
    "As in the workbook (column AQ): products + IPI + ICMS-ST. Does not add own ICMS. The engine's landed cost adds own ICMS when there is no ST (owner decision pending).",
  "lotOps.importedOrigin": "Imported · {origin}",
  "lotOps.group.purchasePisCofins": "Purchase PIS/COFINS",
  "lotOps.purchasePisCofinsHint":
    "Purchase PIS/COFINS outside the ICMS base: (cost − own ICMS) × rate. Not in the cost.",
  "lotOps.group.issues": "Issues",
  "lotOps.quantity": "Qty.",
  "lotOps.rate": "Rate",
  "lotOps.perUnitBrl": "BRL / unit",
  "lotOps.mva": "MVA original → adjusted",
  "lotOps.stBase": "ST base / unit",
  "lotOps.openRow": "Open calculation tape for {item}",
  "lotOps.search": "Search item, SKU or NCM",
  "lotOps.filter.status": "All statuses",
  "lotOps.filter.route": "All routes",
  "lotOps.filter.ncm": "All NCMs",
  "lotOps.filter.issue": "All issues",
  "lotOps.clearFilters": "Clear filters",
  "lotOps.disconnected": "Updates interrupted. Showing the last confirmed state.",
  "lotOps.scenario": "Fiscal scenario",
  "lotOps.routeUnrecorded": "Route mode not recorded",
  "lotOps.pinnedRecord": "Pinned record",
  "lotOps.queueTitle": "File queue",
  "lotOps.queueHint": "Confirm each workbook’s sheets in sequence. Submitted lots keep running.",
  "lotOps.queueMore": "Drop more spreadsheets here or choose files",
  "lotOps.nextFile": "Configure next file",
  "lotOps.nextFileUncalculated":
    "This file has not been calculated yet: if you move on, it stays imported in Lots, without a calculation.",
  "lotOps.queuePosition": "File {current} of {total}",
  "lotOps.queueWaiting": "Queued",
  "lotOps.queueActive": "Configuring",
  "lotOps.queueDone": "Sheets confirmed",
  "lotOps.queueSkip": "Skip file",
  "lotOps.followLots": "Follow all lots",

  "calculatorFocus.back": "Back",
  "calculatorFocus.announce": "Calculator mode. Press Escape to go back.",
  "calculatorUi.memoryPermission":
    "Detailed calculation memory is unavailable for this role. Ask an operator with calculation access.",
  "calculatorUi.currencyHint": "Currency: Brazilian reais (BRL).",
  "calculatorUi.origin.entered": "Entered",
  "calculatorUi.origin.published": "Published rule",
  "calculatorUi.origin.calculated": "Calculated",
  "calculatorUi.origin.pending": "Pending",
  "calculatorUi.origin.finding": "Evidence — awaiting review",
  "calculatorUi.origin.treatment": "Published treatment",
  "calculatorUi.status.covered": "Covered",
  "calculatorUi.status.missing": "Missing rule",
  "calculatorUi.status.stale": "Outside validity",
  "calculatorUi.status.researching": "Researching",
  "calculatorUi.status.unchecked": "Unchecked",
  "calculatorUi.status.review": "Review required",
  "calculatorUi.why": "Why this value? {label}",
  "calculatorUi.date": "Calculation date",
  "calculatorUi.selected": "Selected ruleset",
  "calculatorUi.pinned": "Calculated with",
  "calculatorUi.viewMemory": "View calculation memory",
  "calculatorUi.memory": "Calculation memory",
  "calculatorUi.purchasePisCredit": "PIS credit · purchase",
  "calculatorUi.purchaseCofinsCredit": "COFINS credit · purchase",
  "calculatorUi.memoryHint":
    "Recorded inputs and values, in reading order. Original audit values remain in the details.",
  "calculatorUi.result.empty": "Awaiting inputs",
  "calculatorUi.result.loading": "Calculating…",
  "calculatorUi.result.unavailable": "Value unavailable",
  "calculatorUi.individual.empty":
    "Enter product, route and cost to calculate with published rules.",
  "calculatorUi.individual.definition": "Fiscal cost per unit",
  "calculatorUi.operation.definition": "Net tax burden of the operation",
  "calculatorUi.unit": "BRL per unit",
  "calculatorUi.operation.unit": "BRL · operation",
  "calculatorUi.unitQuantity": "Unit calculation · quantity {quantity}",
  "calculatorUi.inputTitle": "Scenario inputs",
  "calculatorUi.context": "Calculation context",
  "calculatorUi.scope":
    "Scope: values resolved by the engine. Untracked families do not mean zero.",
  "calculatorUi.operation.scope":
    "PIS/COFINS and pricing outside this calculation. IBS/CBS and ISS excluded.",
  "calculatorUi.operation.empty": "Enter product, both routes, and purchase and sale values.",
  "calculatorUi.operation.example": "Load example",
  "calculatorUi.operation.exampleLoaded": "Example loaded · review the inputs before calculating.",
  "calculatorUi.operation.routeRequired": "Select valid supplier, center and customer states.",
  "calculatorUi.operation.active": "Select a published ruleset for the operation.",
  "calculatorUi.operation.unsaved": "Operation simulation · this is not a saved record.",
  "calculatorUi.previous": "Previous result — inputs changed",
  "calculatorUi.completed": "Calculation complete. Review the result below.",
  "calculatorUi.goResult": "Go to result",
  "calculatorUi.blocked": "Outstanding issues prevent a complete result. Review the reasons below.",
  "calculatorUi.taxSubtotal": "Tax subtotal: {value}",
  "calculatorUi.formulaUnavailable":
    "Formula not supplied in this record. Open the full calculation memory.",
  "calculatorUi.sourceUnavailable": "Legal basis not supplied in this record",
  "calculatorUi.sourceRelationship":
    "Record sources. A step relationship appears only when supplied by the engine.",
  "calculatorUi.sources": "Rules and sources ({count})",
  "calculatorUi.canonical": "Canonical value",
  "calculatorUi.notCovered": "Not stated · not a zero rate",
  "calculatorUi.openRule": "Open applied rule",
  "calculatorUi.presentationOrder":
    "Reading order: goods → ICMS → PIS/COFINS base → IPI → MVA/ST → acquisition. Values and original audit trace are preserved.",
  "calculatorUi.rule": "Applied rule",
  "calculatorUi.precision": "Precision and rounding",
  "calculatorUi.precisionUnavailable": "Intermediate precision not supplied in this record.",
  "calculatorUi.numberLabel": "{label} · {unit} · Brazilian reais",
  "calculatorUi.tape.empty":
    "Calculation memory will be available after calculation. No rate has been assumed.",
  "calculatorUi.tape.loading": "Loading the record’s calculation memory…",
  "calculatorUi.tape.blocked": "Fiscal memory unavailable while the result requires review.",
  "calculatorUi.tape.error": "Could not load calculation memory. Try again.",
  "calculatorUi.export.record": "Reproducible record with inputs, version and calculation memory.",
  "calculatorUi.export.partial":
    "Includes outstanding issues; unavailable values remain identified.",
  "calculatorUi.export.simulation": "Export simulation (JSON)",
  "calculatorUi.diff.title": "Revision comparison",
  "calculatorUi.diff.field": "Field",
  "calculatorUi.diff.before": "Before",
  "calculatorUi.diff.after": "After",
  "calculatorUi.diff.delta": "Absolute delta",
  "calculatorUi.mode.individual": "Individual",
  "calculatorUi.mode.workbook": "Spreadsheet",
  "calculatorUi.mode.operation": "Purchase and sale",
  "calculatorUi.mode.choose": "Which calculation should I use?",
  "calculatorUi.mode.individualHint": "One product and one route: check the cost including taxes.",
  "calculatorUi.mode.operationHint":
    "Purchase and resale: compare cash flow, earnings and sale price.",
  "calculatorUi.mode.workbookHint":
    "Multiple products: upload a spreadsheet and track the batches.",
  "operation.form.cestInvalid": "Enter all 7 CEST digits or leave it blank.",
  "operation.design.routeSupplier": "Supplier",
  "operation.design.routeCenter": "Center",
  "operation.design.routeCustomer": "Customer",
  "operation.design.reviewDetails": "What needs review",
  "operation.design.metricsTitle": "Sales, contribution and margin",
  "operation.design.purchaseTitle": "Purchase and product",
  "operation.design.saleTitle": "Sale and pricing",
  "operation.design.expensesTitle": "Expenses for this operation",
  "operation.design.declaredSummary": "Input summary",
  "operation.design.declaredOnly": "Declared values · no result yet",
  "operation.design.toCalculate": "To be calculated",
  "operation.design.resultTitle": "Operation result",
  "operation.design.resultSubtitle":
    "Cash flow, earnings and taxes from the same calculation. Review pending items before deciding.",
  "operation.design.contextDetails": "Operation data and pricing detail",
  "operation.design.saleTotal": "Sale · total excluding pass-through ST",
  "operation.design.earningsBasis": "P&L basis · after declared expenses",
  "operation.design.statementTitle": "How the result is formed",
  "operation.form.title": "Simulate your purchase and sale",
  "operation.form.intro": "Enter the product, what you buy and who you will resell it to.",
  "operation.form.required": "Required",
  "operation.form.requiredHint": "* Required fields. Missing fiscal data may require review.",
  "operation.form.product": "Product",
  "operation.form.classification": "CEST and goods origin",
  "operation.form.classificationHint":
    "Use the invoice classification. It may be needed to resolve the rules; missing data does not mean exemption.",
  "operation.form.purchaseHint": "From the supplier to the distribution center.",
  "operation.form.saleHint": "From the distribution center to your customer.",
  "operation.form.unitHint": "Value per unit. Quantity applies to both purchase and sale.",
  "operation.form.totalHint": "Total operation value. It is not multiplied by quantity.",
  "operation.form.invoiceSt": "Purchase invoice ST",
  "operation.form.declared": "Declared amount",
  "operation.form.priceGoal": "How do you want to set the sale price?",
  "operation.form.knownPrice": "I already have a price",
  "operation.form.knownPriceHint": "Enter the value to simulate cash flow and earnings.",
  "operation.form.findPrice": "Calculate a price for me",
  "operation.form.findPriceHint": "Set a NET contribution or a TR share of the sale price.",
  "operation.form.federalPending": "Regime not declared · result may be partial",
  "operation.form.nextHint":
    "The simulation shows cash flow and P&L. Fiscal issues remain visible.",
  "operation.form.submit": "Simulate purchase and sale",
  "operation.form.needExample": "Need an example?",
  "operation.form.resultHint":
    "Complete the inputs above and simulate to compare cash flow and P&L. Fiscal detail will be available to inspect.",
  "operation.form.fixFields": "Review the highlighted fields before simulating.",
  "operation.form.purchaseRequired": "Enter a valid purchase value.",
  "operation.form.saleRequired": "Enter a valid sale price.",
  "operation.form.retainedInvalid":
    "Enter the invoice ST in reais with up to two decimals, or leave it blank.",
  "calculatorUi.description": "Product, route and published rules in a traceable calculation.",
  "calculatorUi.recent.retry": "Try loading again",
  "calculatorUi.recent.review": "{count} items await fiscal review",

  "legacy.batch.exportJson": "Export memory (JSON)",
  "legacy.batch.exportCsv": "Export all rows (CSV)",
  "legacy.batch.onlyReview": "Only rows needing review ({count})",
  "legacy.batch.noReview": "No rows need review in this file.",
  "legacy.breakdown": "Tax and cost breakdown",
  "legacy.pricing": "Sale and payment",
  "legacy.resultEmpty":
    "Complete the operation and calculate to inspect price, costs, taxes and margin.",
  "workspace.operationsTitle": "Fiscal operations",
  "workspace.researchTitle": "Agent research",
  "review.savedResult": "Open saved result",
  "review.progress": "{calculated} calculated · {review} to review",
  "evidence.empty.prepareResearch": "Prepare research for this NCM",
  "evidence.empty.researchHint":
    "No documents match these filters. Open research with this NCM, then choose sources and review the reason before starting.",
  "recalculateLot.action": "Recalculate lot",
  "recalculateLot.body":
    "Create a new calculation for the {count} saved items dated {date}, preserving any input corrections. The previous calculation stays available.",
  "recalculateLot.previousVersion": "Original version",
  "recalculateLot.nextVersion": "New published version",
  "recalculateLot.noVersion": "Publish a different ruleset version before recalculating this lot.",
  "recalculateLot.incomplete":
    "The saved lot inputs are incomplete or inconsistent. Refresh the results before trying again.",
  "recalculateLot.submit": "Create new calculation",
  "recalculateLot.created": "New lot calculation created.",
  "recalculateLot.originalEngine": "Original engine",
  "recalculateLot.engineBefore": "before {version}",
  "recalculateLot.unchanged.title": "Nothing changed since the original calculation.",
  "recalculateLot.unchanged.body":
    "With the rules ({ruleset}) and the current engine ({engine}), every row would come out exactly as in the original calculation, so a new calculation would change nothing.",
  "recalculateLot.how": "How to recalculate",
  "recalculateLot.engine.title":
    "Recalculate with the current engine ({engine}) and the same rules ({ruleset})",
  "recalculateLot.engine.hint":
    "Same items, same corrections and same ruleset version; only the engine changes.",
  "recalculateLot.changes.title": "What changed since the original calculation",
  "recalculateLot.change.IMPORTED_PURCHASE_LINES":
    "Align imported interstate purchase ICMS and the PIS/COFINS credit base with the applied 4% rate (engine 1.19.0). Creates a new record; the original is preserved.",
  "recalculateLot.change.PURCHASE_LINES":
    "1.6.0 · Own ICMS and purchase PIS/COFINS outside the base",
  "recalculateLot.change.GENERAL_RULE":
    "1.7.0 · General rule (no ST) for routes without a published rule",
  "recalculateLot.change.PIS_COFINS_PROFILES":
    "1.8.0 · PIS/COFINS profiles (single-stage, zero rate, pending)",
  "recalculateLot.change.ROUTE_RULES":
    "1.9.0 · ST derived from the destination rule and general rule on the sale",
  "recalculateLot.change.ST_ADJUSTMENTS":
    "1.10.0 · RJ FECP in the adjusted MVA, ST withheld by the PR→SP sender and statutory interstate own ICMS on the purchase",
  "recalculateLot.change.PIS_COFINS_CATALOG_V2":
    "1.13.0 · Expanded statutory PIS/COFINS catalog for fuels and mineral water; products needing confirmation stay in review",
  "recalculateLot.ruleset.title": "Use another published ruleset version",
  "recalculateLot.ruleset.hint": "The items are recalculated with the chosen version.",
  "recalculateLot.reason": "Reason (optional)",
  "recalculateLot.reasonPlaceholder": "E.g. check the lot with engine 1.13.0",
  "recalculateLot.audit":
    "Who recalculated, the reason and the link to the original lot are recorded.",
  "pisCofinsConfirm.open": "Confirm profile in bulk ({count})",
  "pisCofinsConfirm.title": "Confirm PIS/COFINS profile",
  "pisCofinsConfirm.intro":
    "Engine 1.8.0 does not apply a zero rate when the NCM alone cannot prove the law's condition, nor pick a list when the NCM is on more than one. Check what the file says about each product and confirm the treatment of each NCM. The confirmation is recorded with who, when and why; the original calculation does not change.",
  "pisCofinsConfirm.loading": "Reading the {count} items waiting for a confirmation…",
  "pisCofinsConfirm.notConfirmable":
    "These items cannot be confirmed in bulk: the catalog takes no confirmation for their NCMs (beverages or outside the catalog). Open an item to see why.",
  "pisCofinsConfirm.recalculate": "Recalculate with the confirmations",
  "pisCofinsConfirm.list.STANDARD": "Standard regime (CST 01)",
  "pisCofinsConfirm.list.ZERO_RATE": "Zero rate (CST 06)",
  "pisCofinsConfirm.list.SINGLE_STAGE": "Single-stage (CST 04)",
  "pisCofinsConfirm.list.BEVERAGE": "Single-stage / cold beverages",
  "pisCofinsConfirm.lists.note":
    "NCM on more than one list. The engine does not choose: say which one applies to these products. Nothing is pre-selected.",
  "pisCofinsConfirm.lists.hint.STANDARD":
    "The product fits none of the lists below: PIS/COFINS at the regime's rates, with a purchase credit when non-cumulative.",
  "pisCofinsConfirm.lists.hint.ZERO_RATE":
    "The product meets this list's condition: CST 06 on the sale and no purchase credit (CST 73).",
  "pisCofinsConfirm.lists.hint.SINGLE_STAGE":
    "Single-stage resale: CST 04 on the sale and no purchase credit (CST 70).",
  "pisCofinsConfirm.lists.hint.BEVERAGE":
    "Not available: the engine does not calculate the cold-beverage regime (art. 25 rates for the wholesaler). If this is the list, the item stays in review.",
  "pisCofinsConfirm.lists.noSuggestion":
    "No suggestion for an NCM on more than one list: choose after checking the product.",
  "pisCofinsConfirm.row.open": "Confirm PIS/COFINS profile",
  "pisCofinsConfirm.row.confirmed":
    "Confirmed: {treatment}. It goes into the next calculation of this file; this calculation stays as it was made.",
  "pisCofinsConfirm.row.otherReasons":
    "Only the PIS/COFINS profile is confirmed; the other review reasons remain.",
  "pisCofinsConfirm.treatment.STANDARD": "Standard regime",
  "pisCofinsConfirm.treatment.ZERO_RATE": "Zero rate",
  "pisCofinsConfirm.treatment.SINGLE_STAGE_RESALE": "Single-stage (resale)",
  "pisCofinsConfirm.qualifier.not": "not {subject}",
  "pisCofinsConfirm.qualifier.is": "is {subject}",
  "pisCofinsConfirm.qualifier.outside": "outside the condition",
  "pisCofinsConfirm.qualifier.meets": "meets the condition",
  "pisCofinsConfirm.subject.ORDINARY_BREAD": "ordinary bread",
  "pisCofinsConfirm.subject.BREAD_PREMIX": "ordinary bread premix",
  "pisCofinsConfirm.reason.suggested":
    "{treatment}: the file's descriptions name {terms} (NCM {ncm}).",
  "pisCofinsConfirm.reason.default":
    "{treatment}: checked against the file's descriptions (NCM {ncm}).",
  "pisCofinsConfirm.done.one": "{count} item confirmed: {treatment}",
  "pisCofinsConfirm.done.other": "{count} items confirmed: {treatment}",
  "pisCofinsConfirm.recorded":
    "Recorded with your user, the date and the reason. It goes into the next calculation of this file.",
  "pisCofinsConfirm.groupTitle.one": "Confirm the profile of {count} item with NCM {ncm}",
  "pisCofinsConfirm.groupTitle.other": "Confirm the profile of {count} items with NCM {ncm}",
  "pisCofinsConfirm.alreadyConfirmed": "{count} already confirmed in this file",
  "pisCofinsConfirm.items": "Products, as the file describes them",
  "pisCofinsConfirm.selected": "{selected} of {total} selected",
  "pisCofinsConfirm.noDescription": "No description in the file",
  "pisCofinsConfirm.treatmentLabel": "Treatment",
  "pisCofinsConfirm.hint.STANDARD":
    "CST 01: debit on the sale and credit on the purchase at the regime's rates.",
  "pisCofinsConfirm.hint.ZERO_RATE":
    "CST 06: no debit on the sale and no credit on the purchase. Only valid when the catalog backs the NCM.",
  "pisCofinsConfirm.hint.SINGLE_STAGE_RESALE":
    "CST 04: single-stage resale, no debit and no credit. Only valid when the catalog backs the NCM.",
  "pisCofinsConfirm.suggested":
    "Pre-selected because the descriptions name {terms}. Check and confirm: nothing is applied without your click.",
  "pisCofinsConfirm.noSuggestion": "Choose the treatment after checking the descriptions.",
  "pisCofinsConfirm.reason": "Reason",
  "pisCofinsConfirm.audit":
    "Who confirmed, when and the reason are recorded. The original calculation does not change.",
  "pisCofinsConfirm.submit.one": "Confirm {treatment} for {count} item",
  "pisCofinsConfirm.submit.other": "Confirm {treatment} for {count} items",
  "pisCofinsConfirm.choose": "Choose the treatment",
  "pisCofinsConfirm.band.title.one": "{count} item with a confirmed PIS/COFINS profile",
  "pisCofinsConfirm.band.title.other": "{count} items with a confirmed PIS/COFINS profile",
  "pisCofinsConfirm.band.body":
    "The confirmations go into the next calculation of this file; this calculation stays as it was made.",
  "recalculateLot.change.INPUT_CORRECTIONS": "PIS/COFINS profile confirmed on {count} items",
  "recalculateLot.reasonConfirmations": "Recalculate with the PIS/COFINS profile confirmations",
  "calculateSheets.action.one": "Calculate {count} sheet",
  "calculateSheets.action.other": "Calculate {count} sheets",
  "calculateSheets.body":
    "Sheets of {file} imported and never calculated. Each sheet uses the rows, mapping and premises stored at import; there is no need to upload the file again.",
  "calculateSheets.bodyNoFile":
    "Each sheet uses the rows, mapping and premises stored at import; there is no need to upload the file again.",
  "calculateSheets.listLabel": "Sheets to calculate",
  "calculateSheets.reading": "Reading the sheets and each one's premises from the stored file…",
  "calculateSheets.readingShort": "Reading premises…",
  "calculateSheets.rows": "{count} valid items",
  "calculateSheets.excluded": "{count} with errors left out",
  "calculateSheets.premise.tr": "TR {value}",
  "calculateSheets.premise.saleUf": "Sold to {value}",
  "calculateSheets.premise.regime.NON_CUMULATIVE": "Non-cumulative PIS/COFINS",
  "calculateSheets.premise.regime.CUMULATIVE": "Cumulative PIS/COFINS",
  "calculateSheets.premise.regime.UNKNOWN": "Regime not stated",
  "calculateSheets.noPremises":
    "The sheet states no sale premises: it calculates the purchase taxes, without a sale price.",
  "calculateSheets.unread":
    "The file is too large to read its premises here: it calculates without a sale price, or adjust this sheet.",
  "calculateSheets.blockedPricing":
    "The sheet's TR has no valid sale UF. Adjust this sheet to calculate it.",
  "calculateSheets.adjust": "Adjust premises",
  "calculateSheets.sending": "Creating calculation…",
  "calculateSheets.state.created": "Calculating",
  "calculateSheets.state.failed": "Not started",
  "calculateSheets.state.existing": "Already calculated",
  "calculateSheets.running": "Creating {done} of {total}…",
  "calculateSheets.retry": "Retry the failed ones",
  "calculateSheets.once":
    "Each sheet is calculated only once: a second click, another tab or a colleague get the same calculation, never a duplicate.",
  "calculateSheets.created": "Sheet calculations created.",
  "calculateSheets.bandLabel": "Imported sheets not calculated",
  "calculateSheets.band.title.one": "{count} sheet of this file has not been calculated yet",
  "calculateSheets.band.title.other": "{count} sheets of this file have not been calculated yet",
  "calculateSheets.band.body.one":
    "{sheets} was imported with its own premises. Calculate it without uploading the file again.",
  "calculateSheets.band.body.other":
    "{sheets} were imported with each sheet's premises. Calculate them without uploading the file again.",
  "calculateUpload.action": "Calculate",
  "calculateUpload.help": "Calculate from the file already imported, without uploading it again",
  "calculateUpload.title": "Calculate imported sheet",
  "calculateUpload.body":
    "{count} valid items from {file} · {sheet}. It uses the file and the mapping stored at import; there is no need to upload it again.",
  "calculateUpload.excluded": "{count} rows with errors stay out, as at import.",
  "calculateUpload.readingPremises": "Reading the sheet's premises…",
  "calculateUpload.premisesNone":
    "The sheet states no sale premises (TR, sale UF, regime). Choose them below to see the sale price.",
  "calculateUpload.premisesUnavailable":
    "The sheet's premises (TR, sale UF, regime) could not be read again. Check them before calculating.",
  "calculateUpload.submit": "Calculate {count} items",
  "calculateUpload.created": "Lot calculation created.",
  "recalculation.basis.CURRENT_ENGINE": "Recalculated with the current engine and the same rules",
  "recalculation.basis.RULESET": "Recalculated with another ruleset version",
  "recalculation.compare.title": "Comparison with the original calculation",
  "recalculation.compare.openOriginal": "Open original calculation",
  "recalculation.compare.rules": "Rules {before} → {after}",
  "recalculation.compare.engine": "Engine {before} → {after}",
  "recalculation.compare.byYou": "by you",
  "recalculation.compare.by": "by {id}",
  "recalculation.compare.reviewToCalculated": "Left review",
  "recalculation.compare.calculatedToReview": "Went to review",
  "recalculation.compare.stillReview": "Still in review",
  "recalculation.compare.taxDelta": "Tax change",
  "recalculation.compare.newlyCalculatedTax": "Taxes of the items that left review",
  "recalculation.compare.note":
    "The change only compares items calculated in both runs ({changed} changed): {before} → {after}, purchase taxes × quantity.",
  "recalculation.compare.pinned": "The original calculation stays pinned and was not changed.",
  "recalculation.compare.unmatched":
    "{count} items have no match in the other calculation and were left out of the comparison.",
  "proposals.create.advancedEditingHint":
    "JSON edits are submitted as entered and do not update the guided form. The rule type stays fixed while editing JSON. Evidence references are attached automatically.",
  "proposals.create.discardJson": "Discard JSON edits and return to guided form",
  "proposals.create.editJsonHint":
    "Continue from the completed guided draft. The guided form will be preserved separately.",
  "proposals.create.startJsonHint":
    "The guided draft is incomplete. Start a separate JSON template; partial guided fields will remain available when you return, but will not be copied into the template.",
  "proposals.create.editJson": "Edit completed draft as JSON",
  "proposals.create.startJson": "Start separate JSON template",
  "proposals.create.unlinkEvidence": "Remove",
  "proposals.create.linkedEvidence": "Linked evidence",
  "proposals.create.linkedEvidenceHint":
    "Attach the approved documents supporting the rate, route, validity and exceptions. Up to 100 documents; the server checks their approval again when creating the proposal.",
  "proposals.create.removeEvidence": "Remove evidence: {title}",
  "proposals.create.addEvidence": "Add approved evidence",
  "proposals.create.changeEvidence": "Change evidence",
  "proposals.create.selectEvidence": "Choose approved evidence to support the new proposal.",
  "proposals.create.noEvidence":
    "No approved evidence matches. Review evidence before creating a proposal.",
  "proposals.create.type.fiscal": "Fiscal parameter",
  "proposals.create.type.commercial": "Commercial fee",
  "proposals.create.type.operational": "Operational cost",
  "proposals.create.business.scope": "Applicability",
  "proposals.create.business.scopeHint":
    "Optional exact identifiers. Blank fields apply to all values in the organization.",
  "proposals.create.business.category": "Category",
  "proposals.create.business.paymentMethod": "Payment method",
  "proposals.create.business.transactionType": "Transaction type",
  "proposals.create.business.takeRate": "Commercial fee (%)",
  "proposals.create.business.percentHint":
    "Enter a percentage from 0 to 100. For example, 10 means 10%.",
  "proposals.create.business.logistics": "Logistics",
  "proposals.create.business.freight": "Freight",
  "proposals.create.business.other": "Other costs",
  "proposals.create.business.formula": "Calculation method",
  "proposals.create.business.fixed": "Fixed amount (BRL)",
  "proposals.create.business.percent": "Percentage (%)",
  "proposals.create.business.amount": "Amount (BRL)",
  "proposals.create.business.amountHint":
    "Enter a nonnegative amount in reais. Enter 0 explicitly if this cost does not apply.",
  "review.nextTitle": "What to do next",
  "review.correctInput": "Check the product, route and fiscal cost, then run a new calculation.",
  "review.fiscalHelp":
    "Review the matching fiscal rules. Missing or conflicting rates need a reviewed proposal and a published version.",
  "review.costHelp":
    "Review commercial fees and operational costs. Approving a proposal alone does not change a saved calculation.",
  "review.immutableHelp":
    "New calculations keep the original result and its ruleset version unchanged.",
  "review.correctRecalculate": "Correct and recalculate",
  "review.inspectRules": "Review matching rules",
  "review.proposeRule": "Create rule proposal",
  "review.loadSource": "Load the original input to prepare a new calculation.",
  "review.sourceUnavailable":
    "The original input is unavailable for this record. Start a new calculation with verified product and cost data.",
  "review.sourceLoaded":
    "Original input loaded from version {version}. Review the fields and choose the published version for the new calculation. Nothing is submitted automatically.",
  "review.amountsPending": "Amounts and rates are not final while this item requires review.",
  "review.taskHelp":
    "This file needs review. Open an affected row to check its data or matching rules. After publishing corrections, create a new calculation; retrying an interrupted task does not apply new rules.",
  "lotMap.empty": "No readable sheets were found. Choose another XLSX or CSV file.",
  "lotMap.inspecting": "Reading sheets and suggesting columns…",
  "lotMap.requiredCost": "Select the goods cost column to continue.",
  "lotMap.duplicateColumns":
    "Each source column can be assigned to only one field. Review the highlighted selections.",
  "lotMap.originalHelp":
    "This download is the original uploaded file. Corrections in the calculation do not change it.",
  "lotMap.downloading": "Preparing download…",
  "ui.results.new": "New calculation",
  "legacy.batch.template": "Download CSV template (v8)",
  "legacy.batch.supplier": "Supplier defaults",
  "legacy.batch.error":
    "Check the 26-column template, numeric values, operation date and file limits (5 MB / 500 rows).",
  "legacy.batch.count": "{count} rows processed",
  "legacy.batch.product": "Product / NCM",
  "legacy.batch.result": "Status and issues",
  "legacy.batch.sale": "Sale price",
  "legacy.batch.margin": "Margin",
  "rules.detail.fiscal.title": "Published fiscal parameters",
  "rules.detail.fiscal.ipi": "IPI",
  "rules.detail.fiscal.internal": "Internal ICMS",
  "rules.detail.fiscal.interstate": "Interstate ICMS",
  "rules.detail.fiscal.st": "Declared ICMS-ST",
  "rules.detail.fiscal.mva": "Original MVA",
  "rules.detail.fiscal.effectiveRate": "Effective burden (MVA ALQ_intra)",
  "rules.detail.fiscal.effectiveUntil": "until {date}",
  "rules.detail.fiscal.adjustedMva": "Published adjusted MVA",
  "rules.detail.fiscal.missing": "Not provided",
  "rules.detail.fiscal.yes": "Applicable",
  "rules.detail.fiscal.no": "Not applicable",
  "rules.detail.fiscal.ipiTreatment": "IPI treatment",
  "rules.detail.fiscal.icmsTreatment": "ICMS treatment",
  "rules.detail.fiscal.mode": "ICMS mode",
  "rules.detail.fiscal.reduction": "Base reduction (%)",
  "rules.detail.fiscal.conditions": "Additional conditions",
  "rules.detail.fiscal.payment": "Payment method",
  "rules.detail.fiscal.transaction": "Transaction type",
  "rules.detail.fiscal.TAXED": "Taxed",
  "rules.detail.fiscal.EXEMPT": "Exempt",
  "rules.detail.fiscal.EXCLUDED": "Excluded",
  "rules.detail.fiscal.unspecified.one": "{count} parameter not provided",
  "rules.detail.fiscal.unspecified.other": "{count} parameters not provided",
  "rules.detail.fiscal.empty": "No parameters provided",
  "rules.detail.sourceNote": "Source note (original text)",

  "workspace.calculationDescription":
    "Review taxes and issues for each product. Open the explanation to see how the result was calculated.",
  "workspace.calculationSummary": "Calculation summary",

  "workspace.savedCommercialNote":
    "This saved record retains commercial input issues from its original workflow. They are not additional fields requested by the fiscal calculator.",
  "lookup.routeFilter": "Filter by route and date",
  "lookup.routeOptional": "Optional · look up the NCM before defining an operation",
  "lookup.dateMissing": "Date not set",
  "lookup.useToday": "Use today’s date",
  "lookup.clearRoute": "Clear route and date",
  "lookup.refineMissing": "To filter for an operation, complete: {fields}.",
  "lookup.officialClassification": "View official classification",
  "workspace.individualVersionUnavailable": "Select an available ruleset version to simulate.",

  "workspace.addEvidence": "Research a question",
  "workspace.unitCostSum": "Sum of unit costs (without quantities)",
  "workspace.openFile": "Open the upload",
  "workspace.reviews": "Reviews",
  "workspace.documents": "Documents",
  "workspace.discovery": "Research a question",
  "workspace.publications": "Publications",
  "workspace.individual": "Individual",
  "workspace.spreadsheet": "Spreadsheet",
  "workspace.optionalColumns": "More columns (optional)",
  "workspace.fileType": "Choose Excel (.xlsx, .xlsm), CSV or delimited TXT.",
  "workspace.newProposal": "Choose evidence to create a proposal",
  "lookup.registered": "Published rules for this NCM",
  "lookup.registeredNote":
    "These rules are linked to the NCM. Route and date help narrow the lookup.",
  "lookup.noRegistered": "No published rules for this NCM",
  "lookup.noRegisteredBody":
    "The base has no published rules for this code yet. This does not mean zero tax. Look up another product or browse the rule library.",
  "ui.filters.remove": "Remove filter: {filter}",
  "ui.results.search": "Search saved calculations",
  "ui.upload.pending": "Reading your file…",
  "customer.results.action": "View results",
  "lookup.title": "Look up rules",
  "workspace.operation": "Purchase + sale",
  "operation.title": "Resale operation taxes",
  "operation.body":
    "Purchase from the supplier to BackChannel and sale to the customer, using each leg’s published rules. Enter a fixed price, TR or contribution target through SP.",
  "operation.route": "Operation route",
  "operation.supplier": "Supplier (UF)",
  "operation.supplierHint": "Issues the purchase invoice",
  "operation.center": "BackChannel centre (UF)",
  "operation.centerHint": "Where BCH receives and resells",
  "operation.customer": "Customer (UF)",
  "operation.customerHint": "Sale destination",
  "operation.cest": "CEST (optional)",
  "operation.goodsOrigin": "Goods origin (CST)",
  "operation.goodsOrigin.hint":
    "Origins 1, 2, 3 and 8 use the 4% interstate rate (Senate Resolution 13/2012). Not informed: the rule's rate applies.",
  "operation.goodsOrigin.notInformed": "Not informed",
  "operation.goodsOrigin.option.0": "National",
  "operation.goodsOrigin.option.1": "Foreign, direct import",
  "operation.goodsOrigin.option.2": "Foreign, acquired on the domestic market",
  "operation.goodsOrigin.option.3": "National, import content above 40% and up to 70%",
  "operation.goodsOrigin.option.4": "National, basic productive processes (PPB)",
  "operation.goodsOrigin.option.5": "National, import content up to 40%",
  "operation.goodsOrigin.option.6": "Foreign, direct import with no national equivalent (CAMEX)",
  "operation.goodsOrigin.option.7": "Foreign, domestic market with no national equivalent (CAMEX)",
  "operation.goodsOrigin.option.8": "National, import content above 70%",
  "operation.purchaseValue": "Purchase before IPI and ST (BRL)",
  "operation.saleValue": "Sale before pass-through ST (BRL)",
  "operation.buyer": "Customer",
  "operation.taxpayer": "ICMS taxpayer (resale)",
  "operation.finalConsumer": "Final consumer (DIFAL)",
  "operation.calculate": "Calculate operation",
  "operation.calculating": "Calculating…",
  "operation.invalid.ncm": "Enter an 8-digit NCM.",
  "operation.invalid.values": "Enter valid purchase and sale values.",
  "operation.result": "Tax result",
  "operation.ruleset": "Ruleset",
  "operation.status.ok": "Calculated from published rules",
  "operation.status.review": "Needs review",
  "operation.issue.purchase_rule_missing": "No published ICMS rule for the purchase",
  "operation.issue.purchase_rule_ambiguous": "Ambiguous purchase rule (add the CEST)",
  "operation.issue.sale_rule_missing": "No published ICMS rule for the sale",
  "operation.issue.sale_rule_ambiguous": "Ambiguous sale rule (add the CEST)",
  "operation.issue.purchase_value_missing": "Purchase value missing",
  "operation.issue.sale_value_missing": "Sale value missing",
  "operation.mode.ST": "ICMS-ST",
  "operation.mode.STANDARD": "Standard ICMS",
  "operation.mode.NOT_TAXED": "ICMS not taxed",
  "operation.mode.none": "No published rule",
  "operation.purchase": "Purchase",
  "operation.sale": "Sale",
  "operation.totals": "Operation tax load",
  "operation.totalsHint": "What BCH pays and what it passes on",
  "operation.stClosed": "ST paid on entry: internal sale carries no ICMS",
  "operation.line.value": "Invoice value",
  "operation.line.ownIcms": "Own ICMS",
  "operation.line.mva": "ST base · MVA",
  "operation.line.stEntry": "Entry ICMS-ST",
  "operation.line.stRetained": "ICMS-ST retained on the supplier invoice",
  "operation.line.fcpDifal": "Destination FCP on the DIFAL",
  "operation.stRetained": "ICMS-ST retained on the purchase invoice (optional)",
  "operation.stRetainedHint":
    "Total retained on the invoice, including when entering unit prices. Declare 0 if the invoice states zero; leave blank if unstated. The declaration does not establish collection responsibility.",
  "operation.line.acquisition": "Acquisition cost",
  "operation.line.credit": "ICMS credit",
  "operation.line.saleValue": "Sale value",
  "operation.line.stSale": "ICMS-ST charged to customer",
  "operation.line.invoice": "Sale invoice total",
  "operation.line.taxesInCost": "Taxes in cost (IPI + entry ST)",
  "operation.line.icmsPayable": "ICMS payable (sale − credit)",
  "operation.line.carryover": "Credit carried forward",
  "operation.line.salePaid": "Paid by BCH on the sale (ICMS + DIFAL)",
  "operation.line.stCustomer": "ST passed to the customer",
  "operation.line.burden": "Net tax burden",
  "operation.note.pisCofins":
    "PIS/COFINS are outside this base (regime not yet accredited); never shown as zero.",
  "operation.note.pricing":
    "Price, markup and commercial margin stay in the commercial calculator (R-15).",
  "operation.note.reimbursement":
    "Entry ST with an interstate sale: ST reimbursement is not modelled here.",
  "operation.note.senderWithholding": "ST withheld by the sender ({agreement})",
  "operation.stReview.title": "Purchase ST collection",
  "operation.stReview.route": "Purchase route",
  "operation.stReview.source": "Amount provenance",
  "operation.stReview.source.prior":
    "Prior ST declared as included in the price; no new charge declared.",
  "operation.stReview.source.invoice":
    "Amount declared as withheld on the supplier invoice; this does not confirm a protocol.",
  "operation.stReview.source.calculated":
    "Amount calculated in the returned result; this provenance does not establish who collects.",
  "operation.stReview.source.pending": "Provenance pending review.",
  "operation.stReview.responsibility": "Collection responsibility",
  "operation.stReview.responsibility.pending": "Responsibility not resolved.",
  "operation.stReview.responsibility.prior": "No new collection declared for this purchase.",
  "operation.stReview.responsibility.sender":
    "Sender, under the returned agreement for this route.",
  "operation.stReview.responsibility.general":
    "No ST calculated for this purchase under the returned general rule.",
  "operation.stReview.responsibility.rule":
    "The selected rule does not calculate ST for this purchase.",
  "operation.stReview.stAmount": "ICMS-ST stated in the result",
  "operation.stReview.fcpAmount": "Purchase FCP/FECP-ST",
  "operation.stReview.fcpUndetailed": "No separate breakdown",
  "operation.stReview.conflict":
    "The returned declarations and fiscal metadata conflict. Review the invoice, route and rule before using the amounts or assigning collection responsibility.",
  "operation.stReview.review":
    "This result requires review. Amounts and responsibility remain pending; any agreement below is returned information, not confirmation of applied withholding.",
  "operation.stReview.anticipation":
    "Recipient anticipation still requires review. Missing sender information does not establish who pays or prove that ST does not apply.",
  "operation.stReview.returnedAgreement": "Returned agreement, for review:",
  "operation.stReview.returnedBasis": "Returned legal basis:",
  "operation.stReview.generalBasis": "Returned general-rule basis:",
  "operation.stReview.cashScope":
    "Acquisition-cost breakdown, with no additional payment or split between supplier and tax authority. ST recovery and payment timing are not assessed.",
  "operation.note.statutoryOwnIcms": "Interstate own ICMS at the statutory rate ({basis})",
  "operation.note.generalRule": "Purchase calculated with the general rule (no ST)",
  "operation.note.saleGeneralRule": "Sale calculated with the general rule (no ST)",
  "operation.note.destinationStRule": "Purchase calculated with the derived destination rule",
  "operation.statutory.sf2289": "Res. SF 22/89",
  "operation.statutory.sf132012": "Res. SF 13/2012",
  "operation.evidence": "Evidence and rules ({count})",
  "rulesets.policy.label": "Calculation policy",
  "rulesets.policy.title": "Draft calculation policy",
  "rulesets.policy.body":
    "The policy rides with the next publication and never changes earlier calculations. tax-family-v1: a rule answers only for the taxes it states; the TIPI row supplies IPI and never a zero ICMS. tax-family-v2: the same, and the adjusted MVA uses the rule's effective burden as ALQ intra, unrounded.",
  "rulesets.policy.legacy-v1": "whole rule; stored adjusted MVA allowed",
  "rulesets.policy.derived-mva-v1": "whole rule; derived adjusted MVA",
  "rulesets.policy.tax-family-v1": "per tax: route ICMS, TIPI IPI; derived MVA",
  "rulesets.policy.tax-family-v2": "per tax; MVA adjusted with the effective burden (ALQ_intra)",
  "rulesets.policy.reason": "Reason for the change",
  "rulesets.policy.reasonRequired": "Write at least 10 characters.",
  "rulesets.policy.saved": "Policy updated on the draft.",
  "rulesets.policy.save": "Save policy",
  "gaps.tab": "Gaps",
  "gaps.title": "Coverage gaps",
  "gaps.description":
    "NCM codes and routes calculations could not find in the published ruleset. Research official sources with AI and record what was checked.",
  "gaps.summary": "Gap summary",
  "gaps.how":
    "Research uses Vertex AI with Google Search over reviewed official sources only (CONFAZ plus origin and destination SEFAZ). Results become evidence for review; nothing is published.",
  "gaps.researchNext": "Research the top 5 with AI",
  "gaps.researching": "Queuing research…",
  "gaps.researchNext.done":
    "{queued} research task(s) queued; {failed} without an available source.",
  "gaps.error": "That did not complete. Try again.",
  "gaps.filter": "Filter by status",
  "gaps.filter.all": "All",
  "gaps.status.OPEN": "Open",
  "gaps.status.RESEARCHING": "Researching",
  "gaps.status.NO_RULE_FOUND": "Checked, no ST",
  "gaps.status.RULE_FOUND": "Rule found",
  "gaps.status.RESOLVED": "Resolved",
  "gaps.status.DISMISSED": "Dismissed",
  "gaps.state.OPEN": "Open",
  "gaps.state.RESEARCHING": "Researching",
  "gaps.state.NO_RULE_FOUND": "Checked, no ST",
  "gaps.state.RULE_FOUND": "Rule found",
  "gaps.state.RESOLVED": "Resolved",
  "gaps.state.DISMISSED": "Dismissed",
  "gaps.list": "Gaps by priority",
  "gaps.empty": "No gaps in this filter",
  "gaps.emptyBody":
    "When a calculation finds no rule for an NCM and route, the gap appears here automatically.",
  "gaps.honesty":
    "A gap is not a zero tax: calculations stay in review until a rule is published. “Checked, no ST” records the check with evidence.",
  "gaps.occurrences": "Items",
  "gaps.calculations": "Calculations",
  "gaps.lastSeen": "Last seen",
  "gaps.researchTask": "Research: {status}",
  "gaps.research.QUEUED": "queued",
  "gaps.research.RUNNING": "running",
  "gaps.research.WAITING_REVIEW": "awaiting review",
  "gaps.research.SUCCEEDED": "done",
  "gaps.research.FAILED": "failed",
  "gaps.research.CANCELLED": "cancelled",
  "gaps.outcome.NO_ST_FOUND": "No ST found",
  "gaps.outcome.RULE_FOUND": "Rule found",
  "gaps.outcome.INCONCLUSIVE": "Inconclusive",
  "gaps.outcomeHint.NO_ST_FOUND":
    "Official sources reviewed; no ST in force for this NCM and route. A valid answer.",
  "gaps.outcomeHint.RULE_FOUND":
    "An act is in force (MVA, CEST). Create the rule proposal from the evidence.",
  "gaps.outcomeHint.INCONCLUSIVE": "Not conclusive yet; the gap stays open for another pass.",
  "gaps.research": "Research with AI",
  "gaps.recordFinding": "Record finding",
  "gaps.proposeStandard": "Create proposal",
  "gaps.dismiss": "Dismiss",
  "gaps.finding.title": "Finding · NCM {ncm} · {route}",
  "gaps.finding.outcome": "What was checked",
  "gaps.finding.note": "Reviewer note",
  "gaps.finding.notePlaceholder":
    "E.g. ICMS Protocol 97/10 reviewed; NCM not in the annex for SP→RJ.",
  "gaps.finding.cited": "Research evidence",
  "gaps.finding.evidenceIds": "Other evidence (IDs)",
  "gaps.finding.checkedAsOf": "Checked as of",
  "gaps.finding.noteRequired": "Write at least 10 characters.",
  "gaps.finding.evidenceRequired": "Cite at least one official evidence record.",
  "gaps.finding.evidenceInvalid": "Invalid evidence IDs.",
  "gaps.finding.boundary":
    "Recording a finding publishes nothing. Rules go through proposal, review and publication.",
  "gaps.finding.save": "Save finding",
  "gaps.dismissTitle": "Dismiss gap · NCM {ncm}",
  "gaps.dismissReason": "Reason",
  "quick.description": "Enter the NCM, CEST or product. Origin and destination are optional.",
  "quick.searchBy": "Search by",
  "quick.mode.ncm": "Search by NCM",
  "quick.mode.cest": "Search by CEST",
  "quick.mode.product": "Search by product",
  "quick.hint.ncm":
    "Enter the eight NCM digits as in the TIPI. With fewer digits, pick the product from the list.",
  "quick.hint.cest": "Enter the CEST (e.g. 17.001.00) to see the NCM codes it covers.",
  "quick.hint.product":
    "Describe the product (e.g. chocolate, biscuit, hair dryer) and pick the NCM.",
  "quick.placeholder.ncm": "E.g. 1704.90.10",
  "quick.placeholder.cest": "E.g. 17.001.00",
  "quick.placeholder.product": "E.g. chocolate",
  "quick.anyState": "Any state",
  "quick.search": "Search",
  "quick.invalid.ncm": "Enter an NCM with 2 to 8 digits.",
  "quick.invalid.cest": "Enter a 7-digit CEST (e.g. 17.001.00).",
  "quick.invalid.product": "Describe the product to search.",
  "quick.inForceOn": "In force on",
  "quick.routeOptional": "Without origin and destination, every rule for the NCM is shown.",
  "quick.clear": "Clear search",
  "quick.start.title": "Start with the NCM",
  "quick.start.body":
    "You will see the published fiscal data: ICMS regime, MVA, rates, CEST, validity and legal basis.",
  "quick.start.try": "Try:",
  "quick.start.exampleLabel": "Look up NCM {ncm} from {origin} to {destination}",
  "quick.candidates.title": "Pick the product",
  "quick.candidates.body": "NCM catalog products for “{query}”.",
  "quick.cest.missing": "CEST not found",
  "quick.cest.missingBody": "Check the code in ICMS Agreement 142/18 or search by NCM.",
  "quick.cest.pick": "Pick an NCM covered by this CEST:",
  "quick.loadingCatalog": "Loading description…",
  "quick.internalSt.title": "Heads up:",
  "quick.internalSt.body": "this NCM has ST in the internal operation of {uf}.",
  "quick.internalSt.action": "View internal ST {uf} → {uf}",
  "quick.inForce.title": "Rules in force for this operation",
  "quick.outside.title": "Not in force on this date",
  "quick.other.title": "Other rules for this NCM",
  "quick.other.body": "Rules in force on other routes. Click a route to look it up.",
  "quick.more": "Showing the first {count} rules. See all in the",
  "quick.honesty":
    "Published rules in the active ruleset only. No rule is not an exemption; PIS/COFINS are outside this base.",
  "quick.none.title": "Not applicable.",
  "quick.none.route": "There are no published rules in force for {route}.",
  "quick.none.body":
    "This NCM has no published fiscal rule yet. That is not a zero tax: calculations go to review.",
  "quick.none.bodyOther":
    "This NCM has rules on other routes (below). For this route, calculations go to review.",
  "quick.regime.st": "ICMS-ST",
  "quick.regime.stOff": "ST not applicable",
  "quick.regime.standard": "Standard ICMS",
  "quick.regime.exempt": "ICMS not taxed",
  "quick.value.exempt": "Exempt",
  "quick.value.outside": "Outside this base",
  "quick.value.internalOp": "Internal operation",
  "quick.fact.regime": "Regime",
  "quick.fact.originalMva": "Original MVA",
  "quick.fact.adjustedMva": "Adjusted MVA",
  "quick.fact.derived": "derived",
  "quick.fact.internal": "Internal rate (destination)",
  "quick.fact.interstate": "Interstate rate",
  "quick.fact.reduction": "Base reduction",
  "quick.detail": "View detail",
  "quick.regime.ipiOnly": "IPI only (TIPI)",
  "quick.ipi.title": "National IPI (TIPI)",
  "quick.ipi.body":
    "National TIPI row: states only this NCM's IPI. ICMS comes from the route rules above.",
  "quick.gap.seen": "{count} calculation item(s) without a rule",
  "quick.gap.openResearch": "Open research",
  "quick.gap.all": "View gaps",
  "quick.pickRoute": "Several rules in force. Pick a route to see the full fiscal data.",
  "quick.validity": "Validity",
  "quick.legal": "Legal basis",
  "quick.useRoute": "Look up this route",
  "lookup.catalog": "NCM catalog",
  "lookup.library": "Rule library",
  "lookup.description": "Find a product or NCM and open its published rules.",
  "lookup.catalogNote": "The catalog identifies classification; it does not establish a tax rate.",
  "lookup.destinations": "Tax tools",
  "lookup.route": "Operation route",
  "lookup.origin": "Origin state",
  "lookup.destination": "Destination state",
  "lookup.swap": "Swap origin and destination",
  "lookup.internal": "Intrastate operation",
  "account.description": "Your profile, language and sign-in methods.",
  "account.section.profile": "Profile",
  "account.section.preferences": "Preferences",
  "account.section.passkeys": "Passkeys",
  "account.section.password": "Password",
  "account.profileManaged": "Your account details are managed by your administrator.",
  "account.passwordHelp":
    "Create a password or change your existing one using a secure link sent to your account email. You do not need a previous password to use this verified email flow.",
  "account.passwordAction": "Send password link",
  "account.passwordUnavailable":
    "Password email is available only when signed in to a connected account.",
  "account.title": "My account",
  "account.sections": "Account sections",
  "account.section.language": "Language",
  "account.section.profile.description": "Your name, email and access profile.",
  "account.section.language.description": "Language of the interface text.",
  "account.languageHint": "Applies immediately, without reloading the page.",
  "account.passwordSentTo": "The link will be sent to",
  "legacy.modeHelp":
    "Export your results before leaving this page; nothing is saved to the platform.",
  "legacy.switch": "Previous calculator",
  "legacy.switch.help":
    "Opens the previous calculator ({version}) from next.backchannel.ws. Fixed tables; published rules do not change.",
  "legacy.switch.helpActive": "Active. Press to return to published rules.",
  "legacy.title": "Previous calculator",
  "legacy.tabs.label": "Previous calculator tools",
  "legacy.engineTitle": "Previous calculator {version}",
  "legacy.provenance": "pinned {date} · commit {commit} · historical tables, not published rules",
  "legacy.routeLabel": "Route",
  "legacy.confirm.date": "Date",
  "legacy.drop.title": "Drop the previous calculator CSV (v8) here",
  "legacy.drop.limits": ".csv · 26 columns (v8) · up to 500 rows · 5 MB",
  "legacy.batch.foot":
    "Empty fields use the supplier defaults; invalid values require review. Export Excel as CSV first.",
  "legacy.batch.supplierFact": "{supplier} defaults",
  "legacy.batch.local": "Local calculation. Not saved as a platform result.",
  "legacy.batch.parsingNote":
    "This calculator reads “1.250,00” as one thousand two hundred fifty and accepts the CSV with the template's title row. The original app reads that number as 1.25 and may reject the title row; if results differ, check those fields first.",
  "legacy.batch.results": "CSV rows",
  "legacy.description":
    "Profit calculator from next.backchannel.ws, version {version}, with fixed tables: CMV, credits, ST, DIFAL, margin and intermediation. It neither uses nor changes published rules; results stay in this browser.",
  "legacy.operation": "Operation",
  "legacy.resale": "Purchase and resale",
  "legacy.intermediation": "Intermediation",
  "legacy.route": "Product and route",
  "legacy.legalDescription": "Legal product description",
  "legacy.costs": "Purchase costs",
  "legacy.options": "Fiscal evidence and payment",
  "legacy.quantityNote":
    "The previous calculator uses whole-row monetary amounts. Quantity only affects the boleto fee; it does not multiply cost or revenue.",
  "legacy.channel": "Payment channel",
  "legacy.inPerson": "In person",
  "legacy.brand": "Card brand",
  "legacy.installments": "Installments",
  "legacy.stProof": "Provide structured ST evidence",
  "legacy.compare": "Compare BCH SP / ES",
  "legacy.calculate": "Calculate with the previous calculator",
  "legacy.result": "Previous calculator result",
  "legacy.resultNote":
    "Calculated with the fixed tables of the previous calculator {version}. This is a compatibility result, not fiscal approval.",
  "legacy.review":
    "Review required. These inputs do not produce a complete calculation in the previous calculator.",
  "legacy.block.purchase": "Purchase",
  "legacy.block.sale": "Sale",
  "legacy.block.saleTaxes": "Sale taxes",
  "legacy.block.result": "Result",
  "legacy.block.service": "Service",
  "legacy.block.margin": "Margin",
  "legacy.marginSub": "margin {pct}",
  "legacy.cm1Sub": "CM1 / GMV {pct}",
  "legacy.compareTitle": "BCH SP × BCH ES",
  "legacy.export": "Export calculation memory (JSON)",
  "legacy.field.supplierUF": "Supplier state",
  "legacy.field.bchCenter": "BCH center",
  "legacy.field.customerUF": "Customer state",
  "legacy.field.purchasePurpose": "Purchase purpose",
  "legacy.field.supplierTotalInclTaxes": "Supplier invoice value (BRL)",
  "legacy.field.freight": "Purchase freight (BRL)",
  "legacy.field.insurance": "Insurance (BRL)",
  "legacy.field.otherExpenses": "Other purchase expenses (BRL)",
  "legacy.field.freightRevenue": "Freight charged to buyer (BRL)",
  "legacy.field.freightCost": "Delivery freight cost (BRL)",
  "legacy.field.logisticsCost": "Logistics cost (BRL)",
  "legacy.field.stValueFromSupplier": "ST on supplier invoice (BRL)",
  "legacy.field.boletoFeeFixed": "Boleto fee (BRL)",
  "legacy.field.markupPct": "Pricing percentage",
  "legacy.field.backchannelCommissionPct": "BCH commission",
  "legacy.field.quantity": "Quantity",
  "legacy.field.ipiBase": "IPI base",
  "legacy.field.isImported": "Imported goods",
  "legacy.field.isZFMSupplier": "Zona Franca de Manaus supplier",
  "legacy.field.customerIsIcmsTaxpayer": "Buyer is an ICMS taxpayer",
  "legacy.field.stAlreadyCollected": "Supplier already collected ST",
  "legacy.field.pricing_method": "Pricing method",
  "legacy.field.paymentMethod": "Payment method",
  "legacy.option.resale": "Resale",
  "legacy.option.own_use": "Own use",
  "legacy.option.fixed_asset": "Fixed asset",
  "legacy.option.manufacturing": "Manufacturing",
  "legacy.option.valor_com_imposto": "Including IPI",
  "legacy.option.valor_sem_imposto": "Excluding IPI",
  "legacy.option.gross_margin_on_purchase": "Gross margin on purchase",
  "legacy.option.markup_on_cost": "Markup on cost",
  "legacy.option.target_contribution_after_tax": "Target contribution after taxes",
  "legacy.option.credit_card": "Credit card",
  "legacy.option.boleto": "Boleto",
  "legacy.option.pix": "PIX",
  "legacy.service.gmv": "GMV (BRL)",
  "legacy.service.take": "Service fee (%)",
  "legacy.service.iss": "ISS (%)",
  "legacy.service.cost": "Operations cost (BRL)",
  "legacy.result.purchaseValue": "Purchase value",
  "legacy.result.totalCredits": "Total credits",
  "legacy.result.fiscalCMV": "Fiscal cost of goods",
  "legacy.result.entryAnticipation": "Entry anticipation",
  "legacy.result.merchandisePrice": "Merchandise price",
  "legacy.result.invoiceTotal": "Invoice total",
  "legacy.result.icmsST": "ICMS-ST",
  "legacy.result.fecpST": "FECP-ST",
  "legacy.result.difalOnSale": "DIFAL",
  "legacy.result.totalSaleTaxes": "Sale taxes",
  "legacy.result.paymentFees": "Payment fees",
  "legacy.result.marginValue": "Contribution",
  "legacy.serviceResult.serviceValue": "Service value",
  "legacy.serviceResult.iss": "ISS",
  "legacy.serviceResult.totalWithholding": "Withholding",
  "legacy.serviceResult.netCashToReceive": "Net receivable",
  "legacy.serviceResult.revenueTaxes": "Revenue taxes",
  "legacy.serviceResult.valueForMargin": "Value for margin",
  "legacy.serviceResult.operationsCost": "Operations cost",
  "lookup.product": "Product or NCM",
  "lookup.placeholder": "E.g. coffee, 0901 or 0901.21.00",
  "lookup.category": "Category · HS chapter",
  "lookup.allCategories": "All categories",
  "lookup.clear": "Clear product and category",
  "lookup.selected": "Selected product",
  "lookup.change": "Change product",
  "lookup.calculate": "Calculate this product",
  "lookup.descriptionColumn": "Description",
  "lookup.chapterColumn": "HS chapter",
  "common.nextPage": "Next page",
  "common.pageResults": "{count} on this page · {total} results",
  "lookup.results": "Catalog products",
  "lookup.noProducts": "No products found",
  "lookup.noProductsBody": "Try another term, NCM or chapter.",
  "lookup.candidates": "Published rule candidates",
  "lookup.conditions":
    "Matches by NCM, route and validity. CEST, regime and transaction conditions still need checking. Review the legal basis and complete the calculator inputs to determine the result.",
  "lookup.noRules": "No published rule for this lookup",
  "lookup.noRulesBody":
    "This does not mean zero tax. Coverage may be incomplete; consult the library and sources.",
  "lookup.unavailable": "Not provided",
  "lookup.version": "Version",
  "lotMap.help":
    "Select the sheet, header and columns. Declare whether each goods cost is a unit price or a line total. Sale prices are not converted automatically.",
  "lotMap.mesa.fields": "Fiscal fields",
  "lotMap.mesa.preview": "Preview · {count} rows after the header",
  "lotMap.mesa.column": "Column {index}",
  "lotMap.mesa.mapped": "Column {column} → {field}",
  "lotMap.mesa.required": "Required",
  "lotMap.confirmHint": "Stores the original file and reads every row. No row is dropped silently.",
  "lotMap.sheet": "Sheet",
  "lotMap.header": "Header row",
  "lotMap.unmapped": "Not assigned",
  "lotMap.decimal": "Number format",
  "lotMap.originUf": "Origin state when the row is blank",
  "lotMap.destinationUf": "Destination state when the row is blank",
  "lotMap.sample": "Sample values",
  "lotMap.comparisonHelp":
    "Optional comparison: map the per-unit amounts the file states. The engine recalculates using published rules. Differences up to R$ 0.01 count as equal. A match compares amounts; it does not approve an Excel formula. CSV does not retain Excel formulas.",
  "lotMap.field.expected_ipi": "Expected IPI per unit",
  "lotMap.field.expected_icms_st": "Expected ICMS-ST per unit",
  "lotMap.field.expected_tax_total": "Expected tax total per unit",
  "lotCompare.title": "Compare amounts from my file (optional)",
  "lotCompare.field": "Tax",
  "lotCompare.expected": "File amount / unit",
  "lotCompare.actual": "Engine amount / unit",
  "lotCompare.delta": "Engine minus file",
  "lotCompare.status": "Comparison",
  "lotCompare.match": "Amounts match",
  "lotCompare.difference": "Amount differs",
  "lotCompare.pending": "Awaiting valid calculation",
  "lotMap.cached":
    "Use cached formula values. They will not be recalculated; confirm the workbook was updated in Excel.",
  "lotMap.confirm": "Confirm and check coverage",
  "lotFlow.label": "Spreadsheet calculation steps",
  "lotFlow.stepOf": "Step {current} of {total}",
  "lotFlow.step.send": "Upload",
  "lotFlow.step.columns": "Review columns",
  "lotFlow.step.coverage": "Check coverage",
  "lotFlow.step.calculate": "Calculate",
  "lotFlow.step.results": "Results",
  "lotFlow.session.title": "Lots sent in this session",
  "lotFlow.session.hint.one": "It keeps calculating while you send another spreadsheet.",
  "lotFlow.session.hint.other": "They keep calculating while you send another spreadsheet.",
  "lotFlow.session.view": "See progress",
  "lotFlow.session.viewResult": "See result",
  "lotFlow.session.open": "Open record",
  "lotFlow.record.created": "Lot record created for tracking and audit.",
  "lotFlow.record.open": "View record and submitter",
  "lotFlow.session.another": "Send another spreadsheet",
  "lotFlow.session.count.one": "{count} lot from this session stays on this page",
  "lotFlow.session.count.other": "{count} lots from this session stay on this page",
  "lotFlow.reading.title": "Reading the spreadsheet",
  "lotFlow.reading.sheets": "Looking for sheets with a product list",
  "lotFlow.reading.header": "Finding the header row and the number format",
  "lotFlow.reading.columns": "Suggesting the NCM, cost, quantity and route columns",
  "lotFlow.detect.title": "What we found",
  "lotFlow.detect.body.one":
    "Sheet {sheet} · 1 product row. If something is wrong, adjust it below.",
  "lotFlow.detect.body.other":
    "Sheet {sheet} · {rows} product rows. If something is wrong, adjust it below.",
  "lotFlow.detect.ok": "Detected",
  "lotFlow.detect.check": "Check",
  "lotFlow.detect.sheets.one": "{count} sheet",
  "lotFlow.detect.sheets.other": "{count} sheets",
  "lotFlow.detect.lists.one": "{count} product list",
  "lotFlow.detect.lists.other": "{count} product lists",
  "lotFlow.detect.header": "Header on row {row}",
  "lotFlow.detect.decimal": "Numbers written as {format}, read from the values themselves",
  "lotFlow.detect.decimalDefault": "Numbers written as {format} (default: the values do not say)",
  "lotFlow.detect.routeFixed": "Single route",
  "lotFlow.detect.source.SHEET_NAME": "read from the sheet name",
  "lotFlow.detect.source.COLUMN": "read from the UF columns",
  "lotFlow.detect.source.HEADER_BLOCK": "read from the block above the header",
  "lotFlow.detect.source.PARAMETER_SHEET": "read from the parameters sheet",
  "lotFlow.detect.routeRows.one": "Route per row · {count} route in the file",
  "lotFlow.detect.routeRows.other": "Route per row · {count} routes in the file",
  "lotFlow.detect.routeMissing": "The route is missing: choose the origin and destination UF below",
  "lotFlow.detect.costMissing": "The unit tax cost column is missing: choose it under Tax fields",
  "lotFlow.detect.column": "{field} in {column}",
  "lotFlow.field.ncm": "NCM",
  "lotFlow.field.custo": "Cost",
  "lotFlow.field.quantidade": "Quantity",
  "lotFlow.confirm.title": "Summary before you confirm",
  "lotFlow.confirm.rows": "product rows",
  "lotFlow.confirm.repair": "rows with a suggested repair",
  "lotFlow.confirm.mended": "rows repaired",
  "lotFlow.confirm.open": "rows with pending inputs",
  "lotFlow.confirm.mini": "{rows} rows · {open} with pending inputs",
  "lotFlow.run.title": "Set up the calculation",
  "lotFlow.run.body":
    "Date, rules version and, if you want, the PIS/COFINS regime and the sale price. The rest comes from the spreadsheet.",
  "lotFlow.run.ready": "{count} rows ready to calculate.",
  "lotFlow.premises.title": "Premises read from the sheet, already filled in below:",
  "lotFlow.premises.tr": "Sale value with TR {value} ({cell})",
  "lotFlow.premises.saleUf": "Sale destination UF {value} ({cell}), ICMS taxpayer customer",
  "lotFlow.premises.regime": "PIS/COFINS regime {value} ({cell})",
  "lotFlow.premises.saleDiscount":
    "Sale commercial discount {value} ({cell}) · totals only, the tax base does not change",
  "lotFlow.premises.purchaseDiscount":
    "Purchase commercial discount {value} ({cell}) · totals only, the tax base does not change",
  "lotFlow.premises.changed": "changed by you",
  "lotFlow.premises.check":
    "These are the file's premises, not published rules: check them before calculating.",
  "lotMap.field.item_id": "Row identifier",
  "lotMap.field.sku": "SKU",
  "lotMap.field.category": "Category",
  "lotMap.field.marca": "Brand",
  "lotMap.field.familia": "Family",
  "lotMap.field.ean": "EAN",
  "lotMap.field.peso": "Weight",
  "lotMap.field.ncm": "NCM",
  "productFile.title": "Product in the file",
  "productFile.fact.description": "Description",
  "productFile.fact.category": "Category",
  "productFile.fact.brand": "Brand",
  "productFile.fact.family": "Family",
  "productFile.fact.ean": "EAN",
  "productFile.fact.weight": "Weight",
  "productFile.cellTitle": "{header}, cell {cell}",
  "productFile.cellTitlePlain": "cell {cell}",
  "lotMap.field.cest": "CEST",
  "lotMap.field.origem_mercadoria": "Goods origin (CST)",
  "lotMap.field.uf_origem": "Origin state",
  "lotMap.field.uf_destino": "Destination state",
  "lotMap.field.custo": "Goods cost (required)",
  "lotMap.field.quantidade": "Quantity",
  "lotMap.field.meio_pagamento": "Payment method",
  "lotMap.field.tipo_transacao": "Transaction type",

  "lotSim.permission": "Calculation execution permission is required to import and simulate.",
  "lotSim.retry.slow": "The server took too long to respond; trying again…",
  "lotSim.retry.network": "The connection dropped; trying again…",
  "lotSim.retry.action": "Try again",
  "lotSim.missingUpload": "Import a file before starting a task.",
  "lotSim.downloadOriginal": "Download original",
  "lotSim.title": "Tax calculator",
  "lotSim.subtitle": "Operations · Lot tax calculator · published rules",
  "lotSim.body": "Apply published rules to your list and inspect the breakdown of each tax.",
  "lotSim.input": "Prepare simulation",
  "lotSim.template": "Download CSV template",
  "lotSim.file": "Excel or CSV file · up to 5,000 rows per sheet and 25 MB",
  "lotSim.date": "Operation date",
  "lotSim.version": "Ruleset version",
  "lotSim.choose": "Select a published version",
  "lotSim.loading": "Processing…",
  "lotSim.noRules":
    "There are no published rules for simulation. Ask the tax owner to check the required coverage.",
  "lotSim.run": "Calculate lot",
  "lotSim.rows": "File rows",
  "lotSim.fix":
    "Rows with errors are left out of the simulation and listed below. Correct them in the file and import again to include them. No row is dropped silently.",
  "lotSim.row": "Row",
  "lotSim.cost": "Unit fiscal cost",
  "lotSim.result": "Result / issues",
  "lotSim.receipt": "Simulation receipt",
  "lotSim.trace": "Open calculation trace",
  "lotSim.export": "Export request and result",
  "lotSim.size": "The file limit is 25 MB.",
  "lotSim.runHint": "The task will be recorded with the selected version.",
  "lotSim.mode.label": "Calculator mode",
  "lotSim.mode.lote": "Lot Upload",
  "lotSim.mode.individual": "Individual Simulation",
  "lotSim.drop.title": "Drop your spreadsheets here",
  "lotSim.drop.active": "Release to read the spreadsheet",
  "lotSim.drop.limits": ".xlsx, .xlsm or .csv · up to 5,000 rows per sheet · 25 MB",
  "lotSim.drop.legacySteps": "How to fix it",
  "lotSim.drop.choose": "Choose files",
  "lotSim.drop.orOne": "or choose a file",
  "lotSim.drop.sending": "Sending {size} MB straight to storage…",
  "lotSim.upload.title": "Calculate from a spreadsheet",
  "lotSim.upload.body":
    "Upload an Excel or CSV file. We check its columns and published tax rules, and flag items that need review.",
  "lotSim.guide.title": "How the spreadsheet is processed",
  "lotSim.guide.files": "Several files at once, confirmed one after another",
  "lotSim.guide.sheets": "Every product sheet you choose becomes its own calculation",
  "lotSim.guide.route": "One fixed route, or a route per row from the UF columns",
  "lotSim.guide.numbers": "The number format, 1.234,56 or 1,234.56",
  "lotSim.guide.premises": "TR, sale UF and regime from the sheet header, offered as inputs",
  "lotSim.guide.repair": "“Repair spreadsheet” suggests fixes; you accept each one",
  "lotSim.rowsShown": "Showing {shown} of {total} rows",
  "lotSim.showMoreRows": "Show {count} more",
  "lotSim.showAllRows": "Show all {total}",
  "lotSim.drop.invalid": "This file could not be read",
  "lotSim.file.change": "Change file",
  "lotSim.file.facts.sheets": "{count} sheets",
  "lotSim.file.facts.rows": "{count} rows",
  "lotSim.file.facts.rowsRead": "{count} rows read",
  "lotSim.file.facts.columns": "{count} columns",
  "lotSim.file.facts.formulas": "{count} formulas",
  "lotSim.file.facts.invalid": "{count} rows with errors",
  "lotSim.file.facts.size": "{size} KB",
  "lotSim.file.facts.fiscalDate": "fiscal date {date}",
  "lotSim.file.noDrop": "No row was dropped silently.",
  "lotSim.run.blocked.rows": "No valid row to simulate. Correct the file and import it again.",
  "lotSim.run.excludedNote": "{count} rows with errors will be left out and listed below.",
  "lotSim.excluded.title": "{count} rows left out of the simulation",
  "lotSim.excluded.hint":
    "These rows have errors in the file. The valid rows are calculated; each excluded row is listed here with its sheet, row, column and reason, and in the exports.",
  "lotSim.status.excluded": "Left out",
  "lotSim.row.excluded": "Left out: {reason}",
  "lotSim.run.blocked.version": "Choose a published version.",
  "lotSim.run.blocked.date": "Set the operation date.",
  "lotSim.drop.or": "or choose several files",
  "lotSim.stepKicker": "STEP {n}",
  "lotSim.banner":
    "Cost may be per unit or a line total, as declared in base_valor. Taxes come from published rules.",
  "lotSim.clear": "Remove file",
  "lotLive.steps.label": "Reading steps",
  "lotLive.steps.sheets": "Looking for sheets",
  "lotLive.steps.header": "Header and format",
  "lotLive.steps.columns": "Suggesting columns",
  "lotLive.steps.state.complete": "complete",
  "lotLive.steps.state.running": "in progress",
  "lotLive.steps.state.waiting": "waiting",
  "lotLive.caption": "First rows · header in row {row}",
  "lotLive.headerTag": "Header",
  "lotLive.table.region": "Preview of the {sheet} sheet",
  "lotLive.table.rowNumber": "Row number",
  "lotLive.columns.title": "Recognized columns",
  "lotLive.columns.field": "{field} · {column}",
  "lotLive.columns.missing": "{field} not found",
  "lotLive.review": "Review columns",
  "lotLive.reviewNeeded": "Review columns",
  "lotLive.summary.decimal": "{format}",
  "lotLive.fixedRoute": "Route {origin} → {destination}",
  "lotLive.sheets.ready": "{count} sheets ready to calculate",
  "lotLive.premise.tr": "TR",
  "lotLive.premise.saleUf": "Sale UF",
  "lotLive.premise.regime": "PIS/COFINS",
  "lotLive.premise.saleDiscount": "Sale discount",
  "lotLive.premise.purchaseDiscount": "Purchase discount",
  "lotLive.premise.missing": "Not stated on this sheet",
  "lotLive.ignored.one": "{count} sheet ignored: {names}",
  "lotLive.ignored.other": "{count} sheets ignored: {names}",
  "lotLive.calculate.invalid": "Review the columns for {sheets} before calculating",
  "lotLive.calculate.choose": "Choose at least one sheet",
  "lotLive.autoInfo":
    "If the workbook already provides the route, supplier, and tax inputs, calculation starts automatically when this check finishes. Otherwise, review the columns and confirm; rows missing a rule or input stay in review.",
  "lotLive.announce.reading": "{file}: reading the spreadsheet",
  "lotLive.announce.header": "Header in row {row} · {count} columns recognized",
  "lotLive.announce.sheetsReady": "{count} sheets ready to calculate",
  "lotLive.format.notAccepted": "not accepted",
  "lotLive.format.saveAsXlsx": "Save as .xlsx",
  "lotLive.format.rule":
    "Accepted formats: .xlsx, .xlsm, .csv and UTF-8 delimited .txt. .xls (Excel 97-2003) is not accepted. Up to 5,000 rows per sheet and 25 MB.",
  "lotLive.format.limits": "up to 5,000 rows per sheet · 25 MB",
  "lotSim.metric.rows": "Rows",
  "lotSim.metric.calculated": "Calculated",
  "lotSim.metric.review": "Review",
  "reviewFix.title": "What is missing to calculate",
  "reviewFix.generalRuleRow": "General rule (no ST), not a published rule: {basis}.",
  "reviewFix.generalRule.one":
    "{count} row calculated by the general rule (no ST): Res. SF 22/89 rate (or verified internal rate), NCM proven outside ST.",
  "reviewFix.generalRule.other":
    "{count} rows calculated by the general rule (no ST): Res. SF 22/89 rate (or verified internal rate), NCM proven outside ST.",
  "reviewFix.destinationStRuleRow":
    "{label}: ST rule of the destination, published as {source}, with the Res. SF 22/89 interstate rate. {basis}.",
  "reviewFix.fcpInAlqIntraRow":
    "Destination FECP in the adjusted MVA: ALQ intra {alqIntra} ({internal} + FECP {fcp}). ICMS-ST {icmsSt} and FECP-ST {fcpSt}, on separate lines. {basis}.",
  "reviewFix.stCollectionRow":
    "ST withheld by the sender ({agreement}, {route}): ICMS-ST {amount}, FECP-ST {fcpAmount}, on the supplier invoice. {basis}.",
  "reviewFix.destinationStRule.one":
    "{count} row calculated with the ST rule derived from the destination's published rule (another origin, same MVA, statutory interstate rate).",
  "reviewFix.destinationStRule.other":
    "{count} rows calculated with the ST rule derived from the destination's published rule (another origin, same MVA, statutory interstate rate).",
  "compareFile.name.ipi": "IPI",
  "compareFile.name.icmsSt": "ICMS-ST",
  "compareFile.name.taxTotal": "total taxes",
  "compareFile.name.landed": "landed cost",
  "compareFile.name.ownIcms": "inbound ICMS",
  "compareFile.name.purchasePisCofins": "purchase PIS/COFINS",
  "compareFile.name.workbookCost": "workbook cost (prod. + IPI + ST)",
  "compareFile.name.salePrice": "sale price with TR",
  "compareFile.name.saleIcms": "own ICMS on the sale",
  "compareFile.name.salePisCofins": "PIS/COFINS on the sale",
  "compareFile.name.saleStFcp": "ICMS-ST and FCP-ST on the sale invoice",
  "compareFile.name.buyerInvoice": "buyer's sale invoice",
  "compareFile.toggle": "Compare with my file",
  "compareFile.fields":
    "Compares {fields} with the columns the file states. Differences up to R$ 0.01 count as equal.",
  "compareFile.tally.rows": "rows compared",
  "compareFile.tally.difference": "different",
  "compareFile.tally.match": "equal",
  "compareFile.tally.pending": "without an engine value",
  "compareFile.onlyDifferent": "Only different",
  "compareFile.caption": "Results compared with the file",
  "compareFile.base": "Base BRL / unit",
  "compareFile.field.ipi": "IPI / unit",
  "compareFile.field.icmsSt": "ICMS-ST / unit",
  "compareFile.field.taxTotal": "Taxes / unit",
  "compareFile.field.landed": "Landed cost / unit",
  "compareFile.field.ownIcms": "Inbound ICMS / unit",
  "compareFile.field.purchasePisCofins": "Purchase PIS/COFINS / unit",
  "compareFile.field.workbookCost": "Workbook cost / unit",
  "compareFile.field.salePrice": "Sale with TR / unit",
  "compareFile.field.saleIcms": "Own ICMS on sale / unit",
  "compareFile.field.salePisCofins": "PIS/COFINS on sale / unit",
  "compareFile.field.saleStFcp": "ICMS-ST/FCP-ST on sale / unit",
  "compareFile.field.buyerInvoice": "Buyer invoice / unit",
  "compareFile.file": "File",
  "compareFile.engine": "Engine",
  "compareFile.delta": "Δ",
  "compareFile.deltaHint": "Difference: engine − file",
  "compareFile.verdict": "Comparison",
  "compareFile.notMapped": "No column in the file",
  "compareFile.note":
    "Read-only: the file's values come from the columns mapped at import. Differences up to R$ 0.01 count as equal. A row without a rule has no engine value and is never treated as zero. Turn the comparison off to return to the results table.",
  "compareFile.limit": "Showing {shown} of {total} different rows. Export the CSV to see them all.",
  "compareFile.empty.title": "No different rows",
  "compareFile.empty.body":
    "With the current filters, the engine's values match the file or are not calculated yet.",
  "reviewCause.title": "{count} of {total} rows to review",
  "reviewCause.hint":
    "By cause, with the action that resolves each. A row can have more than one cause: the groups do not add up. Estimated quotes are labeled and kept separate from confirmed fiscal totals.",
  "reviewCause.reading": "Reading each row's causes…",
  "reviewCause.example": "E.g.: {text}",
  "reviewCause.less": "Show fewer causes",
  "reviewCause.more.one": "{count} more cause",
  "reviewCause.more.other": "{count} more causes",
  "reviewCause.viewRows.one": "See the row",
  "reviewCause.viewRows.other": "See the {count} rows",
  "reviewCause.research.one": "Research {count} gap",
  "reviewCause.research.other": "Research {count} gaps",
  "reviewCause.scope.ncm.one": "{count} NCM",
  "reviewCause.scope.ncm.other": "{count} NCMs",
  "reviewCause.scope.route.one": "{count} route",
  "reviewCause.scope.route.other": "{count} routes",
  "reviewCause.kind.RULE": "Rule",
  "reviewCause.kind.CEST": "Classification",
  "reviewCause.kind.FILE": "Spreadsheet",
  "reviewCause.kind.PROFILE": "PIS/COFINS",
  "reviewCause.kind.OTHER": "Review",
  "reviewCause.short.CEST_MISMATCH": "CEST does not match the rule",
  "reviewCause.short.AMBIGUOUS_CEST": "Several possible CESTs",
  "reviewCause.short.NO_RULE_FOR_ROUTE": "NCM has no published rule on this route",
  "reviewCause.short.NO_RULE_FOR_NCM": "NCM has no published rule",
  "reviewCause.short.ICMS_NOT_PUBLISHED": "ICMS not published for the route",
  "reviewCause.short.RULE_EXPIRED": "Rule expired on the calculation date",
  "reviewCause.short.RULE_NOT_YET_EFFECTIVE": "Rule not yet in force on the date",
  "reviewCause.short.RULESET_EMPTY": "No published rules",
  "reviewCause.short.FIELD_MISSING": "Field missing in the spreadsheet",
  "reviewCause.short.PROFILE_PENDING": "PIS/COFINS profile to confirm",
  "reviewCause.short.BENEFIT_NOT_IN_RULE": "cBenef not in the sale rule",
  "reviewCause.short.SALE_RULE_MISSING": "No rule for the sale ICMS",
  "reviewCause.short.OTHER": "Other cause",
  "reviewCause.short.ACQUISITION_PENDING": "Acquisition fiscal data pending",
  "reviewCause.next.ACQUISITION_PENDING":
    "Open the row details to review and complete the pending classification, goods origin or fiscal rule.",
  "reviewCause.next.RULE":
    "Review the applicable rules or research the route; publish before recalculating.",
  "reviewCause.next.CEST": "Fix the CEST and recalculate.",
  "reviewCause.next.FILE": "Fix the spreadsheet and import it again.",
  "reviewCause.next.PROFILE": "Confirm the PIS/COFINS profile by product and recalculate.",
  "reviewCause.next.OTHER": "Open the row to see the calculation memory.",
  "reviewCause.profile.BEVERAGE_PROFILE": "cold beverage under Lei 13.097/2015",
  "reviewCause.profile.REQUIRES_CONFIRMATION": "a list with a condition the NCM cannot prove",
  "reviewCause.profile.OVERLAPPING_LISTS": "in more than one list",
  "reviewCause.profile.NOT_IN_CATALOG": "treatment outside the statutory list",
  "reviewCause.profile.OTHER": "to confirm",
  "reviewCause.rowTitle": "Why this row needs review",
  "reviewCause.fact.product": "Product",
  "reviewCause.fact.route": "NCM and route",
  "reviewCause.fact.provenance": "Source",
  "reviewCause.fact.provenanceRow": "{sheet}, row {row}",
  "reviewCause.fact.rules": "rules {version}",
  "reviewCause.noRule": "No published rule",
  "reviewCause.pending": "Pending",
  "reviewFix.fixCests": "Fix CEST and recalculate ({count})",
  "reviewFix.reason.CEST_MISMATCH":
    "CEST {cest} does not match NCM {ncm} on {route} (expected {expected}).",
  "reviewFix.reason.AMBIGUOUS_CEST":
    "NCM {ncm} on {route} has rules for several CESTs ({expected}); the row states none.",
  "reviewFix.reason.NO_RULE_FOR_ROUTE": "NCM {ncm} has published rules, but none for {route}.",
  "reviewFix.reason.NO_RULE_FOR_NCM": "No published rule for NCM {ncm} ({route}).",
  "reviewFix.reason.ICMS_NOT_PUBLISHED":
    "Only the TIPI row covers NCM {ncm}: no ICMS rule for {route}.",
  "reviewFix.reason.RULE_EXPIRED":
    "The rule for NCM {ncm} on {route} ended before the calculation date.",
  "reviewFix.reason.RULE_NOT_YET_EFFECTIVE":
    "The rule for NCM {ncm} on {route} starts after the calculation date.",
  "reviewFix.reason.RULESET_EMPTY": "No fiscal rules are published.",
  "reviewFix.reason.FIELD_MISSING": "The row has no valid {field}.",
  "reviewFix.reason.PROFILE_PENDING": "NCM {ncm} has its own PIS/COFINS treatment ({profile}).",
  "reviewFix.reason.BENEFIT_NOT_IN_RULE": "cBenef {benefit} is not in the published sale rule.",
  "reviewFix.reason.SALE_RULE_MISSING":
    "No rule states the ICMS of the sale {saleRoute} for NCM {ncm}.",
  "reviewFix.reason.OTHER": "Review needed for NCM {ncm} on {route}.",
  "reviewFix.fix.SET_CEST": "Fix: use CEST {value} from the published rule.",
  "reviewFix.fix.PICK_CEST": "Fix: pick the CEST in Repair sheet.",
  "reviewFix.fix.RESEARCH_ROUTE": "Next step: research the route.",
  "reviewFix.fix.FIX_SHEET": "Fix: fill {field} in the sheet and import it again.",
  "reviewFix.fix.STATE_TREATMENT": "Fix: state the confirmed treatment.",
  "reviewFix.fixFailed": "No CEST fix could be applied to the sheet.",
  "lotSim.column.item": "Item",
  "lotSim.column.ncm": "NCM / route",
  "lotSim.column.ipi": "IPI",
  "lotSim.column.icmsSt": "ICMS (ST or own)",
  "lotSim.column.taxTotal": "Taxes",
  "lotSim.column.landed": "Landed",
  "lotSim.column.status": "Status",
  "lotSim.expand": "Open calculation memory for row {row}",
  "lotSim.collapse": "Close calculation memory for row {row}",
  "lotSim.waterfall.title": "Fiscal memory",
  "lotSim.waterfall.cost": "Fiscal unit cost",
  "lotSim.waterfall.ipi": "(+) IPI",
  "lotSim.waterfall.icmsSt": "(+) ICMS (ST or own)",
  "lotSim.waterfall.taxTotal": "Tax total",
  "lotSim.waterfall.take": "(+) Marketplace fee",
  "lotSim.waterfall.logistics": "(+) Logistics",
  "lotSim.waterfall.freight": "(+) Freight",
  "lotSim.waterfall.other": "(+) Other",
  "lotSim.waterfall.landed": "Landed unit cost",
  "costs.operationalNotConfigured":
    "Operational cost not configured — outside the fiscal calculation",
  "costs.feeNotConfigured": "Commercial fee not configured — outside the fiscal calculation",
  "costs.bothNotConfigured":
    "Operational cost and commercial fee not configured — outside the fiscal calculation",
  "costs.explainer":
    "IPI, ICMS and ICMS-ST and the fiscal landed cost are calculated. The commercial landed cost is unavailable until these costs are published.",
  "costs.fiscalLanded": "Fiscal landed unit cost",
  "costs.pricingBasis":
    "Sale price and margin use the fiscal landed cost, before operational cost and commercial fee.",
  "costs.notConfiguredShort": "Not configured",
  "costs.invalid":
    "The operational cost or commercial fee rule cannot be applied; the item needs review.",
  "lotSim.waterfall.ipiRate": "Published IPI rate",
  "lotSim.waterfall.mva": "Adjusted MVA",
  "shadow.title": "Comparison with verified data",
  "shadow.hint":
    "Shadow mode: the same item calculated with verified or certified fiscal facts in force on {date}. Read only.",
  "shadow.returned": "Returned and stored amounts are still the published rule's.",
  "shadow.unavailable":
    "Facts could not be read for this calculation. The calculation was not affected.",
  "shadow.status.NO_FACTS": "No verified or certified fact covers this NCM and route.",
  "shadow.status.INCOMPLETE":
    "Verified facts do not cover every field needed, so there is no alternative result.",
  "shadow.status.CONFLICT":
    "Verified facts disagree with each other; no alternative result was calculated.",
  "shadow.status.AMBIGUOUS":
    "Facts for different CESTs exist for this NCM and the item states no CEST.",
  "shadow.status.NOT_COMPARABLE": "Item without NCM or state: nothing to compare.",
  "shadow.changed": "Verified data would change this item.",
  "shadow.same": "Verified data confirm this item.",
  "shadow.level.CERTIFIED": "Level: certified.",
  "shadow.level.VERIFIED": "Level: verified.",
  "shadow.gap": "no published rule, facts would fill this gap",
  "shadow.revalidation": "revalidation requested",
  "shadow.column.field": "Field",
  "shadow.column.rule": "Published rule",
  "shadow.column.facts": "Verified data",
  "shadow.field.stApplicable": "ICMS-ST applies",
  "shadow.field.originalMva": "Original MVA",
  "shadow.field.destinationInternalRate": "Destination internal rate",
  "shadow.field.interstateRate": "Interstate rate",
  "shadow.st.yes": "yes",
  "shadow.st.no": "no",
  "shadow.noSt.certified": "No ST (IOB certified)",
  "shadow.noSt.verified": "No ST (verified data)",
  "shadow.noSt.internal":
    "Internal ST at destination ({uf}): no withholding by the sender; the recipient pays the advance or ST on internal operations.",
  "shadow.noSt.internalNoUf":
    "Internal ST at destination: no withholding by the sender; the recipient pays the advance or ST on internal operations.",
  "shadow.admin.title": "Shadow mode: comparison with verified data",
  "shadow.admin.hint":
    "Last {days} days. How many items verified or certified facts would change. Returned amounts stay the rule's.",
  "shadow.admin.off":
    "Shadow mode is off. It needs FISCAL_FACTS_MODE=SHADOW in the environment (now: {environment}) and the Shadow or On mode saved above.",
  "shadow.admin.calculations": "Calculations",
  "shadow.admin.compared": "Items compared",
  "shadow.admin.changed": "Would change",
  "shadow.admin.gapsFilled": "Gaps filled",
  "shadow.admin.disagreements": "Disagree with the rule",
  "shadow.admin.noFacts": "No facts",
  "shadow.admin.incomplete": "Incomplete or in conflict",
  "shadow.admin.levels": "Certified / verified",
  "shadow.admin.landedDelta": "Δ landed cost (sum)",
  "shadow.admin.maxDelta": "Largest |Δ| per item",
  "shadow.admin.routes": "Routes with the most compared items",
  "shadow.admin.column.route": "NCM · route",
  "shadow.admin.column.compared": "Compared",
  "shadow.admin.column.changed": "Would change",
  "shadow.admin.column.delta": "Δ landed cost",
  "shadow.admin.last": "Last comparison: {time}",
  "shadow.admin.none": "No comparison recorded in this period.",
  "calc.form.regime": "PIS/COFINS regime",
  "calc.form.regime.UNKNOWN": "Not stated",
  "calc.form.regime.NON_CUMULATIVE": "Non-cumulative (1.65% / 7.6%)",
  "calc.form.regime.CUMULATIVE": "Cumulative (0.65% / 3%)",
  "calc.form.regimeHint":
    "Used when the rule does not state PIS/COFINS. In spreadsheets, a populated row regime takes precedence, including UNKNOWN; this control fills absent regimes or an unconfirmed mapping default. Without a regime, PIS/COFINS is not tracked.",
  "calc.form.pricing": "Sale price",
  "calc.form.pricing.NONE": "Do not price",
  "calc.form.pricing.MARKUP": "Markup on landed cost",
  "calc.form.pricing.TARGET_MARGIN": "Gross margin on price",
  "calc.form.pricingRate": "Percentage (%)",
  "calc.form.pricingRateError": "Enter a valid percentage. A target margin must stay below 100%.",
  "fiscalLines.fcp": "(+) FCP/FECP",
  "fiscalLines.fcpSt": "(+) FCP-ST",
  "fiscalLines.fcpNote":
    "Destination state's poverty-fund surcharge, as the rule in force states it. Without FCP in the rule, it shows as not tracked.",
  "fiscalLines.notTracked": "not tracked",
  "fiscalLines.notApplicable": "not applicable",
  "fiscalLines.exempt": "exempt",
  "fiscalLines.pisRate": "PIS rate on the sale",
  "fiscalLines.cofinsRate": "COFINS rate on the sale",
  "fiscalLines.pisOnSale": "(−) PIS on the sale",
  "fiscalLines.cofinsOnSale": "(−) COFINS on the sale",
  "fiscalLines.source.RULE": "published rule",
  "fiscalLines.source.REGIME_DEFAULT": "regime general rate",
  "pricing.title": "Price and margin",
  "pricing.salePrice": "Sale price",
  "pricing.method.MARKUP": "markup {rate}",
  "pricing.method.TARGET_MARGIN": "target margin {rate}",
  "pricing.margin": "Margin",
  "pricing.marginPct": "{value} of price",
  "calc.form.pricing.NET_TARGET_MARGIN": "Desired net margin (after sale taxes)",
  "calc.form.pricing.COST_PLUS_TR": "Sale value with TR (purchase invoice cost ÷ (1 − TR))",
  "calc.form.pricingTrHint":
    "As in the workbook: price = purchase invoice cost (goods + IPI + ICMS-ST) ÷ (1 − TR). The sale's ICMS, PIS/COFINS and ST are computed on that price, not built into it.",
  "pricing.method.COST_PLUS_TR": "TR {rate}",
  "pricing.tr.invoiceCost": "Purchase invoice cost (goods + IPI + ICMS-ST)",
  "pricing.tr.icmsOnSale": "Own ICMS on the sale",
  "pricing.tr.icmsClosed":
    "Goods already under ST: internal sale with no new ICMS (CST 60). PIS/COFINS on the full price.",
  "pricing.tr.icmsBurdenNeeded":
    "Internal sale with no base reduction stated by the rule: own ICMS at the nominal rate. If an effective burden applies (e.g. RICMS/SP art. 39), it must be published in the rule.",
  "pricing.tr.pisCofins": "PIS/COFINS on the sale (outside the ICMS base)",
  "pricing.tr.pisCofinsFormula": "({price} − ICMS {icms}) × rate",
  "pricing.tr.st": "ICMS-ST on the sale invoice",
  "pricing.tr.stNotOnInvoice":
    "The sale rule is ST but the invoice carries no retention (no agreement or a non-taxpayer customer); any advance payment is the buyer's.",
  "pricing.tr.fcpSt": "FCP/FECP-ST on the sale invoice",
  "pricing.tr.difal": "DIFAL + destination FCP",
  "pricing.tr.buyerInvoice": "Buyer's sale invoice (price + ICMS-ST + FCP-ST)",
  "pricing.tr.margin": "Left after the sale taxes",
  "pricing.tr.marginNote":
    "The TR does not build in the sale taxes: what is left after them is lower than the TR (workbook note 4).",
  "pricing.tr.cst": "Indicative CST {cst}",
  "calc.form.pricingNetHint":
    "The price is (landed cost − credits) ÷ (1 − margin − sale taxes): the margin you enter is what is left after the sale's ICMS, PIS and COFINS.",
  "calc.form.pricingNetRegime":
    "Without the PIS/COFINS regime, the net margin neither deducts PIS/COFINS on the sale nor adds the purchase credits.",
  "calc.form.saleDestination": "Sale destination",
  "calc.form.saleDestination.center": "Internal sale at the distribution center",
  "calc.form.customerType": "Sale customer",
  "calc.form.customerType.ICMS_TAXPAYER": "ICMS taxpayer",
  "calc.form.customerType.FINAL_CONSUMER": "Final consumer (DIFAL)",
  "pricing.method.NET_TARGET_MARGIN": "net margin {rate}",
  "pricing.net.route": "Sale {origin} → {destination} · {customer}",
  "pricing.net.assumedDestination": "internal sale at the distribution center",
  "pricing.net.assumedCustomer": "ICMS taxpayer customer",
  "pricing.net.assumedNote":
    "Assumption: {what}. State the sale destination and customer to fix it.",
  "pricing.net.formula": "Price = (landed cost − credits) ÷ (1 − margin − sale taxes)",
  "pricing.net.formulaValues": "({cost} − {credits}) ÷ {divisor} = {price}",
  "pricing.net.icmsOnSale": "(−) ICMS on the sale",
  "pricing.net.icmsClosed": "ICMS-ST paid on entry: no ICMS on the sale and no ICMS credit.",
  "pricing.net.icmsNotTaxed": "Sale without ICMS: the purchase ICMS credit is reversed.",
  "pricing.net.fcpOnSale": "(−) FCP on the sale",
  "pricing.net.difalOnSale": "(−) DIFAL on the sale",
  "pricing.net.credits": "(−) Purchase credits",
  "pricing.net.creditsDetail": "ICMS {icms} · PIS {pis} · COFINS {cofins}",
  "pricing.net.netCost": "Cost net of credits",
  "pricing.net.margin": "Net margin",
  "pricing.net.markup": "Markup on landed cost",
  "lotOps.group.price": "Suggested price",
  "lotOps.price.netMargin": "Net margin",
  "lotOps.price.markup": "Markup",
  "pricing.untracked": "PIS/COFINS not tracked: the margin is before these contributions.",
  "calculations.explain.fiscalLines": "FCP, PIS/COFINS and margin",
  "lotSim.status.calculated": "Calculated",
  "lotSim.status.review": "Review",
  "lotSim.pending": "Waiting for simulation",
  "lotSim.individual.body":
    "One SKU, one route, published rules. Price and margin are under More options.",
  "lotSim.individual.ncm": "NCM",
  "lotSim.individual.origin": "Origin UF",
  "lotSim.individual.destination": "Destination UF",
  "lotSim.selectUf": "Select a state",
  "lotSim.individual.quantity": "Quantity",
  "lotSim.individual.result": "Result",
  "lotSim.individual.resultMeta": "{date} · {version}",
  "calc.form.title": "Product and route",
  "calc.form.ncmPlaceholder": "e.g. 8471.30.12",
  "calc.form.ncmHint": "The product's 8-digit NCM.",
  "calc.form.ncmError": "Enter the 8 NCM digits.",
  "calc.form.route": "Route",
  "calc.form.ufError": "Choose the UF.",
  "calc.form.swap": "Swap origin and destination",
  "calc.form.costHint": "Fiscal cost of one unit, before taxes.",
  "calc.form.costInvalid": "Use the format 1,000.00.",
  "calc.form.costError": "Enter the unit fiscal cost.",
  "calc.form.more": "More options",
  "calc.form.moreSummary": "Qty {quantity} · {date} · Rules {version}",
  "calc.form.sku": "SKU (optional)",
  "calc.form.skuPlaceholder": "e.g. CAFE-500G",
  "calc.form.cest": "CEST (optional)",
  "calc.form.cestPlaceholder": "e.g. 17.001.00",
  "calc.form.cestHint": "Only if the product has an assigned CEST; do not guess the code.",
  "calc.form.cestRemoved": "CEST removed: {cest} does not match NCM {ncm}",
  "calc.form.missing": "Still needed: {fields}.",
  "calc.form.ready": "Ready to calculate.",
  "calc.form.calculate": "Calculate",
  "calc.form.calculating": "Calculating…",
  "calc.result.cost": "Cost",
  "calc.result.empty":
    "Fill in NCM, route and cost, then Calculate. The result appears here, tax by tax.",
  "calc.result.taxes": "{value} in taxes",
  "calc.result.mva": "MVA {value}",
  "calc.result.icmsNote":
    "With tax substitution this amount is ICMS-ST. Without ST it is the purchase's own ICMS, added to cost with no credit.",
  "calc.fecp.omitted": "Destination FECP not stated in the rule; ST calculated without FECP",
  "calc.recent.title": "Recent calculations",
  "calc.recent.all": "See all lots",
  "calc.recent.error": "Could not load recent calculations.",
  "calc.recent.empty": "No calculations in the last 30 days.",
  "calc.recent.items.one": "{count} item",
  "calc.recent.items.other": "{count} items",
  "calc.recent.missing": "What is missing",
  "calc.recent.missingIssue": "{issue} · {count}",
  "calc.recent.seeItems": "See items",
  "calc.recent.next.queued": "Waiting for the runner",
  "calc.recent.next.running": "{done} of {total} items calculated",
  "calc.recent.next.failed": "The calculation stopped; open it to see why.",
  "calc.error.details": "Technical details",
  "calc.error.generic.title": "Could not calculate",
  "calc.error.generic.body": "Try again. If it persists, send the technical details to support.",
  "calc.error.lot.title": "The lot stopped before finishing",
  "calc.error.lot.body":
    "The reason is under Technical details. Fix the spreadsheet and send the lot again; if you are not sure what to fix, send the code to support.",
  "calc.error.lot.retryableBody":
    "This was a temporary failure. Use Retry to try again; if it fails again, send the code to support.",
  "calc.error.OPERATION_NOT_AVAILABLE.title": "Calculation is not available here",
  "calc.error.OPERATION_NOT_AVAILABLE.body":
    "This environment does not run the tax engine (for example, demo mode). Calculate in the live environment.",
  "calc.error.DEPENDENCY_UNAVAILABLE.title": "The tax engine did not respond",
  "calc.error.DEPENDENCY_UNAVAILABLE.body": "Nothing was saved. Try again in a moment.",
  "calc.error.NO_PUBLISHED_RULESET.title": "There are no published rules to calculate with",
  "calc.error.NO_PUBLISHED_RULESET.body":
    "Choose another published version. If none applies, ask the tax owner to check coverage for the NCM, route and transaction date.",
  "calc.error.VALIDATION_FAILED.title": "Some inputs were not accepted",
  "calc.error.VALIDATION_FAILED.body": "Check the NCM, UFs, cost and date, then try again.",
  "calc.error.BATCH_TOO_LARGE.title": "The lot is over the limit",
  "calc.error.BATCH_TOO_LARGE.body": "Split the spreadsheet into smaller files and upload again.",
  "calc.error.RATE_LIMITED.title": "Too many calculations in a row",
  "calc.error.RATE_LIMITED.body": "Wait a few seconds and try again.",
  "calc.error.PERMISSION_DENIED.title": "You cannot run calculations",
  "calc.error.PERMISSION_DENIED.body": "Ask an administrator for permission to run calculations.",
  "calc.error.NETWORK.title": "No connection to the tax API",
  "calc.error.NETWORK.body": "Check your connection and try again.",
  "calc.rate.ipiRate": "IPI rate",
  "calc.rate.interstateIcmsRate": "Interstate ICMS rate",
  "calc.rate.destinationInternalIcmsRate": "Destination internal ICMS rate",
  "calc.rate.originalMva": "Original MVA",
  "calc.rate.adjustedMva": "Adjusted MVA",
  "mva.adjust.title": "MVA adjustment (ICMS-ST)",
  "mva.adjust.alqInter": "Interstate rate (ALQ inter)",
  "mva.adjust.alqIntra": "Effective internal rate (ALQ intra)",
  "mva.adjust.original": "Original MVA",
  "mva.adjust.adjusted": "Adjusted MVA",
  "mva.adjust.applied": "Adjustment applied",
  "mva.adjust.yes": "Yes",
  "mva.adjust.no": "No",
  "mva.adjust.reason.ADJUSTED": "ALQ intra is above the interstate rate: the MVA was adjusted.",
  "mva.adjust.reason.NOT_INTERSTATE": "Internal operation: the original MVA applies.",
  "mva.adjust.reason.INTRA_NOT_GREATER_THAN_INTER":
    "ALQ intra does not exceed the interstate rate: the original MVA applies, unadjusted.",
  "mva.adjust.source.RULE": "Effective burden from the rule: {legal}",
  "mva.adjust.source.NOMINAL_NOT_INFORMED":
    "effective burden not stated — using the nominal internal rate",
  "mva.adjust.source.NOMINAL_OUT_OF_VALIDITY":
    "effective burden outside its validity — using the nominal internal rate",
  "mva.adjust.debit": "The ST debit uses the nominal internal rate ({rate}).",
  "calc.rate.takeRate": "Marketplace fee rate",
  "calc.engine.name": "Engine",
  "calc.engine.version": "Engine version",
  "calc.engine.policy": "Calculation policy",
  "calc.engine.rounding": "Rounding",
  "calc.engine.scale": "Decimal places",
  "lotSim.exportCsv": "Export CSV",
  "lotSim.results": "Results by item",
  "lotSim.resultsHint": "{count} rows · {date} · {version}",

  "app.brand": "TaxChannel",
  "app.name": "Tax Operations",
  "app.org": "BackChannel",

  "nav.areas": "Areas",
  "nav.overview": "Overview",
  "nav.evidence": "Evidence",
  "nav.proposals": "Proposals",
  "nav.rulesets": "Rulesets",
  "nav.rules": "Rules",
  "nav.calculator": "Calculator",
  "nav.calculations": "Calculations",
  "nav.sources": "Sources",
  "nav.audit": "Audit",
  "nav.settings": "Profile",
  "nav.admin.module": "Administration",
  "nav.users": "Users",
  "nav.legal": "Company details",
  "nav.agents": "Agents",
  "nav.demos": "Demos",
  "nav.agentFindings": "Agent records",
  "agents.retention": "Run logs are available for 30 days.",
  "agents.retentionFindings": "Findings stay permanently in Agent records.",
  "agentFindings.title": "Agent records",
  "agentFindings.description":
    "Everything the browser agent extracted, day by day (Brasília time): totals by outcome and route, filters and export. Findings are review material and are kept permanently.",
  "agentFindings.day.previous": "Previous day",
  "agentFindings.day.next": "Next day",
  "agentFindings.day.pick": "Pick a day",
  "agentFindings.day.today": "Today",
  "agentFindings.day.total.one": "{count} finding",
  "agentFindings.day.total.other": "{count} findings",
  "agentFindings.byOutcome": "By outcome",
  "agentFindings.byRoute": "By route",
  "agentFindings.heat.title": "Findings over the last {days} days",
  "agentFindings.heat.window": "Chart period",
  "agentFindings.heat.days": "{days} days",
  "agentFindings.heat.less": "Less",
  "agentFindings.heat.more": "More",
  "agentFindings.heat.error": "Daily totals could not be loaded.",
  "agentFindings.table.title": "Findings of the day",
  "agentFindings.retention":
    "Findings are kept permanently. Screenshots and run logs are available for 30 days (except those saved as demos).",
  "agentFindings.export.dayCsv": "Export day (CSV)",
  "agentFindings.export.dayJson": "Export day (JSON)",
  "agentFindings.export.range": "Export range…",
  "agentFindings.export.rangeTitle": "Export a date range",
  "agentFindings.export.rangeBody":
    "Downloads the findings between the chosen dates (Brasília days, inclusive), up to a year.",
  "agentFindings.export.from": "From",
  "agentFindings.export.to": "To",
  "agentFindings.export.format": "Format",
  "agentFindings.export.filtersApply":
    "The current filters (outcome, route, NCM) also apply to the export.",
  "agentFindings.export.invalid": "Choose a valid range of up to 366 days, with no future dates.",
  "agentFindings.export.go": "Download",
  "agentFindings.export.busy": "Preparing…",
  "agentFindings.export.done": "{count} findings exported.",
  "agentFindings.export.truncated":
    "{count} findings exported; the 20,000 limit was reached. Narrow the range.",
  "agentFindings.export.error": "The export failed. Try again.",
  "agentFindings.filter.ncm": "NCM or description",
  "agentFindings.filter.ncmPlaceholder": "E.g. 8516 or dryers",
  "agentFindings.filter.outcome": "Outcome",
  "agentFindings.filter.route": "Route",
  "agentFindings.filter.all": "All",
  "agentFindings.filter.clear": "Clear filters",
  "agentFindings.filteredCount": "Showing {shown} of {total} findings of the day.",
  "agentFindings.empty.day": "No findings on this day",
  "agentFindings.empty.dayBody":
    "The agent recorded no lookups on this date. Use the chart to jump to a day with activity.",
  "agentFindings.empty.filtered": "No findings match these filters",
  "agentFindings.col.time": "Time",
  "agentFindings.col.ncm": "NCM",
  "agentFindings.col.route": "Route",
  "agentFindings.col.outcome": "Outcome",
  "agentFindings.col.mva": "Original MVA",
  "agentFindings.col.cest": "CEST",
  "agentFindings.col.validity": "Validity",
  "agentFindings.col.basis": "Legal basis",
  "agentFindings.col.source": "Source",
  "agentFindings.col.run": "Run",
  "agentFindings.col.frame": "Screenshot",
  "agentFindings.source.task": "Queue task",
  "agentFindings.source.lookupJob": "System lookup",
  "agentFindings.source.gap": "Coverage gap",
  "agentFindings.openRun": "Open run",
  "agentFindings.openFrame": "Open the screenshot for NCM {ncm}",
  "agents.schedule.recordRuns": "Record the screen of runs",
  "agents.schedule.recordRunsHint":
    "Recording starts after login (the sign-in form is never recorded) and feeds the Demos section. Run files are deleted after 30 days; those saved as demos are kept.",
  "agents.live.recording": "Recording",
  "agents.live.recordingHint": "This run's screen is being recorded since login finished.",
  "agents.runs.current": "Run started {time}.",
  "agents.runs.col.demo": "Demo",
  "demos.title": "Demos",
  "demos.description":
    "Recorded agent runs saved to present how the process works: the screen video, the narrated steps in sync, and what was found.",
  "demos.listLabel": "Saved demos",
  "demos.empty.title": "No demos yet",
  "demos.empty.body": "In Administration → Agents, open a recorded run and use “Save as demo”.",
  "demos.empty.action": "Go to Agents",
  "demos.card.routes.one": "{count} route",
  "demos.card.routes.other": "{count} routes",
  "demos.card.ncms.one": "{count} NCM",
  "demos.card.ncms.other": "{count} NCMs",
  "demos.card.findings.one": "{count} finding",
  "demos.card.findings.other": "{count} findings",
  "demos.notFound.title": "Demo not found",
  "demos.notFound.body": "It may have been removed. The original run is still in Agents.",
  "demos.back": "All demos",
  "demos.detail.savedOn": "Saved {time}",
  "demos.detail.openRun": "Open run in Agents",
  "demos.delete.action": "Remove demo",
  "demos.delete.title": "Remove this demo?",
  "demos.delete.body":
    "“{title}” leaves the Demos section. The run, its steps, findings and recordings stay in Agents. The action is audited.",
  "demos.delete.confirm": "Remove demo",
  "demos.delete.error": "The demo could not be removed. Try again.",
  "demos.summary.title": "Run summary",
  "demos.summary.duration": "Video",
  "demos.summary.lookups": "Lookups",
  "demos.summary.findings": "Findings",
  "demos.summary.routes": "Routes",
  "demos.summary.run": "Run",
  "demos.summary.boundary":
    "A demonstration of the process. Findings are review material: they never create, approve or publish rules.",
  "demos.timeline.title": "Narrated steps",
  "demos.timeline.hint": "Click a step to jump to that moment in the video.",
  "demos.timeline.empty": "This run has no steps.",
  "demos.timeline.seek": "Jump to {time}",
  "demos.timeline.offCamera": "not recorded",
  "demos.findings.moment": "In the video",
  "demos.findings.seek": "Jump to this finding in the video",
  "demos.player.noRecording": "This demo has no recording.",
  "demos.player.unavailable": "The video is not available right now. Steps and findings are below.",
  "demos.player.leave": "Leave presentation mode",
  "demos.player.leaveShort": "Exit",
  "demos.player.segment": "Part {part} of {count}",
  "demos.player.single": "Screen recording",
  "demos.player.present": "Presentation mode",
  "demos.save.action": "Save as demo",
  "demos.save.open": "View demo",
  "demos.save.reasonRunning": "Available once the run ends.",
  "demos.save.reasonNoRecording": "This run has no recording.",
  "demos.save.defaultTitle": "IOB agent · {time}",
  "demos.save.title": "Save as demo",
  "demos.save.body":
    "This run's recording, steps and findings become available in Administration → Demos.",
  "demos.save.titleLabel": "Title",
  "demos.save.titleHint": "Suggested from the queue task. Up to 120 characters.",
  "demos.save.titleRequired": "Enter a title.",
  "demos.save.descriptionLabel": "Description",
  "demos.save.optional": "(optional)",
  "demos.save.retention":
    "The video and frames are copied to the demos area and no longer follow the 30-day deletion of runs.",
  "demos.save.confirm": "Save demo",
  "demos.save.saving": "Saving…",
  "demos.save.errorConflict": "This run is already a demo or has not finished yet.",
  "demos.save.errorStorage": "The recording could not be preserved right now. Try again shortly.",
  "demos.save.error": "The demo could not be saved. Try again.",
  "agents.title": "IOB agent",
  "agents.description":
    "Follow the agent that queries the IOB Simulador Tributário, organise its queue and schedule, and review what it found.",
  "agents.statusLabel": "Agent status",
  "agents.tabs": "Agent sections",
  "agents.tab.live": "Live",
  "agents.tab.queue": "Queue",
  "agents.tab.schedule": "Schedule",
  "agents.tab.history": "History",
  "agents.tab.settings": "Settings",
  "agents.state.running": "Run in progress",
  "agents.state.recording": "Recording this run's screen",
  "agents.state.stopping": "Stopping",
  "agents.state.stoppingDetail": "Stop requested; the current lookup finishes first",
  "agents.state.noSignal": "No signal",
  "agents.state.pausedDetail": "No new lookup starts until it is resumed",
  "agents.state.outsideWindow": "Outside schedule",
  "agents.state.noCredentialsDetail": "Add the IOB login under Settings",
  "agents.state.stoppedDetail": "The last run failed; see History",
  "agents.findings.open": "{count} findings: view in History",
  "agents.findings.runTitle": "Findings from the run of {time}",
  "agents.findings.openLive": "View screen and steps",
  "agents.status.RUNNING": "Running",
  "agents.status.WAITING_WINDOW": "Waiting outside schedule hours",
  "agents.status.STOPPED": "Stopped with an error",
  "agents.status.IDLE": "Waiting for work",
  "agents.status.NO_CREDENTIALS": "No IOB credentials",
  "agents.source": "Source",
  "agents.source.IOB_SIMULADOR": "IOB Simulador Tributário",
  "agents.currentLookup": "Current lookup",
  "agents.noLookup": "No lookup in progress",
  "agents.lookupsDone": "Lookups done",
  "agents.findings": "Findings",
  "agents.errors": "Errors",
  "agents.heartbeat": "Heartbeat",
  "agents.lastPoll": "Last poll",
  "agents.heartbeatAgo": "{age} ago",
  "agents.heartbeatStale": "Silent for {age}",
  "agents.stop": "Stop run",
  "agents.stopping": "Stop requested",
  "agents.stop.title": "Stop the agent run?",
  "agents.stop.body":
    "The agent safely finishes its current step and closes the session. It only runs again at the next time on the weekly schedule.",
  "agents.stop.confirm": "Stop run",
  "agents.stop.error": "Could not request the stop. Try again.",
  "agents.lastError": "Last error",
  "agents.live.title": "Agent screen",
  "agents.live.meta.idle": "No run in progress",
  "agents.live.note.disconnectedIdle": "Viewer has no stream; retrying in {time}.",
  "agents.live.note.disconnectedIdleNow": "Viewer has no stream; reconnecting…",
  "agents.live.note.unconfiguredIdle": "This environment does not stream the agent's screen.",
  "agents.live.viewer.label": "Viewer:",
  "agents.live.viewer.live": "live",
  "agents.live.viewer.connecting": "connecting…",
  "agents.live.viewer.disconnected": "disconnected",
  "agents.live.viewer.unconfigured": "stream not configured",
  "agents.live.viewer.historical": "historical capture",
  "agents.live.meta.streaming": "Live stream of the agent's browser",
  "agents.live.meta.frame": "Frame from {time} · {age} ago",
  "agents.live.meta.noFrame": "No recorded frame",
  "agents.live.note.historical":
    "Run of {time}: this is that run's record, not the current screen.",
  "agents.live.note.historicalPlain": "Record of an earlier run, not the current screen.",
  "agents.live.note.disconnectedWorking":
    "The agent keeps working; only the viewer dropped. Retrying in {time}.",
  "agents.live.note.disconnectedWorkingNow":
    "The agent keeps working; only the viewer dropped. Reconnecting…",
  "agents.live.note.connectingWorking": "The agent is working; opening the stream.",
  "agents.live.note.unconfiguredWorking":
    "The agent is working. This environment does not stream the screen; recorded frames follow below.",
  "agents.live.art.waiting": "Agent waiting",
  "agents.live.art.blocked": "Agent blocked",
  "agents.live.art.noFrame": "The viewer has not received a frame yet",
  "agents.live.stage.label": "Current lookup stage",
  "agents.live.stage.query": "Query",
  "agents.live.stage.capture": "Capture",
  "agents.live.stage.finding": "Finding",
  "agents.live.stage.state.done": "done",
  "agents.live.stage.state.current": "in progress",
  "agents.live.stage.state.recovering": "recovering from an error",
  "agents.live.stage.state.todo": "pending",
  "agents.live.stage.at": "Last event {time}",
  "agents.live.viewOnly": "View only",
  "agents.live.reconnect": "Reconnect now",
  "agents.live.canvasLabel": "Live screen of the agent's browser, view only",
  "agents.live.noFrame": "No frame recorded yet.",
  "agents.steps.title": "Steps",
  "agents.steps.hint": "Newest first",
  "agents.steps.polling": "Live · refreshes every 2.5 s",
  "agents.steps.empty": "No steps recorded for this run.",
  "agents.steps.openFrame": "Enlarge the frame for step {sequence}",
  "agents.steps.group.session": "Session and navigation",
  "agents.steps.group.inProgress": "In progress",
  "agents.steps.group.count.one": "{count} step",
  "agents.steps.group.count.other": "{count} steps",
  "agents.steps.recovery.one": "Assisted recovery · {count} action",
  "agents.steps.recovery.other": "Assisted recovery · {count} actions",
  "agents.live.overlay.IDLE": "Agent waiting for work · next check within 5 min",
  "agents.live.overlay.STOPPED": "Last run failed · next check within 5 min",
  "agents.live.overlay.WAITING_WINDOW": "Outside the schedule · {detail}",
  "agents.live.overlay.PAUSED": "Agent paused · no new lookup starts until it is resumed",
  "agents.live.overlay.NO_CREDENTIALS":
    "IOB credentials missing · the agent cannot sign in to the simulator",
  "agents.kind.SESSION": "Session",
  "agents.kind.NAVIGATE": "Navigate",
  "agents.kind.INPUT": "Input",
  "agents.kind.CLICK": "Click",
  "agents.kind.WAIT": "Wait",
  "agents.kind.READ": "Read",
  "agents.kind.EXTRACT": "Extract",
  "agents.kind.RECOVER": "Recover",
  "agents.kind.PAUSE": "Pause",
  "agents.kind.ERROR": "Error",
  "agents.frame.title": "Frame · {time}",
  "agents.frame.alt": "Frame captured by the agent at {time}",
  "agents.frame.error": "Could not load the frame.",
  "agents.frame.loading": "Loading frame…",
  "agents.findings.title": "Run findings",
  "agents.findings.boundary":
    "Findings are review material: they record what the simulator page showed. They never create, approve or publish rules; a rule only changes with the official act, through proposal → review → publication.",
  "agents.findings.filter": "Filter by outcome",
  "agents.findings.all": "All",
  "agents.findings.compare": "Compare with published rules",
  "agents.findings.compareShort": "Compare rules",
  "agents.findings.viewFrame": "View frame",
  "agents.findings.empty": "No findings in this run.",
  "agents.findings.emptyFiltered": "No findings with this outcome.",
  "agents.outcome.ST_FOUND": "ST found",
  "agents.outcome.NO_ST_FOUND": "No ST",
  "agents.outcome.INTERNAL_ST_ONLY": "Internal ST only",
  "agents.outcome.NCM_NOT_FOUND": "NCM not found",
  "agents.outcome.UNREADABLE": "Unreadable",
  "agents.outcome.INCONCLUSIVE": "Inconclusive",
  "agents.col.ncm": "NCM",
  "agents.col.route": "Route",
  "agents.col.outcome": "Outcome",
  "agents.col.mva": "Original MVA",
  "agents.col.cest": "CEST",
  "agents.col.validity": "Validity",
  "agents.col.basis": "Legal basis",
  "agents.col.captured": "Captured",
  "agents.col.actions": "Actions",
  "agents.validity.range": "{from} to {to}",
  "agents.validity.from": "from {from}",
  "agents.runs.title": "Run history",
  "agents.runs.viewing": "Viewing the run started {time}.",
  "agents.runs.backToLatest": "Back to the current run",
  "agents.runs.select": "View the run from {time}",
  "agents.runs.col.started": "Started",
  "agents.runs.col.status": "Status",
  "agents.runs.col.duration": "Duration",
  "agents.runs.col.lookups": "Lookups",
  "agents.runs.col.findings": "Findings",
  "agents.runs.col.errors": "Errors",
  "agents.runs.trigger.SCHEDULE": "Scheduled",
  "agents.runs.trigger.MANUAL": "Manual",
  "agents.run.status.RUNNING": "Running",
  "agents.run.status.SUCCEEDED": "Succeeded",
  "agents.run.status.FAILED": "Failed",
  "agents.run.status.STOPPED": "Stopped",
  "agents.noRuns.title": "No runs yet",
  "agents.noRuns.body":
    "When the agent starts within its weekly schedule, the screen, steps and findings appear here.",
  "agents.status.PAUSED": "Paused",
  "agents.workingOn": "Working on",
  "agents.workingOnPosition": "{position} of {count} in the queue",
  "agents.workingOnWaiting": "None running · {count} waiting in the queue",
  "agents.workingOnNone": "No task in the queue",
  "agents.workingOnGaps": "Queue empty · coverage gaps",
  "agents.schedule.weekly": "Weekly schedule",
  "agents.schedule.block.mondayToThursday": "Monday to Thursday",
  "agents.schedule.block.friday": "Friday",
  "agents.schedule.block.weekend": "Saturday and Sunday",
  "agents.schedule.off": "Off",
  "agents.schedule.perDayHours": "{hours} a day",
  "agents.schedule.allDay": "24 hours",
  "agents.schedule.allDayNote": "All day · 00:00–24:00",
  "agents.schedule.from": "Start",
  "agents.schedule.to": "End",
  "agents.schedule.nextDay": "ends at {time} the next day",
  "agents.schedule.issue.CLOCK_INVALID": "Use the 24 h format HH:MM, from 00:00 to 23:59.",
  "agents.schedule.fullDayNextDay": "24 h, ends at {time} the next day",
  "agents.schedule.week": "Week · Brasília time",
  "agents.schedule.dayAria": "{day}: {ranges}",
  "agents.schedule.dayAriaOff": "{day}: no hours",
  "agents.schedule.legendOn": "Active hours",
  "agents.schedule.legendNow": "Now",
  "agents.schedule.noActive":
    "No active hours: the agent makes no lookups until a block is switched on.",
  "agents.schedule.weeklyHours": "Hours per week",
  "agents.schedule.weeklyHoursMeta": "{percent} of the week",
  "agents.schedule.perWeek": "Per week",
  "agents.schedule.perWeekValue": "{count} lookups",
  "agents.schedule.perWeekMeta": "at the effective pace, within the schedule",
  "agents.scheduleNow": "Schedule",
  "agents.scheduleNow.active": "Within hours",
  "agents.scheduleNow.idle": "Outside hours",
  "agents.scheduleNow.none": "No active hours",
  "agents.scheduleNow.until": "until {time}",
  "agents.scheduleNow.resumes": "resumes {time}",
  "agents.scheduleNow.always": "24 h, 7 days",
  "agents.queueEta": "Queue remaining",
  "agents.queueEtaEmpty": "Nothing queued",
  "agents.schedule.day.0": "Mon",
  "agents.schedule.dayLong.0": "Monday",
  "agents.schedule.day.1": "Tue",
  "agents.schedule.dayLong.1": "Tuesday",
  "agents.schedule.day.2": "Wed",
  "agents.schedule.dayLong.2": "Wednesday",
  "agents.schedule.day.3": "Thu",
  "agents.schedule.dayLong.3": "Thursday",
  "agents.schedule.day.4": "Fri",
  "agents.schedule.dayLong.4": "Friday",
  "agents.schedule.day.5": "Sat",
  "agents.schedule.dayLong.5": "Saturday",
  "agents.schedule.day.6": "Sun",
  "agents.schedule.dayLong.6": "Sunday",
  "agents.schedule.title": "Schedule and pace",
  "agents.schedule.hint": "Weekly schedule in Brasília time (America/Sao_Paulo), 24 h clock",
  "agents.schedule.pause": "Pause between lookups (s)",
  "agents.schedule.pauseHint": "Between {min} and {max} seconds",
  "agents.schedule.maxPerHour": "Max lookups per hour",
  "agents.schedule.maxPerHourHint": "Up to {max} per hour",
  "agents.schedule.fallback": "Use coverage gaps when the queue is empty",
  "agents.schedule.fallbackHint":
    "With no queued task, the agent looks up the most frequent coverage gaps.",
  "agents.schedule.killSwitch": "Pause the agent",
  "agents.schedule.killSwitchOn":
    "The agent is paused. No new IOB lookups until resumed; the VM stays up.",
  "agents.schedule.killSwitchOff":
    "Stops IOB lookups at the agent's next check (within 5 min) without shutting down the VM.",
  "agents.schedule.pauseConfirm.title": "Pause the agent?",
  "agents.schedule.pauseConfirm.body":
    "The agent finishes the current lookup and starts no other IOB lookup until someone resumes it. The queue and task progress are kept.",
  "agents.schedule.pauseConfirm.confirm": "Pause agent",
  "agents.schedule.effective": "Effective pace",
  "agents.schedule.effectiveValue": "{count} lookups/h",
  "agents.schedule.limitedByCap": "capped by the hourly maximum",
  "agents.schedule.limitedByPause": "limited by the pause",
  "agents.schedule.issue.PAUSE_RANGE":
    "The pause must be a whole number between {min} and {max} seconds.",
  "agents.schedule.issue.RATE_RANGE":
    "The hourly maximum must be a whole number between 1 and {max}.",
  "agents.schedule.updated": "Updated by {who} on {time}",
  "agents.schedule.neverUpdated": "Default values, never changed",
  "agents.schedule.save": "Save schedule and pace",
  "agents.schedule.discard": "Discard",
  "agents.schedule.saved": "Schedule and pace saved. The agent applies them on its next lookup.",
  "agents.schedule.conflict":
    "Someone else changed these settings. The current values are loaded; review and save again.",
  "agents.schedule.error": "Could not save. Try again.",
  "agents.schedule.dirty": "Unsaved changes",
  "agents.who.you": "you",
  "agents.credentials.title": "IOB credentials",
  "agents.credentials.configured": "Configured",
  "agents.credentials.notConfigured": "Not configured",
  "agents.credentials.notConfiguredBody":
    "Without credentials the agent cannot sign in to IOB Simulador.",
  "agents.credentials.account": "Account",
  "agents.credentials.updated": "Updated by {who} on {time}",
  "agents.credentials.explain":
    "Saved directly to the platform's credential store. They are not kept in the database, in logs or in this browser, and nobody can read them back from here. The agent uses the new credentials on its next session.",
  "agents.credentials.username": "IOB username",
  "agents.credentials.password": "IOB password",
  "agents.credentials.save": "Save credentials",
  "agents.credentials.replace": "Replace credentials",
  "agents.credentials.saving": "Saving…",
  "agents.credentials.saved":
    "Credentials saved securely. The agent uses them on its next session.",
  "agents.credentials.error": "Could not save the credentials. Nothing changed; try again.",
  "agents.credentials.unavailableTitle": "Credential store not configured",
  "agents.credentials.unavailableBody":
    "This environment does not have the IOB credential store yet. Once the infrastructure is ready, credentials can be set here.",
  "agents.queue.title": "Task queue",
  "agents.queue.description":
    "The agent works the queue top to bottom, one lookup at a time, at the configured pace and weekly schedule.",
  "agents.queue.pace": "{perHour} lookups/h · {perWeek} per week · {hours} of schedule per week",
  "agents.queue.new": "New task",
  "agents.queue.empty.title": "The queue is empty",
  "agents.queue.empty.body":
    "Create a task for the agent to look up the catalog, the NCMs we use or a list.",
  "agents.queue.emptyGaps": "While the queue is empty, the agent works on coverage gaps.",
  "agents.queue.finished": "Finished",
  "agents.queue.workingNow": "Working now",
  "agents.queue.position": "Position {position}",
  "agents.queue.progress": "{processed} of {items}",
  "agents.queue.count.done": "{count} looked up",
  "agents.queue.count.cached": "{count} already covered",
  "agents.queue.count.failed": "{count} failed",
  "agents.queue.count.pending": "{count} pending",
  "agents.queue.count.skipped": "{count} skipped",
  "agents.queue.eta": "Estimate",
  "agents.queue.eta.minutes": "≈ {count} min of schedule",
  "agents.queue.eta.hours": "≈ {count} h of schedule",
  "agents.queue.eta.until": "ends ≈ {time} (Brasília)",
  "agents.queue.eta.done": "No pending items",
  "agents.queue.eta.paused": "Paused · no estimate",
  "agents.queue.eta.agentPaused": "Agent paused · no estimate",
  "agents.queue.eta.none": "No estimate: check schedule and pace",
  "agents.queue.eta.completed": "Completed on {time}",
  "agents.queue.eta.cancelled": "Cancelled on {time}",
  "agents.queue.created": "Created on {time}",
  "agents.queue.actions": "Actions for task {name}",
  "agents.queue.action.MOVE_UP": "Move up",
  "agents.queue.action.MOVE_DOWN": "Move down",
  "agents.queue.action.MOVE_TO_FRONT": "Move to front",
  "agents.queue.action.PAUSE": "Pause",
  "agents.queue.action.RESUME": "Resume",
  "agents.queue.action.CANCEL": "Cancel task",
  "agents.queue.details": "Details",
  "agents.queue.actionError": "Could not update the task. Try again.",
  "agents.queue.cancel.title": "Cancel the task “{name}”?",
  "agents.queue.cancel.body":
    "The {count} pending items will be skipped. What was already looked up stays recorded as findings. This cannot be undone.",
  "agents.queue.cancel.confirm": "Cancel task",
  "agents.queue.cancel.keep": "Keep in queue",
  "agents.task.status.QUEUED": "Queued",
  "agents.task.status.RUNNING": "Running",
  "agents.task.status.PAUSED": "Paused",
  "agents.task.status.COMPLETED": "Completed",
  "agents.task.status.CANCELLED": "Cancelled",
  "agents.task.scope.CATALOG": "Full NCM catalog",
  "agents.task.scope.CATALOG_CHAPTERS": "NCM catalog · chapters {chapters}",
  "agents.task.scope.SEEN": "NCMs used in our calculations (12 months)",
  "agents.task.scope.LIST": "List of {count} NCMs",
  "agents.task.scope.LOOKUP_JOB": "System lookup",
  "agents.task.scope.SWEEP": "Web research sweep",
  "agents.task.item.PENDING": "Pending",
  "agents.task.item.IN_PROGRESS": "Looking up",
  "agents.task.item.DONE": "Looked up",
  "agents.task.item.CACHED": "Already covered",
  "agents.task.item.FAILED": "Failed",
  "agents.task.item.SKIPPED": "Skipped",
  "agents.task.detail.route": "Route",
  "agents.task.detail.scope": "Scope",
  "agents.task.detail.started": "Started",
  "agents.task.detail.items": "Items",
  "agents.task.detail.filter": "Filter items by status",
  "agents.task.detail.all": "All",
  "agents.task.detail.col.ncm": "NCM",
  "agents.task.detail.col.status": "Status",
  "agents.task.detail.col.outcome": "Outcome",
  "agents.task.detail.col.attempts": "Attempts",
  "agents.task.detail.col.updated": "Updated",
  "agents.task.detail.empty": "No items with this status.",
  "agents.task.detail.showing": "{shown} of {total}",
  "agents.task.detail.notFound": "Task not found.",
  "agents.create.title": "New task",
  "agents.create.name": "Name",
  "agents.create.nameHint": "Left blank, we use “{name}”.",
  "agents.create.scope": "What to look up",
  "agents.create.scope.CATALOG.body":
    "Every active NCM of the official catalog, or only the chosen chapters.",
  "agents.create.scope.SEEN.body": "NCMs that appeared in our calculations in the last 365 days.",
  "agents.create.scope.LIST": "NCM list",
  "agents.create.scope.LIST.body": "Paste the codes: one per line or comma separated.",
  "agents.create.chapters": "Chapters (optional)",
  "agents.create.chaptersAll": "No chapter chosen: the whole catalog.",
  "agents.create.chaptersSome.one": "{count} chapter chosen",
  "agents.create.chaptersSome.other": "{count} chapters chosen",
  "agents.create.chaptersClear": "Clear",
  "agents.create.chapter": "Chapter {chapter}",
  "agents.create.list": "NCMs",
  "agents.create.listPlaceholder": "8516.31.00\n85094050\n2203.00.00, 3304.99.90",
  "agents.create.listCount": "Valid: {count}",
  "agents.create.listDuplicates": "Duplicates ignored: {count}",
  "agents.create.listInvalid": "Invalid: {count}",
  "agents.create.listInvalidLine": "Line {line}: “{value}”",
  "agents.create.listMore": "and {count} more",
  "agents.create.listTooMany": "At most {max} NCMs per task.",
  "agents.create.listEmpty": "Paste at least one 8-digit NCM.",
  "agents.create.listInvalidBlock": "Fix or remove the invalid lines to create the task.",
  "agents.create.origin": "Origin UF",
  "agents.create.destination": "Destination UF",
  "agents.create.skipCovered": "Skip NCMs already covered",
  "agents.create.skipCoveredHint":
    "Does not look up what a published rule or a finding from the last 30 days already answers.",
  "agents.create.placement": "Queue placement",
  "agents.create.placement.END": "At the end of the queue",
  "agents.create.placement.FRONT": "At the front",
  "agents.create.estimate": "Estimate",
  "agents.create.estimateOnCreate":
    "Calculated on create: the NCM total is only known on the server.",
  "agents.create.estimateList": "{count} lookups · {eta} · {until}",
  "agents.create.estimateSkip": "Before skipping covered NCMs; the real total may be lower.",
  "agents.create.estimatePending": "Paste the list to see the estimate.",
  "agents.create.submit": "Create task",
  "agents.create.creating": "Creating…",
  "agents.create.error": "Could not create the task. Check the fields and try again.",
  "agents.jobs.title": "System lookups",
  "agents.jobs.description":
    "Read only. Backend workflows submit thousands of NCM × route entries; what a published rule covers is answered at once, the rest goes to research.",
  "agents.jobs.empty": "No lookup submitted by the system.",
  "agents.jobs.entries": "{count} entries",
  "agents.jobs.lanes": "Research",
  "agents.jobs.lane.iob": "IOB",
  "agents.jobs.lane.web": "Web",
  "agents.jobs.lane.none": "Cache only",
  "agents.jobs.eta": "Expected",
  "agents.jobs.heading": "Batch lookup · calculation date {date}",
  "agents.jobs.workflow": "Workflow",
  "agents.jobs.created": "Created",
  "agents.jobs.completed": "Completed",
  "agents.jobs.calcDate": "Calculation date",
  "agents.jobs.openTask": "View task",
  "agents.jobs.noTask": "No IOB task",
  "agents.jobs.breakdown": "Entries by status",
  "agents.jobs.status.RUNNING": "Running",
  "agents.jobs.status.COMPLETED": "Completed",
  "agents.jobs.status.CANCELLED": "Cancelled",
  "agents.jobs.entry.COVERED": "Covered",
  "agents.jobs.entry.FOUND": "Found",
  "agents.jobs.entry.NO_ST": "No ST",
  "agents.jobs.entry.NOT_FOUND": "Not found",
  "agents.jobs.entry.FAILED": "Failed",
  "agents.jobs.entry.QUEUED": "Queued",
  "agents.jobs.entry.RESEARCHING": "Researching",
  "nav.mode": "Mode",
  "nav.mode.developers": "Developers",
  "nav.developers.keys": "API keys",
  "nav.developers.requests": "Requests",
  "nav.developers.docs": "API documentation",
  "nav.developers.mcp": "MCP tools",
  "nav.developers.section": "API",
  "nav.developers.dock": "Developers",
  "nav.viewAs.title": "Role preview",
  "nav.viewAs.help":
    "Preview navigation and available tools. Your account stays Super admin; actions still use your real account.",
  "nav.viewAs.label": "View as",
  "nav.viewAs.own": "Me",
  "nav.viewAs.short.commercial": "Commercial",
  "nav.viewAs.short.manager": "Manager",
  "nav.viewAs.short.developer": "Dev",
  "nav.viewAs.short.reader": "Reader",
  "nav.viewAs.acting": "Viewing as {role}",
  "nav.viewAs.banner":
    "You are viewing the workspace as {role}. The super-admin session is unchanged.",
  "nav.viewAs.exit": "Return to Super admin",
  "nav.operationsHome": "Operations",
  "nav.menu": "Navigation menu",
  "nav.open": "Open navigation",
  "nav.close": "Close navigation",
  "nav.collapse": "Collapse navigation",
  "nav.expand": "Expand navigation",
  "nav.locked": "No permission",

  "trace.origin": "Origin",
  "trace.state": "State",
  "trace.next": "Next step",
  "trace.howItWorks": "How it works",
  "trace.evidence.origin": "Observed source",
  "trace.evidence.state": "Triage",
  "trace.evidence.next": "Propose or archive",
  "trace.sources.origin": "Reviewed official source",
  "trace.sources.state": "Collection",
  "trace.sources.next": "Run or replay",
  "trace.proposals.origin": "Accepted evidence",
  "trace.proposals.state": "Review",
  "trace.proposals.next": "Publish a ruleset",
  "trace.rulesets.origin": "Approved proposals",
  "trace.rulesets.state": "Publication",
  "trace.rulesets.next": "Calculation pins the version",
  "trace.rules.origin": "HS chapter",
  "trace.rules.state": "Published rule",
  "trace.rules.next": "Gap without an invented rate",
  "trace.rules.chapter.origin": "HS chapter",
  "trace.rules.chapter.state": "Official classification",
  "trace.rules.chapter.next": "Published subset, if any",
  "trace.audit.origin": "Actor",
  "trace.audit.state": "Action",
  "trace.audit.next": "Correlation",
  "commandSearch.trigger": "Search tax workspace",
  "commandSearch.title": "Fiscal search",
  "commandSearch.description":
    "Launch an extraction, open the Siscomex catalog (classification, not a rate) or a stored record.",
  "commandSearch.placeholder": "ICMS SP stationery, NCM 84713012, or a destination…",
  "commandSearch.results": "Fiscal search results",
  "commandSearch.emptyTitle": "Nothing found in this base",
  "commandSearch.emptyBody": "Try a tax family, UF, NCM, HS chapter, or an evidence title.",
  "commandSearch.move": "Move",
  "commandSearch.open": "Open",
  "commandSearch.close": "Close search",
  "commandSearch.honesty": "Catalog classifies. Only a published ruleset calculates.",
  "commandSearch.group.launch": "Launch extraction",
  "commandSearch.group.evidence": "Evidence",
  "commandSearch.group.rules": "Rules",
  "commandSearch.group.sources": "Sources",
  "commandSearch.group.proposals": "Proposals",
  "commandSearch.group.calculations": "Calculations",
  "commandSearch.group.catalog": "NCM catalog",
  "commandSearch.launch.label": "Search {query} on official sources",
  "commandSearch.launch.hint": "Fetcher and extractor. Does not publish a rule.",
  "commandSearch.catalog.label": "NCM {ncm} in the Siscomex catalog",
  "commandSearch.catalog.hint": "Official classification. Not a published rate.",
  "commandSearch.catalog.prefix.label": "NCM {ncm}… in the Siscomex catalog",
  "commandSearch.catalog.chapter.label": "HS {chapter} · {title}",
  "commandSearch.catalog.chapter.hint": "Harmonized System chapter. Not a rate.",
  "commandSearch.searching": "Searching {groups}…",
  "commandSearch.partialError": "Could not search {groups}.",
  "commandSearch.emptyPartialTitle": "Nothing found in the categories that answered",
  "commandSearch.denied": "Outside your access, not searched: {groups}.",
  "ui.sort.label": "Sort by",
  "ui.sort.direction": "Order: {direction}",
  "ui.table.staleError": "The list could not be refreshed. These rows may be out of date.",
  "ui.table.refreshing": "Refreshing…",
  "ui.table.loading": "Loading results…",
  "ui.table.density": "Density",
  "ui.table.density.normal": "Normal",
  "ui.table.density.compact": "Compact",
  "ui.table.columns": "Columns",
  "ui.table.columnsLegend": "Secondary columns",
  "ui.drawer.navLabel": "Move through the list",
  "ui.drawer.previous": "Previous in list",
  "ui.drawer.next": "Next in list",
  "ui.drawer.position": "{index} of {total}",
  "ui.toast.region": "Notifications",
  "ui.toast.close": "Dismiss notification",
  "ui.stat.error": "This figure could not be loaded",
  "ui.stat.unknown": "No data for this period",
  "ui.stat.stale": "Out of date",
  "ui.stat.staleSince": "Out of date · {since}",
  "lots.summary.count.one": "{count} lot",
  "lots.summary.count.other": "{count} lots",
  "lots.summary.window": "· period: {period}",
  "lots.toast.exported": "{format} exported · {count} items",
  "lots.toast.truncated": "{format} exported up to the {cap}-item limit",
  "lots.toast.failed": "{format} export did not finish",
  "proposals.summary.count.one": "{count} proposal",
  "proposals.summary.count.other": "{count} proposals",
  "evidence.toast.APPROVED.one": "{count} document approved",
  "evidence.toast.APPROVED.other": "{count} documents approved",
  "evidence.toast.REJECTED.one": "{count} document rejected",
  "evidence.toast.REJECTED.other": "{count} documents rejected",
  "evidence.toast.DUPLICATE.one": "{count} document marked as duplicate",
  "evidence.toast.DUPLICATE.other": "{count} documents marked as duplicate",

  "common.placeholder.url": "https://…",
  "common.placeholder.evidencePath": "/evidence/…",
  "common.placeholder.sourceRunPath": "/sources/…/runs/…",
  "common.placeholder.uuid": "00000000-0000-0000-0000-000000000000",
  "common.placeholder.time": "HH:MM",
  "common.search": "Search",
  "proposals.filter.search": "Summary, reference or NCM",
  "rulesets.filter.search": "Version or author",
  "rules.filter.search": "NCM, excerpt or legal reference",
  "audit.filter.search": "Action, actor or correlation",
  "rulesets.inForce": "Ruleset in force",
  "rulesets.inForce.missing": "No published ruleset",
  "common.filters": "Filters",
  "common.moreFilters": "More filters",
  "common.clear": "Clear",
  "common.clearFilters": "Clear filters",
  "date.placeholder.dmy": "dd/mm/yyyy",
  "date.placeholder.mdy": "mm/dd/yyyy",
  "date.openCalendar": "Open calendar",
  "common.apply": "Apply",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.back": "Back",
  "common.next": "Next",
  "tabs.scrollNext": "More tabs",
  "tabs.scrollPrev": "Previous tabs",
  "common.confirm": "Confirm",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.loading": "Loading…",
  "common.refresh": "Refresh",
  "common.retry": "Try again",
  "common.details": "Details",
  "common.status": "Status",
  "common.jurisdiction": "Jurisdiction",
  "common.publisher": "Publisher",
  "common.updated": "Updated",
  "common.created": "Created",
  "common.author": "Author",
  "common.reviewer": "Reviewer",
  "common.reason": "Reason",
  "common.none": "None",
  "common.all": "All",
  "common.selected.one": "{count} selected",
  "common.selected.other": "{count} selected",
  "common.selectAll": "Select all on page",
  "common.selectRow": "Select {label}",
  "common.results.one": "{count} result",
  "common.results.other": "{count} results",
  "common.loadMore": "Load more",
  "common.loadingMore": "Loading results…",
  "common.endOfList": "End of list",
  "common.firstPage": "First page",
  "common.pageSize": "Rows per page",
  "common.sortBy": "Sort by {field}",
  "common.sortAscending": "ascending",
  "common.sortDescending": "descending",
  "auth.brand.about": "Discover TaxChannel",
  "common.language": "Language",
  "common.environment": "Environment",
  "common.of": "of",
  "common.yes": "Yes",
  "common.no": "No",
  "common.notAvailable": "—",
  "common.workspaceHome": "Workspace home",

  "state.empty.title": "No results in this slice",
  "state.empty.body": "Clear the filters to see the list, or search with another term.",
  "stepper.state.pending": "pending",
  "stepper.state.current": "current step",
  "stepper.state.complete": "complete",
  "stepper.state.invalid": "needs a fix",
  "stepper.state.blocked": "blocked until an earlier step is fixed",
  "stepper.state.submitting": "submitting",
  "stepper.state.result": "result",
  "state.error.title": "Could not load",
  "state.error.body": "The request failed. Check your connection and try again.",
  "state.loading.label": "Loading content",

  "access.denied.title": "Access denied",
  "access.denied.body": "Your role does not include {permission}. Ask the tax workspace admin.",
  "access.denied.short": "Requires {permission}",
  "access.disabled.title": "Action not available yet",
  "access.disabled.body": "{reason}",
  "access.unavailable.title": "Service unavailable",
  "access.unavailable.body": "A required dependency is not responding: {reason}. Try again later.",
  "access.requestAccess": "Request access",
  "access.legend": "Denied, disabled and unavailable are distinct states.",

  "auth.accessTitle": "Sign in to your account",
  "auth.signIn": "Sign in",
  "auth.email": "Email",
  "auth.emailPlaceholder": "name@backchannel.com.br",
  "auth.password": "Password",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.forgotPassword": "Forgot password?",
  "auth.resetPassword": "Reset password",
  "auth.resetPasswordDescription":
    "We'll email a reset link in the language chosen for this account.",
  "auth.resetLinkDescription": "Choose a new password to sign in to Tax Operations.",
  "auth.error.passwordMismatch": "The passwords do not match.",
  "auth.invite.title": "Set up your account",
  "auth.invite.description":
    "Choose your password first. On the next step, you can add a passkey or continue to your workspace.",
  "auth.invite.activationError":
    "We could not activate your account. Try again. If this continues, contact your administrator.",
  "auth.invite.submit": "Activate account",
  "auth.invite.invalid": "This invite is invalid or has expired. Ask for a new invite.",
  "auth.invite.invalidHelp": "Request a new invite from a super admin.",
  "auth.invite.displayName": "How we should address you",
  "auth.invite.expires": "Invite valid until {date}",
  "auth.invite.passkeyTitle": "Add a passkey (optional)",
  "auth.invite.passkeyDescription":
    "A passkey signs in to this workspace without a password. Skip and add one later in your profile.",
  "auth.invite.passkeySkip": "Not now",
  "auth.passwordPolicy":
    "At least 8 characters. No uppercase letters, numbers or symbols required.",
  "auth.error.passwordLength": "Use between 8 and 128 characters.",
  "auth.sendResetLink": "Send link",
  "auth.resetMissing": "This reset link is invalid or has expired. Request a new one from Sign in.",
  "auth.newPassword": "New password",
  "auth.confirmPassword": "Confirm new password",
  "auth.confirmReset": "Set new password",
  "auth.backToSignIn": "Back to sign in",
  "auth.resetting": "Updating…",
  "auth.resetSent": "If this account can be recovered, we sent a reset link.",
  "auth.resetComplete": "Password updated. Sign in with your new password.",
  "auth.signOut": "Sign out",
  "auth.accountMenu": "Account menu",
  "auth.accountTrigger": "Open the account menu for {name}",
  "auth.accountSection": "Your account",
  "auth.accountSettings": "My account",
  "auth.enterDevelopers": "Open Developers",
  "auth.backToOperations": "Back to Operations",
  "auth.languagePreference": "Language preference",
  "auth.signingIn": "Authenticating…",
  "auth.loading.title": "Preparing your space.",
  "auth.loading.description": "A moment to open your workspace.",
  "auth.loading.delayedDetail": "You can keep waiting.",
  "auth.loading.territory": "Brazil · Fiscal territory",
  "auth.loading.country": "Brazil",
  "auth.loading.reconnect": "Restoring your connection",
  "auth.loading.session": "Restoring the protected session",
  "auth.loading.identity": "Verifying your BackChannel identity",
  "auth.loading.workspace": "You will continue as soon as it is ready.",
  "auth.loading.delayed": "This is taking longer than usual.",
  "auth.session": "Session",
  "auth.sessionUnavailable": "Your session could not be loaded",
  "auth.sessionUnavailableDescription":
    "Your identity is still authenticated, but the tax workspace did not respond. Try again or sign out.",
  "auth.role": "Role",
  "auth.permissions": "Permissions",
  "auth.mock": "Mock session",
  "auth.callback.title": "Completing sign-in",
  "auth.callback.body": "Exchanging the authorization code for session tokens.",
  "auth.error.title": "Sign-in failed",
  "auth.error.state": "Invalid state parameter: possible CSRF attempt.",
  "auth.error.missingCode": "The provider did not return an authorization code.",
  "auth.error.exchange": "The authorization code exchange failed.",
  "auth.error.config": "Sign-in is not configured: {reason}.",
  "auth.error.credentials": "Could not sign in. Check your email and password.",
  "auth.error.resetEmailRequired": "Enter your email first to reset your password.",
  "auth.error.resetMismatch": "Passwords do not match.",
  "auth.error.reset": "Could not reset your password. Request a new link and try again.",
  "auth.error.network":
    "The identity service is unavailable right now. Check your connection and try again.",
  "auth.error.challenge":
    "Your account requires an additional step. Finish account setup and try again.",
  "auth.error.passwordResetRequired":
    "Your password needs to be reset. Use “Forgot password?” to continue.",
  "auth.passkey": "Sign in with passkey",
  "auth.passkeySigningIn": "Waiting for your passkey…",
  "auth.google": "Continue with Google",
  "auth.googleRedirecting": "Opening Google…",
  "auth.googleReaderNote": "First Google sign-in: Reader role.",
  "auth.continueWithEmail": "Continue with email",
  "auth.otherOptions": "Other sign-in options",
  "auth.emailFormLabel": "Sign in with email and password",
  "auth.lastUsed": "Last used on this browser",
  "auth.callback.googleBody": "Confirming your Google sign-in.",
  "auth.callback.provisionedTitle": "Account created",
  "auth.callback.provisionedBody":
    "Account created as Reader — ask an administrator to adjust your access.",
  "auth.callback.provisionedHint":
    "You can already open the read-only areas. A super admin can change your role in Administration → Users.",
  "auth.callback.provisionedContinue": "Continue",
  "auth.error.google": "Could not sign in with Google. Try again.",
  "auth.error.googleNotInvited":
    "This Google account has no access to Tax Operations. Use your @backchannel.com.br account or ask a super admin for access.",
  "auth.error.googleRejected": "Google did not confirm this sign-in. Try again.",
  "auth.error.googleUnavailable":
    "Google sign-in is not available right now. Use email and password or a passkey.",
  "auth.error.googleCancelled": "Google sign-in was cancelled.",
  "auth.or": "or",
  "auth.passkeyHostHint": "Available at tax.backchannel.com.br or this localhost.",
  "auth.passkeyHostHintDeployed": "Available at tax.backchannel.com.br.",
  "auth.error.passkey": "The passkey could not be verified. Try again.",
  "auth.error.passkeyUnsupported": "This browser does not support passkeys.",
  "auth.error.passkeyCancelled":
    "The passkey was not used. Try again or choose another way to sign in.",
  "auth.error.passkeyOrigin":
    "Open Tax Operations from its BackChannel hostname to use this passkey.",
  "auth.error.passkeyUnavailable":
    "Passkey sign-in is temporarily unavailable. Use your password or try again later.",
  "auth.error.passkeyTimeout": "The passkey prompt timed out. Try again or use your password.",
  "auth.accessPending.title": "Tax workspace access pending",
  "auth.accessPending.body":
    "Your BackChannel identity is verified, but it has not been enrolled as a tax operator in the tax workspace yet. Ask an administrator to add it to the operator registry.",
  "auth.accessPending.request": "Request tax workspace access",
  "auth.expired": "Your session expired. Sign in again to continue.",
  "auth.tokenNotice":
    "The identity token stays in memory; this tab keeps a scoped refresh token and never records credentials.",
  "auth.loginDescription": "Brazilian tax evidence, rules and calculations.",
  "auth.brand.secure": "Access protected by BackChannel identity.",
  "auth.brand.help": "Need help?",
  "auth.map.title": "Brazil fiscal map",
  "auth.map.legend.label": "Map legend",
  "auth.map.legend.unwatched": "Outside the current list",
  "auth.map.stateLabel": "{state} ({uf}). Capital {capital}. {watch}.",
  "auth.map.watched": "Watched SEFAZ",
  "auth.map.unwatched": "Outside the current SEFAZ list",
  "auth.map.fact.AC": "Named after the Aquiri river; it borders Peru and Bolivia.",
  "auth.map.fact.AL": "Brazil's second-smallest state; Maceió sits between lagoons and sea.",
  "auth.map.fact.AP": "The Equator crosses Amapá.",
  "auth.map.fact.AM": "Brazil's largest state: most of Brazilian Amazonia is here.",
  "auth.map.fact.BA": "Salvador was Brazil's first capital.",
  "auth.map.fact.CE": "Fortaleza has one of the country's longest urban waterfronts.",
  "auth.map.fact.DF": "Brasília opened in 1960; it is a federal district, not a state.",
  "auth.map.fact.ES": "Vitória is an island capital, linked to the mainland by bridges.",
  "auth.map.fact.GO": "Heart of the Cerrado; Goiânia was planned in 1933.",
  "auth.map.fact.MA": "Lençóis Maranhenses are dunes that fill with rainwater lagoons.",
  "auth.map.fact.MT": "Home to the northern Pantanal and Chapada dos Guimarães.",
  "auth.map.fact.MS": "Bonito and the southern Pantanal sit in this state.",
  "auth.map.fact.MG": "It has more municipalities than any other state.",
  "auth.map.fact.PA": "Belém sits at the Amazon's mouth; Marajó Island is vast.",
  "auth.map.fact.PB": "Ponta do Seixas is the easternmost point of the Americas.",
  "auth.map.fact.PR": "Iguaçu Falls sit on the border with Argentina.",
  "auth.map.fact.PE": "Recife and Olinda form the colonial pair on this coast.",
  "auth.map.fact.PI": "It has the Northeast's shortest coast, at the Parnaíba delta.",
  "auth.map.fact.RJ": "It was Brazil's capital until 1960.",
  "auth.map.fact.RN": "Natal was founded on Christmas Day, 1599.",
  "auth.map.fact.RS": "The only majority-pampas state; gaúcho country.",
  "auth.map.fact.RO": "It grew from the Madeira-Mamoré railway territory.",
  "auth.map.fact.RR": "Brazil's northernmost state; Mount Roraima is a tepui.",
  "auth.map.fact.SC": "Florianópolis is an island capital, with strong European immigration.",
  "auth.map.fact.SP": "The most populous state; the BackChannel office is in Vila Olímpia.",
  "auth.map.fact.SE": "Brazil's smallest state by area.",
  "auth.map.fact.TO": "The newest state, created in 1988 from northern Goiás.",
  "auth.map.hq.fact": "Rua Tenerife 31, suite 31A — Tenerife Building, Vila Olímpia.",
  "auth.map.capital": "Capital",
  "auth.map.sefaz": "SEFAZ",
  "auth.map.close": "Close",
  "auth.map.illustrationKind": "Regional illustration",
  "auth.map.regionArt.north": "Illustration of the North: territory, river and a cited document",
  "auth.map.regionArt.northeast":
    "Illustration of the Northeast: territory, sun on the coast and a cited document",
  "auth.map.regionArt.centralWest":
    "Illustration of the Central-West: territory, tablelands and a cited document",
  "auth.map.regionArt.southeast":
    "Illustration of the Southeast: territory, city blocks and a cited document",
  "auth.map.regionArt.south":
    "Illustration of the South: territory, araucaria pines and a cited document",
  "auth.map.hq.name": "BackChannel office",
  "auth.map.hq.eyebrow": "São Paulo",
  "auth.map.hq.role": "Office · Vila Olímpia",
  "auth.map.hq.address": "Address",
  "auth.map.hq.phone": "Phone",
  "auth.map.hq.openMaps": "Open in Google Maps",
  "auth.map.hq.pinLabel": "BackChannel office in Vila Olímpia, São Paulo",
  "auth.map.hq.illustrationAlt":
    "Illustration of the BackChannel office: São Paulo on the map and the suite 31A building in Vila Olímpia",
  "auth.map.hq.label": "São Paulo · HQ",
  "auth.domainHint": "Use your @backchannel.com.br account.",
  "auth.providersLoading": "Checking sign-in options…",
  "auth.providersFailed": "We couldn’t check Google sign-in.",
  "auth.error.emailRequired": "Enter your email.",
  "auth.error.emailInvalid": "Enter a valid email, like name@backchannel.com.br.",
  "auth.error.passwordRequired": "Enter your password.",
  "auth.atlas.title": "The tax territory, state by state.",
  "auth.atlas.intro": "Evidence, rules and calculations in one place.",
  "auth.atlas.context": "{count} SEFAZ on the watched source list",
  "auth.atlas.place": "Vila Olímpia",
  "auth.atlas.compactLabel": "Brazil, with the BackChannel office in São Paulo",
  "auth.value.label": "What the platform does",
  "auth.value.calculation": "ICMS, ST and IPI calculated by NCM and route",
  "auth.value.evidence": "Rules backed by official evidence",
  "auth.value.research": "IOB agent and SEFAZ research",

  "overview.workspace.eyebrow": "Product taxes",
  "overview.workspace.title": "Look up, calculate and review",
  "overview.workspace.description":
    "Find rules by product and route, calculate your spreadsheet and review the results.",
  "overview.mockNotice": "Local demo: visible data is simulated.",
  "overview.ledger.eyebrow": "Fiscal ledger",
  "overview.ledger.title": "What the base already holds, and what it does not yet govern",
  "overview.ledger.publishedOn": "Ruleset {version} published {date}.",
  "overview.ledger.publishedEmpty":
    "No ruleset is published. This system does not price lists yet.",
  "overview.ledger.unpublished": "Not published",
  "overview.ledger.noCount": "—",
  "overview.ledger.outsideBase": "outside this base",
  "overview.ledger.ofCatalog": "of {catalog}",
  "overview.ledger.state.published": "published",
  "overview.ledger.state.draft": "in review",
  "overview.ledger.state.reference": "reference, not governed",
  "overview.ledger.state.absent": "absent",
  "overview.ledger.state.notCollected": "not tracked here",
  "overview.ledger.family.ncm": "NCM",
  "overview.ledger.family.ncm.hint": "Siscomex catalog, not a rate",
  "overview.ledger.openCatalog": "Open the NCM reference catalog",
  "overview.ledger.openCestCatalog": "Open the CEST reference catalog",
  "overview.ledger.family.cest": "CEST",
  "overview.ledger.family.cest.hint": "CONFAZ catalog, not a rate",
  "overview.ledger.family.ipi": "IPI / TIPI",
  "overview.ledger.family.ipi.hint": "federal IPI rate (alíquota)",
  "overview.ledger.family.pisCofins": "PIS / COFINS",
  "overview.ledger.family.pisCofins.hint":
    "statutory catalog V2 in calculator · regime not accredited",
  "overview.ledger.family.icms": "Internal and interstate ICMS",
  "overview.ledger.family.icms.hint": "internal and interstate alíquota",
  "overview.ledger.family.icmsSt": "ICMS-ST",
  "overview.ledger.family.icmsSt.hint": "tax substitution",
  "overview.ledger.family.mva": "MVA / IVA-ST",
  "overview.ledger.family.mva.hint": "value-added margin",
  "overview.ledger.family.iss": "ISS",
  "overview.ledger.family.iss.hint": "outside this base: goods resale, not a municipal service",
  "overview.ledger.openPublished": "Open published rules",
  "overview.ledger.openDraft": "Open proposals in review",
  "overview.cycle.published": "Published",
  "overview.catalog.expiring": "Expire in 30 days",
  "overview.catalog.missingProvenance": "Missing provenance",
  "overview.coverage.eyebrow": "Territorial coverage",
  "overview.coverage.title": "Evidence and rules by UF",
  "overview.coverage.description":
    "See where published route rules and captured evidence are concentrated. Select a state to open its filtered catalog.",
  "overview.coverage.mode.label": "Coverage data",
  "overview.coverage.mode.rules": "Published rules",
  "overview.coverage.mode.evidence": "Evidence & news",
  "overview.coverage.map.title": "Interactive map of Brazil by UF",
  "overview.coverage.map.description":
    "Each state is selectable and shaded by its relative record count. Exact counts are available in the state details.",
  "overview.coverage.map.stateLabel": "{state}, {uf}: {count} records. Select for details.",
  "overview.coverage.legend.label": "Records per UF in this view",
  "overview.coverage.legend.none": "0 records",
  "overview.coverage.legend.low": "Lower",
  "overview.coverage.legend.mid": "Middle",
  "overview.coverage.legend.high": "Higher",
  "overview.coverage.legend.unknown": "No data",
  "overview.coverage.legend.explain.rules":
    "Colour = published rules citing the UF as origin or destination, in bands relative to the UFs in this view. Not a rate and not a national percentage.",
  "overview.coverage.legend.explain.evidence":
    "Colour = evidence and news captured per UF, in bands relative to the UFs in this view. Not a rate and not a national percentage.",
  "overview.coverage.legend.ufCount": "{count} UF",
  "overview.coverage.legend.range": "{min}–{max} · {count} UF",
  "overview.coverage.map.stateLabelUnknown":
    "{state}, {uf}: no data in this view. Select for details.",
  "overview.coverage.freshness.updated": "Updated {time}",
  "overview.coverage.freshness.stale": "Could not refresh · data from {time}",
  "overview.coverage.freshness.retry": "Try again",
  "overview.coverage.state.band": "{band} · {count} records in this view",
  "overview.coverage.state.unknown": "No data for this UF in “{mode}”",
  "overview.coverage.summary.unknown":
    "The read returned no per-UF coverage. No state is shown as zero.",
  "overview.coverage.list.title": "All UFs",
  "overview.coverage.list.description": "Text equivalent of the map · {mode}",
  "overview.coverage.list.sort": "Sort",
  "overview.coverage.list.sort.count": "Records",
  "overview.coverage.list.sort.name": "A–Z",
  "overview.coverage.list.sort.region": "Region",
  "overview.coverage.list.row": "{state} ({uf}), {region}: {count} records, {band} band",
  "overview.coverage.list.rowUnknown": "{state} ({uf}), {region}: no data",
  "overview.coverage.error.title": "Could not load coverage by UF",
  "overview.coverage.error.body":
    "The fiscal base and the map share one read. Nothing is shown as zero while it fails.",
  "overview.coverage.error.retry": "Try again",
  "overview.coverage.attribution": "Map geometry: @svg-maps/brazil · CC BY 4.0",
  "overview.coverage.clear": "National view",
  "overview.coverage.state.eyebrow": "Selected state",
  "overview.coverage.state.rules": "Published rules",
  "overview.coverage.state.evidence": "Evidence & news",
  "overview.coverage.state.origin": "Origin routes",
  "overview.coverage.state.destination": "Destination routes",
  "overview.coverage.state.pending": "evidence items await review in this state.",
  "overview.coverage.region.north": "North",
  "overview.coverage.region.northeast": "Northeast",
  "overview.coverage.region.centralWest": "Central-West",
  "overview.coverage.region.southeast": "Southeast",
  "overview.coverage.region.south": "South",
  "overview.coverage.updates.eyebrow": "Recent evidence for the UF",
  "overview.coverage.updates.title": "Latest regional updates",
  "overview.coverage.updates.scope": "Captured evidence",
  "overview.coverage.updates.error":
    "Regional updates are unavailable right now. Open the state evidence catalogue to continue.",
  "overview.coverage.updates.empty": "No state-scoped evidence has been captured yet.",
  "overview.coverage.openRules": "Open {uf} rules",
  "overview.coverage.openEvidence": "Open {uf} evidence",
  "overview.coverage.summary.eyebrow": "Country view",
  "overview.coverage.summary.title": "National snapshot",
  "overview.coverage.summary.description":
    "Bands compare records per UF within this view: rules with an origin or destination UF, or captured evidence. They do not measure national coverage or rates.",
  "overview.coverage.summary.nationalRules": "Rules without origin and destination UF",
  "overview.coverage.summary.federalEvidence": "Federal evidence",
  "overview.coverage.summary.federalPending": "Federal items pending",
  "overview.coverage.summary.empty": "No state-scoped records are available in this view.",
  "overview.coverage.ranking.title": "Highest concentration",
  "overview.coverage.ranking.description": "Relative to this view",
  "overview.coverage.crossing.federal":
    "{family} is federal. Map colours remain route rules or evidence by UF. There is no per-state rate for this family.",
  "overview.coverage.crossing.convenio":
    "{family} comes from CONFAZ. The map does not split this family by UF.",
  "overview.coverage.crossing.state":
    "{watched} of {total} watched SEFAZ hosts. Other UFs stay dim until a URL review. Colours are not rates.",
  "overview.coverage.crossing.stateAll":
    "All {total} SEFAZ are on the watched source list. Colours remain records per UF, not a {family} rate.",
  "overview.coverage.crossing.municipal": "ISS is municipal. This goods ledger does not track ISS.",
  "overview.coverage.crossing.stateWatched":
    "{state} ({uf}) is on the SEFAZ allow-list. The numbers below are this UF's rules and evidence, not the {family} rate.",
  "overview.coverage.crossing.stateUnwatched":
    "{state} ({uf}) has no reviewed SEFAZ host yet. Without a reviewed URL we do not invent a rate.",
  "overview.work.rules.action": "Look up rules",
  "overview.route.label": "Today's route",
  "overview.route.calculator": "Calculate spreadsheet",
  "overview.gaps.eyebrow": "What the base still does not govern",
  "overview.gaps.title": "Ledger gaps",
  "overview.gaps.description":
    "In-scope families still without a published rule. PIS/COFINS stay outside this base and do not need a form. Municipal ISS is out: BackChannel prices goods with federal and state taxes. We do not invent a rate.",
  "overview.gaps.empty":
    "In-scope families already have a published rule. PIS/COFINS remain outside this base. Municipal ISS is not collected.",
  "overview.gaps.openProposals": "Open proposals",
  "overview.gaps.openRules": "Open rules",
  "overview.gaps.openOfficialSource": "Open official source",
  "overview.gaps.pisCofins.guidance":
    "The platform legal entity is outside Simples Nacional (legal-entity partner on the QSA). Lucro Presumido or Lucro Real, product treatment and current evidence are still needed to govern PIS/COFINS; there is no safe single rate.",
  "overview.gaps.iss.guidance":
    "ISS is a municipal service tax. BackChannel does not collect ISS: the operation is wholesale goods, with federal IPI and state ICMS. We do not model a municipality.",
  "overview.gaps.noForm": "No official feed here",
  "overview.priority.empty": "Nothing in this summary currently requires action.",
  "overview.priority.shownOf": "{shown} of {total}",
  "overview.changes.eyebrow": "Monthly governance",
  "overview.changes.title": "What changed this cycle",
  "overview.changes.description": "Difference between the active version and its governed base.",
  "overview.changes.added": "Added",
  "overview.changes.changed": "Changed",
  "overview.changes.removed": "Removed",
  "overview.changes.total": "{count} governed rule changes in this release",
  "overview.changes.noBaseline": "This version has no comparable published base.",
  "overview.changes.noRuleset": "There is no published ruleset to compare.",
  "overview.changes.openCatalog": "Open published catalog",
  "overview.exceptions.window":
    "Most frequent structured signals in calculations completed during the last 24 hours.",
  "overview.exceptions.openReviews": "Open finance review",
  "overview.technical.title": "Ingestion and audit details",
  "overview.technical.description": "Technical delivery health, secondary to fiscal decision work.",

  "overview.priority.eyebrow": "Decision work",
  "overview.priority.title": "Priority inbox",
  "overview.priority.description":
    "Work that can change a fiscal outcome or block safe calculation.",
  "overview.priority.open": "open",
  "overview.priority.more": " · {count} additional alerts not shown",
  "overview.ingestion.eyebrow": "Evidence supply",
  "overview.exceptions.eyebrow": "Calculation quality",
  "overview.section.instruments": "Operational instruments",
  "overview.section.attention": "Needs attention",
  "overview.section.recentRuns": "Recent runs",
  "overview.section.recentActivity": "Governance activity",
  "overview.section.issues": "Top issues",
  "overview.issues.hint": "Most frequent issue codes across recent calculations.",
  "overview.issues.relativeHint": "Relative to the most frequent listed issue.",
  "overview.ruleset.integrity": "Published content digest",
  "overview.runs.stalled":
    "This run has exceeded the two-hour processing window. Check the source or retry it.",
  "overview.runs.viewSources": "View all source runs",
  "overview.activity.viewAudit": "View full audit log",
  "overview.empty.priority": "No operational alerts were returned in this summary.",
  "overview.empty.issues": "No structured calculation issues were returned.",
  "overview.empty.runs": "No recent source runs were returned.",
  "overview.empty.activity": "No recent governed activity was returned.",
  "overview.attention.evidenceAged.title": "{count} evidence items awaiting triage for over 24 h",
  "overview.attention.evidenceAged.detail":
    "The queue is growing faster than triage across state sources.",
  "overview.attention.proposalStuck.title": "{count} proposals waiting for a second approver",
  "overview.attention.proposalStuck.detail":
    "Separation of duties requires a reviewer different from the author.",
  "overview.attention.sourceDegraded.title": "Degraded source: {source}",
  "overview.attention.sourceDegraded.detail": "The source reported: {reason}",
  "overview.attention.sourceDegraded.failedRuns": "Recent runs of this source failed.",
  "overview.attention.dlqDepth.title": "{count} pending failures in {publisher}",
  "overview.attention.dlqDepth.detail":
    "Source-scoped observation at {observedAt}. Monitoring is authoritative for the shared physical subscription; run a source preview before replaying.",
  "overview.attention.refreshError":
    "The refresh is unavailable; the pending-failure count is hidden until a successful read.",
  "overview.attention.kind.evidence": "Evidence queue",
  "overview.attention.kind.proposal": "Rule review",
  "overview.attention.kind.source": "Source health",
  "overview.attention.kind.review": "Review queue",
  "overview.attention.kind.dlq": "Dead-letter queue",
  "overview.issue.taxConfigTableNotConfigured": "Tax configuration table not configured",
  "overview.issue.ncmMissingOrInvalid": "NCM missing or invalid",
  "overview.issue.originUfMissingOrInvalid": "Origin UF missing or invalid",
  "overview.issue.destinationUfMissingOrInvalid": "Destination UF missing or invalid",
  "overview.issue.fiscalParameterMissing": "Fiscal parameter missing",
  "overview.issue.fiscalParameterAmbiguous": "Ambiguous fiscal parameter for the NCM route",
  "overview.issue.baseCostMissingOrInvalid": "Base cost missing or invalid",
  "overview.issue.baseCostInferred": "Base cost inferred from price",
  "overview.issue.originalMvaMissingOrInvalid": "Original MVA (IVA-ST) missing or invalid",
  "overview.issue.destinationIcmsMissingOrInvalid":
    "Destination internal ICMS rate missing or invalid",
  "overview.issue.interstateIcmsInvalid": "Interstate ICMS rate invalid",
  "overview.issue.ipiMissingOrInvalid": "IPI rate missing or invalid",
  "overview.issue.takeRateMissingOrInvalid": "Intermediation fee missing or invalid",
  "overview.issue.operationalCostInvalid": "Operational cost invalid",
  "overview.issue.saleLegMissingOrInvalid": "No rule for the sale route",
  "overview.issue.netMarginUnreachable": "Net margin unreachable",
  "overview.issue.resaleProfilePending": "PIS/COFINS profile pending",
  "overview.issue.icmsBenefitNotApplicable": "ICMS benefit not in the rule",
  "fiscalLines.source.PIS_COFINS_PROFILE": "PIS/COFINS profile",
  "lotOps.group.pisCofinsProfile": "PIS/COFINS profile",
  "overview.issue.pisCofinsProfilePending": "PIS/COFINS profile to confirm",
  "overview.issue.cbsIbsRatePending": "CBS/IBS: the year's rate is not published",
  "overview.issue.cbsIbsClassPending": "CBS/IBS: confirm the classification (cClassTrib)",
  "issueHelp.pisCofinsProfilePending":
    "The statutory catalog cannot settle PIS/COFINS for this NCM (cold beverage, a condition to confirm or overlapping lists). State the confirmed treatment; no rate is assumed and the item stays in review.",
  "issueHelp.cbsIbsRatePending":
    "There is no published CBS/IBS rate for the fiscal date's year, or the date is 2027 or later (the due regime is not calculated yet). Publish the year's rate or wait for the engine.",
  "issueHelp.cbsIbsClassPending":
    "The CBS/IBS classification (cClassTrib) needs confirmation. State the class and the basis; no rate is assumed and the item stays in review.",
  "pisCofinsProfile.title": "PIS/COFINS profile",
  "pisCofinsProfile.profile.STANDARD": "Standard regime",
  "pisCofinsProfile.profile.SINGLE_STAGE": "Single-stage (zero-rate resale)",
  "pisCofinsProfile.profile.ZERO_RATE": "Zero rate",
  "pisCofinsProfile.profile.PENDING": "Pending",
  "pisCofinsProfile.short.STANDARD": "Standard",
  "pisCofinsProfile.short.SINGLE_STAGE": "Single-stage",
  "pisCofinsProfile.short.ZERO_RATE": "Zero rate",
  "pisCofinsProfile.short.PENDING": "Pending",
  "pisCofinsProfile.candidate.SINGLE_STAGE": "single-stage",
  "pisCofinsProfile.candidate.ZERO_RATE": "zero rate",
  "pisCofinsProfile.candidate.BEVERAGE": "cold beverage",
  "pisCofinsProfile.cst": "CST {cst}",
  "pisCofinsProfile.creditCst": "credit CST {cst}",
  "pisCofinsProfile.field.profile": "Profile",
  "pisCofinsProfile.field.saleCst": "Sale CST",
  "pisCofinsProfile.field.creditCst": "Credit CST",
  "pisCofinsProfile.field.source": "Source",
  "pisCofinsProfile.field.basis": "Legal basis",
  "pisCofinsProfile.field.condition": "Legal condition",
  "pisCofinsProfile.field.candidate": "Likely profile",
  "pisCofinsProfile.none": "no CST",
  "pisCofinsProfile.source.CATALOG": "statutory catalog",
  "pisCofinsProfile.source.OPERATOR": "stated by the operator",
  "pisCofinsProfile.source.REGIME": "regime",
  "pisCofinsProfile.validFrom": "in force since {date}",
  "pisCofinsProfile.validRange": "in force from {from} to {to}",
  "pisCofinsProfile.regimeBasis": "Regime basis (no statutory list applies to the NCM)",
  "pisCofinsProfile.catalog": "Catalog {catalog} · engine 1.8.0",
  "pisCofinsProfile.opensSource": "opens the law on Planalto",
  "pisCofinsProfile.pending.BEVERAGE_PROFILE":
    "Cold beverage (Lei 13.097/2015): no zero rate for a wholesaler; state the treatment",
  "pisCofinsProfile.pending.REQUIRES_CONFIRMATION":
    "A legal condition the NCM cannot prove (a TIPI “Ex” or a description); confirm the treatment",
  "pisCofinsProfile.pending.OVERLAPPING_LISTS":
    "NCM on more than one list (single-stage and zero rate); confirm which applies",
  "pisCofinsProfile.pending.NOT_IN_CATALOG":
    "The stated treatment is not on this NCM's statutory list",
  "issueHelp.resaleProfilePending":
    "This NCM has its own PIS/COFINS treatment (single-stage, cold beverages or zero rate). State the confirmed treatment; the margin stays pending, never zero.",
  "issueHelp.icmsBenefitNotApplicable":
    "The cBenef given is not in the published sale rule or is not in force. Confirm the code or publish the rule with the benefit.",
  "wb.issue.NCM_WITH_SUFFIX.title": "NCM with an unmapped suffix",
  "wb.issue.NCM_WITH_SUFFIX.hint":
    "The field has 10 digits (an 8-digit NCM plus an internal suffix). Confirm the 8-digit NCM and the extra attribute in the master data; the row is never truncated automatically.",
  "issueHelp.taxConfigTableNotConfigured":
    "No fiscal rules are published. Publish a ruleset before calculating.",
  "issueHelp.ncmMissingOrInvalid":
    "The row has no 8-digit NCM. Fix the NCM column in the file or the row and recalculate.",
  "issueHelp.originUfMissingOrInvalid":
    "The origin UF is empty or not a UF. Fix the origin column or fix the lot's route.",
  "issueHelp.destinationUfMissingOrInvalid":
    "The destination UF is empty or not a UF. Fix the destination column or fix the lot's route.",
  "issueHelp.fiscalParameterMissing":
    "No published rule states the ICMS of this NCM on this route. Research the rule (Research gaps) and publish it before recalculating.",
  "issueHelp.fiscalParameterAmbiguous":
    "More than one rule answers this NCM and route. State the row's CEST to pick the right rule.",
  "issueHelp.baseCostMissingOrInvalid":
    "The unit cost is empty, zero or not a number. Fix the cost column and recalculate.",
  "issueHelp.baseCostInferred":
    "There was no cost: the calculation used the sale price as its base. State the purchase cost for a reliable figure.",
  "issueHelp.originalMvaMissingOrInvalid":
    "The ICMS-ST rule has no original MVA (IVA-ST). The rule must be corrected through a proposal.",
  "issueHelp.destinationIcmsMissingOrInvalid":
    "The rule has no destination internal rate. The rule must be corrected through a proposal.",
  "issueHelp.interstateIcmsInvalid":
    "The rule's interstate rate does not match the route. The rule needs review.",
  "issueHelp.ipiMissingOrInvalid": "The rule has no IPI rate for this NCM.",
  "issueHelp.takeRateMissingOrInvalid":
    "No intermediation fee is configured for this category and payment method.",
  "issueHelp.operationalCostInvalid":
    "No operational cost (logistics, freight) is configured for this category.",
  "issueHelp.saleLegMissingOrInvalid":
    "The price needs the sale rule (center → customer) and no published rule states the ICMS of that route. Choose another sale destination or publish the rule.",
  "issueHelp.netMarginUnreachable":
    "With this margin and the sale taxes no positive price exists. Lower the margin asked.",

  "evidence.empty.title": "No evidence in the queue",
  "evidence.empty.body":
    "Discovery runs every 3 hours (Brasília time) and fills this queue with official documents.",
  "evidence.empty.action": "View sources",
  "evidence.attention.lowConfidence": "Low confidence",
  "evidence.title": "Evidence",
  "evidence.description":
    "Documents collected from official sources. Extraction proposes evidence; it never approves, publishes or calculates.",
  "evidence.tabs.label": "Evidence area",
  "evidence.tabs.documents": "Review queue",
  "evidence.tabs.tasks": "Tasks",
  "evidence.tasks.title": "Evidence tasks",
  "evidence.tasks.description":
    "Organize follow-up for observed evidence. Completing a task does not approve the document or change a published rule.",
  "evidence.tasks.agentEyebrow": "Agent queue",
  "evidence.tasks.agentTitle": "Fiscal research in progress",
  "evidence.tasks.agentDescription":
    "Tasks sent to the research agent stay here with their status, citations and next review step.",
  "evidence.tasks.agentActive": "In progress",
  "evidence.tasks.agentReview": "In review",
  "evidence.tasks.agentQueue": "Research tasks",
  "evidence.tasks.agentWindowHint": "Showing the 12 most recent fiscal tasks.",
  "evidence.tasks.agentSearch": "Search by question or task",
  "evidence.tasks.agentStatus": "Filter by status",
  "evidence.tasks.agentEmpty":
    "No agent research has been sent yet. Use Research a question in Documents to create the first task.",
  "evidence.tasks.agentSelected": "Selected research",
  "evidence.tasks.agentCitations": "Citations",
  "evidence.tasks.agentEvidence": "In evidence",
  "evidence.tasks.agentProvider": "Fiscal runner",
  "evidence.tasks.agentNoSummary": "The agent has not published a summary yet.",
  "evidence.tasks.agentDetailStale":
    "The detail could not be refreshed; showing the last known state.",
  "evidence.tasks.agentOpenDesk": "Open in desk",
  "evidence.tasks.agentOpenEvidence": "Open evidence",
  "evidence.tasks.results.one": "{count} task",
  "evidence.tasks.results.other": "{count} tasks",
  "evidence.tasks.results.many": "{count} tasks",
  "evidence.tasks.create": "Create task",
  "evidence.tasks.edit": "Edit task",
  "evidence.tasks.titleLabel": "Title",
  "evidence.tasks.descriptionLabel": "Description",
  "evidence.tasks.assignee": "Assignee",
  "evidence.tasks.dueDate": "Due date",
  "evidence.tasks.dueDateHint": "Calendar date without a time.",
  "evidence.tasks.state": "State",
  "evidence.tasks.createdBy": "Created by",
  "evidence.tasks.updated": "Updated",
  "evidence.tasks.evidence": "Open evidence",
  "evidence.tasks.run": "Open run",
  "evidence.tasks.evidenceId": "Linked evidence (optional)",
  "evidence.tasks.sourceRunId": "Linked run (optional)",
  "evidence.tasks.referenceHint":
    "Paste an internal link or an identifier already used in this organization.",
  "evidence.tasks.referenceInvalid": "Use a valid internal link or the matching identifier.",
  "evidence.tasks.noReference": "No reference",
  "evidence.tasks.empty": "No evidence tasks yet.",
  "evidence.tasks.emptyBody": "Create a task to track a manual verification.",
  "evidence.tasks.save": "Save task",
  "evidence.tasks.cancel": "Cancel editing",
  "evidence.tasks.statusSaved": "Task saved for this account.",
  "evidence.tasks.saving": "Saving task…",
  "evidence.tasks.loadError": "Tasks could not be loaded.",
  "evidence.tasks.saveError": "Task could not be saved. Try again.",
  "evidence.tasks.retry": "Reload and try again",
  "evidence.tasks.conflict": "This task changed in another session. Reload to continue.",
  "evidence.tasks.terminal": "Completed or cancelled tasks cannot be reopened.",
  "evidence.tasks.state.OPEN": "Open",
  "evidence.tasks.state.IN_PROGRESS": "In progress",
  "evidence.tasks.state.BLOCKED": "Blocked",
  "evidence.tasks.state.DONE": "Done",
  "evidence.tasks.state.CANCELLED": "Cancelled",
  "evidence.extract.note":
    "The extractor reads the artifact and writes an excerpt for review. It does not approve evidence and it does not publish a rule.",
  "evidence.column.title": "Document",
  "evidence.column.source": "Source",
  "evidence.column.jurisdiction": "Jurisdiction",
  "evidence.column.published": "Published",
  "evidence.column.fetched": "Fetched",
  "evidence.column.confidence": "Confidence",
  "evidence.column.status": "Status",
  "evidence.column.tags": "Tags",
  "evidence.filter.status": "Review status",
  "evidence.filter.jurisdiction": "Jurisdiction",
  "evidence.filter.tag": "Tax tag",
  "evidence.filter.search": "Title, publisher or hash",
  "evidence.bulk.approve": "Approve selected",
  "evidence.bulk.reject": "Reject selected",
  "evidence.bulk.markDuplicate": "Mark as duplicate",
  "evidence.bulk.cap": "Bulk triage is capped at {max} documents per operation.",
  "evidence.bulk.capReached": "Cap of {max} documents reached; selection stopped there.",
  "evidence.bulk.confirm.one": "Apply {action} to {count} document?",
  "evidence.bulk.confirm.other": "Apply {action} to {count} documents?",
  "evidence.bulk.done.one": "{count} document updated.",
  "evidence.bulk.done.other": "{count} documents updated.",
  "evidence.detail.title": "Evidence review",
  "evidence.detail.canonicalUrl": "Canonical URL",
  "evidence.detail.contentHash": "Content hash",
  "evidence.locator.css": "Page section",
  "evidence.locator.pdf-page": "PDF page",
  "evidence.locator.document": "Whole document",
  "evidence.locator.value.excerpt": "excerpt",
  "evidence.detail.rawArtifact": "Raw artifact",
  "evidence.detail.normalizedArtifact": "Normalized artifact",
  "evidence.detail.noNormalized": "Not normalized yet",
  "evidence.detail.storedDocument": "Stored document",
  "evidence.detail.storedDocumentHint": "Preserved text for review.",
  "evidence.detail.byteRange": "Bytes {start}–{end}",
  "evidence.detail.downloadRaw": "Download raw artifact",
  "evidence.detail.rawDownloading": "Downloading raw artifact…",
  "evidence.detail.rawDownloadUnavailable":
    "The raw artifact is not available for download right now.",
  "evidence.detail.artifactUnavailable": "The stored document is currently unavailable.",
  "evidence.detail.locators": "Document locators",
  "evidence.detail.previousPage": "Previous page",
  "evidence.detail.nextPage": "Next page",
  "evidence.detail.decision": "Review decision",
  "evidence.detail.approve": "Approve evidence",
  "evidence.detail.reject": "Reject",
  "evidence.detail.duplicate": "Duplicate",
  "evidence.detail.announce.APPROVED": "Evidence approved",
  "evidence.detail.announce.REJECTED": "Evidence rejected",
  "evidence.detail.announce.DUPLICATE": "Marked as duplicate",
  "evidence.detail.reasonHint":
    "Enter at least 10 characters. The reason is recorded in the audit log.",
  "evidence.detail.reasonRequired": "Enter at least 10 characters to record the decision.",
  "evidence.detail.proposeRule": "Create rule proposal",
  "evidence.detail.extract": "Extracted excerpt",
  "evidence.detail.part.summary": "Part {number} of {count} · pages {pageFrom}–{pageTo}",
  "evidence.detail.part.link": "Part {number} · pages {pageFrom}–{pageTo}",
  "evidence.detail.part.html.summary": "Part {number} of {count} · {sectionFrom} – {sectionTo}",
  "evidence.detail.part.html.link": "Part {number} · {sectionFrom} – {sectionTo}",
  "evidence.detail.noExtract": "No excerpt has been extracted from this source yet.",
  "evidence.detail.relatedProposals": "Related proposals",
  "evidence.catalogue.label": "Tax news and evidence catalogue",
  "evidence.catalogue.results": "About {count} collected documents",
  "evidence.catalogue.hint":
    "Review source material as an editorial queue, without losing governance controls.",
  "evidence.catalogue.selectPage": "Select this page",
  "evidence.catalogue.sort.fetchedAt": "Latest collected",
  "evidence.catalogue.sort.confidence": "Confidence",
  "evidence.catalogue.sort.jurisdiction": "Jurisdiction",
  "evidence.catalogue.signals": "Detected tax signals",
  "evidence.catalogue.noSignals": "No structured tax signals yet",
  "evidence.catalogue.imageUnavailable": "No source image",
  "evidence.catalogue.proposals": "Proposals",
  "evidence.detail.openOriginal": "Open original",
  "evidence.detail.opensNewTab": "opens in a new tab",
  "evidence.detail.imageUnavailable": "No image published by the source",
  "evidence.detail.fiscalData": "Extracted fiscal data",
  "evidence.detail.detectedSignals": "Detected tax signals",
  "evidence.detail.keyFacts": "Key facts found in the source",
  "evidence.detail.integrity": "Evidence integrity",
  "evidence.detail.technicalDetails": "Technical provenance",
  "evidence.detail.preserved": "Preserved evidence",
  "evidence.detail.noProposals": "No rule proposal has been derived from this evidence.",
  "evidence.detail.insights": "Review insights",
  "evidence.detail.reviewReadiness": "Review readiness",
  "evidence.detail.taxScope": "Detected tax scope",
  "evidence.detail.taxScopeCount": "{count} structured tax signals found",
  "evidence.detail.ruleImpact": "Rule impact",
  "evidence.detail.proposalImpact.one": "Linked to {count} rule proposal",
  "evidence.detail.proposalImpact.other": "Linked to {count} rule proposals",
  "evidence.detail.noProposalImpact": "No rule impact proposed yet",
  "evidence.detail.noStructuredInsight": "Awaiting structured extraction",
  "evidence.detail.insightDisclaimer":
    "Insights summarize captured metadata. They never approve evidence or publish a tax rule.",
  "evidence.detail.readiness.approved": "Human review completed",
  "evidence.detail.readiness.closed": "Review closed",
  "evidence.detail.readiness.unscored": "Manual verification required",
  "evidence.detail.readiness.low": "Low confidence — verify against the source",
  "evidence.detail.readiness.medium": "Ready for analyst review",
  "evidence.detail.readiness.high": "High-confidence extraction",
  "evidence.detail.candidates.title": "Fiscal entry candidates",
  "evidence.detail.candidates.description":
    "Fiscal mentions found in the document and kept linked to their source excerpt.",
  "evidence.detail.candidates.status": "CANDIDATE · not applied",
  "evidence.detail.candidates.empty":
    "No structured fiscal data was identified. Verify the document manually.",
  "evidence.detail.candidates.disclaimer":
    "A candidate never changes a rule. Approve the evidence, prepare the proposal and send it for independent review.",
  "evidence.detail.candidates.use": "Use data in proposal",
  "evidence.detail.candidates.kind.NCM": "NCM",
  "evidence.detail.candidates.kind.CEST": "CEST",
  "evidence.detail.candidates.kind.UF": "UF",
  "evidence.detail.candidates.kind.RATE": "Mentioned rate",

  "proposals.title": "Rule proposals",
  "proposals.description":
    "Every tax change flows through proposal, review, approval and publication.",
  "proposals.column.summary": "Summary",
  "proposals.column.scope": "Scope",
  "proposals.column.impact": "Impact",
  "proposals.column.status": "Status",
  "proposals.column.author": "Author",
  "proposals.column.age": "Age",
  "proposals.detail.title": "Proposal {id}",
  "proposals.detail.evidence": "Supporting evidence",
  "proposals.detail.change": "Proposed change",
  "proposals.detail.approve": "Approve proposal",
  "proposals.detail.reject": "Reject proposal",
  "proposals.detail.approvals": "Approvals",
  "proposals.fourEyes.badge": "Approval",
  "proposals.fourEyes.needed": "One recorded approval. The author may approve and publish.",
  "proposals.fourEyes.youAreAuthor": "You are the author",
  "proposals.fourEyes.selfBlocked": "You authored this proposal. You may approve and publish it.",
  "proposals.fourEyes.progress": "{approved} of {required} approvals",
  "proposals.fourEyes.count.one": "{approved} of {required} approval",
  "proposals.fourEyes.count.other": "{approved} of {required} approvals",
  "proposals.fourEyes.alreadyDecided": "You already recorded your decision on this proposal.",
  "proposals.next.pendingFirst": "Waiting for approval. The author may approve.",
  "proposals.next.pendingSecond": "Waiting for approval. The author may approve.",
  "proposals.next.approved": "Approved. It entered the current draft. The author may publish.",
  "proposals.next.rejected": "Rejected. It stays out of the draft until a new proposal exists.",
  "proposals.next.published": "Published in this ruleset. Published content is immutable.",
  "proposals.next.title": "Next step",
  "proposals.change.kind": "Kind",
  "proposals.change.path": "Path",
  "proposals.change.before": "Before",
  "proposals.change.after": "After",
  "proposals.change.ADDED": "Added",
  "proposals.change.REMOVED": "Removed",
  "proposals.change.CHANGED": "Changed",
  /* Governança — proposal detail, readable change table and decision bar (UX plan PR 5). */
  "proposals.change.field": "Field",
  "proposals.change.rule": "Rule {id}",
  "proposals.change.item": "Change {index} of {total}",
  "proposals.detail.byline": "{reference} · proposed by {author} on {created}",
  "proposals.detail.supersedes": "Supersedes the published rule",
  "proposals.detail.appliesTo": "Applies to",
  "proposals.detail.noDecisions": "No decisions recorded yet.",
  "proposals.detail.evidenceItem": "Document {index}",
  "proposals.decision.title": "Your decision",
  "proposals.decision.placeholder": "E.g. Checked against the official document, RICMS art. 52",
  "proposals.scope.category": "Category: {value}",
  "proposals.scope.paymentMethod": "Payment: {value}",
  "proposals.scope.transactionType": "Transaction: {value}",
  "proposals.field.takeRate": "Intermediation fee",
  "proposals.field.originalMva": "Original MVA",
  "proposals.field.adjustedMva": "Adjusted MVA",
  "proposals.field.effectiveInternalRate": "Effective internal burden",
  "proposals.field.effectiveLegalReference": "Legal basis of the effective burden",
  "proposals.field.effectiveSourceUrl": "Source of the effective burden",
  "proposals.field.effectiveValidFrom": "Effective burden valid from",
  "proposals.field.effectiveValidTo": "Effective burden valid until",
  "proposals.field.destinationInternalIcmsRate": "Destination internal ICMS rate",
  "proposals.field.interstateIcmsRate": "Interstate ICMS rate",
  "proposals.field.ipiRate": "IPI rate",
  "proposals.field.stateBenefitBaseReductionPct": "Base reduction (state benefit)",
  "proposals.field.logistics": "Logistics cost",
  "proposals.field.freight": "Freight",
  "proposals.field.other": "Other costs",
  "proposals.field.validFrom": "Valid from",
  "proposals.field.validTo": "Valid until",
  "proposals.field.treatmentOf": "{tax} treatment",
  "proposals.field.rateOf": "{tax} rate",
  "proposals.field.icmsMode": "ICMS mode",
  "proposals.field.icmsMode.ST": "Tax substitution (ST)",
  "proposals.field.icmsMode.STANDARD": "Standard ICMS",
  "proposals.field.tax.ipi": "IPI",
  "proposals.field.tax.icms": "ICMS",
  "proposals.field.tax.pis": "PIS",
  "proposals.field.tax.cofins": "COFINS",
  "proposals.field.tax.iss": "ISS",
  "proposals.field.treatment.TAXED": "Taxed",
  "proposals.field.treatment.EXEMPT": "Exempt",
  "proposals.field.treatment.EXCLUDED": "Outside this base",
  "proposals.empty.title": "No proposals",
  "proposals.empty.body":
    "Proposals come from approved evidence. Review an official document and turn it into a governed change.",
  "proposals.empty.action": "Open approved evidence",
  "proposals.detail.minuta": "Generated draft",
  "proposals.matches.title": "Published rule comparison",
  "proposals.matches.description":
    "Read-only lookup against this organization’s current published version.",
  "proposals.matches.publishedVersion": "Published version: {version}",
  "proposals.matches.openRuleset": "Open published ruleset",
  "proposals.matches.checked.one": "{count} rule in this category was checked.",
  "proposals.matches.checked.other": "{count} rules in this category were checked.",
  "proposals.matches.exact": "Exact match",
  "proposals.matches.exactHint":
    "The behavior, validity and applicability match; IDs and evidence are excluded from the comparison.",
  "proposals.matches.sameApplicability": "Same applicability",
  "proposals.matches.sameApplicabilityHint":
    "The route and validity match. This does not establish equivalent tax treatment.",
  "proposals.matches.none": "No matches found",
  "proposals.matches.noneHint": "No published rule in this category has the same fingerprint.",
  "proposals.matches.noBase": "No published base is available",
  "proposals.matches.noBaseHint": "The advisory will be available when a published version exists.",
  "proposals.matches.truncated":
    "The list shows the first {count} matches; more matches exist in this category.",
  "proposalPlan.action": "Import plan",
  "proposalPlan.title": "Import proposal plan",
  "proposalPlan.description":
    "Upload a reviewed plan (JSON), check the simulation against the active ruleset and create proposals pending review. Nothing is approved or published.",
  "proposalPlan.noAccess":
    "Importing plans needs the permission to create proposals. Ask your platform administrator for access.",
  "proposalPlan.steps.label": "Import steps",
  "proposalPlan.step.file": "File",
  "proposalPlan.step.review": "Simulation",
  "proposalPlan.step.result": "Result",
  "proposalPlan.file.title": "Plan",
  "proposalPlan.file.drop": "Drop the plan here or choose the file",
  "proposalPlan.file.dropActive": "Drop to load the plan",
  "proposalPlan.file.hint":
    "JSON file written by the plan script, which only reads and creates nothing. Up to {size}.",
  "proposalPlan.file.pick": "Choose file",
  "proposalPlan.file.replace": "Replace file",
  "proposalPlan.file.sample": "Use sample plan",
  "proposalPlan.file.sampleHint": "Demo mode: a plan generated from the sample data.",
  "proposalPlan.file.reading": "Reading the file…",
  "proposalPlan.file.problem.EMPTY": "The file is empty.",
  "proposalPlan.file.problem.TOO_LARGE": "The file is too large to import.",
  "proposalPlan.file.problem.NOT_JSON": "The file is not valid JSON.",
  "proposalPlan.file.problem.NOT_A_PLAN":
    "The file is not a proposal plan: the kind field is missing.",
  "proposalPlan.file.problem.UNSUPPORTED_KIND": "This version cannot import plans of kind {kind}.",
  "proposalPlan.file.problem.INVALID_PLAN": "The plan does not follow the expected format.",
  "proposalPlan.kind.effective-burden-proposal-plan": "ICMS-ST effective burden",
  "proposalPlan.plan.kind": "Kind",
  "proposalPlan.plan.source": "Generated from",
  "proposalPlan.plan.destination": "Destination state",
  "proposalPlan.plan.segments": "CEST segments",
  "proposalPlan.plan.burden": "Effective burden",
  "proposalPlan.plan.basis": "Legal basis",
  "proposalPlan.plan.validUntil": "Valid until",
  "proposalPlan.items.count.one": "{count} item",
  "proposalPlan.items.count.other": "{count} items",
  "proposalPlan.plan.items": "Plan items",
  "proposalPlan.plan.skipped": "{count} rules left out by the generator",
  "proposalPlan.plan.note": "Plan note",
  "proposalPlan.export.action": "Export active ruleset",
  "proposalPlan.export.exporting": "Exporting…",
  "proposalPlan.export.hint":
    "Downloads the content of the active ruleset (read only) so the plan script can run on the real ruleset.",
  "proposalPlan.evidence.pickTitle": "Choose approved evidence",
  "proposalPlan.evidenceSource.ACTIVE_RULE": "evidence inherited from the active rule",
  "proposalPlan.evidenceSource.ADDITIONAL_ONLY": "only the approved additional evidence",
  "proposalPlan.evidenceSource.PLAN": "evidence from the plan",
  "proposalPlan.evidence.title": "Additional evidence (optional)",
  "proposalPlan.evidence.body":
    "Each rule's own evidence covers the MVA, not the effective burden. Paste the IDs of approved evidence (for example RICMS/SP art. 39 and DN CAT 8/2015) to attach it to every proposal created.",
  "proposalPlan.evidence.label": "Evidence IDs",
  "proposalPlan.evidence.placeholder": "One ID per line, or comma separated",
  "proposalPlan.evidence.browse": "Browse approved evidence",
  "proposalPlan.evidence.count.one": "{count} evidence item to attach",
  "proposalPlan.evidence.count.other": "{count} evidence items to attach",
  "proposalPlan.evidence.invalid": "Not an evidence ID: {ids}",
  "proposalPlan.evidence.tooMany": "At most {max} evidence items per import.",
  "proposalPlan.note.label": "Note for the reviewers (optional)",
  "proposalPlan.note.hint": "Goes at the start of the reason of every proposal created.",
  "proposalPlan.note.short": "Write at least 10 characters or leave it empty.",
  "proposalPlan.validate": "Simulate import",
  "proposalPlan.validating": "Simulating…",
  "proposalPlan.review.title": "Simulation against the active ruleset",
  "proposalPlan.review.hint":
    "Ruleset {version}. Nothing was created: check each item before confirming.",
  "proposalPlan.review.back": "Change plan",
  "proposalPlan.review.refresh": "Simulate again",
  "proposalPlan.review.empty": "The plan has no items.",
  "proposalPlan.filter.legend": "Filter by status",
  "proposalPlan.filter.all": "All",
  "proposalPlan.table.caption": "Plan items and the status of each",
  "proposalPlan.table.rule": "Rule",
  "proposalPlan.table.route": "Route",
  "proposalPlan.table.key": "NCM / CEST",
  "proposalPlan.table.change": "Change",
  "proposalPlan.table.status": "Status",
  "proposalPlan.change.effective": "effective burden {rate} — {article}",
  "proposalPlan.change.effectiveNoArticle": "effective burden {rate}",
  "proposalPlan.change.until": "until {date}",
  "proposalPlan.change.source": "Open the official source",
  "proposalPlan.tally.NEW": "New",
  "proposalPlan.tally.CREATED": "Created",
  "proposalPlan.tally.DUPLICATE": "Duplicates",
  "proposalPlan.tally.STALE": "Stale",
  "proposalPlan.tally.INVALID": "Invalid",
  "proposalPlan.status.NEW": "New",
  "proposalPlan.status.CREATED": "Created",
  "proposalPlan.status.DUPLICATE": "Duplicate",
  "proposalPlan.status.STALE": "Stale",
  "proposalPlan.status.INVALID": "Invalid",
  "proposalPlan.status.help.NEW": "Will be created as a proposal pending review.",
  "proposalPlan.status.help.CREATED": "Created by this import, pending review.",
  "proposalPlan.status.help.DUPLICATE":
    "This item of this plan was already imported: nothing will be created.",
  "proposalPlan.status.help.STALE":
    "The active rule is not the one the plan assumed: it will not be created.",
  "proposalPlan.status.help.INVALID": "Cannot become a proposal: see the reason.",
  "proposalPlan.reason.RULE_NOT_FOUND": "The rule is no longer in the active ruleset.",
  "proposalPlan.reason.RULE_CHANGED": "The active rule changed since the plan was generated.",
  "proposalPlan.reason.ALREADY_STATED": "The active rule already states the effective burden.",
  "proposalPlan.reason.EVIDENCE_REJECTED":
    "Evidence is not approved or differs from the approved record.",
  "proposalPlan.reason.POLICY_VIOLATION": "The rule does not satisfy the required policy.",
  "proposalPlan.reason.changedFields": "Differing fields: {fields}",
  "proposalPlan.reason.alreadyImported": "Already imported",
  "proposalPlan.proposal.open": "Open proposal",
  "proposalPlan.confirm.action.one": "Create {count} proposal",
  "proposalPlan.confirm.action.other": "Create {count} proposals",
  "proposalPlan.confirm.none": "No new items to create.",
  "proposalPlan.confirm.title": "Create proposals from the plan?",
  "proposalPlan.confirm.body.one":
    "{count} proposal will be created pending review. It needs another person's approval; this import approves and publishes nothing.",
  "proposalPlan.confirm.body.other":
    "{count} proposals will be created pending review. Each one needs another person's approval; this import approves and publishes nothing.",
  "proposalPlan.confirm.skipped":
    "Left out: {stale} stale, {invalid} invalid and {duplicate} duplicate.",
  "proposalPlan.confirm.evidence": "Additional evidence attached to each proposal: {count}.",
  "proposalPlan.confirm.cancel": "Cancel",
  "proposalPlan.confirm.submit": "Create proposals",
  "proposalPlan.confirm.creating": "Creating…",
  "proposalPlan.result.title": "Proposals created",
  "proposalPlan.result.created.one": "{count} proposal created, pending review.",
  "proposalPlan.result.created.other": "{count} proposals created, pending review.",
  "proposalPlan.result.none":
    "No new proposals: everything in this plan was already imported or no longer applies.",
  "proposalPlan.result.skipped":
    "Not created: {stale} stale, {invalid} invalid and {duplicate} duplicate.",
  "proposalPlan.result.review": "Review pending proposals",
  "proposalPlan.result.another": "Import another plan",
  "proposalPlan.next.title": "Next step: use policy {policy} on the draft",
  "proposalPlan.next.switchBody":
    "These proposals can only be published under policy {policy}, which uses the effective burden as ALQ intra in the MVA adjustment. Draft {version} is on policy {current}; switching it never changes earlier calculations.",
  "proposalPlan.next.switchAction": "Open the draft and switch the policy",
  "proposalPlan.next.readyBody":
    "Draft {version} already uses policy {policy}. Once the proposals are approved, prepare the draft to include them and publish through the normal flow.",
  "proposalPlan.next.readyAction": "Open the draft",
  "proposalPlan.next.prepareBody":
    "There is no draft yet. In Rulesets, prepare the next draft: policy {policy} is already selected.",
  "proposalPlan.next.prepareAction": "Go to Rulesets",
  "rulesets.policy.suggested":
    "The imported plan asks for policy {policy}. It is already selected: write the reason and save.",
  "proposals.create.title": "Create rule proposal",
  "proposals.create.description":
    "Turn approved evidence into a governed change. Creating the proposal does not publish the rule.",
  "proposals.create.evidence": "Linked evidence: {title}",
  "proposals.create.operation": "Change type",
  "proposals.create.operation.upsert": "Add a new rule",
  "proposals.create.operation.supersede": "Replace an existing rule",
  "proposals.create.supersedesRuleId": "Existing rule ID",
  "proposals.create.supersedesRuleIdHint": "Copy the ID from the published rule detail.",
  "proposals.create.ruleType": "Rule type",
  "proposals.create.ruleJson": "Proposed rule (JSON)",
  "proposals.create.ruleJsonHint":
    "The platform will attach the evidence's immutable provenance automatically.",
  "proposals.create.validation": "Complete or correct: {issue}",
  "proposals.create.reasonHint":
    "Explain the change in at least 10 characters. The reason is written to the audit log.",
  "proposals.create.submit": "Create proposal",
  "proposals.create.created": "{reference} was created and sent for review.",
  "proposals.create.requiresApprovedEvidence":
    "Evidence must be approved before it can originate a proposal.",
  "proposals.create.ncm": "NCM",
  "proposals.create.ncmHint":
    "Eight digits already labeled in the evidence. Do not invent a classification.",
  "proposals.create.cest": "CEST",
  "proposals.create.unconfirmed": "Confirm in the source",
  "proposals.create.treatmentHint":
    "Confirm whether the tax applies, is exempt or is excluded. Missing information is not an exclusion.",
  "proposals.create.verifySource":
    "Check the source row before creating a proposal. Document mentions do not confirm the rate, route or validity of this NCM.",
  "proposals.create.validFromHint":
    "Use the effective date stated in the legal act. Publication or capture dates do not establish when the rule takes effect.",
  "proposals.create.validFrom": "Valid from",
  "proposals.create.validTo": "Valid to",
  "proposals.create.originUf": "Origin UF",
  "proposals.create.destinationUf": "Destination UF",
  "proposals.create.treatment": "Treatment",
  "proposals.create.taxed": "Taxed",
  "proposals.create.exempt": "Exempt",
  "proposals.create.excluded": "Not in this evidence",
  "proposals.create.rate": "Official rate",
  "proposals.create.rateHint":
    "Copy the figure from the evidence. Use 0–1 or a percent up to 100. An empty field does not invent a rate.",
  "proposals.create.componentReason": "Treatment reason",
  "proposals.create.ipi": "IPI / TIPI",
  "proposals.create.icms": "ICMS",
  "proposals.create.mode": "Mode",
  "proposals.create.mode.standard": "Standard",
  "proposals.create.mode.st": "Substitution (ST)",
  "proposals.create.interstate": "Interstate rate",
  "proposals.create.internal": "Destination internal rate",
  "proposals.create.mva": "Original MVA (%)",
  "proposals.create.mvaHint":
    "Enter the percentage from the evidence: 125 means 125%. Values may exceed 100%.",
  "proposals.create.effective.title": "Effective burden (optional)",
  "proposals.create.effective.hint":
    "Only for the MVA adjustment (tax-family-v2): the effective internal rate of a destination substitute, for example 12% for foods (RICMS/SP, Annex II, art. 39). The ST debit keeps the nominal internal rate. Without it the engine uses the nominal rate and flags it in the calculation.",
  "proposals.create.effective.rate": "Effective internal rate",
  "proposals.create.effective.basis": "Legal basis of the effective burden",
  "proposals.create.effective.basisPlaceholder": "E.g. RICMS/SP, Annex II, art. 39; DN CAT 8/2015",
  "proposals.create.effective.url": "Source link (optional)",
  "proposals.create.effective.validFrom": "Effective burden: valid from (optional)",
  "proposals.create.effective.validTo": "Effective burden: valid until (optional)",
  "proposals.create.effective.validToHint":
    "After this date the engine goes back to the nominal rate and flags it in the calculation.",
  "proposals.create.locked":
    "PIS, COFINS and ISS stay out of this ledger. This form does not publish a rate for those families.",
  "proposals.create.advanced": "Advanced JSON",

  "rulesets.title": "Rulesets",
  "rulesets.description":
    "Published rulesets are immutable and content hashed. Every calculation pins an exact version.",
  "rulesets.column.version": "Version",
  "rulesets.column.status": "Status",
  "rulesets.column.digest": "Digest",
  "rulesets.column.rules": "Rules",
  "rulesets.column.published": "Published",
  "rulesets.column.publishedBy": "Published by",
  "rulesets.immutable": "Immutable",
  "rulesets.immutable.hint":
    "Published and content hashed. It cannot be edited, only superseded or rolled back.",
  "rulesets.active": "Active",
  "rulesets.compare": "Compare",
  "rulesets.compare.mode": "Compare two versions",
  "rulesets.diff.title": "Differences from {from} to {to}",
  "rulesets.diff.added": "added",
  "rulesets.diff.removed": "removed",
  "rulesets.diff.changed": "changed",
  "rulesets.diff.summary": "{added} added, {removed} removed, {changed} changed",
  "rulesets.diff.none": "No differences between the selected versions.",
  "fieldDiff.kind.added": "Added",
  "fieldDiff.kind.changed": "Changed",
  "fieldDiff.kind.removed": "Removed",
  "fieldDiff.kind.unchanged": "Unchanged",
  "fieldDiff.col.field": "Field",
  "fieldDiff.col.change": "Change",
  "fieldDiff.col.before": "Before",
  "fieldDiff.col.after": "After",
  "fieldDiff.count.added.one": "{count} added",
  "fieldDiff.count.added.other": "{count} added",
  "fieldDiff.count.changed.one": "{count} changed",
  "fieldDiff.count.changed.other": "{count} changed",
  "fieldDiff.count.removed.one": "{count} removed",
  "fieldDiff.count.removed.other": "{count} removed",
  "fieldDiff.unchanged.one": "{count} field unchanged",
  "fieldDiff.unchanged.other": "{count} fields unchanged",
  "fieldDiff.unknownField": "Unmapped field",
  "fieldDiff.unknownField.hint": "Shown as stored; this field has no label yet.",
  "fieldDiff.unit": "Unit: {unit}",
  "fieldDiff.technical": "Technical details",
  "fieldDiff.technical.path": "Stored path",
  "fieldDiff.validity": "Validity",
  "fieldDiff.validity.none": "Not stated",
  "fieldDiff.evidence": "Evidence",
  "fieldDiff.evidence.none": "No linked evidence",
  "fieldDiff.route": "Route",
  "fieldDiff.empty": "No field changed.",
  "fieldDiff.error": "This version could not be loaded.",
  "auditTimeline.actor.human": "Person",
  "auditTimeline.actor.machine": "System",
  "auditTimeline.group": "Group decision · {count}",
  "auditTimeline.tz": "BRT",
  "auditTimeline.tz.title": "Brasília time (UTC−3)",
  "auditTimeline.empty": "No events recorded yet.",
  "auditTimeline.partial": "Showing {shown} of {total}",
  "auditTimeline.error": "The history could not be loaded.",
  "auditTimeline.technical": "Technical details",
  "auditTimeline.current": "This event",
  "auditTimeline.summary.one": "{count} event",
  "auditTimeline.summary.other": "{count} events",
  "auditTimeline.summary.success.one": "{count} succeeded",
  "auditTimeline.summary.success.other": "{count} succeeded",
  "auditTimeline.summary.rejection.one": "{count} rejected",
  "auditTimeline.summary.rejection.other": "{count} rejected",
  "audit.detail.history": "History of this resource",
  "audit.detail.change": "Recorded change",
  "audit.detail.change.hint": "Fields of proposal {reference}, as stored now.",
  "audit.detail.change.none":
    "This event records no before and after values. Open the resource to see its current state.",
  "audit.detail.change.missing": "Proposal {reference} was not found.",
  "proposals.detail.history": "History",
  "trust.OFFICIAL_SOURCE": "Official source",
  "trust.OFFICIAL_SOURCE.off": "Source not in catalog",
  "trust.OFFICIAL_SOURCE.meaning":
    "Attests provenance only: the source is in the reviewed official-source catalog. It does not approve the content.",
  "trust.OFFICIAL_SOURCE.offMeaning": "The cited host matches no source in the reviewed catalog.",
  "trust.OFFICIAL_SOURCE.basis": "Source catalog · {source}",
  "trust.VERIFIED": "Verified",
  "trust.VERIFIED.off": "No human review",
  "trust.VERIFIED.meaning": "A human reviewer confirmed this fact.",
  "trust.VERIFIED.offMeaning": "No person has confirmed this fact yet.",
  "trust.VERIFIED.basis": "Human review",
  "trust.PUBLISHED_RULE": "Published rule",
  "trust.PUBLISHED_RULE.off": "Rule out of validity",
  "trust.PUBLISHED_RULE.meaning":
    "The rule is in a published ruleset; it is what calculation uses.",
  "trust.PUBLISHED_RULE.offMeaning": "The rule was published, but its validity ended.",
  "trust.PUBLISHED_RULE.basis": "Published ruleset · {version}",
  "trust.tip.captured": "Captured on {date}",
  "trust.tip.verifiedAt": "Confirmed on {date}",
  "trust.tip.citation": "Citation",
  "trust.tip.citation.available": "Available · {host}",
  "trust.tip.citation.absent": "No citation",
  "trust.tip.validity": "Validity",
  "trust.tip.current": "current",
  "trust.tip.expired": "expired",
  "trust.tip.basis": "Basis",
  "ruleDiff.field.legacyMva": "Adjusted MVA (legacy)",
  "ruleDiff.field.reasonOf": "Justification ({tax})",
  "ruleDiff.field.evidence": "Evidence",
  "ruleDiff.value.documents.one": "{count} document",
  "ruleDiff.value.documents.other": "{count} documents",
  "ruleDiff.change.removed": "Removed",
  "ruleDiff.count.added.one": "{count} new",
  "ruleDiff.count.added.other": "{count} new",
  "ruleDiff.count.changed.one": "{count} changed",
  "ruleDiff.count.changed.other": "{count} changed",
  "ruleDiff.count.removed.one": "{count} removed",
  "ruleDiff.count.removed.other": "{count} removed",
  "ruleDiff.listLabel": "Rules that changed",
  "ruleDiff.allRoutes": "All routes",
  "ruleDiff.anyUf": "Any state",
  "ruleDiff.anyNcm": "Any NCM",
  "ruleDiff.family.operational": "Operational cost",
  "ruleDiff.family.commercial": "Commercial fee",
  "ruleDiff.scope.category": "Category {value}",
  "ruleDiff.scope.paymentMethod": "Payment {value}",
  "ruleDiff.scope.transactionType": "Transaction {value}",
  "ruleDiff.openRule": "Open rule",
  "ruleDiff.more.one": "Show {count} more rule",
  "ruleDiff.more.other": "Show {count} more rules",
  "ruleDiff.other.title": "Other changes",
  "ruleDiff.noRuleChanges": "No rule changed between the versions. See the technical diff.",
  "ruleDiff.technical.show": "Show technical diff",
  "ruleDiff.technical.hide": "Hide technical diff",
  "ruleDiff.technical.title": "Technical diff",
  "ruleDiff.technical.hint": "Original ruleset lines, as stored, for audit.",
  "rulesets.publish": "Publish",
  "rulesets.publish.title": "Publish ruleset",
  "rulesets.publish.step.review": "Review differences",
  "rulesets.publish.step.impact": "Confirm impact",
  "rulesets.publish.step.confirm": "Confirm publication",
  "rulesets.publish.confirmHint": "Type {version} to confirm publication.",
  "rulesets.publish.effect":
    "From publication on, new calculations use this version. Existing calculations keep their pinned version.",
  "rulesets.rollback": "Roll back",
  "rulesets.rollback.title": "Roll back to {version}",
  "rulesets.rollback.step.select": "Choose target version",
  "rulesets.rollback.step.review": "Review differences",
  "rulesets.rollback.step.confirm": "Confirm rollback",
  "rulesets.rollback.effect":
    "Rollback deletes nothing: it republishes the target version's content as a new version.",
  "rulesets.rollback.confirmHint": "Type {version} to confirm the rollback.",
  "rulesets.staleBase": "This draft's base is stale against the active ruleset.",
  "rulesets.publish.onlyDraft": "Only the draft can be published.",
  "rulesets.publish.needsProposal": "The draft needs at least one approved proposal.",
  "rulesets.publish.publisherConflict": "The draft needs at least one approved proposal.",
  "rulesets.publish.segregation":
    "Publication is recorded in the audit log. The author may publish.",
  "rulesets.publish.included": "Included proposals",
  "rulesets.publish.includedMore": "and {count} more",
  "rulesets.rollback.onlyPublished":
    "Only published or superseded versions can be rollback targets.",
  "rulesets.rollback.target": "Target: {version}",
  "rulesets.empty.title": "No rulesets",
  "rulesets.empty.body": "The draft is generated automatically when a proposal is approved.",
  "rulesets.empty.action": "Open proposals under review",
  "rulesets.column.basedOn": "Based on",
  "rulesets.column.supersededBy": "Superseded by",
  "rulesets.included.author": "Author",
  "rulesets.included.reviewers": "Reviewers",

  "rules.title": "Rules",
  "rules.description": "Browse the rules in force by route (origin → destination), NCM and kind.",
  "rules.browse.title": "Search published rules",
  "rules.browse.hint":
    "Search published rules by NCM, origin or destination. Each filter is optional.",
  "rules.browse.prompt":
    "Filter the published rules below. Open a result to inspect its scope and evidence.",
  "rules.browse.ncm": "NCM",
  "rules.browse.ncmPlaceholder": "e.g. 2106.90.90",
  "rules.route.choose": "Choose UF",
  "rules.route.swap": "Swap origin and destination",
  "rules.route.applied": "{origin} → {destination} · {count} published on this route",
  "rules.routes.priority": "Priority routes",
  "rules.catalogs": "Siscomex and CEST catalogs",
  "rules.sources.title": "Sources on this route",
  "rules.sources.hint":
    "Official sources already tied to origin, destination or the Union. No source, no invented rate.",
  "rules.sources.empty": "No allow-listed source covers this route.",
  "rules.sources.search": "Search this route in Mesa",
  "rules.sources.open": "Open sources",
  "rules.sources.unwatched":
    "{origin} or {destination} is still off the SEFAZ watchlist. Periodic collection does not cover that end.",
  "rules.empty.route.title": "No published rule on {origin} → {destination}",
  "rules.empty.route.body":
    "The route is selected. Without a rate in this ruleset, ICMS, ST and MVA are not invented.",
  "rules.lookup.cest.title": "CEST {cest}",
  "rules.lookup.cest.segment": "Segment",
  "rules.lookup.cest.ncm": "NCM/HS prefixes",
  "rules.chapters.label": "HS chapters",
  "rules.chapters.note":
    "Two-digit HS chapters with the official title. Open a chapter to see published rules. They are not a rate and not a published ruleset.",
  "rules.chapterDetail.eyebrow": "HS chapter",
  "rules.chapterDetail.honesty":
    "This chapter is Siscomex classification. It is not a rate and not a published ruleset.",
  "rules.chapterDetail.notFound": "This HS chapter does not exist.",
  "rules.chapterDetail.notFound.body":
    "Official chapters run from 01 to 97. Return to the rules list.",
  "rules.chapterDetail.published": "Published rules in this chapter",
  "rules.chapterDetail.empty.title": "No published rule in this chapter",
  "rules.chapterDetail.empty.body":
    "The catalog classifies the chapter. Without a ruleset on this NCM prefix, a rate is not invented.",
  "rules.chapterDetail.seeAll": "See all in the rules list",
  "rules.chapterDetail.section": "Section {section}",
  "rules.chapterDetail.section.label": "HS section",
  "rules.chapterDetail.prefix": "NCM prefix",
  "rules.chapterDetail.prefix.hint": "Eight digits. Only the first two are closed.",
  "rules.chapterDetail.published.hint": "In this published ruleset. Not the catalog.",
  "rules.chapterDetail.catalog.asOf": "Classif on {asOf}: {catalog} codes. Not a rate.",
  "rules.chapterDetail.structure": "Structure",
  "rules.chapterDetail.structure.chapter": "Chapter",
  "rules.chapterDetail.structure.heading": "Heading",
  "rules.chapterDetail.structure.subheading": "Subheading",
  "rules.chapterDetail.structure.mercosur": "Mercosur",
  "rules.chapterDetail.structure.hint":
    "Didactic cut. The legal text in force is in Classif; this does not classify a product.",
  "rules.chapterDetail.classification": "Classification",
  "rules.chapterDetail.titles": "Official titles",
  "rules.chapterDetail.sources": "Official sources",
  "rules.chapterDetail.openClassif": "Open Classif",
  "rules.chapterDetail.openNesh": "Open NESH",
  "rules.chapterDetail.openHub": "Classification hub",
  "rules.chapterDetail.neighbors": "Neighbouring chapters",
  "rules.chapterDetail.previous": "Previous chapter, HS {chapter}",
  "rules.chapterDetail.next": "Next chapter, HS {chapter}",
  "rules.chapterDetail.illustration.alt":
    "Civic illustration of {title}. Not an official photo and not a rate.",
  "rules.chapterDetail.illustration.generated":
    "Vertex illustration of the chapter. Not an official photo and not a rate.",
  "rules.chapterDetail.illustration.paper": "Civic paper. This chapter has no illustration yet.",
  "rules.empty.noRuleset.title": "No published rule",
  "rules.empty.published.title": "No fiscal rule in this ruleset",
  "rules.empty.published.body":
    "The published ruleset has no rules of this kind. Siscomex Classif remains a classification, not a rate.",
  "rules.lookup.title": "Lookup {ncm}",
  "rules.lookup.catalog": "Siscomex catalog",
  "rules.lookup.published": "Published rules for this NCM",
  "rules.lookup.associated": "Associated rules",
  "rules.ncm.all": "All rules for {ncm}",
  "rules.lookup.proposals": "Proposals",
  "rules.lookup.evidence": "Evidence",
  "rules.lookup.state.reference": "reference (not a rate)",
  "rules.lookup.state.absent": "absent",
  "rules.lookup.catalogMiss": "This 8-digit NCM is not in this organization's Siscomex catalog.",
  "rules.lookup.honesty":
    "PIS and COFINS stay outside this base. Municipal ISS is not collected on this operation. Without a published ruleset, ST, ICMS and MVA are not invented.",
  "rules.lookup.openEvidence": "Open evidence for this NCM",
  "rules.lookup.openProposals": "Open proposals for this NCM",
  "rules.column.kind": "Kind",
  "rules.column.ncm": "NCM",
  "rules.chapter": "Chapter {chapter}",
  "rules.chapter.short": "HS {chapter}",
  "rules.column.route": "Route",
  "rules.column.rate": "Rate",
  "rules.column.value": "Value",
  "rules.column.validity": "Validity",
  "rules.column.reference": "Legal reference",
  "rules.filter.kind": "Rule kind",
  "rules.filter.ncm": "NCM",
  "rules.filter.originUf": "Origin UF",
  "rules.filter.destinationUf": "Destination UF",
  "rules.filter.asOf": "Effective on",
  "rules.filter.asOf.applied": "Valid on {date}",
  "rules.filter.uf": "UF",
  "rules.validFrom": "In force since {date}",
  "rules.validTo": "until {date}",
  "rules.openEnded": "open ended",
  "rules.kind.FISCAL": "Fiscal",
  "rules.kind.OPERATIONAL_COST": "Operating cost",
  "rules.kind.COMMERCIAL_FEE": "Commercial fee",
  "rules.route.any": "any",
  "rules.activeRuleset": "Ruleset {version}, published {date}",
  "rules.provenance": "Provenance",
  "rules.provenance.legacyCommercialFee": "Previous calculator intermediation fee (basis 100)",
  "rules.provenance.retailCommercialFee": "Retail commercial fee (basis 100)",
  "rules.provenance.global": "Global",
  "rules.empty.noRuleset.body": "Rules in force appear after a draft is published.",
  "rules.empty.noRuleset.action": "Open rulesets",
  "rules.detail.technicalId": "Technical ID",
  "rules.detail.title": "Rule details",
  "rules.detail.honesty":
    "The rate below is the figure published in this ruleset. The Siscomex catalog classifies; it does not calculate.",
  "rules.detail.notFound": "This rule is not in the published ruleset.",
  "rules.detail.notFound.body":
    "The detail page only shows the in-force record. Return to the list or open the published ruleset.",
  "rules.detail.openRuleset": "Open ruleset {version}",
  "rules.detail.cest": "CEST",
  "rules.related.scope":
    "Rules linked to NCM {ncm} in version {version}, across all routes and validity periods. Related does not mean applicable to your operation.",
  "rules.related.current": "Current rule",
  "rules.detail.siblings": "Other rules for this NCM",
  "record.id": "Id",
  "record.backToList": "Back to the list",
  "listing.figure.gazette": "Illustration of an official paper bulletin",
  "listing.figure.ledger": "Illustration of an open civic register",
  "listing.figure.portal": "Illustration of a civic portal",

  "calculations.empty.action": "View rulesets",
  "calculations.title": "Calculation audit",
  "calculations.description":
    "Every calculation records the exact ruleset version, the request hash and the detected issues.",
  "calculations.playground.eyebrow": "Playground",
  "calculations.playground.title": "How a lot enters the calculation",
  "calculations.playground.body":
    "The lot lives in the marketplace. Only the fiscal snapshot enters here: NCM, route, date and input value. This is not the production lots database.",
  "calculations.playground.honesty":
    "Changing the marketplace lot does not change the rule. A new CALCULATE against a published ruleset issues another receipt. Without a published ruleset, there is no honest calculation.",
  "calculations.playground.openRules": "Open rules that match this snapshot",
  "calculations.playground.matching": "Published rules for this NCM",
  "calculations.playground.noRules":
    "No published rule for this NCM. The catalog classifies; the published ruleset calculates.",
  "calculations.playground.noRuleset":
    "There is no published ruleset. The playground shows classification and route; it does not invent a rate.",
  "calculations.playground.ncm": "NCM",
  "calculations.playground.route": "Route",
  "calculations.playground.cest": "CEST",
  "calculations.playground.date": "Calculation date",
  "calculations.playground.value": "Input value",
  "calculations.playground.quantity": "Quantity",
  "calculations.playground.emptyCest": "no CEST on this snapshot",
  "calculations.playground.snapshot.stationery": "Stationery SP → RJ",
  "calculations.playground.snapshot.machinery": "Machinery MG → SP",
  "calculations.playground.snapshot.beverages": "Beverages RS → SC",
  "calculations.column.ruleset": "Ruleset",
  "calculations.column.items": "Items",
  "calculations.column.review": "Review",
  "calculations.column.workflow": "Workflow",
  "calculations.column.itemId": "Item",
  "calculations.column.baseCost": "Base cost",
  "calculations.column.ipi": "IPI",
  "calculations.column.icmsSt": "ICMS (ST or own)",
  "calculations.column.landedUnitCost": "Landed unit cost",
  "calculations.column.issues": "Issues",
  "calculations.filter.issue": "Issue code",
  "calculations.detail.title": "Calculation {id}",
  "calculations.detail.replayed": "Response replayed by idempotency",
  "calculations.detail.engine": "Engine",
  "calculations.detail.pinned": "Pinned version",
  "calculations.detail.items": "Items",
  "calculations.detail.explain": "Explain",
  "calculations.detail.export": "Export",
  "calculations.detail.exported": "Export {filename} is ready.",
  "calculations.explain.title": "How {item} was calculated",
  "calculations.explain.inputs": "Inputs",
  "calculations.explain.steps": "Steps",
  "calculations.explain.provenance": "Rule provenance",
  "calculations.explain.issues": "Issues",
  "calculations.explain.baseCost": "Base cost ({source})",
  "calculations.explain.lookup": "Lookup mode: {mode}",
  "calculations.explain.reviewRequired":
    "This item needs finance review before it becomes a price.",
  "calculations.explain.close": "Close explanation",

  "calculations.tabs.label": "Calculator tools",
  "fiscalTasks.description":
    "Follow long-running fiscal lots, their immutable snapshot, progress and calculated results.",
  "fiscalTasks.summary.review": "Waiting for review",
  "fiscalTasks.summary.items": "Lot items",
  "fiscalTasks.summary.calculated": "Calculated items",
  "fiscalTasks.summary.attempts": "Attempts",
  "fiscalTasks.status.QUEUED": "Queued",
  "fiscalTasks.status.RUNNING": "Running",
  "fiscalTasks.status.WAITING_REVIEW": "Needs review",
  "fiscalTasks.status.SUCCEEDED": "Completed",
  "fiscalTasks.status.FAILED": "Failed",
  "fiscalTasks.status.CANCELLED": "Cancelled",
  "fiscalTasks.column.lot": "Fiscal lot",
  "fiscalTasks.detail.title": "Upload {id}",
  "fiscalTasks.detail.description":
    "Operational lot record: inputs, pinned rules, execution and auditable result.",
  "fiscalTasks.record.title": "Record",
  "fiscalTasks.record.hint":
    "Facts pinned when the upload was created. Later corrections do not change them.",
  "fiscalTasks.detail.progress": "Execution progress",
  "fiscalTasks.detail.updated": "Updated {date}",
  "fiscalTasks.detail.chunks": "steps completed",
  "fiscalTasks.detail.polling": "This state refreshes by itself while the calculation runs.",
  "lotWait.title.queued": "Lot queued",
  "lotWait.title.chunk": "Calculating chunk {current} of {total}",
  "lotWait.title.running": "Calculating the lot",
  "lotWait.seconds": "{count} s",
  "lotWait.minutes": "{count} min",
  "lotWait.waited": "queued for {duration}",
  "lotWait.ahead.none": "No lot ahead: yours is next",
  "lotWait.ahead.one": "{count} lot ahead",
  "lotWait.ahead.other": "{count} lots ahead",
  "lotWait.rows": "{done} of {total} rows",
  "lotWait.stagesLabel": "Lot stages",
  "lotWait.stage.received": "Received",
  "lotWait.stage.queued": "Queued",
  "lotWait.stage.running": "Calculating",
  "lotWait.stage.results": "Results",
  "lotWait.state.done": "done",
  "lotWait.state.active": "now",
  "lotWait.state.pending": "next",
  "lotWait.chunks.one": "{count} chunk",
  "lotWait.chunks.other": "{count} chunks",
  "lotWait.chunksLabel": "Calculation chunks",
  "lotWait.chunksDone": "{done} of {total} chunks complete",
  "lotWait.chunk": "Chunk {index} of {total}",
  "lotWait.chunkState.done": "done",
  "lotWait.chunkState.active": "calculating now",
  "lotWait.chunkState.pending": "next",
  "lotWait.chunkState.failed": "failed",
  "lotWait.count.calculated": "Calculated",
  "lotWait.count.review": "To review",
  "lotWait.count.failedChunks": "Failed chunks",
  "lotWait.next.title": "What happens now",
  "lotWait.next.start":
    "The calculation starts by itself: queued lots are picked up automatically, usually within 1 minute.",
  "lotWait.next.chunks.one": "We calculate in {count} chunk; results appear when it finishes.",
  "lotWait.next.chunks.other":
    "We calculate in {count} chunks; partial results appear as each chunk finishes.",
  "lotWait.next.leave":
    "You can leave this screen: the calculation keeps running on the server and the lot stays in Lots.",
  "lotWait.attempt":
    "Attempt {current} of {max}: an earlier attempt did not finish and the lot was resumed.",
  "lotWait.follow": "Follow in Lots",
  "lotWait.partialTitle": "Partial subtotal · updates with each chunk",
  "fiscalTasks.detail.results": "Results by item",
  "fiscalTasks.detail.resultsHint": "{count} items already have a persisted result",
  "fiscalTasks.detail.sourceSystem": "Source system",
  "fiscalTasks.detail.lotId": "Lot ID",
  "fiscalTasks.detail.listId": "List ID",
  "fiscalTasks.detail.calculationDate": "Fiscal date",
  "fiscalTasks.detail.snapshotRows": "Captured rows",
  "fiscalTasks.detail.snapshotHash": "Snapshot hash",
  "fiscalTasks.detail.ruleset": "Ruleset used",
  "fiscalTasks.detail.selector": "Requested selector",
  "fiscalTasks.detail.resolvedVersion": "Resolved version",
  "fiscalTasks.detail.digest": "Ruleset digest",
  "fiscalTasks.detail.artifact": "Input artifact",
  "fiscalTasks.detail.noArtifact": "No artifact attached",
  "fiscalTasks.detail.issues": "Issues found",
  "fiscalTasks.detail.noIssues": "No issues recorded in this snapshot.",
  "fiscalTasks.detail.trace": "Operational trace",
  "fiscalTasks.detail.workflow": "Source workflow",
  "fiscalTasks.detail.requestId": "requestId",
  "fiscalTasks.detail.created": "Created",
  "fiscalTasks.detail.started": "Started",
  "fiscalTasks.detail.completed": "Completed",
  "fiscalTasks.detail.revision": "Concurrency revision",
  "fiscalTasks.action.cancel": "Cancel task",
  "fiscalTasks.action.retry": "Retry",
  "fiscalTasks.action.cancelDisabled":
    "Only queued, running or review-waiting tasks can be cancelled.",
  "fiscalTasks.action.retryDisabled": "Only failed or cancelled tasks can be retried.",
  "fiscalTasks.action.cancelled": "Cancellation request sent.",
  "fiscalTasks.action.requeued": "Task requeued.",
  "fiscalTasks.retry.defaultReason": "Retry after reviewing the lot's fiscal input.",
  "fiscalTasks.resultStatus.CALCULATED": "Calculated",
  "fiscalTasks.resultStatus.REVIEW_REQUIRED": "Needs review",
  "fiscalTasks.results.item": "Item",
  "fiscalTasks.results.route": "Route",
  "fiscalTasks.results.taxes": "IPI + ICMS-ST",
  "fiscalTasks.results.landed": "Landed cost",
  "fiscalTasks.results.issues": "Issues",
  "fiscalTasks.results.calculation": "Calculation",
  "fiscalTasks.results.openCalculation": "Open receipt",
  "fiscalTasks.results.search": "Filter by item",
  "fiscalTasks.results.empty.title": "No persisted results",
  "fiscalTasks.results.empty.filtered": "No item matches this filter.",
  "fiscalTasks.results.empty.body": "Results appear as the calculation progresses.",
  "fiscalTasks.dialog.cancel.title": "Cancel this fiscal task?",
  "fiscalTasks.dialog.cancel.body":
    "No new rows will be calculated. A step already in progress may finish.",
  "fiscalTasks.dialog.cancel.warning":
    "The snapshot and persisted results remain preserved for audit.",
  "fiscalTasks.dialog.cancel.confirm": "Confirm cancellation",
  "fiscalTasks.dialog.retry.title": "Retry fiscal task",
  "fiscalTasks.dialog.retry.body":
    "Finished steps stay immutable; only what is left to calculate is queued again.",
  "fiscalTasks.dialog.retry.reason": "Retry reason",
  "fiscalTasks.dialog.retry.reasonHint": "Enter at least 10 characters to record the decision.",
  "fiscalTasks.dialog.retry.confirm": "Queue task",

  "sources.empty.title": "No sources registered",
  "sources.empty.body":
    "Sources come from the official registry; URLs cannot be added from the interface.",
  "sources.title": "Official sources",
  "sources.description": "Check which sources are up to date and open documents that need review.",
  "sources.registry.eyebrow": "Official registry",
  "sources.registry.title": "Sources behind every investigation",
  "sources.registry.description":
    "The catalogue defines where the agent can search. A source is not a tax rule: it delivers documents for review.",
  "sources.registry.flow": "How a source becomes evidence",
  "sources.registry.step.review": "Reviewed source",
  "sources.registry.step.reviewHint": "Domain, jurisdiction and cadence stay controlled.",
  "sources.registry.step.grounding": "Grounded search",
  "sources.registry.step.groundingHint": "Research stays within the authorized official sources.",
  "sources.registry.step.evidence": "Evidence to review",
  "sources.registry.step.evidenceHint": "Nothing becomes a rule or rate automatically.",
  "sources.registry.note":
    "Free-form URLs do not enter the registry directly; ask your team to review a new source.",
  "sources.action.requestReview": "Request a new source",
  "sources.request.title": "Request source onboarding",
  "sources.request.titlePrefix": "Review source",
  "sources.request.notice":
    "This creates a review task; it does not activate the URL or change the official registry.",
  "sources.request.name": "Source name",
  "sources.request.publisher": "Publisher",
  "sources.request.jurisdiction": "Jurisdiction",
  "sources.request.url": "Official URL",
  "sources.request.reasonHint":
    "Explain why this source should be reviewed and what fiscal information it may support.",
  "sources.request.submit": "Create review task",
  "sources.request.created": "Request recorded as a review task.",
  "sources.request.openTasks": "View tasks",
  "sources.request.payload.name": "Name",
  "sources.request.payload.publisher": "Publisher",
  "sources.request.payload.jurisdiction": "Jurisdiction",
  "sources.request.payload.url": "Official URL",
  "sources.request.payload.reason": "Reason",
  "sources.request.payload.governance":
    "The official registry should only be updated after governed review and configuration.",
  "sources.discovery.note":
    "Automatic collection checks every 3 hours (Brasília time) when it is not paused and visits each source once per its cadence (daily for now), oldest first; a degraded source is retried once per cadence. “Run now” does not wait for the next slot. The “Last run” column shows what actually ran.",
  "sources.extract.note":
    "The extractor only writes evidence for review. The Siscomex (NCM) source stays paused until Classif is published as a reference catalog, never as a rate.",
  "sources.intro.summary": "How documents are collected",
  "sources.filter.dlq": "With pending failures",
  "sources.filter.search": "Name, publisher or jurisdiction",
  "sources.status.ACTIVE": "Active",
  "sources.status.PAUSED": "Paused",
  "sources.status.DEGRADED": "Degraded",
  "sources.status.DISABLED": "Disabled",
  "sources.catalogue.results": "{count} sources",
  "sources.catalogue.degraded.one": "{count} degraded",
  "sources.catalogue.degraded.other": "{count} degraded",
  "sources.fact.rate": "Success 7 d",
  "sources.fact.documents": "Documents",
  "sources.column.name": "Source",
  "sources.column.status": "Status",
  "sources.column.lastRun": "Last run",
  "sources.column.nextDue": "Next search",
  "sources.column.successRate": "Success rate",
  "sources.column.documents": "Documents (7 d)",
  "sources.column.cadence": "Cadence",
  "sources.column.baseUrl": "Base URL",
  "sources.dlq.label": "Pending failures",
  "sources.health.current": "Source pending failures: {count}",
  "sources.health.observedAt": "Observed {when}",
  "sources.health.stale": "Source pending-failure count is stale",
  "sources.health.unavailable": "Source pending-failure count unavailable",
  "sources.health.lastObserved": "Last observed {when}",
  "sources.health.diagnostic":
    "Cloud monitoring is the reference for the shared failure count. Run a source preview to review exact message IDs.",
  "sources.health.failedRuns": "Recent source run failures",
  "sources.health.compact.current": "{count}",
  "sources.health.compact.stale": "⚠ {count}",
  "sources.health.compact.unavailable": "—",
  "sources.cadence.daily": "Daily",
  "sources.cadence.weekly": "Weekly",
  "sources.due.now": "On the next tick",
  "sources.run.detail.title": "Run {id}",
  "sources.run.detail.description": "Collection outcome and documents linked to this run.",
  "sources.run.detail.identity": "{name} · {publisher} · {jurisdiction}",
  "sources.run.detail.notFound": "Run not found",
  "sources.run.detail.invalid":
    "The identifier is invalid or the run does not belong to this source.",
  "sources.run.detail.sourceError": "Could not read the source",
  "sources.run.detail.readError": "Could not read the run",
  "sources.run.detail.result": "Run outcome",
  "sources.run.detail.live": "Following this run · updates automatically",
  "sources.run.detail.ageNotice": "No completion recorded after two hours",
  "sources.run.detail.staleNotice":
    "No update recorded for more than 24 hours. Close this run to allow new source checks. Documents already extracted will be preserved.",
  "sources.run.detail.cancelStale": "Close stalled run",
  "sources.run.detail.cancelling": "Requesting closure…",
  "sources.run.detail.cancelRequested":
    "Closure requested. Waiting for confirmation of the run status.",
  "sources.run.detail.created": "Created",
  "sources.run.detail.reused": "Reused",
  "sources.run.detail.countNote":
    "Created and reused counts refer to documents linked to this run. A reused document does not establish approval of tax rules.",
  "sources.run.detail.documents": "Documents from this run",
  "sources.run.detail.review": "Review document",
  "sources.run.detail.waiting": "Waiting for documents",
  "sources.run.detail.waitingBody":
    "No documents are linked yet. This page queries status and receipts.",
  "sources.run.detail.empty": "No linked documents",
  "sources.run.detail.emptyBody":
    "No document links are recorded for this run. This does not establish that the source has never been collected.",
  "sources.run.detail.timing": "When it happened",
  "sources.run.detail.started": "Started",
  "sources.run.detail.finished": "Finished",
  "sources.run.detail.technical": "Technical identifiers",
  "sources.run.detail.runId": "Run ID",
  "sources.run.detail.sourceId": "Source ID",
  "sources.runs": "Runs",
  "sources.run.duration": "Duration",
  "sources.run.discovered": "Discovered",
  "sources.run.ingested": "Ingested",
  "sources.run.failed": "Failed",
  "sources.run.compact.discovered.one": "{count} discovered",
  "sources.run.compact.discovered.other": "{count} discovered",
  "sources.run.compact.failed.one": "{count} failure",
  "sources.run.compact.failed.other": "{count} failures",
  "sources.action.runNow": "Run now",
  "sources.action.pause": "Pause",
  "sources.action.resume": "Resume",
  "sources.action.replayDlq": "Replay pending failures",
  "sources.action.inspectDlq": "Inspect pending failures",
  "sources.run.accepted": "Fiscal source run queued with identifier {id}.",
  "sources.dlq.title": "Pending-failure recovery — {source}",
  "sources.dlq.previewNotice":
    "Preview is asynchronous: it neither publishes nor acknowledges messages. Review the execution logs and copy only approved IDs.",
  "sources.dlq.executeNotice":
    "Execution republishes only the supplied IDs and acknowledges each pending failure after publication.",
  "sources.dlq.maxMessages": "Pull limit (1–100)",
  "sources.dlq.rate": "Messages per second (0.1–10)",
  "sources.dlq.execute": "Execute previously reviewed IDs",
  "sources.dlq.messageIds": "Exact message IDs",
  "sources.dlq.messageIdsHint":
    "One previewed ID per line. Duplicates, whitespace and more than 100 IDs are rejected.",
  "sources.dlq.reasonHint":
    "Include the ticket or change record and its approval (10–256 characters).",
  "sources.dlq.queuePreview": "Queue safe preview",
  "sources.dlq.confirmExecute": "Queue selected replay",
  "sources.dlq.acceptedPreview":
    "Preview queued ({id}). Review its logs before selecting any message.",
  "sources.dlq.acceptedExecute":
    "Selected replay queued ({id}); verify the outcome in logs and metrics.",
  "sources.degraded": "Source degraded: {reason}",
  "sources.degraded.noRun": "No run is recorded yet",
  "sources.degraded.technical": "Technical detail",
  "sources.degraded.timeout": "Connection timed out",
  "sources.degraded.timeoutHost": "Connection timed out to {host}",
  "sources.degraded.dns": "DNS lookup failed",
  "sources.degraded.dnsHost": "DNS lookup failed for {host}",
  "sources.degraded.tls": "TLS or certificate error",
  "sources.degraded.tlsHost": "TLS or certificate error at {host}",
  "sources.degraded.http": "The source responded HTTP {status}",
  "sources.degraded.httpHost": "{host} responded HTTP {status}",
  "sources.degraded.reset": "The connection was reset",
  "sources.degraded.resetHost": "The connection to {host} was reset",
  "sources.degraded.connect": "Could not connect",
  "sources.degraded.connectHost": "Could not connect to {host}",
  "sources.degraded.security": "Blocked by the security policy",
  "sources.degraded.robots": "Blocked by robots.txt",
  "sources.degraded.unsupported": "Unsupported document format",
  "sources.degraded.parse": "The document could not be parsed",
  "sources.degraded.unknown": "Failed to collect the source · {raw}",

  "discovery.title": "Launch a fiscal search",
  "discovery.description":
    "Ask the agent a question or extract an official URL; follow everything through human review.",
  "discovery.mode.label": "Fiscal task type",
  "discovery.mode.research": "Research a question",
  "discovery.mode.researchHint": "No URL: the agent searches the selected official sources.",
  "discovery.mode.url": "Extract from a URL",
  "discovery.mode.urlHint": "With a URL: preserve the document and review candidates.",
  "discovery.queryHint": "Describe the question, tax, UF or NCM you want to investigate.",
  "discovery.sourcesHint":
    "The task stays bounded to active or degraded sources in the reviewed registry.",
  "discovery.degraded.badge": "Degraded source",
  "discovery.degraded.hint": "The last capture failed; citations remain subject to review.",
  "discovery.degraded.hintWithReason":
    "The last capture failed ({reason}); citations remain subject to review.",
  "discovery.stage.eyebrow": "Work area",
  "discovery.stage.title": "Follow what came in",
  "discovery.stage.description": "See the execution, evidence and what still needs human review.",
  "discovery.stage.urlEmpty": "Send an official URL to follow its receipt and candidates here.",
  "discovery.research.retryDispatch": "Retry dispatch",
  "discovery.research.retryReason": "Reason for retry",
  "discovery.research.retryHint":
    "Send pending citations from this task. Keep evidence already received.",
  "discovery.research.eyebrow": "Fiscal agent",
  "discovery.research.title": "Research official sources online",
  "discovery.research.description":
    "The agent searches the web, filters authorized domains and stores citations for review.",
  "discovery.research.provider": "AI provider",
  "discovery.research.defaultModel": "gemini-4-argon",
  "discovery.research.grounding": "Google Search grounding",
  "discovery.research.taskMode": "Each send creates an auditable task",
  "discovery.research.conversation": "Fiscal agent conversation",
  "discovery.research.operator": "Operator request",
  "discovery.research.agent": "Research agent",
  "discovery.research.noUrl": "You do not need to paste a URL to get started.",
  "discovery.research.emptyPrompt": "Write a fiscal question or task above.",
  "discovery.research.waitingAnswer":
    "The agent is processing the task and will keep its answer here.",
  "discovery.research.resultReady":
    "The summary is below; review its citations before proposing a change.",
  "discovery.research.chatHint":
    "The answer, official citations and evidence links will appear here when the run finishes.",
  "discovery.research.launch": "Research with agent",
  "discovery.research.launchTask": "Send to the research agent",
  "discovery.research.pending": "Researching official sources…",
  "discovery.research.failed": "Fiscal research did not complete.",
  "discovery.research.summary": "Agent summary",
  "discovery.research.noSummary": "No summary is available yet.",
  "discovery.research.candidates": "Results",
  "discovery.research.accepted": "Accepted",
  "discovery.research.ingested": "In evidence",
  "discovery.research.rejected": "Discarded",
  "discovery.research.citations": "Official citations",
  "discovery.research.citationStatus.QUEUED": "Queued for ingestion",
  "discovery.research.citationStatus.FETCHING": "Ingesting",
  "discovery.research.citationStatus.INGESTED": "In evidence",
  "discovery.research.citationStatus.REJECTED": "Rejected",
  "discovery.research.rejectionReason": "Rejection reason: {reason}",
  "discovery.research.noCitations": "No official citation was accepted for this research.",
  "discovery.research.openSourceRun": "Open run",
  "discovery.research.openEvidence": "Open evidence",
  "discovery.research.disclaimer":
    "The summary and citations do not change rules or rates. Evidence must be reviewed before any proposal.",
  "discovery.research.execution": "Task execution",
  "discovery.research.step.request": "Task persisted",
  "discovery.research.step.requestHint":
    "The request is stored in Tax Platform with correlation and idempotency.",
  "discovery.research.step.vertex": "Agent research",
  "discovery.research.step.vertexHint":
    "The agent receives the query and searches official sources.",
  "discovery.research.step.grounding": "Sources and citations",
  "discovery.research.step.groundingHint":
    "Citations are filtered against the authorized source registry and enter the evidence pipeline.",
  "discovery.research.step.review": "Human review",
  "discovery.research.step.reviewHint":
    "A person must review evidence before creating a proposal or changing rules.",
  "discovery.research.step.done": "Completed",
  "discovery.research.step.active": "In progress",
  "discovery.research.step.pending": "Pending",
  "discovery.research.step.failed": "Failed",
  "discovery.research.error.VERTEX_QUOTA": "Vertex quota was exhausted (HTTP 429).",
  "discovery.research.error.VERTEX_UNAVAILABLE": "Vertex was unavailable (HTTP 408, 425 or 5xx).",
  "discovery.research.error.VERTEX_TIMEOUT": "The Vertex search timed out.",
  "discovery.research.error.VERTEX_NETWORK": "The connection to Vertex failed.",
  "discovery.research.error.VERTEX_OUTPUT_BUDGET":
    "The Vertex response exhausted its output token budget.",
  "discovery.research.error.VERTEX_BLOCKED": "Vertex blocked the response (safety or recitation).",
  "discovery.research.error.VERTEX_REJECTED": "Vertex rejected the research request.",
  "discovery.research.error.VERTEX_INVALID_RESPONSE": "Vertex returned an invalid response.",
  "discovery.research.error.RUNTIME_UNAVAILABLE": "The task record is not available yet.",
  "discovery.research.error.CITATION_DISPATCH_FAILED":
    "The citations could not be sent to the evidence queue.",
  "discovery.research.error.INTERNAL_ERROR": "Fiscal research failed because of an internal error.",
  "discovery.research.error.retryable": "It will be tried again automatically.",
  "discovery.research.taskId": "Task ID",
  "discovery.research.requestId": "Provider request ID",
  "discovery.research.searchQueries": "Search queries",
  "discovery.research.trace": "View technical trace",
  "discovery.research.history": "Agent research history",
  "discovery.query": "What to search",
  "discovery.placeholder": "ICMS SP stationery, NCM 84713012, MVA MG…",
  "discovery.sources": "Matching official sources",
  "discovery.noSources": "No authorized official source matches this query.",
  "discovery.needQuery": "Write a fiscal question with at least 3 characters.",
  "discovery.needSource": "Select at least one active source.",
  "discovery.needReason": "The reason is written to the audit log. Use at least 10 characters.",
  "discovery.excluded":
    "PIS, COFINS and ISS stay outside this base. The search will not invent a rate or dispatch a source.",
  "discovery.reasonHint": "Record the reason for this search for your team.",
  "discovery.launch": "Launch extraction",
  "discovery.harvest": "Evidence extracted for this query",
  "discovery.openEvidence": "Open",
  "discovery.awaitingFigure": "Select evidence from the queue to read its stored excerpt.",
  "discovery.timelineEmpty": "Chosen sources appear here once the query settles.",
  "discovery.idle": "No run yet",
  "discovery.ncmChip": "NCM {ncm}",
  "discovery.disclaimer": "Received documents go through review before a rule is proposed.",
  "discovery.figure.note": "Stored document excerpt. Open the source to consult the publication.",
  "discovery.figure.unavailable": "Official figure unavailable",
  "discovery.figure.noHost": "official host",
  "discovery.figure.emptyExcerpt": "The extractor has not returned text for this artifact yet.",
  "discovery.harvestNew": "from this run",
  "discovery.harvestKnown": "already in the queue",
  "discovery.findings.claim": "What the source states",
  "discovery.findings.vigencia": "In force",
  "discovery.findings.pending": "Still open",
  "discovery.findings.noDate": "The artifact did not bring an in-force date",
  "discovery.findings.needsTriage": "Not triaged yet",
  "discovery.findings.noRate": "No rate was copied",
  "discovery.maxDocuments": "At most {count} documents per source.",
  "discovery.retryPending": "Retry pending sources",
  "discovery.accepted": "{source}: run accepted ({id}).",
  "discovery.dispatchFailed":
    "{source}: the request could not be confirmed. Accepted runs continue.",
  "discovery.linkDisclosure": "Extract fiscal data from a URL",
  "discovery.linkTitle": "Extract data from an official link",
  "discovery.linkHint":
    "Enter a URL from a reviewed source. The system preserves the document, extracts fiscal candidates and waits for human approval.",
  "discovery.linkFlow": "Fiscal URL extraction flow",
  "discovery.linkFlow.url": "URL",
  "discovery.linkFlow.evidence": "Evidence",
  "discovery.linkFlow.candidate": "Candidate",
  "discovery.linkFlow.approval": "Approval",
  "discovery.linkSource": "Reviewed source",
  "discovery.linkSelectSource": "Select a reviewed source",
  "discovery.linkUrl": "Official URL",
  "discovery.linkSubmit": "Extract fiscal data",
  "discovery.linkNeedSource": "Select a reviewed source.",
  "discovery.linkNeedUrl": "Enter the reviewed official link.",
  "discovery.linkInvalidUrl": "Enter a valid HTTPS link.",
  "discovery.linkHttps": "The link must use HTTPS.",
  "discovery.linkNeedReason": "The reason must contain at least 10 characters.",
  "discovery.linkFailed": "The directed link was not accepted.",
  "discovery.linkAccepted": "URL accepted. Fiscal extraction is running.",
  "discovery.linkProgress": "Fiscal URL extraction progress",
  "discovery.linkProgressHint":
    "When the document arrives, open the evidence to review candidates and create a proposal.",
  "discovery.linkCandidateReady": "candidate available",
  "discovery.linkWaiting": "The run is fetching and normalizing the official document…",
  "discovery.linkNoDocuments": "The run finished without documents. Open details to investigate.",
  "discovery.linkOpenRun": "Open run",
  "discovery.runUnavailable": "Status unavailable",
  "discovery.receipts.created": "New document",
  "discovery.receipts.reused": "Already stored",
  "discovery.receipts": "Documents from run {source}",
  "discovery.receipts.hasMore": "This run has more documents than this page.",
  "discovery.receipts.endedEmpty": "This run ended without received documents.",
  "discovery.failedDocuments": "{count} failed documents",
  "discovery.receipts.empty": "This run has not returned documents yet.",
  "discovery.counts": "{created} created · {reused} reused",
  "discovery.reusedNotRate": "A reused document is not an approved rate or published rule.",

  "audit.empty.title": "No events yet",
  "audit.empty.body": "Every decision, publication and run writes an immutable event.",
  "audit.access.roleRequired":
    "Audit belongs to Developers. A tax developer or authorized super admin role is required.",
  "audit.title": "Audit",
  "audit.description":
    "Immutable record of decisions: who acted, when, on which resource and under which correlation.",
  "audit.column.when": "When",
  "audit.column.actor": "Actor",
  "audit.column.action": "Action",
  "audit.column.resource": "Resource",
  "audit.column.correlation": "Correlation",
  "audit.filter.actor": "Actor",
  "audit.filter.action": "Action",
  "audit.action.EVIDENCE_APPROVED": "Evidence approved",
  "audit.action.EVIDENCE_REJECTED": "Evidence rejected",
  "audit.action.EVIDENCE_BULK_REVIEWED": "Evidence reviewed in bulk",
  "audit.action.PROPOSAL_CREATED": "Proposal created",
  "audit.action.PROPOSAL_APPROVED": "Proposal approved",
  "audit.action.PROPOSAL_REJECTED": "Proposal rejected",
  "audit.action.RULESET_PUBLISHED": "Ruleset published",
  "audit.action.RULESET_ROLLED_BACK": "Ruleset rolled back",
  "audit.action.SOURCE_RUN_TRIGGERED": "Source run triggered",
  "audit.action.SOURCE_PAUSED": "Source paused",
  "audit.action.DLQ_REPLAYED": "Pending failures replayed",
  "audit.action.CALCULATION_EXPORTED": "Calculation exported",
  "audit.immutable": "Read only. Audit entries cannot be edited or deleted.",
  "audit.detail.title": "Audit event",
  "audit.detail.notFound": "This event is not in the register.",
  "audit.detail.notFound.body":
    "The detail page only shows the immutable event. Return to the list to search by action, actor or correlation.",
  /* Auditoria — readable resource labels and record byline (UX plan PR 5). */
  "audit.detail.byline": "{actor} · {when}",
  "audit.detail.technical": "Technical identifiers",
  "audit.resource.evidence": "Document",
  "audit.resource.evidence_documents": "Documents",
  "audit.resource.evidence_task": "Document task",
  "audit.resource.fiscal_task": "Fiscal task",
  "audit.resource.rule_proposal": "Proposal",
  "audit.resource.proposal": "Proposal",
  "audit.resource.ruleset": "Publication",
  "audit.resource.rule": "Rule",
  "audit.resource.source": "Source",
  "audit.resource.calculation": "Calculation",
  "audit.resource.principal": "User",
  "audit.resource.principal_allowlist": "User invitation",
  "audit.resource.tax_integration_key": "API key",
  "audit.resource.ncm_catalog": "NCM catalog",
  "audit.resource.cest_catalog": "CEST catalog",
  "audit.action.admin-command.requested": "Admin command requested",
  "audit.action.admin-command.dispatched": "Admin command dispatched",
  "audit.action.admin-command.dispatch-failed": "Admin command dispatch failed",
  "audit.action.browser-agent.credentials-updated": "IOB agent credentials updated",
  "audit.action.browser-agent.demo-created": "Agent demo recorded",
  "audit.action.browser-agent.demo-deleted": "Agent demo deleted",
  "audit.action.browser-agent.settings-updated": "IOB agent settings updated",
  "audit.action.browser-agent.stop-requested": "IOB agent stop requested",
  "audit.action.browser-agent.task-created": "IOB agent task created",
  "audit.action.browser-agent.task-pause": "IOB agent task paused",
  "audit.action.browser-agent.task-resume": "IOB agent task resumed",
  "audit.action.browser-agent.task-cancel": "IOB agent task cancelled",
  "audit.action.browser-agent.task-move-up": "IOB agent task moved up",
  "audit.action.browser-agent.task-move-down": "IOB agent task moved down",
  "audit.action.browser-agent.task-move-to-front": "IOB agent task moved to the front",
  "audit.action.calculation.completed": "Calculation completed",
  "audit.action.evidence-task.assigned": "Document task assigned",
  "audit.action.evidence-task.created": "Document task created",
  "audit.action.evidence-task.status-changed": "Document task status changed",
  "audit.action.evidence-task.updated": "Document task updated",
  "audit.action.evidence.artifact-read": "Document original file read",
  "audit.action.evidence.bulk-reviewed": "Documents reviewed in bulk",
  "audit.action.evidence.normalized-ingested": "Document collected",
  "audit.action.evidence.normalized-reused": "Document reused",
  "audit.action.evidence.reviewed": "Document reviewed",
  "audit.action.fiscal-facts.revoked": "Fiscal fact revoked",
  "audit.action.fiscal-facts.settings-updated": "Fiscal facts settings updated",
  "audit.action.fiscal-research-citation.stale-update-ignored": "Stale citation update ignored",
  "audit.action.fiscal-research-citation.updated": "Research citation updated",
  "audit.action.fiscal-research.dispatch-failed": "Fiscal research dispatch failed",
  "audit.action.fiscal-research.dispatch-retry-requested": "Fiscal research re-send requested",
  "audit.action.fiscal-research.dispatch-retry-updated": "Fiscal research re-send updated",
  "audit.action.fiscal-research.dispatched": "Fiscal research sent",
  "audit.action.fiscal-research.requested": "Fiscal research requested",
  "audit.action.fiscal-research.research-retry-updated": "Fiscal research retry updated",
  "audit.action.fiscal-research.retry-restarted": "Fiscal research restarted",
  "audit.action.fiscal-research.stale-update-ignored": "Stale research update ignored",
  "audit.action.fiscal-research.updated": "Fiscal research updated",
  "audit.action.fiscal-task.cancel-requested": "Fiscal task cancellation requested",
  "audit.action.fiscal-task.cancelled": "Fiscal task cancelled",
  "audit.action.fiscal-task.chunk-completed": "Fiscal task part completed",
  "audit.action.fiscal-task.completed": "Fiscal task completed",
  "audit.action.fiscal-task.created": "Fiscal task created",
  "audit.action.fiscal-task.failed": "Fiscal task failed",
  "audit.action.fiscal-task.requeued": "Fiscal task requeued",
  "audit.action.fiscal-task.retry-resolved": "Fiscal task retry resolved",
  "audit.action.fiscal-task.retry-scheduled": "Fiscal task retry scheduled",
  "audit.action.integration-key.created": "API key created",
  "audit.action.integration-key.revoked": "API key revoked",
  "audit.action.integration-key.rotated": "API key rotated",
  "audit.action.principal.allowlist.created": "User invitation created",
  "audit.action.principal.allowlist.updated": "User invitation updated",
  "audit.action.principal.updated": "User updated",
  "audit.action.rule-proposal.created": "Proposal created",
  "audit.action.rule-proposal.approved": "Proposal approved",
  "audit.action.rule-proposal.rejected": "Proposal rejected",
  "audit.action.ruleset.policy-changed": "Calculation policy changed",
  "audit.action.ruleset.published": "Ruleset published",
  "audit.action.ruleset.rolled-back": "Ruleset rolled back",
  "audit.action.source-run.cancellation-requested": "Run cancellation requested",
  "audit.action.source-run.stale-cancelled": "Stale run cancelled",
  "audit.action.source-run.worker-updated": "Source run updated",
  "audit.action.source.paused": "Source paused",
  "audit.action.source.resumed": "Source resumed",
  "audit.action.tax-lookup-job.submitted": "Tax lookup submitted",
  "audit.action.web-research.settings-updated": "Web research settings updated",
  "audit.action.web-research.sweep-created": "Web research sweep created",
  "audit.action.EVIDENCE_TASK_ASSIGNED": "Document task assigned",
  "audit.action.EVIDENCE_TASK_CREATED": "Document task created",
  "audit.action.EVIDENCE_TASK_STATUS_CHANGED": "Document task status changed",
  "audit.action.EVIDENCE_TASK_UPDATED": "Document task updated",
  "audit.action.FISCAL_TASK_CANCEL_REQUESTED": "Fiscal task cancellation requested",
  "audit.action.FISCAL_TASK_CREATED": "Fiscal task created",
  "audit.action.FISCAL_TASK_REQUEUED": "Fiscal task requeued",
  "audit.resource.admin_command": "Admin command",
  "audit.resource.browser_agent_credentials": "IOB agent credentials",
  "audit.resource.browser_agent_demo": "Agent demo",
  "audit.resource.browser_agent_run": "IOB agent run",
  "audit.resource.browser_agent_settings": "IOB agent settings",
  "audit.resource.browser_agent_task": "IOB agent task",
  "audit.resource.coverage_gap": "Coverage gap",
  "audit.resource.evidence_artifact": "Document file",
  "audit.resource.fiscal_fact": "Fiscal fact",
  "audit.resource.fiscal_facts_settings": "Fiscal facts settings",
  "audit.resource.fiscal_research_citation": "Research citation",
  "audit.resource.fiscal_research_task": "Fiscal research",
  "audit.resource.source_run": "Source run",
  "audit.resource.tax_lookup_job": "Tax lookup",
  "audit.resource.web_research_settings": "Web research settings",
  "audit.resource.web_research_sweep": "Web research sweep",
  "audit.column.actorId": "Identity",
  "audit.column.request": "Request",
  "audit.column.reason": "Reason",

  "legal.title": "Company details",
  "legal.description":
    "BackChannel's cadastral identity. It is not a published rate and it does not replace a ruleset.",
  "legal.section.entity": "Platform legal entity",
  "legal.entity.hint": "BackChannel's cadastral identity. It is not a published rate.",
  "legal.entity.legalName": "Legal name",
  "legal.entity.tradeName": "Trade name",
  "legal.entity.cnpj": "CNPJ",
  "legal.entity.status": "Registration status",
  "legal.entity.status.active": "Active",
  "legal.entity.nature": "Legal nature",
  "legal.entity.registeredAddress": "Receita registered address",
  "legal.entity.commercialOffice": "Commercial office",
  "legal.entity.simples": "Simples Nacional",
  "legal.entity.simples.badge": "Outside Simples",
  "legal.entity.simples.excluded":
    "Outside Simples Nacional: legal-entity partner on the QSA (LC 123/2006 art. 3, §4, I). We do not compute a DAS rate.",
  "legal.entity.federalRegime": "Federal profit regime",
  "legal.entity.federalRegime.unaccredited":
    "The tax registry does not establish the PIS/COFINS regime. The accountant-confirmed policy, once recorded, appears on this page.",
  "legal.entity.notice":
    "This panel identifies the company. It does not calculate tax and it does not replace a published ruleset.",
  "legal.entity.uf": "UF",
  "legal.entity.cnae": "Primary CNAE",
  "settings.title": "Profile",
  "settings.description": "Your name, language and passkeys for this workspace.",
  "users.title": "Users",
  "users.description": "Invite operators, choose their role and language, and resend setup mail.",
  "users.missingOrganization":
    "This account has no organization scope, so invites cannot be created.",
  "settings.passkeys.title": "Passkeys",
  "settings.passkeys.description":
    "Enroll a passkey for Tax Operations only. It does not replace the Internal Tool passkey.",
  "settings.passkeys.add": "Add passkey",
  "settings.passkeys.adding": "Waiting for the authenticator…",
  "settings.passkeys.remove": "Revoke",
  "settings.passkeys.loading": "Loading passkeys…",
  "settings.passkeys.empty": "No passkeys enrolled in this tax workspace.",
  "settings.passkeys.added": "Passkey enrolled. Use it the next time you sign in.",
  "settings.passkeys.removed": "Passkey revoked.",
  "settings.passkeys.error": "The passkeys could not be updated. Try again.",
  "settings.passkeys.unsupported": "This browser does not support passkeys.",
  "settings.passkeys.hostHint":
    "Enroll passkeys at tax.backchannel.com.br or on localhost against a local API.",
  "settings.passkeys.hostHintDeployed": "Enroll passkeys at tax.backchannel.com.br.",
  "settings.passkeys.created": "Created {date}",
  "settings.passkeys.lastUsed": "Last used {date}",
  "settings.passkeys.neverUsed": "not yet used",
  "settings.apiBase": "API origin",
  "settings.buildInfo": "Build",
  "settings.technical.summary": "Show technical details",
  "settings.technical.identity": "Identity details",
  "settings.principalId": "Principal ID",
  "settings.organizationScopes": "Organization scope",
  "settings.tokenPresent": "Token present",
  "settings.expiresIn": "Expires in",
  "settings.bulkCap": "Bulk triage limit",
  "settings.access.inviteError":
    "The invitation could not be completed. A pending user may already exist. Close this panel and check the list before trying again; use Resend invite for an existing user.",
  "settings.access.editHelp":
    "Changes apply to this user’s workspace access. Resending sends the last saved role and language.",
  "settings.access.search": "Name, email or role",
  "settings.access.noMatches": "No users match this search.",
  "settings.access.inviteHelp":
    "Choose a role and language. The recipient gets a secure link to set up their account.",
  "settings.access.resent": "Invitation sent again. The previous setup link no longer works.",
  "settings.access.resendError":
    "The invitation could not be resent. Try again; do not assume an email was delivered.",
  "settings.access.title": "Workspace access",
  "settings.access.hint": "Manage roles and account access",
  "settings.access.new": "Invite user",
  "settings.access.description":
    "Create accounts, send invite emails and choose the invite language. Only the super admin sees this module.",
  "settings.access.singleEnvironment":
    "Single controlled workspace: scopes stay within the selected organization and every change is audited.",
  "settings.access.tableCaption": "Authorized principals and pending invites",
  "settings.access.email": "Email",
  "settings.access.status": "Status",
  "settings.access.role": "Role",
  "settings.access.role.platformAdmin": "Super admin",
  "settings.access.role.taxOperator": "Tax manager",
  "settings.access.role.superAdmin": "Super admin",
  "settings.access.role.taxManager": "Tax manager",
  "settings.access.role.taxCommercial": "Commercial",
  "settings.access.commercialRoleHint":
    "Calculator, lots and invoice browsing and uploads for your organization. No fiscal review or publication.",
  "settings.access.role.taxReader": "Tax reader",
  "settings.access.role.taxDeveloper": "Tax developer",
  "settings.access.origin": "Origin",
  "settings.access.origin.googleAuto": "Google (automatic)",
  "settings.access.origin.manual": "Added by an admin",
  "settings.access.origin.invite": "Invite",
  "settings.access.origin.googleLinked": "Google linked",
  "settings.access.readerUntilPromoted": "Reader until promoted",
  "settings.access.googleAutoNotice":
    "Created automatically on the first Google sign-in, as a Reader. Change the role to promote them (for example Tax manager, Tax developer or Super admin).",
  "settings.access.locale": "Invite language",
  "settings.access.localeHint": "The invite and account-setup emails use this language.",
  "settings.access.resendInvite": "Resend invite",
  "settings.access.superAdminRoleHint": "Full access, including Users and Developers.",
  "settings.access.managerRoleHint":
    "Fiscal lookup, calculator, lots and sources. Does not see Users or Developers.",
  "settings.access.readerRoleHint":
    "Read only. Cannot execute calculations, publications or ingestion.",
  "settings.access.developerRoleHint":
    "API keys, consumer docs and MCP tools. Cannot publish rules or invite users.",
  "settings.access.permissionsCount": "Permissions",
  "settings.access.active": "Active",
  "settings.access.pending": "Pending invite",
  "settings.access.inactive": "inactive",
  "settings.access.empty": "No access records yet.",
  "settings.access.edit": "Edit access",
  "settings.access.invite": "Invite operator",
  "settings.access.displayName": "Display name",
  "settings.access.yourAreas": "Areas available to you",
  "settings.access.activeToggle": "Allow sign-in to this workspace",
  "settings.access.permissions": "Explicit permissions",
  "settings.access.permissionsHint":
    "Permissions are explicit. Platform administrators always retain the administrator permission.",
  "settings.access.adminRoleHint": "Full workspace access and allowlist management.",
  "settings.access.operatorRoleHint": "Access only to the areas selected below.",
  "settings.access.preview": "View access",
  "settings.access.previewEyebrow": "Safe access preview",
  "settings.access.previewTitle": "What this user can see",
  "settings.access.previewNotice":
    "Preview only. Your administrator session is unchanged and no actions are executed as this user.",
  "settings.access.previewInactive":
    "This access is inactive or pending, so every destination remains unavailable until enrollment is complete.",
  "settings.access.previewAllowed": "Available",
  "settings.access.previewDenied": "Unavailable",
  "settings.access.auditHint": "This action is written to the immutable audit log.",
  "settings.access.createAccount": "Send invitation",
  "settings.access.invited": "Account created. Check its invitation status in the user list.",
  "settings.access.saved": "Access updated. The user can sign in with the assigned permissions.",
  "settings.access.saveError": "Access could not be saved. Check the values and try again.",
  "settings.access.unavailableEdit":
    "The access list is unavailable. Wait for it to load before making edits.",

  "settings.integrations.title": "Issued keys",
  "settings.integrations.hint": "Attributable, scoped credentials",
  "settings.integrations.description":
    "Create individual keys for authorized systems. Organization, workflows and scopes stay bound to the integration.",
  "settings.integrations.new": "New key",
  "settings.integrations.currentOrganization": "Current organization",
  "settings.integrations.tableCaption": "Registered integration keys",
  "settings.integrations.empty": "No integration keys have been created.",
  "settings.integrations.name": "Name",
  "settings.integrations.owner": "Owner",
  "settings.integrations.organization": "Organization",
  "settings.integrations.environment": "Environment",
  "settings.integrations.scopes": "Scopes",
  "settings.integrations.scope.READ_RULES": "Read published rules",
  "settings.integrations.scope.READ_RULES.description":
    "List the governed rules for a pinned version.",
  "settings.integrations.scope.READ_NCM_CATALOG": "Read NCM catalog",
  "settings.integrations.scope.READ_NCM_CATALOG.description":
    "Read NCM classification and provenance.",
  "settings.integrations.scope.CALCULATE": "Run calculations",
  "settings.integrations.scope.CALCULATE.description": "Submit bounded batches to the tax engine.",
  "settings.integrations.scope.READ_CALCULATION": "Read this integration's calculations",
  "settings.integrations.scope.READ_CALCULATION.description":
    "Read results created by this integration.",
  "settings.integrations.workflows": "Allowed workflows",
  "settings.integrations.expiry": "Expiry",
  "settings.integrations.lastUsed": "Last used",
  "settings.integrations.status": "Status",
  "settings.integrations.active": "Active",
  "settings.integrations.revoked": "Revoked",
  "settings.integrations.expired": "Expired",
  "settings.integrations.created": "Created",
  "settings.integrations.rotate": "Rotate",
  "settings.integrations.revoke": "Revoke",
  "settings.integrations.form.title": "Register integration key",
  "settings.integrations.form.nameHint": "Use a name that identifies the consuming system.",
  "settings.integrations.form.workflowHint":
    "Separate IDs with commas. At least one workflow is required.",
  "settings.integrations.form.scopeHint":
    "The key may call only operations covered by the selected scopes.",
  "settings.integrations.form.expiryDays": "Expires in (days)",
  "settings.integrations.form.expiryHint": "Default: 30 days · maximum: 90 days.",
  "settings.integrations.form.reason": "Reason",
  "settings.integrations.form.reasonHint":
    "At least 10 characters. The reason is written to audit.",
  "settings.integrations.form.submit": "Create key",
  "settings.integrations.form.cancel": "Cancel",
  "settings.integrations.form.overlap": "Rotation overlap (hours)",
  "settings.integrations.form.overlapHint": "The previous key stays valid for at most 24 hours.",
  "settings.integrations.form.secretTitle": "Save this key now",
  "settings.integrations.form.secretNotice":
    "The secret is shown once and is not saved in the console. Copy it to your system vault before closing.",
  "settings.integrations.form.secretReplay":
    "This was an idempotent replay. For safety, the secret cannot be recovered; rotate the key when ready.",
  "settings.integrations.form.secretCopy": "Key secret",
  "settings.integrations.form.secretClose": "Close and keep my copy",
  "settings.integrations.form.secretDiscardTitle": "Discard the displayed secret?",
  "settings.integrations.form.secretDiscardBody":
    "After closing, the console cannot show this secret again. Confirm only after copying it.",
  "settings.integrations.form.secretDiscard": "Close and discard",
  "settings.integrations.form.secretKeep": "Return to secret",
  "settings.integrations.form.recovery":
    "Secret unavailable on this replay. Rotate the key to issue a new secret.",
  "settings.integrations.form.rotateTitle": "Rotate integration key",
  "settings.integrations.form.rotateBody":
    "A new key keeps the same scopes and workflows. The current key expires after the selected overlap.",
  "settings.integrations.form.revokeTitle": "Revoke integration key",
  "settings.integrations.form.revokeBody":
    "Revocation blocks new requests immediately and cannot be undone.",
  "settings.integrations.form.confirmRevoke": "Confirm revocation",
  "settings.integrations.action.success": "Change recorded and audited.",
  "settings.integrations.action.error": "The change could not be completed. Try again.",
  "settings.integrations.action.replay": "Replay received: metadata was returned again.",
  "settings.integrations.more": "Scopes and details",
  "settings.mcp.title": "MCP connection",
  "settings.mcp.hint": "Five operations for an AI client with an attributable key",
  "settings.mcp.description":
    "The MCP server answers at POST /v1/mcp. Configure your AI client (for example, Cursor) with the URL below and the X-Tax-Api-Key header. It reads the published ruleset, the NCM catalog and batch calculation. Never use an operator session; fiscal tasks and sources stay outside this key.",
  "settings.mcp.auth":
    "X-Tax-Api-Key header · scopes READ_RULES, READ_NCM_CATALOG, CALCULATE and READ_CALCULATION",
  "settings.mcp.config": "Example MCP configuration",
  "settings.mcp.tools": "Tools",
  "settings.mcp.tool.current": "tax_current_ruleset",
  "settings.mcp.tool.current.body": "Pinned published version for calculation.",
  "settings.mcp.tool.rules": "tax_lookup_rules",
  "settings.mcp.tool.rules.body":
    "Published rules on the origin → destination route, with the ruleset version.",
  "settings.mcp.tool.ncm": "tax_ncm_catalog",
  "settings.mcp.tool.ncm.body": "Siscomex classification. Not a rate.",
  "settings.mcp.tool.batch": "tax_calculate_batch",
  "settings.mcp.tool.batch.body": "Applies the published ruleset to a batch.",
  "settings.mcp.tool.calculation": "tax_get_calculation",
  "settings.mcp.tool.calculation.body": "Fiscal memory of a calculation made by this integration.",
  "settings.apiDocs.title": "Consumer documentation",
  "settings.apiDocs.hint": "Five governed operations · copy-ready examples",
  "settings.apiDocs.description":
    "Use the X-Tax-Api-Key header. Never put a key in a URL, query cache or logs.",
  "settings.apiDocs.baseUrl": "Workspace API base URL: {baseUrl}",
  "settings.apiDocs.auth": "Authentication and scopes",
  "settings.apiDocs.scopes":
    "READ_RULES reads published rules; READ_NCM_CATALOG reads classification and provenance; CALCULATE submits batches; READ_CALCULATION reads results for the same integration.",
  "settings.apiDocs.requestIdentity":
    "Request identity: X-Tax-Attempt-Id is a server-generated UUID for each attempt. X-Request-Id and X-Correlation-Id may be supplied by the client and are not unique; retain all three IDs for support. Only authenticated attempts on the five integration routes enter history; unauthenticated 401s and gateway failures are not shown.",
  "settings.apiDocs.errors": "Errors",
  "settings.apiDocs.endpoints": "Endpoint reference",
  "settings.apiDocs.requiredScope": "Required scope",
  "settings.apiDocs.parameters": "Parameters",
  "settings.apiDocs.endpoint.current.parameters": "None.",
  "settings.apiDocs.endpoint.current.output":
    "The current published ruleset metadata: version, policy version, digest and publication time.",
  "settings.apiDocs.endpoint.rules.parameters":
    "Query: rulesetVersion is required and must be PUBLISHED or SUPERSEDED; cursor, limit (max 100) and q are optional.",
  "settings.apiDocs.endpoint.rules.output":
    "A bounded page of full rule payloads with validity, NCM applicability and evidence provenance.",
  "settings.apiDocs.endpoint.ncm.parameters": "Query: cursor, limit (max 100) and q are optional.",
  "settings.apiDocs.endpoint.ncm.output":
    "A bounded page of NCM classification and provenance. It does not contain tax rates.",
  "settings.apiDocs.endpoint.batch.parameters":
    "Header: Idempotency-Key. JSON body below; one allowlisted workflow and at most 500 items.",
  "settings.apiDocs.endpoint.batch.output":
    "The stored deterministic calculation result, including the calculation ID and item outcomes.",
  "settings.apiDocs.endpoint.calculation.parameters":
    "Path: id is the calculation UUID returned by the batch operation.",
  "settings.apiDocs.endpoint.calculation.output":
    "The result only when the calculation belongs to this integration and organization.",
  "settings.apiDocs.error.400":
    "Invalid request: malformed JSON, missing pinned rulesetVersion, invalid scope fields or limit above 100.",
  "settings.apiDocs.error.401":
    "Missing, malformed, duplicate or expired/revoked X-Tax-Api-Key, or the integration owner is no longer authorized. Send exactly one header.",
  "settings.apiDocs.error.403": "The key lacks the required scope or workflow allowlist entry.",
  "settings.apiDocs.error.404":
    "The ruleset or calculation does not exist, or the calculation belongs to another integration.",
  "settings.apiDocs.error.409":
    "No current published ruleset, or the same Idempotency-Key was reused with a different request body. Keep the pinned version and body stable.",
  "settings.apiDocs.error.413": "The JSON request is over the 5 MiB body limit.",
  "settings.apiDocs.error.429":
    "The integration exceeded 120 reads or 10 batches in the minute. Wait for Retry-After seconds, then retry the same batch with its Idempotency-Key.",
  "settings.apiDocs.error.500":
    "Unexpected service failure. Keep request and correlation IDs for support; retry a batch only with the same Idempotency-Key.",
  "settings.apiDocs.ncm":
    "The NCM catalog contains classification and provenance. It is not a rate table.",
  "settings.apiDocs.operations": "Operations",
  "settings.apiDocs.explorerHint":
    "Choose an operation to see its contract and a safe request example.",
  "settings.apiDocs.path": "Path",
  "settings.apiDocs.method": "Method",
  "settings.apiDocs.limits": "Limits",
  "settings.apiDocs.more": "Parameters, limits and errors",
  "settings.apiDocs.example": "Example request",
  "settings.apiDocs.copyExample": "Copy example",
  "settings.apiDocs.copyJson": "Copy JSON",
  "settings.apiDocs.baseUrlLabel": "API base URL",
  "settings.apiDocs.endpoint.current.name": "Current published ruleset",
  "settings.apiDocs.endpoint.current.purpose": "Read metadata for the current published ruleset.",
  "settings.apiDocs.endpoint.current.limits":
    "120 reads per minute per integration. No query parameters.",
  "settings.apiDocs.endpoint.rules.name": "Published rules",
  "settings.apiDocs.endpoint.rules.purpose":
    "Read governed rules for a pinned published or superseded version.",
  "settings.apiDocs.endpoint.rules.limits":
    "120 reads per minute. rulesetVersion is required; limit is at most 100.",
  "settings.apiDocs.endpoint.ncm.name": "NCM catalog",
  "settings.apiDocs.endpoint.ncm.purpose":
    "Read NCM classification and provenance. This is a catalog, not a rate table.",
  "settings.apiDocs.endpoint.ncm.limits":
    "120 reads per minute. Optional cursor, limit (max 100) and q. The catalog does not contain tax rates.",
  "settings.apiDocs.endpoint.batch.name": "Batch calculation",
  "settings.apiDocs.endpoint.batch.purpose":
    "Submit a bounded calculation batch against an allowlisted workflow.",
  "settings.apiDocs.endpoint.batch.limits":
    "10 batches per minute. At most 500 items and 5 MiB. Idempotency-Key is required.",
  "settings.apiDocs.endpoint.calculation.name": "Calculation result",
  "settings.apiDocs.endpoint.calculation.purpose":
    "Read a calculation created by this integration and organization.",
  "settings.apiDocs.endpoint.calculation.limits":
    "120 reads per minute. The calculation must belong to this integration and organization.",
  "settings.apiDocs.batchJson": "Request body: batch.json",
  "settings.developers.title": "Developers",
  "settings.developers.description.integrations":
    "Create and manage the individual key for each integrated system.",
  "settings.developers.description.api-docs":
    "Endpoints, formats and examples for integrating systems with the tax API.",
  "settings.developers.description.mcp":
    "Tools that AI assistants can use with an integration key.",
  "settings.developers.description.requests":
    "Safe diagnostics for recent requests made by integrations.",
  "settings.requests.title": "Recent requests",
  "settings.requests.hint": "Metadata only · last 30 days",
  "settings.requests.description":
    "Review authenticated integration attempts to investigate status, duration and correlation without exposing credentials or content.",
  "settings.requests.demoNotice":
    "Local demo: these rows come from mock fixtures and do not represent real records.",
  "settings.requests.liveNotice":
    "History is limited to the last 30 days and contains request metadata only.",
  "settings.requests.authenticatedNotice":
    "Only authenticated attempts on the five supported integration routes are recorded; unauthenticated 401s and gateway failures are not shown. Visible window: last 30 days.",
  "settings.requests.filter.status": "HTTP status",
  "settings.requests.filter.statusHint": "Enter a status between 100 and 599.",
  "settings.requests.filter.integration": "Integration",
  "settings.requests.filter.key": "Integration key",
  "settings.requests.filter.method": "Method",
  "settings.requests.filter.route": "Path",
  "settings.requests.filter.problem": "Problem code",
  "settings.requests.filter.all": "All",
  "settings.requests.filter.get": "GET",
  "settings.requests.filter.post": "POST",
  "settings.requests.filter.replayed": "Idempotent replay",
  "settings.requests.filter.replayedOnly": "Replayed only",
  "settings.requests.filter.notReplayed": "Not replayed",
  "settings.requests.column.when": "When",
  "settings.requests.column.operation": "Operation",
  "settings.requests.column.status": "HTTP status",
  "settings.requests.column.duration": "Duration",
  "settings.requests.column.integration": "Integration",
  "settings.requests.column.key": "Key",
  "settings.requests.column.replay": "Replay",
  "settings.requests.replayed": "Yes",
  "settings.requests.notReplayed": "No",
  "settings.requests.tableCaption": "Integration requests from the last 30 days",
  "settings.requests.empty.title": "No recent requests",
  "settings.requests.empty.body": "No attempts match these filters in the 30-day window.",
  "settings.requests.details.title": "Request details",
  "settings.requests.details.notice":
    "Metadata only. The server attempt UUID identifies this recorded attempt; requestId and correlationId may be client-supplied and are nullable. No key, body, query string or stack trace is shown.",
  "settings.requests.details.attemptId": "Server attempt UUID",
  "settings.requests.details.organization": "Organization",
  "settings.requests.details.integration": "Integration ID",
  "settings.requests.details.key": "Key ID",
  "settings.requests.details.environment": "Environment",
  "settings.requests.details.method": "Method",
  "settings.requests.details.route": "Path",
  "settings.requests.details.when": "When",
  "settings.requests.details.duration": "Duration",
  "settings.requests.details.status": "HTTP status",
  "settings.requests.details.problem": "Problem code",
  "settings.requests.details.requestId": "requestId",
  "settings.requests.details.correlationId": "correlationId",
  "settings.requests.details.replay": "Idempotent replay",
  "settings.requests.details.available": "Available",
  "settings.requests.details.unavailable": "Unavailable",
  "settings.requests.details.cause": "Cause",
  "settings.requests.details.diagnostic": "Diagnostic",
  "settings.requests.details.noCause": "Completed without a problem code",
  "settings.requests.details.nextStep": "Next step",
  "settings.requests.details.nextStep.retryWrite":
    "Retry with the same idempotency key and keep the IDs for support.",
  "settings.requests.details.nextStep.retryRead":
    "Retry the request and keep the IDs for support if the service error continues.",
  "settings.requests.details.nextStep.rateLimited":
    "Wait for the Retry-After value from the response, then retry the same idempotent operation.",
  "settings.requests.details.nextStep.permission":
    "Check the API key scope and the allowed workflow for this integration.",
  "settings.requests.details.nextStep.validation":
    "Check the request parameters and environment, then try again.",
  "settings.requests.details.nextStep.idempotency":
    "Reuse the key only with the same body, or send the changed body with a new idempotency key.",
  "settings.requests.details.nextStep.notFound":
    "Check the resource ID or the published ruleset version.",
  "settings.requests.details.nextStep.check":
    "Check the scope, workflow and request parameters, then try again.",
  "settings.requests.details.nextStep.continue":
    "No action needed. Keep the attempt ID for traceability.",
  "settings.requests.details.identifiers": "Identifiers",
  "settings.requests.details.more": "More metadata",
  "settings.requests.recordingDetails": "What is recorded",
  "settings.requests.status.invalid": "Status must be between 100 and 599.",
  "settings.requests.status.http": "HTTP {code}",

  "a11y.skipToContent": "Skip to main content",
  "a11y.breadcrumb": "Breadcrumb",
  "a11y.mainLandmark": "Main content",
  "a11y.routeAnnounce": "{title} loaded",
  "a11y.sortState": "sorted {direction}",
  "a11y.rowActions": "Row actions",
  "a11y.drawerOpened": "Details panel opened",
  "a11y.drawerClosed": "Details panel closed",
  "a11y.statusLabel": "Status: {label}",
  "status.evidence.NEW": "New",
  "status.evidence.IN_REVIEW": "In review",
  "status.evidence.APPROVED": "Approved",
  "status.evidence.REJECTED": "Rejected",
  "status.evidence.DUPLICATE": "Duplicate",
  "status.proposal.DRAFT": "Draft",
  "status.proposal.PENDING_REVIEW": "Pending review",
  "status.proposal.APPROVED": "Approved",
  "status.proposal.REJECTED": "Rejected",
  "status.proposal.PUBLISHED": "Published",
  "status.ruleset.DRAFT": "Draft",
  "status.ruleset.PENDING_REVIEW": "Pending review",
  "status.ruleset.IN_REVIEW": "In review",
  "status.ruleset.APPROVED": "Approved",
  "status.ruleset.PUBLISHED": "Published",
  "status.ruleset.SUPERSEDED": "Superseded",
  "status.ruleset.REJECTED": "Rejected",
  "status.source.ACTIVE": "Active",
  "status.source.PAUSED": "Paused",
  "status.source.DEGRADED": "Degraded",
  "status.source.DISABLED": "Disabled",
  "status.run.QUEUED": "Queued",
  "status.run.DISCOVERING": "Discovering",
  "status.run.FETCHING": "Fetching",
  "status.run.EXTRACTING": "Extracting",
  "status.run.WAITING_REVIEW": "Waiting review",
  "status.run.STALLED": "Stalled",
  "status.run.SUCCEEDED": "Succeeded",
  "status.run.PARTIAL": "Partial",
  "status.run.FAILED": "Failed",
  "status.run.CANCELLED": "Cancelled",
  "status.run.CREATED": "Created",
  "status.run.REUSED": "Reused",
  "status.calculation.CALCULATED": "Calculated",
  "status.calculation.REVIEW_REQUIRED": "Needs review",
  "status.audit.ALLOWED": "Allowed",
  "status.audit.DENIED": "Denied",
  "a11y.keyboardHint": "Press {key} to open the focused item.",

  "rules.guide.link": "Fiscal matrix guide",
  "rules.guide.eyebrow": "How to read a route",
  "rules.guide.title": "Fiscal matrix by product and route",
  "rules.guide.description":
    "Use this page to understand which facts must line up before an ICMS or ICMS-ST rule enters review.",
  "rules.guide.back": "Back to lookup",
  "rules.guide.equationLabel": "The reading key",
  "rules.guide.equationTitle": "Four facts close the operation context",
  "rules.guide.formula": "NCM × CEST × origin → destination",
  "rules.guide.equationAria": "NCM, CEST, origin, destination and review result flow",
  "rules.guide.equationNote":
    "The combination finds applicable evidence. It does not create a rate by itself: validity, legal description, operation and provenance still need to be checked.",
  "rules.guide.result.code": "REVIEW",
  "rules.guide.variable.ncm.title": "Product",
  "rules.guide.variable.ncm.detail": "8-digit NCM classification",
  "rules.guide.variable.cest.title": "Substitution",
  "rules.guide.variable.cest.detail": "CEST and item description",
  "rules.guide.variable.origin.title": "Origin",
  "rules.guide.variable.origin.detail": "Operation departure UF",
  "rules.guide.variable.destination.title": "Destination",
  "rules.guide.variable.destination.detail": "Operation arrival UF",
  "rules.guide.variable.result.title": "Candidate rule",
  "rules.guide.variable.result.detail": "Evidence, validity and human review",
  "rules.guide.stepsTitle": "How the matrix is applied",
  "rules.guide.stepsHint": "The order keeps classification from becoming a tax rate.",
  "rules.guide.step.1.title": "Classify the product",
  "rules.guide.step.1.detail":
    "Confirm the official NCM and preserve its description and classification date.",
  "rules.guide.step.2.title": "Validate the CEST",
  "rules.guide.step.2.detail":
    "Match the CEST and legal description; NCM alone does not confirm ICMS-ST.",
  "rules.guide.step.3.title": "Define the route",
  "rules.guide.step.3.detail":
    "Provide origin, destination, operation type and taxable-event date.",
  "rules.guide.step.4.title": "Gather the legislation",
  "rules.guide.step.4.detail":
    "Find RICMS, agreement, protocol, MVA/PMPF and amendment or revocation acts.",
  "rules.guide.step.5.title": "Send for review",
  "rules.guide.step.5.detail":
    "Only an approved and published proposal can be used as an executable rule.",
  "rules.guide.matrixTitle": "What each field answers",
  "rules.guide.matrixHint": "The table guides research; it does not replace the official source.",
  "rules.guide.matrixAria": "Fiscal facts matrix",
  "rules.guide.matrix.variable": "Field",
  "rules.guide.matrix.question": "Question",
  "rules.guide.matrix.output": "Expected output",
  "rules.guide.matrix.ncm.variable": "NCM",
  "rules.guide.matrix.ncm.question": "What exactly is the merchandise?",
  "rules.guide.matrix.ncm.output": "Official code and description; not a rate.",
  "rules.guide.matrix.cest.variable": "CEST",
  "rules.guide.matrix.cest.question": "Do item and ST description match?",
  "rules.guide.matrix.cest.output": "Catalog and applicability confirmed in legislation.",
  "rules.guide.matrix.origin.variable": "Origin",
  "rules.guide.matrix.origin.question": "Which UF sends the operation?",
  "rules.guide.matrix.origin.output": "Interstate rate and departure benefits to investigate.",
  "rules.guide.matrix.destination.variable": "Destination",
  "rules.guide.matrix.destination.question": "Which UF and recipient type receive it?",
  "rules.guide.matrix.destination.output": "Internal rate, protocol and exceptions to verify.",
  "rules.guide.matrix.result.variable": "Result",
  "rules.guide.matrix.result.question": "Is the evidence sufficient and current?",
  "rules.guide.matrix.result.output": "Candidate, review required or published rule.",
  "rules.guide.routes.column.detail": "What changes",
  "rules.guide.routesTitle": "Priority routes",
  "rules.guide.routesHint": "The distribution state and destination change the legal research.",
  "rules.guide.route.esSp.name": "ES → SP",
  "rules.guide.route.esSp.status": "P0 priority",
  "rules.guide.route.esSp.detail": "Cross ES GETRI, ST, MVA/CEST with SP destination legislation.",
  "rules.guide.route.spSp.name": "SP → SP",
  "rules.guide.route.spSp.status": "P0 priority",
  "rules.guide.route.spSp.detail":
    "Check RICMS, Portarias SRE, validity and revocations inside SP.",
  "rules.guide.route.rj.name": "SP/ES → RJ",
  "rules.guide.route.rj.status": "Source blocked",
  "rules.guide.route.rj.detail":
    "The official RJ source must be accessible before proposing a rule for this route.",
  "rules.guide.sourcesTitle": "Sources to start with",
  "rules.guide.sourcesHint": "Keep the URL, act, validity and excerpt used.",
  "rules.guide.source.ncm.title": "Receita Federal · Classif",
  "rules.guide.source.ncm.detail": "NCM, legal notes and classification history.",
  "rules.guide.source.cest.title": "CONFAZ · Agreement 142/18",
  "rules.guide.source.cest.detail":
    "Reference CEST catalog; it does not prove incidence on its own.",
  "rules.guide.source.es.title": "SEFAZ-ES · MVA/PMPF/PCF/PMC",
  "rules.guide.source.es.detail": "State parameters and acts for ST in ES.",
  "rules.guide.source.sp.title": "SEFAZ-SP · Portaria SRE 12/2026",
  "rules.guide.source.sp.detail": "NCM, CEST, IVA-ST and validity conditions in SP.",
  "rules.guide.guardrailTitle": "Safety rule",
  "rules.guide.guardrailBody":
    "NCM and CEST are reference identifiers. Do not copy a rate from a generic source or treat a CEST as automatic proof of ST.",
  "rules.guide.guardrailNote":
    "When NCM, CEST, UF, date or legal basis is missing, the result stays in fiscal review.",
  "rules.guide.openLookup": "Open NCM and route lookup",
  "errors.PERMISSION_DENIED": "You do not have permission for this operation.",
  "errors.UNAUTHENTICATED": "Session missing or expired.",
  "errors.SEPARATION_OF_DUTIES_VIOLATION": "You already recorded a decision on this proposal.",
  "errors.VERSION_PRECONDITION_FAILED": "The record changed since it was loaded. Reload.",
  "errors.IDEMPOTENCY_KEY_REUSED": "This attempt was already used with different data.",
  "errors.RULESET_STALE_BASE": "The draft base is stale.",
  "errors.BATCH_TOO_LARGE": "Batch above the allowed limit.",
  "errors.RATE_LIMITED": "Too many requests. Wait and try again.",
  "errors.DEPENDENCY_UNAVAILABLE": "A service dependency is unavailable.",
  "errors.ARTIFACT_UNAVAILABLE": "The stored evidence document is unavailable.",
  "errors.OPERATION_NOT_AVAILABLE": "This operation is not enabled in this workspace.",
  "errors.NOT_FOUND": "Record not found.",
  "errors.NO_PUBLISHED_RULESET": "There is no published ruleset.",
  "errors.VALIDATION_FAILED": "Invalid data in the request.",
  "errors.ENVIRONMENT_MISMATCH": "Request context differs from the service.",
  "errors.INTERNAL_ERROR": "Internal service error.",
  "errors.NETWORK": "Network failure contacting the API.",
  "errors.TIMEOUT": "The API took too long to respond.",
  "errors.GATEWAY_TIMEOUT": "The server exceeded its time limit.",
  "errors.UNEXPECTED_RESPONSE": "The server answered in an unexpected format.",
  "failure.offline.what": "You are offline.",
  "failure.offline.todo": "Reconnect and try again. Nothing was sent.",
  "failure.network.what": "Could not reach the tax API.",
  "failure.network.todo": "Check your connection or VPN and try again.",
  "failure.timeout.what": "The API took too long to respond.",
  "failure.timeout.todo":
    "Wait a moment and try again. Long operations keep running on the server.",
  "failure.gatewayTimeout.what": "The server exceeded its time limit while processing.",
  "failure.gatewayTimeout.todo": "Try again shortly. For a large lot, split the file.",
  "failure.unavailable.what": "A required service is unavailable right now.",
  "failure.unavailable.todo":
    "Try again in a few moments. If it persists, contact support with the support code, if shown.",
  "failure.notAvailable.what": "This operation is not available in this environment.",
  "failure.notAvailable.todo": "Use another option or ask an administrator to enable it.",
  "failure.rateLimited.what": "Too many requests in a short time.",
  "failure.rateLimited.todo": "Wait a few seconds and try again.",
  "failure.inProgress.what": "This operation is still in progress.",
  "failure.inProgress.todo": "Wait a few seconds and check again; there is no need to resend.",
  "failure.validation.what": "Some data was not accepted.",
  "failure.validation.todo": "Fix the indicated fields or file and submit again.",
  "failure.unauthenticated.what": "Your session expired.",
  "failure.unauthenticated.todo": "Sign in again and repeat the action.",
  "failure.forbidden.what": "You do not have permission for this action.",
  "failure.forbidden.todo": "Ask an administrator for access and share the support code, if any.",
  "failure.notFound.what": "The record was not found.",
  "failure.notFound.todo": "It may have been removed. Go back to the list and open it again.",
  "failure.conflict.what": "The record changed while you were working.",
  "failure.conflict.todo": "Reload the page to see the current version and repeat the action.",
  "failure.tooLarge.what": "The file or lot is larger than the accepted limit.",
  "failure.tooLarge.todo": "Split the spreadsheet into smaller files and upload again.",
  "failure.server.what": "The server hit an unexpected error.",
  "failure.server.todo":
    "Try again. If it persists, contact support with the support code, if shown.",
  "failure.unexpected.what": "The server answered in an unexpected format.",
  "failure.unexpected.todo":
    "Try again. If it persists, refresh the page or contact support with the support code, if shown.",
  "failure.committed.what": "It may have completed — check before repeating.",
  "failure.committed.todo":
    "The answer did not arrive in time. Check Lots to see whether the item already exists before sending again, to avoid a duplicate.",
  "failure.verifying": "It may have completed — verifying…",
  "failure.verifyingBody":
    "The answer was slow, but the server may have finished. We are confirming without duplicating anything.",
  "failure.supportId": "Support code: {id}",
  "failure.openLots": "Check in Lots",
  "failure.longRunning":
    "Long operations keep running on the server: you can leave this screen and resume later in Lots.",
  "calc.boundary.title": "The calculator stopped responding",
  "calc.boundary.body":
    "This screen hit an unexpected error and saved nothing. Reload the screen; if it persists, share the code with support.",
  "calc.boundary.reload": "Reload the screen",
  "calc.boundary.home": "Back to home",
  "errors.notFoundRoute": "Page not found.",
  "errors.notFoundBody":
    "The requested route does not exist or is not available in this workspace.",
  "errors.unexpectedTitle": "The operation was interrupted",
  "errors.unexpectedBody":
    "The console encountered an unexpected error. Try again or return to the overview; no change was committed.",
  "legacy.band.excellent": "Excellent",
  "legacy.band.healthy": "Healthy",
  "legacy.band.fair": "Fair",
  "legacy.band.critical": "Critical",
  "legacy.yes": "Yes",
  "legacy.no": "No",
  "legacy.blocked": "Calculation blocked",
  "legacy.wf.title": "CMV waterfall — 12 steps",
  "legacy.wf.benchmark": "Benchmark: Mondial_BackChannel_VFinal_9_EN.xlsx",
  "legacy.wf.entry": "Item value with ICMS/PIS/COFINS",
  "legacy.wf.icmsEmbedded": "↳ ICMS embedded (NF × {rate} gross)",
  "legacy.wf.pisEmbedded": "↳ PIS embedded ((NF − {own}) × 1.65%)",
  "legacy.wf.cofinsEmbedded": "↳ COFINS embedded ((NF − {own}) × 7.6%)",
  "legacy.wf.purchaseValue": "Final purchase value",
  "legacy.wf.icmsCreditClosed": "(−) ICMS credit [∅ Case A — closed ST chain]",
  "legacy.wf.icmsCredit": "(−) ICMS credit [NF × {rate} gross]",
  "legacy.wf.pisCredit": "(−) PIS credit [(NF − {own}) × 1.65%]",
  "legacy.wf.cofinsCredit": "(−) COFINS credit [(NF − {own}) × 7.6%]",
  "legacy.wf.totalCredits": "(−) Total credits",
  "legacy.wf.fiscalCMV": "Fiscal COGS",
  "legacy.wf.salePriceZero": "Sale price (0% markup — cost pass-through)",
  "legacy.wf.salePrice": "Sale price ({markup}% margin on sale ÷ {rest}%)",
  "legacy.wf.freightRevenue": "(+) Freight charged to the buyer",
  "legacy.wf.bcIcms": "↳ ICMS base = sale + freight = {value}",
  "legacy.wf.icmsSaleClosed": "(−) ICMS on sale [∅ closed ST chain]",
  "legacy.wf.icmsSale": "(−) ICMS on sale (BC_ICMS × {rate}%)",
  "legacy.wf.pisSale": "(−) PIS on sale [(BC_ICMS − ICMS) × 1.65%] base {base}",
  "legacy.wf.cofinsSale": "(−) COFINS on sale [(BC_ICMS − ICMS) × 7.6%]",
  "legacy.wf.protocol": "ST protocol ({route}): {status}",
  "legacy.wf.protocolClosed": "CLOSED",
  "legacy.wf.protocolOpen": "OPEN — ICMS credit applies",
  "legacy.wf.difal": "(−) DIFAL ({uf} destination)",
  "legacy.wf.fcp": "(−) FCP ({uf})",
  "legacy.wf.logistics": "(−) Logistics (carrier freight cost)",
  "legacy.wf.freightCost": "(−) Freight logistics cost",
  "legacy.wf.commission": "(−) Commission",
  "legacy.wf.paymentFee": "(−) Payment fee ({fee})",
  "legacy.wf.marginValue": "Margin value",
  "legacy.ncm.missing":
    "NCM not found in the previous calculator's fiscal table. Automatic calculation is blocked; review manually.",
  "legacy.ncm.found": "{description} · CEST {cest} · IPI {ipi}% · IVA {iva}% · ST in SP: {st}",
  "legacy.buyerInfo":
    "The buyer's regime does not enter BCH's outbound taxes; it only decides whether DIFAL applies.",
  "legacy.difal.applies":
    "Interstate DIFAL applies. Destination UF {uf}: {base}% + FCP {fcp}% = {total}% of the BCH sale price.",
  "legacy.getnet.mdr": "Getnet MDR",
  "legacy.getnet.anticipation": "Anticipation ({n}× × 1.59%)",
  "legacy.getnet.effective": "Effective rate",
  "legacy.getnet.contract": "Getnet table from contract 3313293 (Table 2).",
  "legacy.boleto.total": "{n} boleto(s) × {fee} = {total}",
  "legacy.pix.free": "PIX has no fee under BCH's current B2B agreement (R$ 0.00 / 0.00%).",
  "legacy.result.salePrice": "Sale price (outbound NF)",
  "legacy.result.difal": "DIFAL + FCP (dest. UF)",
  "legacy.result.marginPct": "Margin %",
  "legacy.st.caseA": "Case A",
  "legacy.st.caseB": "Case B",
  "legacy.st.paidBySupplier": "ICMS-ST paid by the supplier (check against the NF)",
  "legacy.st.payableByBch": "ICMS-ST payable by BCH",
  "legacy.st.adjusted": "adj. MVA",
  "legacy.st.base": "ST base",
  "legacy.st.creditClosed": "ICMS credit = R$ 0.00 (closed ST chain)",
  "legacy.st.creditOpen": "ICMS credit = {value} (open chain)",
  "legacy.ipi.gross": "Gross IPI base (Mondial standard): {base} × {rate}% = {value}",
  "legacy.ipi.net": "Net IPI base (legacy): {base} × {rate}% = {value}",
  "legacy.v15Fields": "v15 fields: invoice, anticipation and pass-through",
  "legacy.spReimbursement": "Pending SP ICMS-ST reimbursement: {value}",
  "legacy.memory": "Calculation memory",
  "legacy.memoryGenerated": "Generated {at}",
  "legacy.bestCenter": "Best center: {center}",
  "legacy.serviceResult.cm1": "CM1 / GMV",
  "legacy.int.pl": "P&L — Intermediation",
  "legacy.int.gmv": "GMV (NF total)",
  "legacy.int.serviceValue": "Service value (intermediation fee)",
  "legacy.int.irrf": "(−) IRRF withheld",
  "legacy.int.csll": "(−) CSLL withheld",
  "legacy.int.cofins": "(−) COFINS withheld",
  "legacy.int.pis": "(−) PIS withheld",
  "legacy.int.netCash": "(=) Net cash to receive",
  "legacy.int.valueForMargin": "(=) Value for margin",
  "legacy.int.operations": "(−) Operations",
  "legacy.int.cm1": "(=) CM1 (before commissions)",
  "legacy.int.approved": "Approved to sell",
  "legacy.int.notApproved": "Not approved (< 8%)",
  "legacy.int.sellerUF": "Seller UF",
  "legacy.int.buyerUF": "Buyer UF",
  "legacy.int.sellerTerms": "Terms — seller",
  "legacy.int.buyerTerms": "Terms — buyer",
  "legacy.int.ownPis": "Own PIS",
  "legacy.int.ownCofins": "Own COFINS",
  "legacy.int.revenueTaxes": "Revenue taxes",
  "legacy.int.withholdingTotal": "Total withholding",
  "legacy.int.cashFlow": "Cash flow — obligations to pay",
  "legacy.int.ownPisCofins": "Own PIS + COFINS",
  "legacy.int.onService": "6.15% of service value",
  "legacy.terms.Upfront": "Upfront",
  "legacy.terms.30": "30 days",
  "legacy.terms.60": "60 days",
  "legacy.terms.90": "90 days",
  "legacy.batch.noDefaults": "no defaults",
  "legacy.batch.commission": "{pct}% commission",
  "legacy.batch.exportReport": "Export report (original v8 format)",
  "legacy.batch.route": "NCM / UF",
  "legacy.batch.purchase": "= Purchase",
  "legacy.batch.saleTaxes": "Sale taxes",
  "legacy.batch.profit": "Profit",
  "legacy.batch.total": "Total ({count} rows)",
  "legacy.batch.kpi.revenue": "Total revenue",
  "legacy.batch.kpi.profit": "Net profit",
  "legacy.batch.kpi.margin": "Average margin",
  "legacy.batch.kpi.critical": "Critical zone",
  "legacy.batch.kpi.products": "{count} product(s)",
  "legacy.batch.kpi.review": "{count} in review",
  "legacy.batch.kpi.merch": "Resale (merchandise) · {count}",
  "legacy.batch.kpi.int": "Intermediation (GMV × intermediation fee) · {count}",
  "legacy.batch.showWaterfall": "Show waterfall",
  "legacy.batch.hideWaterfall": "Hide waterfall",
  "legacy.option.ecommerce": "E-commerce",
  "legacy.wf.ipiGross": "(+) IPI ({rate}% gross)",
  "legacy.wf.ipiNet": "(+) IPI ({rate}% net)",
  "legacy.wf.icmsStPaid": "(+) ICMS-ST paid by the supplier",
  "legacy.wf.icmsStAnticipation": "(+) ICMS-ST entry anticipation (RICMS/SP Art. 426-A)",
  "legacy.wf.icmsStPayable": "(+) ICMS-ST payable by BCH",
  "legacy.wf.feeBoleto": "Boleto ×{n}",
  "legacy.wf.feePix": "PIX",
  "legacy.wf.protocolNa": "N/A",
  "legacy.wf.feeGetnet": "Getnet {pct}%",
  "legacy.alert.OPERATION_DATE_MISSING.info":
    "No operation date: using today. Date-versioned parameters may differ.",
  "legacy.alert.NCM_MISSING.error": "NCM is required for automatic calculation.",
  "legacy.alert.NCM_NOT_IN_TABLE.error":
    "NCM {ncm} is not in the fiscal parameters table. Manual review required.",
  "legacy.alert.CEST_MISSING.warning": "NCM {ncm} requires a CEST, but none is configured.",
  "legacy.alert.CEST_MISSING.error":
    "NCM {ncm} has a CEST pending confirmation (VALIDAR). Calculation is blocked until fiscal/legal confirms the CEST.",
  "legacy.alert.ST_REVOKED_BY_PORTARIA.info": "SP ST revoked for this CEST: {detail}",
  "legacy.alert.ST_EVIDENCE_MISSING.error":
    "ST marked as paid but no amount provided (DQ-01). Calculation blocked.",
  "legacy.alert.ST_EVIDENCE_MISSING.warning":
    "ST marked as paid without the supplier amount. Using R$ 0 — verify manually.",
  "legacy.alert.ST_COLLECTED.warning":
    "ST already collected: ICMS-ST = R$ 0 · ICMS credit = R$ 0 · ICMS debit on sale = R$ 0",
  "legacy.alert.CALCULATION_DEVIATION.error":
    "Markup must be less than 100% (received {pct}%). Calculation blocked.",
  "legacy.alert.ST_PROTOCOL_REVOKED.info": "Protocol SP→{uf}: {detail}. No ST on the BCH invoice.",
  "legacy.alert.ICMS_DOUBLE_TAX.error":
    "ICMS debit on sale > 0 with ST already collected: double taxation detected.",
  "legacy.alert.ST_PROTOCOL_VERIFY.warning": "ST protocol SP → {uf}: needs CONFAZ verification.",
  "legacy.batch.supplierOther": "Other supplier (not configured)",
  "legacy.batch.kind.int": "INT",
  "legacy.batch.kind.resale": "C/V",
  "legacy.batch.takeIss": "Take rate {take}% · ISS {iss}%",
  "legacy.batch.gmv": "GMV {value}",
  "legacy.batch.kpi.intSplit": "GMV {gmv} · CM1 {cm1} · {pct}",
  "legacy.ncm.pRedBC": "pRedBC {pct}%",
  "overview.home.eyebrow": "Overview",
  "overview.home.title": "Calculate and track your lots",
  "overview.home.description": "Calculator, published rules and every lot's history in one place.",
  "overview.home.cta.eyebrow": "Calculate",
  "overview.home.cta.title": "Tax calculator",
  "overview.home.cta.body":
    "Calculate one product by NCM or upload a spreadsheet with the whole lot.",
  "overview.home.cta.upload": "Upload spreadsheet",
  "overview.home.cta.single": "Calculate one product",
  "overview.home.cta.ncmLabel": "NCM (8 digits)",
  "overview.home.cta.ncmPlaceholder": "e.g. 8471.30.12",
  "overview.home.cta.ncmSubmit": "Calculate",
  "overview.home.cta.ncmInvalid": "Enter the 8 NCM digits.",
  "overview.home.cta.readerTitle": "Look up a rule by NCM",
  "overview.home.cta.readerBody":
    "Your profile is read-only. Look up the published rule for an NCM and route.",
  "overview.home.cta.readerSubmit": "Look up",
  "overview.home.rules.eyebrow": "Published rules",
  "overview.home.rules.count": "tax rules in force",
  "overview.home.rules.ncms": "{count} NCMs",
  "overview.home.rules.routes": "{count} UF → UF routes",
  "overview.home.rules.st": "{count} with ICMS-ST",
  "overview.home.rules.expiring": "{count} expire within 30 days",
  "overview.home.rules.version": "Version {version} · published on {date}",
  "overview.home.rules.coverage": "Coverage by family",
  "overview.home.rules.openLibrary": "View all rules",
  "overview.home.rules.openCoverage": "View coverage by UF",
  "overview.home.rules.none": "No ruleset has been published yet.",
  "overview.home.new.eyebrow": "New rules",
  "overview.home.new.title": "What changed in version {version}",
  "overview.home.new.since": "Compared with {from} · published {relative}",
  "overview.home.new.sinceDate": "Compared with {from} · last published on {date}",
  "overview.home.new.added": "New",
  "overview.home.new.changed": "Changed",
  "overview.home.new.addedCount": "+{count} new",
  "overview.home.new.changedCount": "{count} changed",
  "overview.home.new.removedCount": "−{count} removed",
  "overview.home.new.national": "National",
  "overview.home.new.validFrom": "in force since {date}",
  "overview.home.new.more.one": "See {count} more change",
  "overview.home.new.more.other": "See {count} more changes",
  "overview.home.new.openDiff": "View full diff",
  "overview.home.new.openHistory": "Publication history",
  "overview.home.new.empty": "No new or changed rules in this version.",
  "overview.home.new.noBaseline":
    "This is the first published version; there is no baseline to compare.",
  "overview.home.jobs.eyebrow": "Lot history",
  "overview.home.jobs.title": "Latest processed lots",
  "overview.home.jobs.items.one": "{count} item",
  "overview.home.jobs.items.other": "{count} items",
  "overview.home.jobs.review": "{count} to review",
  "overview.home.jobs.single": "Single calculation",
  "overview.home.jobs.openAll": "View full history",
  "overview.home.jobs.empty": "No lots processed in the last 30 days.",
  "overview.home.jobs.emptyCta": "Upload spreadsheet",
  "overview.home.jobs.origin.LOT_UPLOAD": "Spreadsheet",
  "overview.home.jobs.origin.FISCAL_TASK": "Tax task",
  "overview.home.jobs.origin.CALCULATOR": "Calculator",
  "overview.home.jobs.origin.INTEGRATION": "Integration",
  "overview.home.jobs.origin.DYNAMIC_LIST": "Dynamic list",
  "overview.home.jobs.origin.RUNTIME": "Automated workflow",
  "overview.home.admin.title": "Platform operations",
  "overview.home.admin.description": "Evidence backlog, sources, queues and technical activity.",
  /* -- UX PR 4: Início and Regras ---------------------------------------- */
  "overview.pulse.agent.trendLabel": "Findings per day over the last {days} days: {values}",
  "overview.pulse.agent.trend": "{count} findings in {days} days",
  "overview.pulse.research.one": "active sweep",
  "overview.pulse.research.other": "active sweeps",
  "overview.pulse.research.lastDone": "Last one finished {when}",
  "overview.pulse.research.none": "No sweeps yet",
  "overview.activity.denied": "denied",
  "home.title": "Home",
  "home.commercial.title": "Commercial home",
  "home.commercial.description":
    "Calculate an operation, upload a spreadsheet or check your invoices.",
  "home.commercial.hero.context": "Purchase → operation hub → sale",
  "home.commercial.editorial.alt":
    "Illustration of two people reviewing documents beside a laptop.",
  "home.commercial.hero.title": "From purchase to sale price, with a clear next step.",
  "home.commercial.hero.description":
    "Declare the purchase, sale and costs. Check the result and any pending items for the operation.",
  "home.commercial.hero.action": "Calculate a new operation",
  "home.commercial.priority.title": "Operational priority",
  "home.commercial.priority.route": "All states, through São Paulo, to all states.",
  "home.commercial.priority.description":
    "The supplier and customer are defined for each operation.",
  "home.commercial.priority.next": "Espírito Santo is planned for a later phase.",
  "home.commercial.priority.qualification":
    "Operational priority does not certify fiscal coverage.",
  "home.commercial.destinations": "Commercial work destinations",
  "home.commercial.calculate.title": "Calculator",
  "home.commercial.calculate.description": "One purchase, one sale and the declared costs.",
  "home.commercial.calculate.action": "Simulate an operation",
  "home.commercial.calculate.readAction": "Open calculator",
  "home.commercial.upload.title": "Lots and spreadsheets",
  "home.commercial.upload.description":
    "Upload several items and follow the processing and review of each lot.",
  "home.commercial.lots.action": "View lots",
  "home.commercial.invoices.help":
    "Check issued and received invoices and the available analyses for the operation.",
  "home.commercial.invoices.title": "Invoices",
  "home.commercial.invoices.action": "Open invoices",
  "home.jobs.description":
    "Follow uploads and open a lot to check its result or review pending items.",
  "home.jobs.loading": "Loading recent lots…",
  "home.jobs.empty": "No lots to show yet. After the first upload, follow its progress here.",
  "home.jobs.stale": "Lots could not be refreshed. The list below shows the last available update.",
  "home.jobs.paused":
    "Lot updates are paused. You can open Lots and try again when the connection returns.",
  "home.description": "Start a calculation, pick up your lots and check the rules in force.",
  "home.cta.body":
    "Type the NCM to calculate one product, or upload a spreadsheet with the whole lot.",
  "home.cta.ncmLabel": "NCM",
  "home.cta.ncmHint": "8 digits, as 0000.00.00.",
  "home.cta.or": "or",
  "home.cta.openCalculator": "Open the full calculator",
  "home.rules.title": "Rules in force",
  "home.rules.inVersion": "rules in ruleset {version}",
  "home.rules.fiscalInVersion": "fiscal rules in ruleset {version}",
  "home.rules.published": "Published on {date}",
  "home.rules.byKind": "By rule type",
  "home.rules.fiscalFacts": "In the fiscal rules",
  "home.rules.kindLink": "{kind}: {count} rules. Open in the library",
  "home.rules.openLibrary": "Open library",
  "home.new.title": "Changes in this version",
  "home.new.versus": "compared with {from}",
  "home.new.openTab": "View new rules",
  "home.jobs.title": "Latest lots",
  "home.jobs.openAll": "View all",
  "rules.new.tab": "New rules",
  "rules.new.title": "New rules",
  "rules.new.description":
    "What was added and what changed in the ruleset in force, compared with the previous version.",
  "rules.new.none.title": "Nothing to compare",
  "rules.new.rulesTitle": "New and changed rules",
  "rules.new.rulesHint": "Each row opens the rule published in this version.",
  "rules.new.noItems": "The per-rule list is not available; see the changed fields below.",
  "rules.new.truncated.one":
    "Showing {shown} rules. {count} more change appears in the changed fields below.",
  "rules.new.truncated.other":
    "Showing {shown} rules. {count} more changes appear in the changed fields below.",
  "rules.new.fieldsTitle": "Changed fields",
  "rules.new.fieldsHint": "Field-by-field difference between the two versions.",
  "rules.new.openRuleset": "Open publication",
  "rules.help.short": "Guide",
  "rules.library.count.all.one": "{count} rule in ruleset {version}",
  "rules.library.count.all.other": "{count} rules in ruleset {version}",
  "rules.library.count.filtered": "{count} of {total} rules in ruleset {version}",
  "quick.chapters.title": "Or browse the catalogue by HS chapter",
  "quick.chapters.body":
    "Pick a chapter to see the products in the Siscomex catalogue. The catalogue identifies the classification; it is not a rate.",
  "quick.chapters.open": "View products in HS chapter {chapter} · {title}",
  "quick.chapters.results": "Products in HS chapter {chapter} · {title}",
  "quick.chapters.resultsBody": "Siscomex catalogue. Pick the NCM to see its published rules.",
  "quick.chapters.clear": "Remove the HS chapter {chapter} filter",
  "quick.chapters.openRules": "Published rules in chapter {chapter}",
  "quick.value.ipiMissing": "No IPI published",
  "quick.fact.fromTipi": "national TIPI",
  "status.job.QUEUED": "Queued",
  "status.job.RUNNING": "Running",
  "status.job.COMPLETED": "Completed",
  "status.job.SUCCEEDED": "Completed",
  "status.job.REVIEW_REQUIRED": "Needs review",
  "status.job.WAITING_REVIEW": "Needs review",
  "status.job.FAILED": "Failed",
  "status.job.CANCELLED": "Cancelled",
  "nav.governance": "Governance",
  "nav.publications": "Publications",
  "coverage.tab": "Coverage",
  "coverage.title": "Coverage by family and UF",
  "coverage.description":
    "What the published base holds per tax family and where rules concentrate on the map.",
  "nav.jobs": "Lot history",
  "lots.title": "Lots",
  "lots.description":
    "Follow workbooks, scenarios and research. From source data to the tax memory of every row.",
  "lots.status.reviewRows": "{count} rows to review",
  "lots.filter.period": "Period",
  "lots.period.today": "Today",
  "lots.period.7d": "7 days",
  "lots.period.30d": "30 days",
  "lots.period.custom": "Custom",
  "lots.filter.from": "From",
  "lots.filter.to": "To",
  "lots.filter.status": "Status",
  "lots.filter.origin": "Origin",
  "lots.filter.review": "Review",
  "lots.filter.reviewOnly": "Only with review",
  "lots.filter.search": "Search",
  "lots.filter.placeholder": "Search by lot, ID or integration",
  "lots.window.incomplete": "Pick both dates for the custom period.",
  "lots.window.order": "The start date must be before the end date.",
  "lots.window.tooLong": "The period can be at most 90 days.",
  "lots.column.lot": "Lot / origin",
  "lots.column.submittedBy": "Submitted by",
  "lots.column.when": "When",
  "lots.column.status": "Status",
  "lots.column.items": "Items",
  "lots.column.review": "Review",
  "lots.column.rulesetVersion": "Version",
  "lots.column.correlation": "Correlation",
  "lots.column.taxTotal": "Total tax",
  "lots.empty.title": "No lots in this period",
  "lots.empty.body": "Upload a spreadsheet or widen the period to see earlier runs.",
  "lots.submitter.unrecorded": "Origin not recorded",
  "lots.batches": "{received} of {expected} parts received",
  "lots.invalidRows": "{count} invalid rows",
  "lots.running": "Calculating",
  "lots.openJob": "Open details for {name}",
  "lots.drawer.subtitle": "{origin} · submitted {relative}",
  "lots.drawer.exportCsv": "Export CSV",
  "lots.drawer.exportJson": "Export JSON",
  "lots.drawer.exporting": "Exporting {loaded} of {total} items…",
  "lots.drawer.cancelExport": "Cancel export",
  "lots.drawer.exportCancelled": "Export cancelled.",
  "lots.drawer.exportDone": "File ready with {count} items.",
  "lots.drawer.exportTruncated": "The file stopped at {cap} items, the export limit.",
  "lots.drawer.exportFailed": "The export failed. Try again.",
  "lots.drawer.openTask": "Open fiscal task",
  "lots.drawer.openCalculation": "Open calculation",
  "lots.drawer.downloadOriginal": "Download original file",
  "lots.drawer.downloadFailed": "The original file is not available.",
  "lots.drawer.notFound": "This lot is not in the filtered period. Widen the period to open it.",
  "lots.drawer.notFoundTitle": "Lot outside the period",
  "lots.section.summary": "Summary",
  "lots.section.items": "Returned items",
  "lots.section.origin": "Origin",
  "lots.section.trace": "Traceability",
  "lots.section.audit": "Audit events",
  "lots.summary.submittedAt": "Submitted",
  "lots.summary.startedAt": "Started",
  "lots.summary.completedAt": "Completed",
  "lots.summary.submittedBy": "Submitted by",
  "lots.summary.workflow": "Origin",
  "lots.summary.ruleset": "Ruleset version",
  "lots.summary.counts": "Items",
  "lots.summary.countsValue":
    "{items} items · {calculated} calculated · {review} for review · {rejected} rejected",
  "lots.summary.taxTotal": "Total tax",
  "lots.summary.landed": "Total landed cost",
  "lots.summary.topIssues": "Top issues",
  "lots.summary.noIssues": "No issues recorded.",
  "lots.summary.notYet": "Available once complete",
  "lots.summary.partial":
    "{received} of {expected} parts of this lot arrived. Totals only add the parts received.",
  "lots.summary.lastError": "Last error",
  "lots.summary.invalid":
    "{count} of {total} rows failed validation. Fix the file and upload it again.",
  "lots.summary.imported": "File imported and not calculated yet.",
  "lots.items.position": "#",
  "lots.items.item": "Item / SKU",
  "lots.items.ncm": "NCM",
  "lots.items.route": "Origin → destination UF",
  "lots.items.status": "Status",
  "lots.items.ipi": "IPI",
  "lots.items.icmsSt": "ICMS (ST or own)",
  "lots.items.taxTotal": "Total tax",
  "lots.items.landed": "Landed cost",
  "lots.items.issues": "Issues",
  "lots.items.actions": "Actions",
  "lots.items.empty": "No items returned yet.",
  "lots.items.part": "Part",
  "lots.items.more": "More items",
  "lots.items.partOption": "Part {index} of {count}",
  "lots.items.explain": "Explain {item}",
  "lots.items.row": "Row",
  "lots.items.rowValid": "Valid",
  "lots.items.rowErrors": "Errors",
  "lots.origin.filename": "File",
  "lots.origin.rows": "Rows",
  "lots.origin.uploadedAt": "Imported",
  "lots.origin.parser": "Parser",
  "lots.origin.integration": "Integration",
  "lots.origin.attempts": "Integration attempts",
  "lots.origin.noAttempts": "No attempts recorded in the last 30 days for this correlation.",
  "lots.origin.attemptLine": "{method} {route} · {status} · {duration} ms",
  "lots.origin.replayed": "replayed",
  "lots.origin.operator": "Submitted by {name} in the platform.",
  "lots.origin.unrecorded": "This calculation predates recording who called the API.",
  "lots.trace.jobId": "Job ID",
  "lots.trace.correlation": "Correlation ID",
  "lots.trace.request": "Request ID",
  "lots.trace.calculations": "Stored calculations ({count})",
  "lots.trace.replayed": "Replayed by idempotency",
  "lots.trace.sourceStatus": "Stored status",
  "lots.trace.moreIds": "and {count} more",
  "lots.trace.workflow": "Workflow (technical ID)",
  "lots.origin.automatic": "Sent automatically · {origin}.",
  "lots.trace.none": "No stored calculations.",
  "lots.audit.empty": "No audit events for this correlation.",
  "lots.audit.open": "Open in audit",
  "overview.home.jobs.origin.UNKNOWN": "Origin not recorded",
  "overview.home.new.icms.ST": "ICMS-ST",
  "overview.home.new.icms.STANDARD": "Own ICMS",
  "overview.home.new.icms.NOT_TAXED": "No ICMS",
  "overview.home.new.noNcm": "No NCM",
  "overview.home.new.openRule": "Open rule {ncm}",
  "status.job.IMPORTED": "Imported",
  "status.job.INVALID": "Invalid",
  "status.job.PARTIAL": "Partial",
  "settings.requests.details.openLot": "View lot",
  "nav.webResearch": "Web research",
  "agents.create.webHint": "This queue is IOB only. For web research, use",
  "agents.create.webHintLink": "Web research",
  "webResearch.title": "Web research",
  "webResearch.description":
    "Plan sweeps of official web sources (SEFAZ, CONFAZ, Senate), follow stages, cost and documents found, and tune the research pace.",
  "webResearch.new": "New sweep",
  "webResearch.tabs": "Web research sections",
  "webResearch.tab.sweeps": "Sweeps",
  "webResearch.tab.settings": "Settings",
  "webResearch.boundary":
    "Annexes and findings are review material. No sweep approves, publishes or calculates rules.",
  "webResearch.list.title": "Sweeps",
  "webResearch.empty.title": "No web research sweeps yet",
  "webResearch.empty.body":
    "Create a sweep to locate, download and extract the official ST annexes by segment and UF. The preview shows calls, cost and time before you create it.",
  "webResearch.empty.infra":
    "Web research stays off until its execution service is enabled. Until then, sweeps you create wait in the queue and spend nothing.",
  "webResearch.empty.action": "Plan the first sweep",
  "webResearch.lane.label": "Web research status",
  "webResearch.lane.PAUSED": "Paused",
  "webResearch.lane.PAUSED.detail": "The kill switch is on: no unit is handed to the worker.",
  "webResearch.lane.RUNNING": "Running",
  "webResearch.lane.RUNNING.detail": "A sweep is in progress, within the pace and budget limits.",
  "webResearch.lane.WAITING": "Queued",
  "webResearch.lane.WAITING.detail":
    "Sweeps are waiting for the worker. If nothing starts, the infrastructure is not enabled yet.",
  "webResearch.lane.IDLE": "Idle",
  "webResearch.lane.IDLE.detail": "No active sweep.",
  "webResearch.lane.grounded": "Searches",
  "webResearch.lane.extraction": "Extractions",
  "webResearch.lane.dailyCap": "Daily search cap",
  "webResearch.lane.monthly": "Monthly budget",
  "webResearch.lane.infra":
    "Execution depends on the web research service being enabled. While it is off, sweeps are accepted and wait in the queue without spending anything.",
  "webResearch.perMinute": "{count}/min",
  "webResearch.status.QUEUED": "Queued",
  "webResearch.status.RUNNING": "Running",
  "webResearch.status.PAUSED": "Paused",
  "webResearch.status.COMPLETED": "Completed",
  "webResearch.status.CANCELLED": "Cancelled",
  "webResearch.status.BUDGET_EXHAUSTED": "Budget exhausted",
  "webResearch.scope.USED": "Used",
  "webResearch.scope.USED.body":
    "NCMs and routes BackChannel calculated in the period. Covers what matters first.",
  "webResearch.scope.USED.short": "Used {days} d",
  "webResearch.scope.CATALOG": "Whole catalog",
  "webResearch.scope.CATALOG.body":
    "Active NCMs of the official catalog, optionally only some chapters.",
  "webResearch.scope.CATALOG.short": "Whole catalog",
  "webResearch.scope.CATALOG.chapters.one": "Catalog · {count} chapter",
  "webResearch.scope.CATALOG.chapters.other": "Catalog · {count} chapters",
  "webResearch.scope.LIST": "List",
  "webResearch.scope.LIST.body": "Paste NCMs (up to 10,000), one per line or comma separated.",
  "webResearch.scope.LIST.short.one": "List of {count} NCM",
  "webResearch.scope.LIST.short.other": "List of {count} NCMs",
  "webResearch.routes.USED": "Used routes",
  "webResearch.routes.USED.body":
    "Only the origin → destination routes seen in calculations for each NCM.",
  "webResearch.routes.USED.short": "used routes",
  "webResearch.routes.ALL_DESTINATIONS": "Every destination UF",
  "webResearch.routes.ALL_DESTINATIONS.body":
    "All 27 UFs as destination; origin does not matter. Segment strategy only.",
  "webResearch.routes.ALL_DESTINATIONS.short": "every UF",
  "webResearch.routes.UF_ALL": "All from/to one UF",
  "webResearch.routes.UF_ALL.body":
    "Every route leaving, reaching or involving one UF (26 or 52 routes).",
  "webResearch.routes.UF_ALL.FROM": "from {uf}",
  "webResearch.routes.UF_ALL.TO": "to {uf}",
  "webResearch.routes.UF_ALL.BOTH": "from and to {uf}",
  "webResearch.routes.EXPLICIT": "Explicit routes",
  "webResearch.routes.EXPLICIT.body": "Pick route by route (origin → destination).",
  "webResearch.routes.EXPLICIT.short.one": "{count} route",
  "webResearch.routes.EXPLICIT.short.other": "{count} routes",
  "webResearch.strategy.SEGMENT": "Segment",
  "webResearch.strategy.SEGMENT.body":
    "Researches where the law is written: one annex per segment × destination UF covers every NCM in that segment. Far cheaper.",
  "webResearch.strategy.PAIR": "Pair",
  "webResearch.strategy.PAIR.body":
    "Checks each NCM × route separately. List or Used scopes only, up to 2,000 units.",
  "webResearch.card.progress": "{percent} done",
  "webResearch.card.failed": "{count} failed",
  "webResearch.detail.created": "Created",
  "webResearch.detail.started": "Started",
  "webResearch.detail.completed": "Finished",
  "webResearch.detail.queuedInfra":
    "This sweep has not started. It runs once the web research worker is enabled; until then it spends nothing.",
  "webResearch.detail.budgetExhausted":
    "The sweep stopped at its call or budget cap. Pending units stay as they are; create another sweep with higher caps to continue.",
  "webResearch.action.PAUSE": "Pause",
  "webResearch.action.RESUME": "Resume",
  "webResearch.action.CANCEL": "Cancel sweep",
  "webResearch.action.RETRY_FAILED": "Retry failures",
  "webResearch.status.COMPLETED_WITH_FAILURES": "Completed with failures",
  "webResearch.action.RETRY_STALLED": "Retry downloads",
  "webResearch.action.CLOSE": "Close sweep",
  "webResearch.action.refetched":
    "The downloads were requested again. Waiting units resume once the documents arrive.",
  "webResearch.action.closed": "The sweep was closed. What it found stays available for review.",
  "webResearch.stalled.title": "Waiting for documents",
  "webResearch.stalled.body":
    "Nothing else can run: {count} units wait for documents that have not been downloaded. A unit fails on its own as soon as its download or reading fails, or {minutes} min after the download request (at most {hours} h). Retry the downloads, or close the sweep now.",
  "webResearch.close.title": "Close this sweep?",
  "webResearch.close.body":
    "{count} units that have not run yet are marked as failed (closed by an operator) and the sweep is completed. What it found stays available for review, and Retry failures reopens them later.",
  "webResearch.close.confirm": "Close sweep",
  "webResearch.completion.ok": "Completed: every unit finished.",
  "webResearch.completion.closed": "Closed by an operator: every unit had finished.",
  "webResearch.outcome.title.one": "Completed with 1 failure",
  "webResearch.outcome.title.other": "Completed with {count} failures",
  "webResearch.outcome.lead":
    "{finished} of {total} units finished ({percent}). What was found already goes to review; the failures below do not hold that material back.",
  "webResearch.outcome.leadOperator":
    "Closed by an operator: {finished} of {total} units had finished ({percent}).",
  "webResearch.outcome.more": "+{count}",
  "webResearch.outcome.blockedDownloads.one": "download blocked by the official site",
  "webResearch.outcome.blockedDownloads.other": "downloads blocked by the official site",
  "webResearch.outcome.missingDownloads.one": "download did not arrive",
  "webResearch.outcome.missingDownloads.other": "downloads did not arrive",
  "webResearch.outcome.noOfficialSource.one": "search cited no official source",
  "webResearch.outcome.noOfficialSource.other": "searches cited no official source",
  "webResearch.outcome.extraction.one": "document reading rejected",
  "webResearch.outcome.extraction.other": "document readings rejected",
  "webResearch.outcome.providerLimits.one": "unit stopped at a provider limit",
  "webResearch.outcome.providerLimits.other": "units stopped at provider limits",
  "webResearch.outcome.closedByOperator.one": "unit closed before it finished",
  "webResearch.outcome.closedByOperator.other": "units closed before they finished",
  "webResearch.outcome.other.one": "other failure",
  "webResearch.outcome.other.other": "other failures",
  "webResearch.outcome.next.blockedDownloads":
    "Retrying tries again, which clears temporary blocks. If it persists, register or review an alternative source for those UFs.",
  "webResearch.outcome.next.missingDownloads":
    "Usually temporary: retrying requests the downloads again.",
  "webResearch.outcome.next.noOfficialSource":
    "The search cited no host from the source catalogue. Review those UFs' sources; retrying searches again.",
  "webResearch.outcome.next.extraction":
    "The reading failed its checks; retrying reads the document again. If it persists, check the document in the list below.",
  "webResearch.outcome.next.providerLimits":
    "Temporary: retrying requeues them within the configured pace.",
  "webResearch.outcome.next.closedByOperator":
    "Retrying reopens the sweep and resumes those units.",
  "webResearch.outcome.next.other": "See each unit's error in the table below.",
  "webResearch.outcome.partial":
    "UFs and hosts named from the first 200 failed units; the counts include all of them.",
  "webResearch.outcome.retry.one": "Retry 1 failure",
  "webResearch.outcome.retry.other": "Retry {count} failures",
  "webResearch.outcome.sources": "Alternative sources",
  "webResearch.error.FETCH_FAILED": "The document could not be downloaded or read",
  "webResearch.error.FETCH_TIMEOUT": "The document did not arrive in time",
  "webResearch.error.NO_REVIEWED_SOURCE": "No reviewed source covers this unit",
  "webResearch.error.CLOSED_BY_OPERATOR": "Sweep closed before this unit ran",
  "webResearch.action.conflict":
    "The sweep changed since you opened it. We reloaded the current state; check it and try again.",
  "webResearch.action.error": "The action could not be applied. Try again.",
  "webResearch.action.retried": "Failed units are back in the queue.",
  "webResearch.cancel.title": "Cancel this sweep?",
  "webResearch.cancel.body":
    "Pending and blocked units are skipped and the sweep cannot be resumed. What was already found stays available for review.",
  "webResearch.cancel.keep": "Keep",
  "webResearch.cancel.confirm": "Cancel sweep",
  "webResearch.stages.title": "Stages",
  "webResearch.stages.units": "{count} units",
  "webResearch.stages.none": "no units",
  "webResearch.stages.error": "Stage progress could not be loaded.",
  "webResearch.stages.of": "of {total}",
  "webResearch.stages.open": "{count} open",
  "webResearch.stages.closed": "none open",
  "webResearch.stage.state.active": "In progress",
  "webResearch.stage.state.attention": "With failures",
  "webResearch.stage.state.done": "Done",
  "webResearch.stage.review": "Review",
  "webResearch.stage.review.unit": "annex readings",
  "webResearch.stage.review.hint":
    "Read values arrive as unverified facts; a person decides in Rules → Verification.",
  "webResearch.stage.review.open": "Open Verification",
  "webResearch.stage.locate": "Locate",
  "webResearch.stage.locate.hint":
    "Grounded search for annexes by segment × UF, CONFAZ agreements, internal rates and the interstate table.",
  "webResearch.stage.fetch": "Download",
  "webResearch.error.NO_OFFICIAL_CITATION": "No official source cited",
  "webResearch.error.GROUNDED_RESPONSE_INVALID": "Invalid search response",
  "webResearch.error.PROVIDER_RATE_LIMITED": "Search limit reached",
  "webResearch.error.PROVIDER_UNAVAILABLE": "Search service unavailable",
  "webResearch.error.URL_NOT_ALLOWED": "Address outside the allowed sources",
  "webResearch.error.FETCH_ROBOTS_DENIED":
    "The official site does not permit automated downloads under its robots policy",
  "webResearch.error.FETCH_HTTP": "The official site refused the download (HTTP {status})",
  "webResearch.error.FETCH": "The document could not be downloaded",
  "webResearch.error.DOCUMENT_CHANGED": "The document changed while being read",
  "webResearch.error.EXTRACT_CHECKS_FAILED": "Extracted rows failed the CEST/NCM checks",
  "webResearch.error.EXTRACTION_INVALID": "Extraction had an invalid format",
  "webResearch.error.EXTRACTION_REJECTED": "Extraction refused by the reading service",
  "webResearch.error.EXTRACTION_TOO_LARGE": "Extraction result too large",
  "webResearch.error.CHUNK_TOO_LARGE": "Document section too large to read",
  "webResearch.error.RESULT_INVALID": "Result rejected by validation",
  "webResearch.error.FETCH_BLOCKED":
    "The official site blocks our egress address; waiting for the publisher to allowlist it",
  "webResearch.error.DOCUMENT_UNSUPPORTED":
    "The document was downloaded but its format cannot be read",
  "webResearch.error.WORKER_ERROR": "Internal runner failure; it will be retried",
  "webResearch.error.LEASE_EXPIRED": "Processing timed out",
  "webResearch.error.INVALID_UNIT_KEY": "Incomplete research unit",
  "webResearch.error.UNSUPPORTED_KIND": "Stage not supported by the worker",
  "webResearch.error.unknown": "Technical failure",
  "webResearch.stage.fetch.hint": "Downloads our own copy of each official document located.",
  "webResearch.stage.extract": "Extract",
  "webResearch.stage.extract.hint":
    "Reads annex rows (CEST, NCM, MVA, validity) from the downloaded copy, with the verbatim quote.",
  "webResearch.stage.verify": "Verify pairs",
  "webResearch.stage.verify.hint":
    "Checks NCM × route only when the segment is ambiguous or the strategy is Pair.",
  "webResearch.cost.title": "Cost",
  "webResearch.cost.live": "live",
  "webResearch.cost.spent": "Spent vs budget",
  "webResearch.cost.grounded": "Searches vs cap",
  "webResearch.cost.extraction": "Extractions",
  "webResearch.cost.estimated": "{count} estimated",
  "webResearch.cost.eta": "ETA",
  "webResearch.cost.etaNone": "finished",
  "webResearch.cost.etaPaused": "paused",
  "webResearch.cost.throughput": "Throughput",
  "webResearch.cost.throughputValue": "{units} units/min · {searches} searches/min",
  "webResearch.cost.throughputMeta": "last {minutes} min · {inFlight} in progress",
  "webResearch.cost.etaRate": "at the real rate, {units} units open",
  "webResearch.cost.etaPace": "at the configured pace",
  "webResearch.cost.estimate": "Planning reserve at creation",
  "webResearch.cost.iob": "IOB certification",
  "webResearch.failed.title": "Failed units",
  "webResearch.failed.hint":
    "Gave up after 3 attempts or a permanent error. Retrying resets the attempts and queues them again.",
  "webResearch.failed.retry": "Retry failures",
  "webResearch.failed.none": "No failed units.",
  "webResearch.col.kind": "Stage",
  "webResearch.col.subject": "Target",
  "webResearch.col.error": "Error",
  "webResearch.col.attempts": "Attempts",
  "webResearch.col.updated": "Updated",
  "webResearch.col.host": "Document",
  "webResearch.col.uf": "UF",
  "webResearch.col.segments": "Segments",
  "webResearch.col.hash": "Hash",
  "webResearch.col.change": "Since last run",
  "webResearch.kind.LOCATE_SEGMENT_UF": "Locate segment × UF",
  "webResearch.kind.LOCATE_CONFAZ_SEGMENT": "Locate CONFAZ agreement",
  "webResearch.kind.LOCATE_INTERNAL_RATE_UF": "Locate internal rate",
  "webResearch.kind.LOCATE_INTERSTATE_TABLE": "Locate interstate table",
  "webResearch.kind.FETCH_DOCUMENT": "Download document",
  "webResearch.kind.EXTRACT_DOCUMENT_SEGMENT": "Extract annex",
  "webResearch.kind.VERIFY_PAIR": "Verify pair",
  "webResearch.docs.title": "Documents found",
  "webResearch.docs.hint": "Hash compared with the previous sweep, “{name}”.",
  "webResearch.docs.hintFirst": "First sweep: every downloaded document shows as new.",
  "webResearch.docs.filter": "Filter documents by change",
  "webResearch.docs.all": "All",
  "webResearch.docs.change.CHANGED": "Changed",
  "webResearch.docs.change.NEW": "New",
  "webResearch.docs.change.SAME": "Unchanged",
  "webResearch.docs.change.PENDING": "Awaiting download",
  "webResearch.docs.failed": "A unit for this document failed",
  "webResearch.docs.none": "No document located yet.",
  "webResearch.docs.more": "Show {count} more",
  "webResearch.docs.less": "Show less",
  "webResearch.docs.truncated": "Showing the first 200 document records of this sweep.",
  "webResearch.wizard.title": "New web research sweep",
  "webResearch.wizard.steps": "New sweep steps",
  "webResearch.wizard.step.scope": "Scope",
  "webResearch.wizard.step.routes": "Routes",
  "webResearch.wizard.step.strategy": "Strategy",
  "webResearch.wizard.step.caps": "Caps",
  "webResearch.wizard.step.preview": "Preview",
  "webResearch.wizard.summary.caps": "{calls} searches · US$ {budget}",
  "webResearch.wizard.summary.preview": "current preview · {cost}",
  "webResearch.wizard.summary.stale": "preview out of date",
  "webResearch.wizard.summary.notYet": "not calculated yet",
  "webResearch.wizard.summary.blocked": "blocked",
  "webResearch.wizard.plan.title": "Plan in this preview",
  "webResearch.wizard.plan.edit": "Edit",
  "webResearch.wizard.name": "Name",
  "webResearch.wizard.scope": "What to research",
  "webResearch.wizard.recommended": "Recommended",
  "webResearch.wizard.days": "Period",
  "webResearch.wizard.daysValue": "{days} days",
  "webResearch.wizard.routes": "Which routes",
  "webResearch.wizard.routes.uf": "UF",
  "webResearch.wizard.routes.direction": "Direction",
  "webResearch.wizard.routes.direction.FROM": "From the UF",
  "webResearch.wizard.routes.direction.TO": "To the UF",
  "webResearch.wizard.routes.direction.BOTH": "Both",
  "webResearch.wizard.routes.list": "Routes (origin → destination)",
  "webResearch.wizard.routes.add": "Add route",
  "webResearch.wizard.routes.remove": "Remove route {route}",
  "webResearch.wizard.routes.explicitEmpty": "Add at least one route.",
  "webResearch.wizard.strategy": "How to research",
  "webResearch.wizard.strategy.pairNotAllowed":
    "Pair is not available for Whole catalog or Every destination UF.",
  "webResearch.wizard.skipFresh": "Reuse answers from the last 30 days",
  "webResearch.wizard.skipFreshHint":
    "Searches another sweep answered in the last 30 days are marked cached and spend nothing.",
  "webResearch.wizard.caps.calls": "Max grounded searches",
  "webResearch.wizard.caps.callsHint": "≈ {time} at {pace} searches/min.",
  "webResearch.wizard.caps.callsRange": "Between 1 and 100,000.",
  "webResearch.wizard.caps.budget": "Budget",
  "webResearch.wizard.caps.budgetHint": "The sweep stops when it reaches this estimated spend.",
  "webResearch.wizard.caps.budgetInvalid": "Enter a dollar amount above zero (e.g. 80 or 12.50).",
  "webResearch.wizard.caps.campaign": "Funding campaign ID",
  "webResearch.wizard.caps.campaignHint":
    "Copy the campaign ID shown on this page. Google Grounding requires a verified campaign; selecting it does not increase its budget.",
  "webResearch.wizard.caps.campaignInvalid":
    "Enter the UUID of the verified campaign that will fund this sweep.",
  "webResearch.wizard.caps.iob": "Certify top N with IOB",
  "webResearch.wizard.caps.iobHint": "Queues IOB tasks for the N most-used pairs. 0 turns it off.",
  "webResearch.wizard.caps.iobUsedOnly": "Only available with the Used scope.",
  "webResearch.wizard.caps.iobRange": "Between 0 and 3,000.",
  "webResearch.wizard.caps.note":
    "Caps apply per sweep. The daily cap and monthly budget in Settings also apply.",
  "webResearch.wizard.back": "Back",
  "webResearch.wizard.next": "Next",
  "webResearch.wizard.toPreview": "Preview",
  "webResearch.wizard.create": "Create sweep",
  "webResearch.wizard.creating": "Creating…",
  "webResearch.wizard.createNeedsPreview": "Preview the current plan before creating.",
  "webResearch.wizard.createError":
    "The sweep could not be created. Try again; the same plan is never created twice.",
  "webResearch.wizard.createConflict":
    "This key was already used for another plan. Refresh the preview and try again.",
  "webResearch.wizard.preview.lead":
    "Nothing is stored until you create. Check what will be researched and what it should cost.",
  "webResearch.wizard.preview.loading": "Planning…",
  "webResearch.wizard.preview.refresh": "Refresh preview",
  "webResearch.wizard.preview.run": "Preview plan",
  "webResearch.wizard.preview.stale": "The plan changed since the last preview.",
  "webResearch.wizard.preview.error": "The preview failed. Review the steps and try again.",
  "webResearch.wizard.preview.invalid": "Fix the “{step}” step before previewing.",
  "webResearch.wizard.preview.fix": "Go to step",
  "webResearch.preview.ncms": "NCMs",
  "webResearch.preview.routes.one": "{count} route",
  "webResearch.preview.routes.other": "{count} routes",
  "webResearch.preview.withCest": "CEST candidates",
  "webResearch.preview.withoutCest": "{count} outside Conv. 142/18",
  "webResearch.preview.ambiguous": "{count} ambiguous",
  "webResearch.preview.segmentsUfs": "Segments × UFs",
  "webResearch.preview.locates.one": "{count} locate unit",
  "webResearch.preview.locates.other": "{count} locate units",
  "webResearch.preview.cached": "{count} cached",
  "webResearch.preview.pairs": "Pairs to verify",
  "webResearch.preview.pairsHint": "Ambiguous only, or Pair strategy.",
  "webResearch.preview.grounded": "Estimated searches",
  "webResearch.preview.extraction": "Estimated extractions",
  "webResearch.preview.usageForecast": "Projection from settled usage",
  "webResearch.preview.forecastUnavailable": "Not enough confirmed usage",
  "webResearch.preview.reservationHint":
    "The reserve assumes the full model context for every planned call. It is not expected spending or a guaranteed bill ceiling. Budget admission still uses reservations.",
  "webResearch.preview.forecastHint":
    "Projection from {searches} search calls and {extractions} extraction calls over {days} days. Excludes {unresolved} unresolved calls; retries and failures can change the cost. Platform prices before free allowances or credits; not a Google invoice.",
  "webResearch.preview.cost": "Conservative planning reserve",
  "webResearch.preview.eta": "Estimated duration",
  "webResearch.preview.withinCaps":
    "The planning reserve fits this sweep’s search and budget caps.",
  "webResearch.preview.fitCaps": "Fit caps to the planning reserve (+20%)",
  "webResearch.warning.cestEmpty":
    "The CEST catalog is empty: every NCM counts as outside Conv. 142/18.",
  "webResearch.warning.noRoutes": "No route found for these NCMs (used routes need calculations).",
  "webResearch.warning.nothing": "Nothing to research for this scope.",
  "webResearch.warning.pairOver": "The Pair plan needs {units} units, above the limit of {max}.",
  "webResearch.preview.overCaps":
    "The planning reserve exceeds the caps. The sweep may stop early; this does not mean the forecast cost has been spent.",
  "webResearch.preview.segmentsList.one": "{count} Conv. 142/18 segment",
  "webResearch.preview.segmentsList.other": "{count} Conv. 142/18 segments",
  "webResearch.preview.segmentMeta": "{ncms} NCMs · {cests} CESTs",
  "webResearch.preview.unitsList": "Planned units by kind",
  "webResearch.preview.warnings": "API warnings",
  "webResearch.settings.title": "Pace and budget",
  "webResearch.settings.hint":
    "Apply to every web research sweep. The API enforces them on each unit it hands out.",
  "webResearch.settings.kill": "Pause web research",
  "webResearch.settings.killOn": "Paused: no unit is handed out, for any sweep.",
  "webResearch.settings.killOff": "On: active sweeps continue within the pace and caps.",
  "webResearch.settings.pace": "Pace",
  "webResearch.settings.grounded": "Searches per minute",
  "webResearch.settings.groundedHint":
    "1 to 30. Start low and raise it after a week without 429 errors.",
  "webResearch.settings.extraction": "Extractions per minute",
  "webResearch.settings.extractionHint":
    "1 to 60 model calls; pages with nothing to read do not count.",
  "webResearch.settings.workers": "Parallel workers",
  "webResearch.settings.workersHint":
    "1 to {max}. Units worked at once; the paces and caps above stay global.",
  "webResearch.settings.caps": "Caps",
  "webResearch.settings.daily": "Daily search cap",
  "webResearch.settings.dailyHint": "Brasília day. 1 to 100,000.",
  "webResearch.settings.monthly": "Monthly budget",
  "webResearch.settings.monthlyHint": "Once reached, no sweep gets work until next month.",
  "webResearch.settings.perDay": "Searches per day",
  "webResearch.settings.perDayMeta": "lower of pace and daily cap",
  "webResearch.settings.perHour": "Searches per hour",
  "webResearch.settings.perHourMeta": "at the configured pace",
  "webResearch.settings.budgetMonth": "Budget this month",
  "webResearch.settings.budgetMonthMeta": "all sweeps combined",
  "webResearch.settings.prices": "Price table (estimates)",
  "webResearch.settings.pricesHint":
    "Used to price the usage the worker reports in US$. Update it when the provider's price changes.",
  "webResearch.settings.price.groundedPromptUsdPer1000": "Per 1,000 grounded prompts",
  "webResearch.settings.price.searchQueryUsdPer1000": "Per 1,000 search queries",
  "webResearch.settings.price.inputTokensUsdPerMillion": "Per million input tokens",
  "webResearch.settings.price.outputTokensUsdPerMillion": "Per million output tokens",
  "webResearch.calculatorBudget.title": "Calculator research budget per investigation",
  "webResearch.calculatorBudget.hint":
    "Applies to new fiscal-gap investigations, including automatic requests. Daily, monthly and campaign budgets remain independent.",
  "webResearch.calculatorBudget.label": "Individual limit (US$)",
  "webResearch.calculatorBudget.fieldHint":
    "Estimated reservation for search and extraction. Actual usage is recorded; an in-flight call may exceed the estimate. Existing investigations retain their original budget.",
  "webResearch.calculatorBudget.unavailable":
    "Calculator research is unavailable in this environment.",
  "webResearch.settings.saved": "Settings saved.",
  "webResearch.settings.conflict":
    "Someone else changed these settings. We reloaded the current version; redo your change.",
  "webResearch.settings.error": "Could not save. Try again.",
  "webResearch.settings.pauseTitle": "Pause web research?",
  "webResearch.settings.pauseBody":
    "Every sweep stops getting work on the worker's next request. Units in progress finish; nothing is lost.",
  "webResearch.settings.pauseConfirm": "Pause web research",
  "certification.badge.PUBLISHED_RULE": "Published rule",
  "certification.badge.CERTIFIED": "IOB certified",
  "certification.badge.VERIFIED": "Verified",
  "certification.badge.UNVERIFIED": "Unverified",
  "certification.badge.EXPIRED": "Expired",
  "certification.badge.CONFLICTING": "Conflicting",
  "certification.badge.REJECTED": "Rejected",
  "certification.badge.SUPERSEDED": "Superseded",
  "certification.meaning.PUBLISHED_RULE":
    "Value from a published ruleset; it always wins over facts.",
  "certification.meaning.CERTIFIED": "Read from the IOB simulator with the result frame recorded.",
  "certification.meaning.VERIFIED": "Confirmed by a reviewer or corroborated by an IOB fact.",
  "certification.meaning.UNVERIFIED":
    "Extracted from an official web source; not yet confirmed by a person or IOB.",
  "certification.meaning.EXPIRED": "Its validity ended and there is no successor.",
  "certification.meaning.CONFLICTING":
    "Disagrees with another fact at the same level; not used until someone decides.",
  "certification.meaning.REJECTED": "Rejected by a reviewer or revoked; never used.",
  "certification.meaning.SUPERSEDED":
    "A newer fact for the same key replaced this one from its new start date.",
  "certification.source.IOB_SIMULADOR": "IOB simulator",
  "certification.source.WEB_RESEARCH": "Web research",
  "certification.source.OPERATOR": "Reviewer",
  "certification.source.CATALOG_DERIVATION": "CEST catalog",
  "certification.source.PUBLISHED_RULESET": "Published ruleset",
  "certification.tip.source": "Source",
  "certification.tip.ruleset": "Version",
  "certification.tip.checked": "Checked",
  "certification.tip.validity": "Validity",
  "certification.tip.validRange": "{from} to {to}",
  "certification.tip.validFrom": "from {from}",
  "certification.tip.host": "Citation",
  "certification.inferred": "inferred start",
  "revalidation.awaiting": "IOB check: queued at the agent's next poll · next window {window}",
  "revalidation.queued": "IOB check queued · {ahead} · expected {eta}",
  "revalidation.queuedHeld": "IOB check queued · {ahead} · its task is paused",
  "revalidation.ahead.one": "{count} lookup ahead",
  "revalidation.ahead.other": "{count} lookups ahead",
  "revalidation.running": "IOB check running now",
  "revalidation.checked": "IOB checked {age}: review the result",
  "revalidation.ended": "The IOB check ended without an answer: send to IOB again",
  "revalidation.notQueueable": "The IOB checks NCM × route facts only: confirm or reject this one",
  "revalidation.paused": "IOB agent paused: the check waits until an admin resumes it",
  "certification.revalidation": "Revalidation pending",
  "certification.revalidation.hint": "The fact stays usable while IOB checks it again.",
  "verification.tab": "Verification",
  "verification.title": "Fiscal fact verification",
  "verification.description":
    "Confirm, reject or send to IOB the facts research found, at the level they were extracted: one annex row verifies every route it covers.",
  "verification.boundary":
    "Fiscal facts do not feed any calculation yet and never publish a rule. Verifying here prepares the base for when the engine starts reading them.",
  "verification.queue.title": "Verification queue",
  "verification.tabs": "Verification queues",
  "verification.tab.unverified": "Unverified",
  "verification.tab.conflicting": "Conflicting",
  "verification.tab.drift": "Drift from published rule",
  "verification.tab.revalidation": "Revalidation pending",
  "verification.tab.expired": "Expired",
  "verification.tabHint.unverified":
    "Sorted by impact: occurrences of the open gaps each fact would answer.",
  "verification.tabHint.conflicting":
    "Facts at the same level that disagree. Neither side is used until someone decides.",
  "verification.tabHint.drift":
    "Certified or verified facts that disagree with the published rule. The rule still applies.",
  "verification.tabHint.revalidation":
    "Still-usable facts IOB must check again: the web disagreed, the source changed or the validity is ending.",
  "verification.tabHint.expired":
    "Validity ended with no successor. Not used for dates after the end.",
  "verification.queue.count": "{shown} of {total}",
  "verification.queue.first": "First page",
  "verification.queue.next": "Next page",
  "verification.empty.unverified": "No facts waiting for verification",
  "verification.empty.conflicting": "No open conflicts",
  "verification.empty.drift": "No drift from the published rule",
  "verification.empty.revalidation": "No revalidation pending",
  "verification.empty.expired": "No expired facts",
  "verification.empty.body":
    "Facts arrive from the IOB simulator and web research. Anything to review shows up here.",
  "verification.detail.none": "Select a fact to see its fields and evidence.",
  "verification.item.drift": "Differs on {fields} · rule {version}",
  "verification.item.conflicts.one": "{count} conflicting fact",
  "verification.item.conflicts.other": "{count} conflicting facts",
  "verification.item.impact": "{gaps} · {occurrences}",
  "verification.gaps.one": "{count} gap",
  "verification.gaps.other": "{count} gaps",
  "verification.occurrences.one": "{count} occurrence",
  "verification.occurrences.other": "{count} occurrences",
  "verification.item.noImpact": "No open gaps",
  "verification.field.stApplicable": "ST applies",
  "verification.field.originalMva": "Original MVA",
  "verification.field.destinationInternalRate": "Internal rate",
  "verification.field.interstateRate": "Interstate rate",
  "verification.field.ncmPrefixes": "Annex NCMs",
  "verification.field.segment": "Destination and origins",
  "verification.field.uf": "State",
  "verification.field.route": "Route",
  "verification.field.kind": "Kind",
  "verification.field.validity": "Validity",
  "verification.field.effectiveTo": "Effective until",
  "verification.field.legalBasis": "Legal basis",
  "verification.field.checked": "Last checked",
  "verification.field.verified": "Verification",
  "verification.field.id": "Fact",
  "verification.value.yes": "Yes",
  "verification.value.no": "No",
  "verification.scope.ORIGINS": "origins {ufs}",
  "verification.scope.ALL_ORIGINS": "all origins",
  "verification.scope.INTERNAL_ONLY": "internal operations only",
  "verification.kind.ST_ROUTE": "NCM route",
  "verification.kind.ST_SEGMENT": "Annex segment",
  "verification.kind.NO_ST_CATALOG": "No ST in catalog",
  "verification.kind.INTERNAL_RATE": "Internal rate",
  "verification.kind.INTERSTATE_RATE": "Interstate rate",
  "verification.subject.internal": "Internal {uf}",
  "verification.subject.modal": "state modal rate",
  "verification.short.st": "ST",
  "verification.value.internalSt": "Internal ST at destination ({uf})",
  "verification.short.mva": "MVA",
  "verification.short.internal": "Internal",
  "verification.short.interstate": "Interstate",
  "verification.bootstrap.title": "Baseline setup",
  "verification.bootstrap.hint":
    "Start with what expands the most: the 27 modal internal rates and the interstate table apply to every route.",
  "verification.bootstrap.internal": "Internal rates by state",
  "verification.bootstrap.internalTally": "{confirmed} of {total} verified · {pending} waiting",
  "verification.bootstrap.interstate": "Interstate table",
  "verification.bootstrap.interstateTally":
    "{confirmed} of {total} routes verified · {pending} waiting",
  "verification.bootstrap.interstateNote":
    "Each origin → destination route is its own fact; confirm them from the Unverified tab.",
  "verification.bootstrap.legend": "Legend",
  "verification.bootstrap.cell.CONFIRMED": "verified or certified",
  "verification.bootstrap.cell.PENDING": "waiting for verification",
  "verification.bootstrap.cell.CONFLICT": "conflicting",
  "verification.bootstrap.cell.NONE": "no fact",
  "verification.settings.title": "Facts in calculations",
  "verification.settings.hint": "Mode and kill switches for the facts layer. Administrators only.",
  "verification.settings.loading": "Loading settings…",
  "verification.settings.dormant":
    "Calculation amounts never use fiscal facts. In Shadow mode the calculator and spreadsheets store a comparison with verified and certified facts; On does not change results yet.",
  "verification.settings.effective": "Effective mode",
  "verification.settings.environment": "Environment",
  "verification.settings.restricted":
    "Saved as {mode}, but the environment caps it at {environment}: the more restrictive always wins.",
  "verification.settings.effectiveHint":
    "The effective mode is the more restrictive of the one saved here and the environment's (FISCAL_FACTS_MODE).",
  "verification.settings.mode": "Mode",
  "verification.mode.OFF": "Off",
  "verification.mode.SHADOW": "Shadow",
  "verification.mode.ON": "On",
  "verification.mode.OFF.hint": "Facts are not consulted.",
  "verification.mode.SHADOW.hint":
    "The engine also calculates with verified and certified facts and stores the difference per item, without changing results.",
  "verification.mode.ON.hint":
    "Facts would fill items with no published rule, always labeled with their certification level.",
  "verification.settings.useCertified": "Use certified and verified facts",
  "verification.settings.useCertifiedHint": "IOB and reviewer-confirmed facts.",
  "verification.settings.useUnverified": "Use unverified facts",
  "verification.settings.useUnverifiedHint":
    "Kill switch for web data: turn it off to ignore them at once.",
  "verification.settings.saved": "Settings saved.",
  "verification.settings.conflict":
    "Someone changed these settings — we loaded the current version. Review and save again.",
  "verification.settings.error": "Could not save. Try again.",
  "verification.settings.save": "Save",
  "verification.action.CONFIRM": "Confirm",
  "verification.action.REVALIDATE": "Confirm values",
  "verification.action.REJECT": "Reject",
  "verification.action.REQUEST_IOB": "Request IOB",
  "verification.done.CONFIRM": "Fact confirmed.",
  "verification.done.REJECT": "Fact rejected. It will not be used.",
  "verification.done.REQUEST_IOB": "IOB check requested; the fact moves to Revalidation pending.",
  "verification.error.stale": "Someone changed this fact — reload before deciding.",
  "verification.error.notAllowed":
    "This action is not allowed in the fact's current state. Reload to see the latest state.",
  "verification.error.generic": "Could not record the decision. Try again.",
  "verification.reload": "Reload",
  "verification.dialog.CONFIRM.title": "Confirm fact",
  "verification.dialog.CONFIRM.body":
    "You checked the values against the cited source. The fact becomes Verified and applies to every route it covers.",
  "verification.dialog.REVALIDATE.title": "Confirm current values",
  "verification.dialog.REVALIDATE.body":
    "You checked the values are still correct. The pending revalidation is closed.",
  "verification.dialog.REJECT.title": "Reject fact",
  "verification.dialog.REJECT.body":
    "The fact stops being used. The reason goes to the audit trail.",
  "verification.dialog.REQUEST_IOB.title": "Request an IOB check",
  "verification.dialog.REQUEST_IOB.body":
    "Flags the fact for the IOB simulator to check. It keeps its current level until the result arrives.",
  "verification.dialog.sending": "Sending…",
  "verification.dialog.reason": "Reason",
  "verification.dialog.note": "Note (optional)",
  "verification.dialog.reasonHint": "At least {min} characters · {count} typed",
  "verification.dialog.noteHint": "Recorded in the fact's history.",
  "verification.detail.fact": "Fact",
  "verification.detail.history": "History",
  "verification.detail.evidence": "Evidence",
  "verification.validity.range": "{from} to {to}",
  "verification.validity.open": "from {from} · open ended",
  "verification.validity.inferredHint":
    "The source stated no start date; the capture date is used.",
  "verification.verifiedBy": "{who} · {time}",
  "verification.event.DERIVED": "Derived",
  "verification.event.RECHECKED": "Rechecked",
  "verification.event.CORROBORATED": "Corroborated",
  "verification.event.CONFLICT_DETECTED": "Conflict detected",
  "verification.event.SUPERSEDED": "Superseded",
  "verification.event.REVALIDATION_REQUESTED": "Revalidation requested",
  "verification.event.CONFIRMED": "Confirmed",
  "verification.event.REJECTED": "Rejected",
  "verification.event.IOB_REQUESTED": "IOB requested",
  "verification.event.REVOKED": "Revoked",
  "verification.event.EXPIRED": "Expired",
  "verification.event.related": "Open related fact",
  "verification.evidence.iob": "Recorded IOB simulator frame",
  "verification.evidence.enlarge": "Enlarge the simulator frame",
  "verification.evidence.frameAdmin": "The simulator frame is visible to administrators.",
  "verification.evidence.noFrame": "No frame recorded for this finding.",
  "verification.evidence.openRun": "Open agent run",
  "verification.evidence.frameTitle": "IOB result · {ncm} · {route}",
  "verification.evidence.annex": "Annex row",
  "verification.evidence.checksPassed": "checks passed",
  "verification.evidence.checksFailed": "checks failed",
  "verification.evidence.locator": "Characters {start}–{end} of the normalized text",
  "verification.evidence.noLocator": "No text locator",
  "verification.evidence.extracted": "extracted {time}",
  "verification.evidence.none": "No evidence attached to this fact.",
  "verification.evidence.allowlisted": "Official source · {source}",
  "verification.evidence.notAllowlisted": "Not an allowlisted source",
  "verification.evidence.openDocument": "Open document",
  "verification.evidence.newTab": "(opens in a new tab)",
  "verification.evidence.openEvidence": "Open evidence",
  "verification.compare.conflictTitle": "Side by side",
  "verification.compare.field": "Field",
  "verification.compare.this": "This fact",
  "verification.compare.open": "Open",
  "verification.compare.differs": "(differs)",
  "verification.compare.host": "Source",
  "verification.compare.driftTitle": "Fact × published rule",
  "verification.compare.driftHint":
    "The published rule still applies. If the fact is right, propose a rule correction through the proposals flow.",
  "verification.compare.rule": "Rule {version}",
  /* Shell and navigation (UX plan PR 1). */
  "shell.nav.home": "Home",
  "shell.nav.lots": "Lots",
  "shell.nav.rules": "Rules",
  "shell.nav.documents": "Documents",
  "shell.nav.productSearch": "Product search",
  "shell.nav.agentsGroup": "Agents",
  "shell.nav.agentIob": "IOB agent",
  "shell.nav.agentLogs": "Records",
  "shell.nav.collapse": "Collapse menu",
  "shell.nav.expand": "Expand menu",
  "shell.search.trigger": "Search NCM, rules, documents…",
  "shell.viewAs.self": "{role} (you)",
  "nav.howItWorks": "How it works",
  "howItWorks.title": "How it works",
  "howItWorks.description":
    "See, with the engine's real numbers, what the system looks up and applies when a product travels from one state to another.",
  "howItWorks.sections": "Sections",
  "howItWorks.section.run": "Guided run",
  "howItWorks.section.runHint":
    "A real simulation, step by step: every formula shows the numbers the engine used and where each value came from.",
  "howItWorks.section.map": "System map",
  "howItWorks.onboarding.title": "In three steps",
  "howItWorks.onboarding.source": "Official source",
  "howItWorks.onboarding.sourceBody":
    "A catalogued site (SEFAZ, CONFAZ, Senate) publishes the act.",
  "howItWorks.onboarding.evidence": "Evidence",
  "howItWorks.onboarding.evidenceBody":
    "We keep our own copy with a hash and the citation of every value read.",
  "howItWorks.onboarding.review": "Review",
  "howItWorks.onboarding.reviewBody":
    "A person confirms before any rule is proposed and published.",
  "howItWorks.onboarding.dismiss": "Got it",
  "howItWorks.onboarding.dismissLabel": "Close the introduction",
  "howItWorks.section.mapHint":
    "Where the data comes from and the path it takes until it becomes a calculation. Select a stage to see what goes in, what comes out and who decides.",
  "howItWorks.section.glossary": "Glossary",
  "howItWorks.section.glossaryHint":
    "The terms that appear in the calculation, each with an illustrative example.",
  "howItWorks.form.title": "Operation",
  "howItWorks.form.presets": "Examples",
  "howItWorks.form.ncm": "NCM",
  "howItWorks.form.origin": "Origin",
  "howItWorks.form.destination": "Destination",
  "howItWorks.form.cost": "Product cost",
  "howItWorks.form.taxpayer": "Is the recipient an ICMS taxpayer?",
  "howItWorks.form.taxpayerYes": "Yes — resale or industry",
  "howItWorks.form.taxpayerNo": "No — final consumer",
  "howItWorks.form.date": "Calculation date",
  "howItWorks.form.run": "Run",
  "howItWorks.form.running": "Running…",
  "howItWorks.form.invalid": "Enter an 8-digit NCM, origin, destination, cost and date.",
  "howItWorks.form.stateless":
    "Stateless simulation: it uses the Calculator's own engine (Operation mode) over the ruleset in force. Nothing is saved to history.",
  "howItWorks.form.permission":
    "The execute-calculations permission is required to run the simulation.",
  "howItWorks.preset.tyre": "Tyre SP → RJ",
  "howItWorks.preset.tyreHint": "4011.10.00 · ICMS-ST with MVA",
  "howItWorks.preset.soda": "Soft drink SP → MG",
  "howItWorks.preset.sodaHint": "2202.10.00 · ICMS-ST",
  "howItWorks.preset.notebook": "Laptop SP → SP",
  "howItWorks.preset.notebookHint": "8471.30.12 · intrastate",
  "howItWorks.preset.airFryer": "Air fryer BA → MG",
  "howItWorks.preset.airFryerHint": "8516.60.00 · ST revoked · final consumer",
  "howItWorks.player.empty":
    "Pick an example or fill in the operation and click Run to watch the engine work.",
  "howItWorks.player.loading": "Looking up catalogue, rules and fiscal facts…",
  "howItWorks.player.controls": "Animation controls",
  "howItWorks.player.play": "Play",
  "howItWorks.player.pause": "Pause",
  "howItWorks.player.back": "Previous step",
  "howItWorks.player.forward": "Next step",
  "howItWorks.player.restart": "Restart",
  "howItWorks.player.showAll": "Show all",
  "howItWorks.player.speed": "Speed",
  "howItWorks.player.progress": "Step {current} of {total}",
  "howItWorks.player.progressLabel": "Run progress",
  "howItWorks.perspective.entry":
    "Taxpayer recipient: the engine calculates the entry {origin} → {destination} — IPI, own ICMS and ICMS-ST, as in the Calculator's cost.",
  "howItWorks.perspective.consumer":
    "Final consumer: the engine calculates the sale {origin} → {destination} — own ICMS and DIFAL (EC 87/2015). There is no ICMS-ST for a final consumer.",
  "howItWorks.tone.done": "Applied",
  "howItWorks.tone.skip": "Not applicable",
  "howItWorks.tone.gap": "Review required",
  "howItWorks.tone.warn": "Partial lookup",
  "howItWorks.stepTitle.ncm": "NCM validated in the catalogue",
  "howItWorks.stepTitle.cest": "CEST and segment (ICMS Agreement 142/18)",
  "howItWorks.stepTitle.ruleset": "Ruleset in force",
  "howItWorks.stepTitle.rule": "Rule for NCM × route",
  "howItWorks.stepTitle.ipi": "IPI (TIPI)",
  "howItWorks.stepTitle.ownIcms": "Own ICMS",
  "howItWorks.stepTitle.mva": "Does ST apply? Original → adjusted MVA",
  "howItWorks.stepTitle.icmsSt": "ST base and ICMS-ST",
  "howItWorks.stepTitle.difal": "DIFAL and FCP",
  "howItWorks.stepTitle.total": "Final cost",
  "howItWorks.step.ncm.found":
    "The code exists in the official Siscomex catalogue. The catalogue identifies the product; it carries no rate.",
  "howItWorks.step.ncm.missing":
    "Code not in the Siscomex catalogue. The engine still looks up rules for it, but check the classification.",
  "howItWorks.step.ncm.error":
    "The NCM catalogue could not be reached right now. The calculation continues from the rules.",
  "howItWorks.step.cest.none":
    "No CEST on the rules for this NCM × route. Without a CEST, the engine requires exactly one rule for NCM + route.",
  "howItWorks.step.cest.rule":
    "The matched rule is specific to CEST {cest}; the segment comes from ICMS Agreement 142/18.",
  "howItWorks.step.cest.candidates":
    "{count} CEST codes appear on this NCM's rules and facts. Providing the CEST breaks ties between competing rules.",
  "howItWorks.step.ruleset.body":
    "The engine pins published ruleset {version} and only considers rules in force on the calculation date. The result always cites that version.",
  "howItWorks.step.rule.found": "One published rule covers this NCM on this route and date.",
  "howItWorks.step.rule.specific":
    "{count} rules fit this route; the engine chose the most specific one (CEST, origin, destination).",
  "howItWorks.step.rule.ambiguous":
    "{count} rules tie for NCM + route without a CEST. The engine does not pick: the item goes to review and the route becomes a coverage gap.",
  "howItWorks.step.rule.missing":
    "No published rule covers this NCM on this route and date. The engine never invents a rate: the item goes to review and the route becomes a coverage gap.",
  "howItWorks.step.ipi.body": "IPI comes from the NCM's national TIPI row, applied to the cost.",
  "howItWorks.step.ipi.none": "No published TIPI row for this NCM: the engine adds no IPI.",
  "howItWorks.step.ownIcms.internal":
    "Intrastate operation in {uf}: the state's internal rate applies.",
  "howItWorks.step.ownIcms.notTaxed":
    "The rule does not tax ICMS on this operation. Open the rule to see whether it is a stated exemption or silence.",
  "howItWorks.step.ownIcms.noRule": "Without an ICMS rule, the engine does not compute own ICMS.",
  "howItWorks.step.ownIcms.closed":
    "ICMS-ST paid on entry already closed the chain for this intrastate sale.",
  "howItWorks.band.4":
    "{origin} → {destination}: 4%, the imported-goods rate (Senate Resolution 13/2012).",
  "howItWorks.band.7":
    "{origin} → {destination}: 7%, from South/Southeast (except ES) to North, Northeast, Centre-West and ES (Senate Resolution 22/89).",
  "howItWorks.band.12":
    "{origin} → {destination}: 12%, the general interstate rate (Senate Resolution 22/89).",
  "howItWorks.band.other":
    "{origin} → {destination}: interstate rate stated by the published rule.",
  "howItWorks.step.mva.adjusted":
    "ST applies. Because the interstate rate is below the internal one, the original MVA is adjusted so buying from out of state gains no edge.",
  "howItWorks.step.mva.intrastate":
    "ST applies. Intrastate, the original MVA holds without adjustment.",
  "howItWorks.step.mva.materialized":
    "ST applies. This policy uses the adjusted MVA materialized on the rule.",
  "howItWorks.step.mva.standard":
    "The rule sets no tax substitution on this route: no MVA and no ICMS-ST.",
  "howItWorks.step.mva.revoked":
    "The rule records ST as not applicable on this route (revoked): the product follows ordinary ICMS.",
  "howItWorks.step.mva.consumer":
    "A final consumer does not resell: the engine withholds no ICMS-ST on this sale.",
  "howItWorks.step.mva.noRule":
    "Without a published rule, the engine cannot tell whether ST applies.",
  "howItWorks.step.icmsSt.body":
    "ICMS-ST collects the tax of later stages up front: presumed base × destination internal rate, minus the own ICMS already charged.",
  "howItWorks.step.icmsSt.none":
    "No tax substitution in this operation: ICMS-ST is not part of the cost.",
  "howItWorks.step.icmsSt.noRule": "Without a published rule, ICMS-ST is not computed.",
  "howItWorks.step.difal.body":
    "Sale to a final consumer in another state: the seller pays {uf} the difference between the internal and the interstate rate.",
  "howItWorks.step.difal.taxpayer":
    "Taxpayer recipient: no final-consumer DIFAL; the difference is handled by ICMS-ST or by the credit.",
  "howItWorks.step.difal.intrastate": "Intrastate operation: there is no rate differential.",
  "howItWorks.step.difal.noRule": "Without a published rule, DIFAL is not computed.",
  "howItWorks.step.total.entry":
    "Cost with the taxes that stay in the product: IPI and ICMS-ST (own ICMS becomes a credit).",
  "howItWorks.step.total.consumer":
    "Cost with IPI and the DIFAL paid to the destination (own ICMS is inside the price).",
  "howItWorks.step.total.review":
    "Non-authoritative result: a rule is missing for this route. Publish the rule before using this value.",
  "howItWorks.step.rule.icmsSilent":
    "The selected rule is the national TIPI row: it states IPI and is silent on ICMS (EXCLUDED). Under policy {policy} the engine uses the whole rule and answers ICMS 0. That is a gap to review, not an exemption.",
  "howItWorks.step.ownIcms.silent":
    "The rule does not state ICMS (EXCLUDED means silent, not exempt). The engine zeroes own ICMS; a route rule that states ICMS is missing.",
  "howItWorks.step.ownIcms.exempt": "The rule states ICMS is exempt on this operation.",
  "howItWorks.step.mva.silent":
    "The rule does not say whether ST applies. The engine applied “no ST”; check the fiscal facts and publish the route rule.",
  "howItWorks.step.icmsSt.silent":
    "ICMS-ST not computed because the rule is silent on ICMS. The cost below may be understated.",
  "howItWorks.step.total.icmsSilent":
    "Engine amount without own ICMS or ICMS-ST: the rule is silent on ICMS. Do not use this cost before the route rule is published.",
  "howItWorks.value.notStated": "Not stated",
  "howItWorks.summary.icmsSilent":
    "Rule silent on ICMS: the engine returned ICMS 0 under the ruleset policy. Treat it as a gap and review it.",
  "ruleDivergence.source.IOB_SIMULADOR": "IOB",
  "ruleDivergence.source.WEB_RESEARCH": "Web research",
  "ruleDivergence.source.OPERATOR": "Operator",
  "ruleDivergence.source.CATALOG_DERIVATION": "Catalogue",
  "ruleDivergence.certified": "certified",
  "ruleDivergence.verified": "verified",
  "ruleDivergence.stMva": "Differs from rule — {source} {verb} ST MVA {mva}",
  "ruleDivergence.st": "Differs from rule — {source} {verb} ST",
  "ruleDivergence.noSt": "Differs from rule — {source} {verb} no ST",
  "ruleDivergence.hint":
    "A certified or verified fiscal fact disagrees with the published rule. Open it in Verification → Drift and prepare the correction proposal.",
  "verification.item.driftSilent": "Rule silent on ICMS (TIPI row): the engine answers ICMS 0",
  "calc.result.icmsSilent":
    "The applied rule is silent on ICMS (TIPI row, EXCLUDED). The engine zeroed ICMS and ICMS-ST under the ruleset policy; that is not an exemption. Treat it as a gap and review it before using this cost.",
  "howItWorks.fact.ncm": "NCM",
  "howItWorks.fact.description": "Official description",
  "howItWorks.fact.cest": "CEST",
  "howItWorks.fact.version": "Version",
  "howItWorks.fact.policy": "Engine policy",
  "howItWorks.fact.digest": "Content (hash)",
  "howItWorks.fact.date": "Date",
  "howItWorks.fact.ruleId": "Rule",
  "howItWorks.fact.route": "Route",
  "howItWorks.fact.validFrom": "In force from",
  "howItWorks.fact.validTo": "In force until",
  "howItWorks.fact.legalReference": "Legal basis",
  "howItWorks.fact.lookup": "Lookup result",
  "howItWorks.fact.stApplicable": "ST applies",
  "howItWorks.fact.fcp": "FCP",
  "howItWorks.value.openEnded": "no end date",
  "howItWorks.value.yes": "Yes",
  "howItWorks.value.no": "No",
  "howItWorks.value.fcpNotModeled": "not computed in this base (no published rate)",
  "howItWorks.term.cost": "cost",
  "howItWorks.term.ipiRate": "IPI rate",
  "howItWorks.term.internalRate": "destination internal",
  "howItWorks.term.interstateRate": "interstate",
  "howItWorks.term.originalMva": "original MVA",
  "howItWorks.term.adjustedMva": "adjusted MVA",
  "howItWorks.term.ipi": "IPI",
  "howItWorks.term.reduction": "base reduction",
  "howItWorks.term.stBase": "ST base",
  "howItWorks.term.ownIcms": "own ICMS",
  "howItWorks.term.icmsSt": "ICMS-ST",
  "howItWorks.term.difal": "DIFAL",
  "howItWorks.formula.ipi": "IPI",
  "howItWorks.formula.ownIcms": "Own ICMS",
  "howItWorks.formula.adjustedMva": "Adjusted MVA",
  "howItWorks.formula.stBase": "ST base",
  "howItWorks.formula.icmsSt": "ICMS-ST",
  "howItWorks.formula.difal": "DIFAL",
  "howItWorks.formula.total": "Final cost",
  "howItWorks.source.label": "Source",
  "howItWorks.source.catalogNcm": "Siscomex catalogue",
  "howItWorks.source.catalogCest": "CEST · ICMS Agreement 142/18",
  "howItWorks.source.tipi": "TIPI · national row",
  "howItWorks.source.rule": "Rule {id}",
  "howItWorks.source.engine": "Calculation engine",
  "howItWorks.source.factAgrees": "matches the rule",
  "howItWorks.source.factDiffers": "differs from the rule",
  "howItWorks.source.factOnly": "fiscal fact, not used in the calculation",
  "howItWorks.summary.title": "Result",
  "howItWorks.summary.taxes": "Taxes in cost: {value}",
  "howItWorks.summary.ruleset": "Ruleset {version} · {date}",
  "howItWorks.summary.openCalculator": "Open in the Calculator",
  "howItWorks.summary.openGaps": "See coverage gaps",
  "howItWorks.summary.openRule": "See rule",
  "howItWorks.summary.pisCofins": "PIS/COFINS stay outside this base.",
  "howItWorks.map.tour": "Walk the flow",
  "howItWorks.map.stop": "Stop",
  "howItWorks.map.bandData": "Where the data comes from",
  "howItWorks.map.bandRules": "How it becomes a rule and a calculation",
  "howItWorks.map.laneWeb": "Public research",
  "howItWorks.map.laneIob": "IOB simulator",
  "howItWorks.map.promotion":
    "Certified or verified facts can become a proposal (ADR 0013, proposed). No fact publishes on its own.",
  "howItWorks.map.count.facts": "{count} facts",
  "howItWorks.map.count.sources": "{count} sources",
  "howItWorks.map.count.queue": "{count} queued",
  "howItWorks.map.count.inReview": "{count} in review",
  "howItWorks.map.count.rules": "{count} rules",
  "howItWorks.map.count.calculations": "{count} calculations in 24 h",
  "howItWorks.map.node.sources": "Official sources",
  "howItWorks.map.node.sourcesSub": "CONFAZ · SEFAZ · Senate",
  "howItWorks.map.node.sourcesBody":
    "The system watches the official publications of the 27 SEFAZ, CONFAZ and the Senate. Every captured document keeps a hash and a date.",
  "howItWorks.map.node.webResearch": "Web research",
  "howItWorks.map.node.webResearchSub": "locate → download → extract",
  "howItWorks.map.node.webResearchBody":
    "Sweeps locate the right annex, download the document and extract NCM/CEST rows, MVA and rates, always with a citation.",
  "howItWorks.map.node.unverified": "Fiscal fact",
  "howItWorks.map.node.unverifiedSub": "Unverified",
  "howItWorks.map.node.unverifiedBody":
    "What research extracts becomes an unverified fiscal fact: useful as guidance, labelled, and never treated as a rule.",
  "howItWorks.map.node.verification": "Human verification",
  "howItWorks.map.node.verificationSub": "Rules → Verification",
  "howItWorks.map.node.verificationBody":
    "A reviewer checks the fact against the cited document and confirms or rejects it. Disagreements with IOB show up as conflicts.",
  "howItWorks.map.node.verified": "Fiscal fact",
  "howItWorks.map.node.verifiedSub": "Verified",
  "howItWorks.map.node.verifiedBody":
    "A fact confirmed by a person, with the citation that supports it.",
  "howItWorks.map.node.iob": "IOB agent",
  "howItWorks.map.node.iobSub": "browser in a VM",
  "howItWorks.map.node.iobBody":
    "An agent drives the IOB Simulator in a virtual machine, looks up NCM × route and records the result screen.",
  "howItWorks.map.node.iobFindings": "Agent records",
  "howItWorks.map.node.iobFindingsSub": "ST, MVA and frames",
  "howItWorks.map.node.iobFindingsBody":
    "Each lookup becomes a record with the result and the recorded frames.",
  "howItWorks.map.node.certified": "Fiscal fact",
  "howItWorks.map.node.certifiedSub": "IOB certified",
  "howItWorks.map.node.certifiedBody":
    "An IOB result is certified by default and holds until a new validity period appears.",
  "howItWorks.map.node.documents": "Documents",
  "howItWorks.map.node.documentsSub": "approved evidence",
  "howItWorks.map.node.documentsBody":
    "Every published rule needs an approved official document as evidence.",
  "howItWorks.map.node.proposals": "Proposals",
  "howItWorks.map.node.proposalsSub": "change with evidence",
  "howItWorks.map.node.proposalsBody":
    "A proposal describes the rule change (MVA, rates, validity) and points to the evidence.",
  "howItWorks.map.node.review": "Review",
  "howItWorks.map.node.reviewSub": "two approvals",
  "howItWorks.map.node.reviewBody":
    "Two different people approve; the author never approves their own change.",
  "howItWorks.map.node.publication": "Publication",
  "howItWorks.map.node.publicationSub": "immutable version",
  "howItWorks.map.node.publicationBody":
    "Publishing creates a new ruleset version with a content hash. Published versions never change.",
  "howItWorks.map.node.ruleset": "Ruleset",
  "howItWorks.map.node.rulesetSub": "in force",
  "howItWorks.map.node.rulesetBody":
    "The version in force is the only source the engine reads to calculate.",
  "howItWorks.map.node.engine": "Calculation engine",
  "howItWorks.map.node.engineSub": "deterministic",
  "howItWorks.map.node.engineBody":
    "The same input and the same version always give the same result, with a calculation trace and the version cited.",
  "howItWorks.map.node.outputs": "Calculator · Lots · API",
  "howItWorks.map.node.outputsSub": "consumers",
  "howItWorks.map.node.outputsBody":
    "The Calculator, spreadsheet lots and API integrations use the same engine and the same version.",
  "howItWorks.map.detail.label": "Selected stage",
  "howItWorks.map.detail.hint":
    "Select a stage to see what goes in, what comes out and who decides there.",
  "howItWorks.map.detail.open": "Open {name}",
  "howItWorks.map.detail.In": "In",
  "howItWorks.map.detail.Out": "Out",
  "howItWorks.map.detail.Who": "Who decides",
  "howItWorks.map.node.sourcesIn":
    "Registered official sites (CONFAZ, SEFAZ, Senate) and each one's allowed hosts.",
  "howItWorks.map.node.sourcesOut":
    "The catalogue research may search and download from, with each capture's hash and date.",
  "howItWorks.map.node.sourcesWho": "Administrators register and review each source.",
  "howItWorks.map.node.webResearchIn": "NCM and route scope, strategy, search cap and budget.",
  "howItWorks.map.node.webResearchOut":
    "Downloaded official documents and read annex lines, each with its literal citation.",
  "howItWorks.map.node.webResearchWho":
    "The system runs it; an administrator creates, pauses, cancels or closes the sweep.",
  "howItWorks.map.node.unverifiedIn":
    "Values read from annexes: CEST, NCM, MVA, rate and validity.",
  "howItWorks.map.node.unverifiedOut": "Facts labelled unverified, in the Verification queue.",
  "howItWorks.map.node.unverifiedWho": "No one yet: an unverified fact never feeds a calculation.",
  "howItWorks.map.node.verificationIn":
    "The unverified fact, the preserved document and the citation.",
  "howItWorks.map.node.verificationOut":
    "A verified or rejected fact, with the reason recorded in the audit log.",
  "howItWorks.map.node.verificationWho":
    "A human reviewer. Verifying a fact does not publish a rule.",
  "howItWorks.map.node.verifiedIn": "Facts confirmed by human review.",
  "howItWorks.map.node.verifiedOut": "Grounds for a rule proposal (ADR 0013, proposed).",
  "howItWorks.map.node.verifiedWho":
    "The decision is recorded; the fact publishes nothing on its own.",
  "howItWorks.map.node.iobIn": "The NCM × route queue and the agent's weekly schedule.",
  "howItWorks.map.node.iobOut": "IOB Simulator lookups, recorded frame by frame.",
  "howItWorks.map.node.iobWho":
    "The agent runs it; an administrator orders the queue and schedule and can stop the run.",
  "howItWorks.map.node.iobFindingsIn": "The result screens the agent captured.",
  "howItWorks.map.node.iobFindingsOut":
    "Findings: ST found, no ST, internal ST only or unreadable, with the frames.",
  "howItWorks.map.node.iobFindingsWho": "The system records what the screen showed.",
  "howItWorks.map.node.certifiedIn": "IOB findings for an NCM × route.",
  "howItWorks.map.node.certifiedOut":
    "IOB-certified facts, valid until a new validity period appears.",
  "howItWorks.map.node.certifiedWho":
    "The certification rule; disagreements with web research go to human review.",
  "howItWorks.map.node.documentsIn": "Official documents collected from the sources.",
  "howItWorks.map.node.documentsOut": "Approved evidence that can support a proposal.",
  "howItWorks.map.node.documentsWho": "Operators approve or reject each document.",
  "howItWorks.map.node.proposalsIn":
    "A rule change (MVA, rates, validity) and the approved evidence.",
  "howItWorks.map.node.proposalsOut": "A proposal in review, with the before/after diff.",
  "howItWorks.map.node.proposalsWho": "An operator proposes; proposing changes no rule.",
  "howItWorks.map.node.reviewIn": "The proposal, its diff and the cited evidence.",
  "howItWorks.map.node.reviewOut": "Approval or rejection, each with a reason.",
  "howItWorks.map.node.reviewWho": "Two people other than the proposer.",
  "howItWorks.map.node.publicationIn": "Approved proposals for the next ruleset.",
  "howItWorks.map.node.publicationOut": "A new immutable ruleset version, with a content hash.",
  "howItWorks.map.node.publicationWho": "Whoever holds publish permission, with a recorded reason.",
  "howItWorks.map.node.rulesetIn": "The published version.",
  "howItWorks.map.node.rulesetOut":
    "The rules in force on each date, the only source the engine reads.",
  "howItWorks.map.node.rulesetWho":
    "No one edits a published version; it changes by publishing another.",
  "howItWorks.map.node.engineIn":
    "The operation (NCM, route, value, date) and the ruleset in force.",
  "howItWorks.map.node.engineOut":
    "A deterministic calculation with its working and the version cited.",
  "howItWorks.map.node.engineWho": "No one: the engine only applies published rules.",
  "howItWorks.map.node.outputsIn": "Engine results for the pinned version.",
  "howItWorks.map.node.outputsOut": "Calculator, spreadsheet lots and API responses.",
  "howItWorks.map.node.outputsWho": "The consumer decides how to use the result.",
  "howItWorks.glossary.example": "Illustrative example",
  "howItWorks.glossary.internal.term": "Internal rate",
  "howItWorks.glossary.internal.body":
    "The percentage a state charges on operations inside it; for ICMS-ST and DIFAL it is the destination's.",
  "howItWorks.glossary.internal.example": "Internal 18% on R$ 100.00 = R$ 18.00.",
  "howItWorks.glossary.interstate.term": "Interstate 4 / 7 / 12%",
  "howItWorks.glossary.interstate.body":
    "Rate between states set by the Senate: 12% in general, 7% from South/Southeast (except ES) to N, NE, CW and ES, 4% for imported goods.",
  "howItWorks.glossary.interstate.example": "SP → BA: 7%. BA → SP: 12%. Imported product: 4%.",
  "howItWorks.glossary.mvaOriginal.term": "Original MVA",
  "howItWorks.glossary.mvaOriginal.body":
    "The presumed value-added margin that the agreement or protocol publishes for the product.",
  "howItWorks.glossary.mvaOriginal.example": "MVA 40% on R$ 100.00 → presumed base of R$ 140.00.",
  "howItWorks.glossary.mvaAdjusted.term": "Adjusted MVA",
  "howItWorks.glossary.mvaAdjusted.body":
    "Corrects the MVA when the interstate rate is below the internal one: ((1 + MVA) × (1 − inter) ÷ (1 − internal)) − 1.",
  "howItWorks.glossary.mvaAdjusted.example": "((1.40 × 0.88) ÷ 0.82) − 1 = 50.24%.",
  "howItWorks.glossary.icmsSt.term": "ICMS-ST",
  "howItWorks.glossary.icmsSt.body":
    "Tax substitution: one taxpayer pays the ICMS of later stages up front. ST base × internal − own ICMS.",
  "howItWorks.glossary.icmsSt.example": "R$ 150.24 × 18% − R$ 12.00 = R$ 15.04.",
  "howItWorks.glossary.difal.term": "DIFAL",
  "howItWorks.glossary.difal.body":
    "Rate differential on sales to a final consumer in another state (EC 87/2015): value × (destination internal − interstate).",
  "howItWorks.glossary.difal.example": "R$ 100.00 × (18% − 12%) = R$ 6.00.",
  "howItWorks.glossary.fcp.term": "FCP",
  "howItWorks.glossary.fcp.body":
    "Poverty Fund: up to 2 extra points on the internal rate of some products in some states. Not computed in this base.",
  "howItWorks.glossary.fcp.example":
    "Internal 18% + FCP 2% = 20%; on R$ 100.00, R$ 2.00 go to the fund.",
  "howItWorks.glossary.cest.term": "CEST",
  "howItWorks.glossary.cest.body":
    "Tax Substitution Specifier Code (ICMS Agreement 142/18): identifies goods subject to ST by segment.",
  "howItWorks.glossary.cest.example": "16.001.00 — new car tyres (NCM 4011.10.00), segment 16.",
  "howItWorks.glossary.validity.term": "Validity",
  "howItWorks.glossary.validity.body":
    "The period a rule is in force. The engine only uses rules in force on the calculation date.",
  "howItWorks.glossary.validity.example":
    "Rule from 03/01/2026, open-ended: applies on 09/28/2026, not on 02/15/2026.",
  /* -- Home v3: attention strip, operations, shell help ------------------ */
  "home.env.tag": "Demo",
  "home.attention.label": "Needs attention",
  "home.attention.clear": "Nothing pending",
  "home.attention.clearDetail": "Lots, verification and expiries are up to date.",
  "home.attention.checking": "checking…",
  "home.attention.unavailable": "unavailable",
  "home.attention.period7d": "last 7 days",
  "home.attention.lotsReview.name": "Lots to review",
  "home.attention.lotsReview.one": "lot to review",
  "home.attention.lotsReview.other": "lots to review",
  "home.attention.lotsReview.action": "Review",
  "home.attention.lotsFailed.name": "Failed lots",
  "home.attention.lotsFailed.one": "failed lot",
  "home.attention.lotsFailed.other": "failed lots",
  "home.attention.lotsFailed.action": "See failures",
  "home.attention.verification.name": "Verification",
  "home.attention.verification.one": "fact to verify",
  "home.attention.verification.other": "facts to verify",
  "home.attention.verification.meta": "No drift or conflicts",
  "home.attention.verification.action": "Verify",
  "home.attention.drift.one": "{count} drift",
  "home.attention.drift.other": "{count} drifts",
  "home.attention.conflicting.one": "{count} in conflict",
  "home.attention.conflicting.other": "{count} in conflict",
  "home.attention.rulesExpiring.name": "Expiries",
  "home.attention.rulesExpiring.one": "rule expiring",
  "home.attention.rulesExpiring.other": "rules expiring",
  "home.attention.rulesExpiring.meta": "next 30 days · ruleset in force",
  "home.attention.rulesExpiring.action": "See rules",
  "home.cta.title": "Start a calculation",
  "home.cta.continue": "Continue calculation",
  "home.cta.continueHint": "8 digits. You complete route and cost in the calculator.",
  "home.jobs.next.review": "Review",
  "home.jobs.next.failure": "See failure",
  "home.jobs.next.open": "Open",
  "home.rules.openCoverage": "Coverage by family and state",
  "home.ops.description": "Agents, web research and governance activity.",
  "home.ops.openAgent": "Open IOB agent",
  "home.ops.openResearch": "Open web research",
  "home.ops.research.units": "{done} of {total} units done",
  "nav.help": "Help",
  "shell.nav.collapseTooltip": "Collapse menu · {shortcut}",
  "shell.nav.expandTooltip": "Expand menu · {shortcut}",
  "verification.bootstrap.summaryInternal": "Internal rates",
  "verification.bootstrap.summaryInterstate": "Interstate table",
  "verification.bootstrap.summaryOf": "{confirmed} of {total}",
  "verification.bootstrap.showDetail": "Details",
  "agents.lookupRelation.task": "part of the running task",
  "agents.lookupRelation.gap": "coverage gap, outside the task route ({route})",
  "agents.lookupRelation.direct": "standalone lookup, outside the task route ({route})",
  "calc.result.waiting": "Waiting for input",
  "ruleDrafts.next.action": "Prepare next draft",
  "ruleDrafts.next.open": "Open draft {version}",
  "ruleDrafts.next.title": "Prepare the next draft ruleset",
  "ruleDrafts.next.body":
    "The draft starts from published version {version} plus every approved proposal (there may be none). Nothing is published: publishing still needs at least one approved proposal and the publish flow.",
  "ruleDrafts.next.noActive":
    "There is no published version: the draft starts from the approved proposals.",
  "ruleDrafts.next.policy": "Draft policy",
  "ruleDrafts.next.recommended": "recommended (ADR 0011, 0015)",
  "ruleDrafts.next.reason": "Reason",
  "ruleDrafts.next.reasonDefault":
    "Adopt tax-family-v1 (ADR 0011): routes without an ICMS rule become review items and gaps, not ICMS 0.",
  "ruleDrafts.next.create": "Create draft",
  "ruleDrafts.next.created": "Draft {version} created with {policy}.",
  "ruleDrafts.readiness.loading": "Checking the content under {policy}…",
  "ruleDrafts.readiness.blocking":
    "{count} violations block adopting {policy}. Fix them through proposals first.",
  "ruleDrafts.readiness.ok": "The content satisfies {policy}.",
  "ruleDrafts.readiness.ipiSummary":
    "{total} route rules mark IPI EXCLUDED: {review} to review and {placeholder} placeholders. Under tax-family-v1, EXCLUDED means silent and IPI comes from TIPI. The review list appears on the draft.",
  "ruleDrafts.adoption.title": "tax-family-v1 adoption (ADR 0011)",
  "ruleDrafts.adoption.hint": "review before publishing",
  "ruleDrafts.adoption.body":
    "Under tax-family-v1, a route rule with IPI EXCLUDED is silent: IPI comes from the TIPI row and enters the cost and the ST base. If the exclusion is a reviewed treatment, restate it as EXEMPT. Placeholders (the workbook did not quote TIPI) can stay as they are.",
  "ruleDrafts.adoption.none": "No route rule marks IPI EXCLUDED.",
  "ruleDrafts.adoption.column.rule": "NCM · CEST",
  "ruleDrafts.adoption.column.route": "Route",
  "ruleDrafts.adoption.column.reason": "IPI EXCLUDED reason",
  "ruleDrafts.adoption.column.kind": "Classification",
  "ruleDrafts.adoption.column.change": "IPI under tax-family-v1",
  "ruleDrafts.adoption.column.draft": "Draft",
  "ruleDrafts.adoption.kind.REVIEW": "Review",
  "ruleDrafts.adoption.kind.PLACEHOLDER": "Placeholder",
  "ruleDrafts.adoption.fromTipi": "EXCLUDED → TIPI {rate}",
  "ruleDrafts.adoption.tipiExempt": "EXCLUDED → TIPI exempt",
  "ruleDrafts.adoption.noTipi": "EXCLUDED → no IPI (no TIPI row)",
  "ruleDrafts.adoption.restated": "→ EXEMPT (restated)",
  "ruleDrafts.adoption.select": "Select {rule}",
  "ruleDrafts.adoption.reason": "Restatement reason",
  "ruleDrafts.adoption.restate": "Restate as EXEMPT ({count})",
  "ruleDrafts.adoption.result":
    "{created} drafts created, {existing} already existed. Attach evidence and submit under Proposal drafts.",
  "ruleDrafts.adoption.truncated": "Showing {shown} of {total}.",
  "ruleDrafts.adoption.violations": "Violations under {policy}",
  "ruleDrafts.status.EVIDENCE_REQUIRED": "Evidence required",
  "ruleDrafts.status.READY": "Ready to submit",
  "ruleDrafts.status.SUBMITTED": "Submitted",
  "ruleDrafts.status.DISCARDED": "Discarded",
  "ruleDrafts.origin.FISCAL_FACT": "Certified fact",
  "ruleDrafts.origin.IPI_RESTATEMENT": "IPI restatement",
  "ruleDrafts.panel.title": "Proposal drafts",
  "ruleDrafts.panel.hint": "{count} drafts",
  "ruleDrafts.panel.body":
    "Drafts are not proposals. Each becomes a proposal (Pending review) only after approved evidence from Documents is attached; review, approval and publication follow the current rules.",
  "ruleDrafts.panel.empty":
    "No drafts for this version. Use Verification → Drift → Propose rules, or the IPI restatement above.",
  "ruleDrafts.group": "Group {group}",
  "ruleDrafts.group.submit": "Attach evidence to group ({count})",
  "ruleDrafts.values":
    "ST {st} · original MVA {mva} · interstate {interstate} · internal {internal}",
  "ruleDrafts.value.blank": "blank",
  "ruleDrafts.value.yes": "yes",
  "ruleDrafts.value.no": "no",
  "ruleDrafts.operation.SUPERSEDE": "Supersedes rule {rule}",
  "ruleDrafts.operation.UPSERT": "New route rule",
  "ruleDrafts.checklist.title": "Official documents to attach",
  "ruleDrafts.checklist.CONV_142_18_ANNEX":
    "Conv. ICMS 142/18, Annex {annex} (segment {segment}, CEST {cest})",
  "ruleDrafts.checklist.CONV_142_18_ANNEX.noCest":
    "Conv. ICMS 142/18: identify the CEST of NCM {ncm}",
  "ruleDrafts.checklist.ST_AGREEMENT":
    "ICMS agreement or protocol binding {originUf} and {destinationUf} for the segment",
  "ruleDrafts.checklist.hint": "hint: {hint}; confirm both states adhere",
  "ruleDrafts.checklist.RICMS_DESTINATION": "RICMS/{destinationUf}: ST annex item for NCM {ncm}",
  "ruleDrafts.checklist.INTERNAL_RATE":
    "{destinationUf} internal rate: RICMS/{destinationUf} article",
  "ruleDrafts.checklist.INTERNAL_RATE.fact":
    "{destinationUf} internal rate: from the VERIFIED fact; attach the act it cites",
  "ruleDrafts.checklist.INTERSTATE_RATE":
    "Senate Res. 22/89: {rate} from {originUf} to {destinationUf}; 4% for imported goods (Senate Res. 13/2012)",
  "ruleDrafts.checklist.IPI_EXEMPTION_ACT":
    "Act granting the IPI exemption to NCM {ncm} (TIPI note, law or decree)",
  "ruleDrafts.checklist.optional": "for reference",
  "ruleDrafts.flag.INTERNAL_RATE_MISSING": "Internal rate blank: no VERIFIED fact",
  "ruleDrafts.flag.FACT_INTERSTATE_DIFFERS": "The fact states another interstate rate",
  "ruleDrafts.flag.IMPORTED_GOODS_CHECK": "Confirm the goods' origin (4% if imported)",
  "ruleDrafts.flag.INTERNAL_OPERATION": "Internal operation: enter the rate",
  "ruleDrafts.flag.IPI_FROM_TIPI": "IPI silent: comes from TIPI",
  "ruleDrafts.flag.IPI_COPIED_FROM_TIPI": "IPI copied from TIPI (legacy policy)",
  "ruleDrafts.flag.IPI_NOT_STATED": "No TIPI row states IPI",
  "ruleDrafts.flag.NO_ST_EXPRESSION": "No ST: ST with stApplicable=false (ADR 0013 open decision)",
  "ruleDrafts.flag.SUPERSEDES_ROUTE_RULE": "Supersedes the same-key route rule",
  "ruleDrafts.flag.MERGED_FACTS": "Several facts share this key",
  "ruleDrafts.missing": "Missing: {fields}",
  "ruleDrafts.missing.evidence": "evidence",
  "ruleDrafts.missing.originalMva": "original MVA",
  "ruleDrafts.missing.destinationInternalRate": "internal rate",
  "ruleDrafts.missing.interstateRate": "interstate rate",
  "ruleDrafts.facts": "{count} fact(s) · {findings} IOB finding(s)",
  "ruleDrafts.submit.title": "Attach evidence and submit",
  "ruleDrafts.submit.groupTitle": "Attach evidence to group {group}",
  "ruleDrafts.submit.body":
    "Evidence must be approved in Documents; the IOB finding is not evidence. Each draft becomes a Pending review proposal.",
  "ruleDrafts.submit.evidence": "Selected evidence",
  "ruleDrafts.submit.noEvidence": "No evidence selected.",
  "ruleDrafts.submit.remove": "Remove",
  "ruleDrafts.submit.internal": "Internal rate (fraction, e.g. 0.20)",
  "ruleDrafts.submit.interstate": "Interstate rate (fraction)",
  "ruleDrafts.submit.mva": "Original MVA (fraction)",
  "ruleDrafts.submit.action": "Submit for review",
  "ruleDrafts.submit.done": "{count} proposal(s) created, pending review.",
  "ruleDrafts.submit.failed": "{count} not submitted: {detail}",
  "ruleDrafts.submit.blocked": "Attach at least one approved evidence document.",
  "ruleDrafts.submit.rateInvalid": "Use a decimal fraction, for example 0.18.",
  "ruleDrafts.submit.effective.title": "Effective burden for the MVA (optional)",
  "ruleDrafts.submit.effective.hint":
    "Valid only under tax-family-v2 and it only adjusts the MVA; the ST debit keeps the nominal internal rate. State the legal basis, for example RICMS/SP, Annex II, art. 39 (12% for foods).",
  "ruleDrafts.submit.effective.rate": "Effective internal rate (fraction, e.g. 0.12)",
  "ruleDrafts.submit.effective.legal": "Legal basis",
  "ruleDrafts.submit.effective.validFrom": "Valid from (optional)",
  "ruleDrafts.submit.effective.validTo": "Valid until (optional)",
  "ruleDrafts.submit.effective.invalid":
    "Give the rate as a fraction together with the legal basis; the end of validity cannot precede its start.",
  "ruleDrafts.discard.action": "Discard",
  "ruleDrafts.discard.title": "Discard draft",
  "ruleDrafts.discard.reason": "Reason (at least 10 characters)",
  "ruleDrafts.openProposal": "Open proposal",
  "ruleDrafts.propose.action": "Propose rules ({count})",
  "ruleDrafts.propose.title": "Propose rules from certified facts",
  "ruleDrafts.propose.body":
    "Creates one proposal draft per NCM × CEST × route for the {count} drift rows, in draft {version} ({policy}). ST and original MVA come from the fact; the interstate rate follows Senate Res. 22/89; the internal rate comes only from a VERIFIED fact, otherwise it stays blank and flagged.",
  "ruleDrafts.propose.evidence":
    "IOB findings are not evidence. Each draft lists the official acts to attach (Conv. ICMS 142/18, the segment agreement or protocol, the destination state's RICMS) and cannot be submitted without approved evidence.",
  "ruleDrafts.propose.idempotent":
    "Running again never duplicates: each fact is drafted once per version. Up to 200 facts per run.",
  "ruleDrafts.propose.noDraft":
    "There is no draft ruleset. Prepare the next draft in Publications before proposing.",
  "ruleDrafts.propose.goPublications": "Go to Publications",
  "ruleDrafts.propose.confirm": "Create drafts",
  "ruleDrafts.propose.result":
    "{created} drafts created · {existing} facts already drafted · {skipped} skipped.",
  "ruleDrafts.propose.open": "Open drafts in {version}",
  "ruleDrafts.adoption.selectHint": "Select at least one rule.",
  "evidenceViewer.title": "Evidence",
  "evidenceViewer.untitled": "Untitled document",
  "evidenceViewer.captured": "captured {time}",
  "evidenceViewer.official": "Official source · {source}",
  "evidenceViewer.notOfficial": "Not on the source list",
  "evidenceViewer.historical": "Historical capture",
  "evidenceViewer.openDocument": "Open document",
  "evidenceViewer.openEvidence": "View preserved document",
  "evidenceViewer.locator": "Locator",
  "evidenceViewer.locatorRange": "characters {start}–{end} of the preserved text",
  "evidenceViewer.noLocator": "No locator",
  "evidenceViewer.noLocatorHint":
    "The quote is not anchored in the document: check the row in the original before deciding.",
  "evidenceViewer.noQuote": "No verbatim quote for this fact.",
  "evidenceViewer.expand": "Show more context",
  "evidenceViewer.notFound":
    "The quote is not in the preserved text at this position. Treat it as a discrepancy.",
  "evidenceViewer.unavailable.forbidden":
    "The preserved text needs document read access; the quote shown is the one recorded at extraction.",
  "evidenceViewer.unavailable.missing":
    "Preserved document unavailable; the quote shown is the one recorded at extraction.",
  "evidenceViewer.unavailable.error": "The preserved document could not be read right now.",
  "evidenceViewer.folded": "Found with normalized whitespace (line breaks in the document).",
  "evidenceViewer.hashDiffers":
    "The text read has a different hash than the extraction: a newer version exists.",
  "evidenceViewer.checks": "Extractor checks: {checks}",
  "evidenceViewer.linkedFields": "Fields linked to the quote",
  "evidenceViewer.inQuote": "in the quote",
  "evidenceViewer.notInQuote": "not found in the quote",
  "factReview.view.label": "Group by",
  "factReview.view.document": "Document / annex",
  "factReview.view.segment": "Segment × UF",
  "factReview.view.facts": "Individual facts",
  "factReview.key.inferred": "inferred validity (no stated start)",
  "factReview.key.segment": "Segment {segment}",
  "factReview.key.segmentNamed": "Seg. {segment} · {name}",
  "factReview.key.segmentUf": "{segment} → {uf}",
  "factReview.filter.search": "Search",
  "factReview.filter.searchPlaceholder": "E.g. Annex 1, 17.031.00, sefaz.ba",
  "factReview.filter.uf": "Destination UF",
  "factReview.filter.segment": "Segment",
  "factReview.filter.all": "All",
  "factReview.filter.scope": "Origin scope",
  "factReview.filter.scope.ALL_ORIGINS": "All origins",
  "factReview.filter.scope.ORIGINS": "Listed origins",
  "factReview.filter.scope.INTERNAL_ONLY": "Internal only",
  "factReview.filter.validity": "Validity",
  "factReview.filter.validity.STATED": "Stated start",
  "factReview.filter.validity.INFERRED": "Inferred start",
  "factReview.filter.exceptions": "Exceptions and signals",
  "factReview.filter.exceptions.WITH": "With exceptions or signals",
  "factReview.filter.exceptions.WITHOUT": "Without exceptions or signals",
  "factReview.filter.desk.all": "All facts",
  "factReview.filter.desk.sample": "Sample",
  "factReview.filter.desk.pending": "To inspect",
  "factReview.filter.desk.exceptions": "Exceptions",
  "factReview.filter.desk.flagged": "With signals",
  "factReview.sort.label": "Sort by",
  "factReview.sort.IMPACT": "Impact (occurrences, then reach) ↓",
  "factReview.sort.AGE": "Oldest first",
  "factReview.sort.SIZE": "Most facts first",
  "factReview.empty.title": "No unverified facts to group",
  "factReview.empty.body":
    "When web research extracts annex rows, the facts appear here grouped by document.",
  "factReview.empty.filtered": "No group matches these filters",
  "factReview.summary": "{groups} · {facts}",
  "factReview.groups.one": "{count} group",
  "factReview.groups.other": "{count} groups",
  "factReview.pendingFacts.one": "{count} pending fact",
  "factReview.pendingFacts.other": "{count} pending facts",
  "factReview.documents.one": "{count} document",
  "factReview.documents.other": "{count} documents",
  "factReview.flagged.one": "{count} flagged",
  "factReview.flagged.other": "{count} flagged",
  "factReview.factsCount.one": "{count} fact",
  "factReview.factsCount.other": "{count} facts",
  "factReview.resume": "Resume review",
  "factReview.caption": "Groups of unverified facts",
  "factReview.col.group": "Document / group",
  "factReview.col.facts": "Facts",
  "factReview.col.reviewed": "Reviewed",
  "factReview.col.exceptions": "Exceptions",
  "factReview.col.impact": "Impact · reach",
  "factReview.col.action": "Action",
  "factReview.reach": "{ncms} NCM × {routes} origins",
  "factReview.reach.oneOrigin": "{ncms} NCM × 1 origin",
  "factReview.reach.none": "No catalog NCM",
  "factReview.reach.hint": "no open gaps",
  "factReview.reach.title":
    "No calculation has asked for these facts yet (0 open gaps). Reach: active catalog NCMs the group covers × origin UFs it applies to.",
  "factReview.impact.gaps.one": "{count} open gap",
  "factReview.impact.gaps.other": "{count} open gaps",
  "factReview.signals.title": "Group signals",
  "factReview.signals.hint":
    "Every fact shares these: you acknowledge them once when confirming, not fact by fact.",
  "factReview.signal.INFERRED_VALIDITY": "Inferred validity across the document",
  "factReview.signal.ORIGIN_SCOPE": "Same origin scope: {scope}",
  "factReview.signal.ack.INFERRED_VALIDITY":
    "Inferred validity: the document states no start; the capture/publication date is used as the start — I confirm.",
  "factReview.signal.ack.ORIGIN_SCOPE":
    "Origin scope: the decision applies to {scope} for the whole group — I confirm.",
  "factReview.decision.signals": "Group properties (acknowledge once)",
  "factReview.blocker.SIGNALS": "Acknowledge the group properties above.",
  "factReview.bar.complete": "Sample complete, no discrepancies",
  "factReview.bar.confirmGroup": "Confirm group · {count} facts",
  "factReview.state.IN_REVIEW": "In review",
  "factReview.state.REVIEW_REQUIRED": "Review required",
  "factReview.age": "extracted {time}",
  "factReview.ofTotal": "of {total}",
  "factReview.conflicting": "{count} in conflict",
  "factReview.review": "Review",
  "factReview.continue": "Continue",
  "factReview.footnote":
    "Counts cover every pending fact in the filter, not just this page. Selecting this page does not select every result.",
  "factReview.back": "Groups",
  "factReview.backToFacts": "Facts",
  "factReview.facts": "Facts in the group",
  "factReview.method.label": "Review method",
  "factReview.method.FULL": "Full review",
  "factReview.method.SAMPLE": "Sampling",
  "factReview.method.sampleDocumentOnly": "Sampling only applies to a document/annex group.",
  "factReview.shortcuts.open": "Shortcuts",
  "factReview.shortcuts.title": "Review desk shortcuts",
  "factReview.shortcuts.walk": "Next / previous fact",
  "factReview.shortcuts.agree": "Agrees with the evidence, next",
  "factReview.shortcuts.evidence": "Move focus to the evidence",
  "factReview.shortcuts.exception": "Mark an exception or discrepancy",
  "factReview.shortcuts.decision": "Open the decision review (does not confirm)",
  "factReview.shortcuts.escape": "Close the top surface or return to groups",
  "factReview.shortcuts.help": "Show this list",
  "factReview.shortcuts.scope": "Shortcuts work only on this desk and never inside text fields.",
  "factReview.shortcuts.toggle": "Keyboard shortcuts on",
  "factReview.nav.label": "Group summary",
  "factReview.nav.facts": "Facts",
  "factReview.nav.inspected": "Reviewed",
  "factReview.nav.exceptions": "Exceptions",
  "factReview.nav.progress": "{done} of {total} to inspect",
  "factReview.nav.show": "Show",
  "factReview.sample.title": "Reviewer sample",
  "factReview.sample.size": "{size} of {population} facts",
  "factReview.sample.mandatory": "Mandatory (flagged)",
  "factReview.sample.representatives": "Representatives",
  "factReview.sample.random": "Reproducible random",
  "factReview.sample.policy": "Policy {policy} · seed",
  "factReview.sample.expansions.one": "expanded {count} time",
  "factReview.sample.expansions.other": "expanded {count} times",
  "factReview.sample.expand": "Expand sample",
  "factReview.sample.full": "Switch to full review",
  "factReview.sample.startFirst": "Inspect a fact to start the session.",
  "factReview.sample.how": "How the sample is chosen",
  "factReview.sample.rule.mandatory":
    "Facts with a flag of their own are always included: failed or escalated checks, no locator, a discrepancy, a changed document or an IOB mismatch. What the whole group shares (inferred validity, one origin scope) is acknowledged once when confirming.",
  "factReview.sample.rule.representatives":
    "One fixed representative per field shape and origin scope and per NCM chapter, covering CEST/NCM variants.",
  "factReview.sample.rule.random":
    "The rest comes from a draw seeded by the group and its manifest: 15% of the group (10 to 60 facts); groups of up to 10 facts are reviewed whole.",
  "factReview.sample.rule.discrepancy":
    "A discrepancy moves the group to “Review required” and expands the sample; with two, only a full review can confirm.",
  "factReview.sample.rule.exceptions":
    "Exceptions stay out of the decision and are decided one by one in the fact queue.",
  "factReview.sample.notCertification":
    "Sampling is a reviewer policy, not automatic certification: included facts become Verified and are recorded as “included by sampling”.",
  "factReview.sample.required":
    "Review required: {count} discrepancy(ies). The sample was expanded; facts with a discrepancy will be decided individually.",
  "factReview.sample.closed":
    "Sampling is closed for this group: too many discrepancies. Switch to a full review to confirm.",
  "factReview.iob.title": "IOB corroboration",
  "factReview.iob.match": "Matches IOB",
  "factReview.iob.mismatch": "Differs from IOB",
  "factReview.iob.none": "No IOB result",
  "factReview.iob.never":
    "IOB never confirms a fact: its certified result is shown next to the sample for the reviewer to decide.",
  "factReview.iob.request": "Request IOB corroboration",
  "factReview.iob.reason.NO_NCM": "No catalog NCM to look up in this sample.",
  "factReview.iob.reason.INTERNAL_ONLY":
    "Internal-only operations have no interstate route for IOB.",
  "factReview.iob.reason.NOT_ST": "IOB only checks ST by NCM × route.",
  "factReview.iob.state.MATCH": "Certified IOB matches",
  "factReview.iob.state.MISMATCH": "Certified IOB differs",
  "factReview.iob.dialog": "Request IOB agent corroboration",
  "factReview.iob.body":
    "Queues LIST lookups for {ncms} sample NCM(s) on routes {routes}, at the end of the agent queue. Recent results are reused.",
  "factReview.iob.enqueue": "Queue {count} task(s)",
  "factReview.iob.done": "{count} task(s) queued. Follow them in IOB agent → Queue.",
  "factReview.iob.partial": "{count} task(s) queued; others failed. Try again.",
  "factReview.iob.taskName": "Corroboration · seg. {segment} · {route}",
  "factReview.session.started": "Session by {who} since {time}",
  "factReview.session.abandon": "Abandon session",
  "factReview.list.empty": "No fact in this filter.",
  "factReview.list.count": "{shown} of {total} facts",
  "factReview.mark.AGREES": "Agrees",
  "factReview.mark.DISCREPANCY": "Discrepancy",
  "factReview.mark.EXCEPTION": "Exception",
  "factReview.mark.PENDING": "To inspect",
  "factReview.mark.sampled": "in the sample",
  "factReview.flag.CHECKS_FAILED": "Failed or escalated extractor check",
  "factReview.flag.INFERRED_VALIDITY": "Inferred validity (no stated start)",
  "factReview.flag.MISSING_LOCATOR": "No locator in the document",
  "factReview.flag.DISCREPANCY": "Conflict or pending revalidation",
  "factReview.flag.DOCUMENT_CHANGED": "A newer version of the document exists",
  "factReview.flag.IOB_MISMATCH": "Certified IOB differs from this value",
  "factReview.field.validFrom": "Valid from",
  "factReview.field.origin": "Data origin",
  "factReview.undo": "Undo mark",
  "factReview.pane.label": "Show",
  "factReview.pane.fact": "Fact",
  "factReview.pane.evidence": "Evidence",
  "factReview.bar.label": "Decision",
  "factReview.bar.progress": "{done} of {total} reviewed",
  "factReview.bar.progressSample": "{done} of {total} in the sample",
  "factReview.bar.exception": "Mark exception",
  "factReview.bar.skip": "Skip",
  "factReview.bar.agree": "Agrees · next",
  "factReview.bar.review": "Review decision",
  "factReview.bar.reviewReady": "Review decision · {count}",
  "factReview.bar.startFirst": "Inspect a fact to start the session.",
  "factReview.bar.readOnly": "Read only: confirming needs the rule review permission.",
  "factReview.error.changed": "The group changed since it was opened. Reload to continue.",
  "factReview.error.generic": "This action could not be saved. Reload and try again.",
  "factReview.stale":
    "Since the session started: {changed} fact(s) changed, {added} joined and {removed} left the group. Changed ones are skipped on confirm.",
  "factReview.refresh": "Refresh group review",
  "factReview.truncated":
    "The group has more than 500 pending facts: filter by segment or UF to review the rest.",
  "factReview.exception.title": "Exception or discrepancy",
  "factReview.exception.kind": "Mark type",
  "factReview.exception.DISCREPANCY.title": "Discrepancy with the document",
  "factReview.exception.DISCREPANCY.hint":
    "The value does not match the row. The group moves to “Review required” and the sample expands.",
  "factReview.exception.EXCEPTION.title": "Exception (decide individually)",
  "factReview.exception.EXCEPTION.hint":
    "Left out of the group decision, without saying it is wrong.",
  "factReview.exception.presets": "Common reasons",
  "factReview.exception.preset.unreadable": "Row unreadable in the document",
  "factReview.exception.preset.otherSegment": "Item from another segment",
  "factReview.exception.preset.valueDiffers": "Value differs from the document",
  "factReview.exception.preset.validity": "Validity to be confirmed",
  "factReview.exception.note": "What differs (optional)",
  "factReview.exception.noteHint": "Kept in the session history and on the fact.",
  "factReview.exception.reason": "Reason",
  "factReview.exception.reasonHint": "At least {min} characters.",
  "factReview.exception.submit": "Mark exception",
  "factReview.exception.submitDiscrepancy": "Record discrepancy",
  "factReview.decision.title": "Confirm group",
  "factReview.decision.inGroup": "Facts in the manifest",
  "factReview.decision.inspected": "Inspected directly",
  "factReview.decision.sampled": "Included by sampling",
  "factReview.decision.excluded": "Exceptions excluded",
  "factReview.decision.included": "Included in this decision",
  "factReview.decision.list": "See the full list of {count} facts",
  "factReview.decision.stale":
    "{count} fact(s) changed since the session started and will be skipped (partial result).",
  "factReview.decision.blocked": "Not ready to confirm",
  "factReview.decision.note": "Review note",
  "factReview.decision.boundary":
    "This action verifies facts. It does not publish rules or change calculations.",
  "factReview.decision.back": "Back to review",
  "factReview.decision.confirm": "Confirm {count} facts",
  "factReview.decision.problem.changed":
    "The scope changed (sample, exceptions or manifest). Reload the group and review what changed.",
  "factReview.decision.problem.incomplete":
    "Inspections required by the policy are missing. Reload the group.",
  "factReview.decision.problem.error": "Could not confirm right now. Nothing was changed.",
  "factReview.blocker.SESSION_NOT_OPEN": "The session is not open.",
  "factReview.blocker.NOTHING_TO_CONFIRM": "No fact included: all are exceptions.",
  "factReview.blocker.SAMPLE_NOT_ALLOWED": "Segment × UF groups do not accept sampling.",
  "factReview.blocker.TOO_MANY_DISCREPANCIES":
    "Too many discrepancies for sampling: review in full.",
  "factReview.blocker.UNINSPECTED": "{count} fact(s) still to inspect.",
  "factReview.inclusion.INSPECTED": "inspected directly",
  "factReview.inclusion.SAMPLED": "included by sampling",
  "factReview.history.GROUP_REVIEW_INSPECTED": "Group review · inspected directly",
  "factReview.history.GROUP_REVIEW_SAMPLED": "Group review · included by sampling",
  "factReview.result.title": "Group confirmed",
  "factReview.result.summary": "{applied} became Verified. No rule was published.",
  "factReview.result.inspected": "Inspected directly",
  "factReview.result.sampled": "Included by sampling",
  "factReview.result.excluded": "Exceptions (pending)",
  "factReview.result.skipped": "Skipped",
  "factReview.result.exceptionsNext":
    "Exceptions stay unverified: decide each one in the individual fact list.",
  "factReview.result.when": "Confirmed {time}",
  "factReview.scopeChoice.reason.AGREEMENT_SIGNATORIES":
    "The CONFAZ matrix ({agreements}) derives the origins: the {uf} annex covers internal operations and interstate retention applies only to the signatory UFs on the operation date.",
  "factReview.scopeChoice.AGREEMENT_ORIGINS.label":
    "Confirm internal + signatory origins ({count} UFs)",
  "factReview.scopeChoice.AGREEMENT_ORIGINS.hint":
    "Derived from {agreements} on {date}. Adhesions, denúncias and exclusions apply on their dates; origins outside the agreement withhold no ST for {uf} (the destination may charge antecipação).",
  "factReview.scopeChoice.agreementShort":
    "internal operations of {uf} + {count} signatory origins",
  "factReview.scopeChoice.proposedAgreement": "proposed: internal + {count} signatory origins",
  "factReview.scopeChoice.agreementUnverified":
    "The agreement is not verified yet: interstate routes only reach SHADOW once it is confirmed in CONFAZ agreements.",
  "factReview.scopeChoice.partial":
    "{known} of {total} facts have a CEST the agreement covers; the others stay internal only.",
  "factReview.scopeChoice.change.JOINS": "{uf} joins on {date} ({agreement})",
  "factReview.scopeChoice.change.LEAVES": "{uf} leaves on {date} ({agreement})",
  "factReview.result.scopeAgreement":
    "Confirmed for internal operations of {uf} and for the CONFAZ agreement's signatory origins on each date.",
  "verification.scope.verifiedAgreement": "verified: internal {uf} + signatories ({agreements})",
  "verification.tab.agreements": "CONFAZ agreements",
  "stAgreements.hint":
    "Signatories of the ST convênios and protocolos per segment. The interstate origins of annex facts come from them.",
  "stAgreements.counts": "{unverified} to verify · {verified} verified · {total} in the catalog",
  "stAgreements.membersToday": "{count} signatories today",
  "stAgreements.checksFailed": "{count} check(s) to review",
  "stAgreements.status.UNVERIFIED": "Unverified",
  "stAgreements.status.VERIFIED": "Verified",
  "stAgreements.status.REJECTED": "Rejected",
  "stAgreements.status.SUPERSEDED": "Superseded",
  "stAgreements.status.MISSING": "Not read",
  "stAgreements.missing.title": "Agreement not read yet",
  "stAgreements.missing.body":
    "Run a CONFAZ agreements research in Administration → Web research → New research to read the official page.",
  "stAgreements.action.CONFIRM": "Confirm agreement",
  "stAgreements.action.REJECT": "Reject",
  "stAgreements.meta.segments": "Segments (Conv. 142/18)",
  "stAgreements.meta.validity": "Validity",
  "stAgreements.meta.published": "Published in the DOU",
  "stAgreements.meta.document": "Document",
  "stAgreements.validity.open": "since {from}",
  "stAgreements.validity.range": "{from} to {to}",
  "stAgreements.checks.title": "Extractor checks to review:",
  "stAgreements.members.title": "Signatories on {date} ({count})",
  "stAgreements.members.none": "No UF bound on this date.",
  "stAgreements.excluded": "Excepted CESTs: {cests}",
  "stAgreements.matrix.title": "Adhesion matrix",
  "stAgreements.matrix.uf": "UF",
  "stAgreements.matrix.from": "From",
  "stAgreements.matrix.to": "To",
  "stAgreements.matrix.how": "Joined → left",
  "stAgreements.matrix.act": "Act",
  "stAgreements.matrix.quote": "Excerpt",
  "stAgreements.matrix.open": "in force",
  "stAgreements.joined.ORIGINAL": "Original signatory",
  "stAgreements.joined.ADHESION": "Adhesion",
  "stAgreements.joined.PLENARY": "Convênio (every UF)",
  "stAgreements.joined.OBSERVED": "Current clause",
  "stAgreements.left.DENUNCIA": "Denúncia",
  "stAgreements.left.EXCLUSAO": "Exclusion",
  "stAgreements.left.REVOGACAO": "Revocation",
  "stAgreements.history": "History",
  "stAgreements.event.DERIVED": "Read from the official page",
  "stAgreements.event.RECHECKED": "Re-read (same version)",
  "stAgreements.event.CONFIRMED": "Confirmed",
  "stAgreements.event.REJECTED": "Rejected",
  "stAgreements.event.SUPERSEDED": "Superseded by a newer version",
  "stAgreements.boundary":
    "Confirming an agreement publishes no rule: it starts deriving the interstate origins of segment facts on each date.",
  "stAgreements.dialog.CONFIRM.title": "Confirm {agreement}",
  "stAgreements.dialog.CONFIRM.body":
    "Check signatories, adhesions, denúncias, exclusions and validity against the preserved official page. The previously verified version of this agreement becomes Superseded.",
  "stAgreements.dialog.REJECT.title": "Reject {agreement}",
  "stAgreements.dialog.REJECT.body":
    "The agreement leaves the matrix; segment facts apply to internal operations only until another version is verified.",
  "stAgreements.retire.open": "Retire misidentified readings ({count})",
  "stAgreements.retire.title": "Retire misidentified readings",
  "stAgreements.retire.body":
    "These unverified observations were stored under a number their own page does not state (a listing line read as the header). They will be rejected with the reason below, and the audit log keeps the record. Verified and seeded agreements are not changed.",
  "stAgreements.retire.none": "No misidentified readings.",
  "stAgreements.retire.readFor": "page read for {agreement}",
  "stAgreements.retire.urlOnly": "no header, named only by its address",
  "stAgreements.retire.submit": "Reject ({count})",
  "stAgreements.dialog.changed": "The agreement changed since you opened it: reload.",
  "stAgreements.dialog.error": "Could not record it now. Nothing changed.",
  "webResearch.scope.CONFAZ_AGREEMENTS": "CONFAZ agreements (signatories)",
  "webResearch.scope.CONFAZ_AGREEMENTS.body":
    "Reads the official page of each ST convênio/protocolo in the reviewed catalog (signatories, adhesions, denúncias, validity) for the origin matrix.",
  "webResearch.scope.CONFAZ_AGREEMENTS.short": "CONFAZ agreements",
  "webResearch.scope.CONFAZ_AGREEMENTS.segments": "CONFAZ agreements · seg. {segments}",
  "webResearch.scope.CONFAZ_AGREEMENTS.route": "official pages",
  "webResearch.wizard.agreements.segments": "Segments",
  "webResearch.wizard.agreements.all": "All {count} catalog agreements",
  "webResearch.wizard.agreements.some": "{count} agreement(s) in the selected segments",
  "webResearch.wizard.agreements.segment": "Segment {segment}",
  "webResearch.wizard.agreements.locate": "Look for other agreements and amendments",
  "webResearch.wizard.agreements.locateHint":
    "One CONFAZ search per segment (a grounded call): convênio/protocolo pages it finds are read as agreements too.",
  "webResearch.wizard.agreements.noRoutes":
    "CONFAZ agreements use no routes: each official page is downloaded and read once.",
  "verification.scope.verifiedInternal": "verified for internal operations only ({uf}→{uf})",
  "factReview.scopeChoice.title": "Origin scope of the decision",
  "factReview.scopeChoice.reason.AGREEMENTS_UNKNOWN":
    "The signatories of this segment's CONFAZ convênio or protocolo are not verified yet. The {uf} annex covers internal operations; interstate retention only exists when the origin UF signed the agreement.",
  "factReview.scopeChoice.default": "suggested",
  "factReview.scopeChoice.INTERNAL_ONLY.label": "Confirm internal operations only ({uf}→{uf})",
  "factReview.scopeChoice.INTERNAL_ONLY.hint":
    "Interstate routes into {uf} stay unverified, waiting for the IOB and the CONFAZ signatory matrix.",
  "factReview.scopeChoice.AS_EXTRACTED.label": "Confirm as extracted: {scope}",
  "factReview.scopeChoice.AS_EXTRACTED.hint": "Applies to the origins the annex lists.",
  "factReview.scopeChoice.AS_EXTRACTED.hintAll":
    "Only if the document proves retention from every UF: without a CONFAZ agreement the origin UF does not withhold ICMS-ST for {uf}.",
  "factReview.scopeChoice.allUfs": "{count} origin UFs",
  "factReview.scopeChoice.origins": "Covered origin UFs",
  "factReview.scopeChoice.internalShort": "internal operations ({uf}→{uf})",
  "factReview.scopeChoice.proposedInternal": "proposed: internal only ({uf}→{uf})",
  "factReview.result.scopeInternal":
    "Confirmed for internal operations only ({uf}→{uf}); interstate routes stay unverified.",
  "factReview.result.groups": "Back to groups",
  "factReview.result.next": "Next group",
  "factReview.skip.STALE_REVISION": "changed since the session started",
  "factReview.skip.NOT_UNVERIFIED": "already {status}",
  "factReview.skip.NOT_FOUND": "not found",
  "scopeFix.scope.INTERNAL_ONLY": "Internal operations only ({uf}→{uf})",
  "scopeFix.scope.AGREEMENT_ORIGINS": "{uf} internal + {count} signatory origins",
  "scopeFix.scope.ORIGINS": "Restricted origins: {ufs}",
  "scopeFix.scope.ALL": "All origins ({count} states)",
  "scopeFix.scope.LISTED": "Origins listed in the document ({count} states): {ufs}",
  "scopeFix.summary.chosen": "Scope to be confirmed",
  "scopeFix.summary.confirmed": "Confirmed scope",
  "scopeFix.summary.internalOnly": "No interstate route becomes Verified: only {uf}→{uf}.",
  "scopeFix.summary.interstate": "{count} interstate origin states become Verified.",
  "scopeFix.summary.wide":
    "Wider than proposed: interstate ST depends on the segment's CONFAZ signatories.",
  "scopeFix.ack.title": "All origins need an explicit acknowledgement",
  "scopeFix.ack.why":
    "The proposal is {proposed}. Interstate ST depends on the segment's CONFAZ signatories: confirm every origin only if the document itself proves retention from each state.",
  "scopeFix.ack.proven": "The document proves retention from every state",
  "scopeFix.ack.justification": "Justification (where the document proves it)",
  "scopeFix.ack.missing": "{count} more characters",
  "scopeFix.ack.ok": "Recorded in the audit trail and the result.",
  "scopeFix.ack.recorded": "All-origins justification:",
  "scopeFix.action.group": "Correct scope",
  "scopeFix.action.fact": "Restrict origin scope",
  "scopeFix.dialog.title": "Restrict origin scope",
  "scopeFix.dialog.current": "Covers today",
  "scopeFix.dialog.to": "Restrict to",
  "scopeFix.dialog.internalHint":
    "Interstate routes to {uf} go back to unverified (left to the IOB and the CONFAZ matrix).",
  "scopeFix.dialog.listLabel": "Only these origin states",
  "scopeFix.dialog.listHint":
    "Tick the origins the document proves; the others go back to unverified.",
  "scopeFix.dialog.listProblem": "Keep at least one state and remove at least one.",
  "scopeFix.dialog.reason": "Reason for the correction",
  "scopeFix.dialog.boundary":
    "Creates a new revision of each fact and keeps the whole history. Shadow calculations use the new scope at once. Widening again needs a new review of the group or the fact.",
  "scopeFix.dialog.submit": "Restrict scope",
  "scopeFix.dialog.doneTitle": "Scope corrected",
  "scopeFix.dialog.done": "{restricted} of {facts} facts restricted.",
  "scopeFix.dialog.doneHint":
    "Each fact got a new revision with a “Scope restricted” event; the original confirmation stays in the history.",
  "scopeFix.dialog.correction": "Correction",
  "scopeFix.dialog.replayed": "already applied (replay)",
  "scopeFix.dialog.problem.stale": "The fact changed since it was opened. Reload and try again.",
  "scopeFix.dialog.problem.notAllowed":
    "Nothing to restrict to that scope (already within it, or it would widen).",
  "scopeFix.dialog.problem.error": "The scope could not be corrected. Try again.",
  "scopeFix.skip.NOT_VERIFIED": "no longer verified",
  "scopeFix.skip.NOT_FOUND": "not found",
  "scopeFix.skip.NOT_ST_SEGMENT": "no origin scope",
  "scopeFix.skip.ALREADY_WITHIN": "already within that scope",
  "scopeFix.skip.OUTSIDE_EXTRACTED": "the fact does not state those origins",
  "scopeFix.skip.WIDENS": "would widen the scope (use a new review)",
  "scopeFix.history.hint":
    "Confirmed groups, with the scope they decided and what their facts cover today. Correct a group confirmed with too many origins here.",
  "scopeFix.history.empty": "No confirmed group yet",
  "scopeFix.history.emptyBody": "Groups show up here after “Confirm group”.",
  "scopeFix.history.confirmed": "{who} · {when} · {count} facts",
  "scopeFix.history.decision": "Decision:",
  "scopeFix.history.facts": "{count} facts",
  "scopeFix.history.restricted": "corrected",
  "scopeFix.history.noneVerified": "No fact is still verified.",
  "scopeFix.history.wide":
    "Covers interstate origins without a verified CONFAZ agreement: review the scope.",
  "scopeFix.history.correction": "{scope} · {who} · {when} · {count} facts",
  "scopeFix.history.first": "Newest",
  "scopeFix.history.more": "Older",
  "scopeFix.decision.AS_EXTRACTED": "As extracted",
  "scopeFix.decision.INTERNAL_ONLY": "Internal operations only",
  "scopeFix.decision.AGREEMENT_ORIGINS": "Internal + signatory origins",
  "scopeFix.event.restricted": "Verified scope now: {ufs}",
  "factReview.blocker.ALL_ORIGINS":
    "Confirm the document proves retention from every state and justify it.",
  "verification.tab.confirmed": "Confirmed groups",
  "verification.event.SCOPE_RESTRICTED": "Scope restricted",
  "verification.scope.verifiedOrigins": "verified for these origins only: {ufs}",
  "audit.scope.title": "Origin scope",
  "audit.scope.decision": "Decided scope",
  "audit.scope.proposed": "Proposed scope",
  "audit.scope.restriction": "Restricted to",
  "audit.scope.previous": "Covered before",
  "audit.scope.origins": "Covered origin states",
  "audit.scope.acknowledged": "All origins: justification",
  "audit.scope.allUfs": "all {count} states",
  "audit.action.fiscal-fact.confirm": "Fiscal fact confirmed",
  "audit.action.fiscal-fact.scope-restricted": "Fact origin scope restricted",
  "audit.action.fiscal-fact-review.confirmed": "Fact group confirmed",
  "audit.action.fiscal-fact-review.scope-restricted": "Confirmed group scope corrected",
  "audit.resource.fiscal_fact_review_session": "Group review",
  "verification.tab.nfe": "Invoices (NF-e)",
  "ruleDrafts.origin.NFE_OBSERVATION": "NF-e observation",
  "ruleDrafts.flag.NFE_CORROBORATION_ONLY":
    "NF-e only corroborates: not a legal source; rates blank until the official act",
  "ruleDrafts.corroboration":
    "NF-e corroboration: {invoices} invoices, {items} items, CFOP {cfop} ({status}). Not a legal source.",
  "nfe.boundary":
    "Invoices corroborate how real suppliers taxed real operations. They are not a legal source: nothing here certifies a fact, changes or publishes a rule. The comparison with the platform is read-only.",
  "nfe.privacy":
    "Privacy: the raw XML, names, addresses, e-mails and phones are not stored. Only the fiscal fields, the access key and the issuer CNPJ are kept.",
  "nfe.upload.title": "Upload invoices",
  "nfe.upload.hint":
    "Authorised NF-e XML (layout 4.00), one by one or inside a .zip with thousands of invoices. Cancellation events (procEventoNFe 110111) may travel in the same upload; cancelled invoices and Omie XML_Invertido copies never reach the paths.",
  "nfe.upload.drop": "Drag .xml or .zip files here",
  "nfe.upload.dropActive": "Drop to add",
  "nfe.upload.limits":
    "XML up to {xml} each · a .zip up to {zip} goes in one request; a bigger one is unpacked in this browser and sent in parts · loose XML in requests of up to {files} files and {chunk}.",
  "nfe.upload.unpacking": "Reading {name}…",
  "nfe.upload.unpackFailed": "{name} could not be read in the browser: {reason}",
  "nfe.upload.pick": "Choose files",
  "nfe.upload.addMore": "Add more",
  "nfe.upload.selected": "{count} files selected",
  "nfe.upload.ready.one": "{count} file ready",
  "nfe.upload.ready.other": "{count} files ready",
  "nfe.upload.readyDetail": "· {xml} XML, {zip} ZIP · {size} · {requests} requests",
  "nfe.upload.rejected.one": "{count} file will not be sent:",
  "nfe.upload.rejected.other": "{count} files will not be sent:",
  "nfe.upload.reject.EXTENSION": "only .xml or .zip",
  "nfe.upload.reject.EMPTY": "empty file",
  "nfe.upload.reject.XML_TOO_LARGE": "XML over 3 MB",
  "nfe.upload.reject.ZIP_TOO_LARGE":
    "zip over 8 MB and this browser cannot unpack it: split it into smaller files",
  "nfe.upload.more": "and {count} more",
  "nfe.upload.send.one": "Send {count} file",
  "nfe.upload.send.other": "Send {count} files",
  "nfe.upload.clear": "Clear selection",
  "nfe.upload.progress": "Request {done} of {total}",
  "nfe.upload.progressFiles": "{done} of {total} files processed",
  "nfe.upload.progressLabel": "Invoice upload progress",
  "nfe.upload.cancel": "Stop after the current request",
  "nfe.upload.cancelled":
    "Upload stopped. Completed requests were imported; the rest can be resumed.",
  "nfe.upload.failedRequests.one": "{count} request failed.",
  "nfe.upload.failedRequests.other": "{count} requests failed.",
  "nfe.upload.retry.one": "Resume {count} request",
  "nfe.upload.retry.other": "Resume {count} requests",
  "nfe.upload.openBatch": "Open batch",
  "nfe.upload.again": "New upload",
  "nfe.upload.toast": "{imported} of {total} invoices imported",
  "nfe.outcome.IMPORTED": "Imported",
  "nfe.outcome.IMPORTED.plural": "Imported",
  "nfe.outcome.DUPLICATE": "Duplicate",
  "nfe.outcome.DUPLICATE.plural": "Duplicates",
  "nfe.outcome.INVALID": "Invalid",
  "nfe.outcome.INVALID.plural": "Invalid",
  "nfe.outcome.SKIPPED": "Skipped",
  "nfe.outcome.SKIPPED.plural": "Skipped",
  "nfe.outcome.CANCELLED": "Cancelled",
  "nfe.outcome.CANCELLED.plural": "Cancelled",
  "nfe.tally.items": "Items",
  "nfe.tally.paths": "Paths touched",
  "nfe.files.file": "File",
  "nfe.files.inside": "in {container}",
  "nfe.files.outcome": "Outcome",
  "nfe.files.reason": "Reason",
  "nfe.files.accessKey": "Access key",
  "nfe.files.items": "Items",
  "nfe.files.filter": "Filter by outcome",
  "nfe.files.all": "All",
  "nfe.files.none": "No file with this outcome.",
  "nfe.files.caption": "Result per file",
  "nfe.files.showMore": "Show more ({shown} of {total})",
  "nfe.reason.ALREADY_IMPORTED": "Access key already imported",
  "nfe.reason.REPEATED_IN_UPLOAD": "Repeated in this upload",
  "nfe.reason.REPLACED_INVERTED_COPY": "Original replaced an inverted ERP copy stored earlier",
  "nfe.reason.PROTOCOL_CANCELLED": "Cancelled: the protocol says so (cStat 101/135/155)",
  "nfe.reason.CANCELLATION_EVENT":
    "Cancellation event (110111); the invoice is left out of the paths",
  "nfe.reason.NOT_NFE_DOCUMENT": "Not an NF-e (CT-e, MDF-e or inutilização)",
  "nfe.reason.EVENT_IGNORED": "NF-e event other than cancellation",
  "nfe.reason.INVERTED_ERP_COPY":
    "Inverted ERP copy (Omie XML_Invertido), not the authorised invoice",
  "nfe.reason.NOT_XML": "Not XML (e.g. a DANFE PDF)",
  "nfe.reason.DIRECTORY": "Folder inside the zip",
  "nfe.reason.SYSTEM_FILE": "System file (e.g. __MACOSX)",
  "nfe.reason.NESTED_ZIP": "Zip inside a zip is not opened",
  "nfe.reason.FOREIGN_OPERATION": "Foreign-trade operation (idDest 3)",
  "nfe.reason.FILE_TOO_LARGE": "File too large",
  "nfe.reason.ZIP_INVALID": "Unreadable zip",
  "nfe.reason.ZIP_TOO_MANY_ENTRIES": "Zip has too many entries",
  "nfe.reason.ZIP_TOO_LARGE": "Zip expands beyond the limit",
  "nfe.reason.ZIP_ENTRY_UNSAFE_PATH": "Unsafe path inside the zip",
  "nfe.reason.ZIP_ENTRY_ENCRYPTED": "Password-protected entry",
  "nfe.reason.ZIP_ENTRY_UNSUPPORTED": "Unsupported compression",
  "nfe.reason.ZIP_ENTRY_TOO_LARGE": "XML too large inside the zip",
  "nfe.reason.ZIP_ENTRY_RATIO": "Suspicious compression ratio",
  "nfe.reason.ZIP_ENTRY_CORRUPT": "Corrupt entry",
  "nfe.reason.TOO_MANY_DOCUMENTS": "Too many documents in this request",
  "nfe.reason.XML_MALFORMED": "Malformed XML",
  "nfe.reason.XML_DTD_FORBIDDEN": "XML with a DTD is not accepted",
  "nfe.reason.NOT_NFE": "Not an NF-e",
  "nfe.reason.UNSUPPORTED_VERSION": "Layout other than 4.00",
  "nfe.reason.UNSUPPORTED_MODEL": "Model other than 55",
  "nfe.reason.INVALID_ACCESS_KEY": "Invalid access key (check digit)",
  "nfe.reason.ACCESS_KEY_MISMATCH": "Access key does not match the invoice data",
  "nfe.reason.NOT_AUTHORIZED": "No authorisation protocol",
  "nfe.reason.HOMOLOGATION": "Homologation (test) invoice",
  "nfe.reason.MISSING_FIELD": "Required field missing",
  "nfe.reason.INVALID_FIELD": "Field with an invalid value",
  "nfe.reason.TOO_MANY_ITEMS": "More than 990 items",
  "nfe.batches.title": "Import batches",
  "nfe.batches.empty": "No batches yet. Uploads appear here with each file's result.",
  "nfe.batch.status.COMPLETED": "Completed",
  "nfe.batch.status.COMPLETED_WITH_ERRORS": "With invalid files",
  "nfe.batch.files.one": "{count} file",
  "nfe.batch.files.other": "{count} files",
  "nfe.batch.entries.one": "{count} document",
  "nfe.batch.entries.other": "{count} documents",
  "nfe.batch.byYou": "by you",
  "nfe.batch.by": "by operator {id}",
  "nfe.batch.result": "{items} items · {paths} paths",
  "nfe.batch.title": "Batch of {when}",
  "nfe.paths.title": "Observed tax paths",
  "nfe.paths.hint":
    "Items sharing route, NCM, CFOP, operation and treatment form one path, compared with the published rule, CERTIFIED/VERIFIED facts and IOB.",
  "nfe.paths.count.one": "{count} path",
  "nfe.paths.count.other": "{count} paths",
  "nfe.paths.truncated":
    "More paths matched than one comparison reads. Narrow by UF or NCM to see them all.",
  "nfe.paths.empty.title": "No invoices imported yet",
  "nfe.paths.empty.body":
    "Upload NF-e XML or a .zip above. Each item becomes corroborating evidence, never a rule.",
  "nfe.paths.empty.readOnly": "Observed paths appear here once invoices are imported.",
  "nfe.column.route": "Route",
  "nfe.column.operation": "Operation",
  "nfe.column.treatment": "Treatment",
  "nfe.column.invoices": "Invoices",
  "nfe.column.items": "Items",
  "nfe.column.emitters": "Issuers",
  "nfe.column.period": "Period",
  "nfe.column.status": "Comparison",
  "nfe.column.inconsistent.one": "{count} item with inconsistent values",
  "nfe.column.inconsistent.other": "{count} items with inconsistent values",
  "nfe.status.MATCHES": "Matches",
  "nfe.status.DIVERGES": "Diverges",
  "nfe.status.NOT_COVERED": "Not covered",
  "nfe.scope.INTERNAL": "Internal",
  "nfe.scope.INTERSTATE": "Interstate",
  "nfe.recipient.CONTRIBUTOR": "Taxpayer",
  "nfe.recipient.EXEMPT_CONTRIBUTOR": "Exempt taxpayer",
  "nfe.recipient.NON_CONTRIBUTOR": "Non-taxpayer",
  "nfe.operation.finalConsumer": "final consumer",
  "nfe.operation.entry": "inbound",
  "nfe.operation.fin.1": "normal",
  "nfe.operation.fin.2": "complementary",
  "nfe.operation.fin.3": "adjustment",
  "nfe.operation.fin.4": "return",
  "nfe.filter.origin": "Origin UF",
  "nfe.filter.destination": "Destination UF",
  "nfe.filter.anyUf": "Any",
  "nfe.filter.ncm": "NCM (prefix)",
  "nfe.filter.ncmPlaceholder": "E.g. 2202",
  "nfe.filter.ncmHint": "Use 2 to 8 digits.",
  "nfe.filter.status": "Comparison",
  "nfe.treatment.title": "Observed treatment",
  "nfe.treatment.reduced": "reduced base {rate}",
  "nfe.treatment.st": "ST",
  "nfe.treatment.retained": "ST previously retained",
  "nfe.treatment.difal": "DIFAL",
  "nfe.treatment.group": "Group",
  "nfe.treatment.orig": "Origin",
  "nfe.treatment.stTitle": "ICMS-ST",
  "nfe.treatment.notStated": "Not stated on the invoices.",
  "nfe.treatment.ibsNote":
    "IBS/CBS are shown as stated on the invoice; observed only, never compared.",
  "nfe.orig.0": "domestic",
  "nfe.orig.1": "foreign, direct import",
  "nfe.orig.2": "foreign, bought domestically",
  "nfe.orig.3": "domestic, imported content > 40%",
  "nfe.orig.4": "domestic, basic production process",
  "nfe.orig.5": "domestic, imported content ≤ 40%",
  "nfe.orig.6": "foreign without similar (CAMEX), direct",
  "nfe.orig.7": "foreign without similar (CAMEX), domestic",
  "nfe.orig.8": "domestic, imported content > 70%",
  "nfe.volume.title": "Observed volume",
  "nfe.value.yes": "Yes",
  "nfe.value.no": "No",
  "nfe.detail.boundary":
    "Read-only comparison. Invoices corroborate; they do not replace legal evidence or change the rule.",
  "nfe.compare.title": "Expected × observed",
  "nfe.compare.field": "Field",
  "nfe.compare.expected": "Platform expects",
  "nfe.compare.observed": "Observed on invoices",
  "nfe.compare.result": "Result",
  "nfe.compare.state.diverges": "diverges",
  "nfe.compare.state.matches": "matches",
  "nfe.compare.state.skipped": "not compared",
  "nfe.compare.notStated": "Not stated",
  "nfe.compare.notComparable": "Not comparable",
  "nfe.compare.adjusted": "Original MVA {original} · adjusted {adjusted}",
  "nfe.compare.rule": "Published rule",
  "nfe.compare.noRule": "No published rule covers this route",
  "nfe.compare.factLevel": "Fact level",
  "nfe.compare.facts.one": "{count} fact",
  "nfe.compare.facts.other": "{count} facts",
  "nfe.compare.comparedOn": "Compared with the state on",
  "nfe.factLevel.PUBLISHED_RULE": "Published rule",
  "nfe.factLevel.CERTIFIED": "Certified",
  "nfe.factLevel.VERIFIED": "Verified",
  "nfe.factLevel.UNVERIFIED": "Unverified (not used)",
  "nfe.factLevel.NONE": "No fact",
  "nfe.source.PUBLISHED_RULE": "Published rule",
  "nfe.source.FISCAL_FACT": "Fiscal fact",
  "nfe.source.FISCAL_FACT.CERTIFIED": "Certified fact",
  "nfe.source.FISCAL_FACT.VERIFIED": "Verified fact",
  "nfe.source.IOB_FINDING": "IOB",
  "nfe.source.SENATE_RESOLUTION_13_2012": "Senate Res. 13/2012",
  "nfe.field.stApplicable": "ST",
  "nfe.field.mva": "MVA",
  "nfe.field.destinationInternalRate": "Destination internal rate",
  "nfe.field.interstateRate": "Interstate rate",
  "nfe.field.fcpRate": "FCP",
  "nfe.stMode.RETAINED": "retained by the sender",
  "nfe.stMode.PREVIOUSLY_RETAINED": "previously retained",
  "nfe.stMode.NONE": "no ST",
  "nfe.note.ST_PREVIOUSLY_RETAINED":
    "CST 60 / CSOSN 500: ST was retained earlier; ST yes/no is not compared on interstate operations.",
  "nfe.note.FINAL_CONSUMER":
    "Final consumer: ST and MVA are not compared (ST concerns the resale chain).",
  "nfe.note.ST_BASE_NOT_MVA": "The ST base is not an MVA (price list, pauta): MVA not compared.",
  "nfe.note.SIMPLES_NACIONAL":
    "Simples Nacional (CSOSN): the own ICMS rate is not stated on the item.",
  "nfe.note.IMPORTED_GOODS":
    "Origin 1, 2, 3 or 8: the 4% interstate rate applies (Senate Res. 13/2012).",
  "nfe.note.INTERNAL_ST_ONLY": "IOB answered internal ST only: no retention by the sender.",
  "nfe.note.ADJUSTED_MVA": "The observed MVA matches the adjusted MVA, not the original one.",
  "nfe.note.RULE_FACT_DISAGREE":
    "The published rule and certified facts disagree; the rule was used.",
  "nfe.note.NOT_ORDINARY_SALE":
    "Inbound, complementary, adjustment or return: not an ordinary sale.",
  "nfe.note.REDUCED_BASE": "Reduced base (pRedBC / pRedBCST): nominal rates are compared.",
  "nfe.note.INCONSISTENT_ITEMS": "Some items failed the internal value checks.",
  "nfe.note.FACTS_UNRESOLVED": "Certified facts are ambiguous or conflicting for this key.",
  "nfe.consistency.title": "Item consistency",
  "nfe.consistency.body.one":
    "{count} of {items} items has a value other than base × rate beyond rounding.",
  "nfe.consistency.body.other":
    "{count} of {items} items have a value other than base × rate beyond rounding.",
  "nfe.consistency.sample": "Sample of inconsistent items",
  "nfe.consistency.item": "Item no.",
  "nfe.consistency.issues": "Checks",
  "nfe.issue.ICMS_VALUE_MISMATCH": "vICMS ≠ base × pICMS",
  "nfe.issue.FCP_VALUE_MISMATCH": "vFCP ≠ base × pFCP",
  "nfe.issue.ICMS_ST_BASE_MISMATCH": "ST base does not match the MVA",
  "nfe.issue.ICMS_ST_VALUE_MISMATCH": "vICMSST does not match",
  "nfe.issue.FCP_ST_VALUE_MISMATCH": "vFCPST does not match",
  "nfe.issue.ST_RETAINED_VALUE_MISMATCH": "Retained ST (vICMSSTRet) does not match",
  "nfe.issue.DIFAL_VALUE_MISMATCH": "DIFAL (vICMSUFDest) does not match",
  "nfe.issue.IPI_VALUE_MISMATCH": "vIPI ≠ base × pIPI",
  "nfe.issue.PIS_VALUE_MISMATCH": "vPIS ≠ base × rate",
  "nfe.issue.COFINS_VALUE_MISMATCH": "vCOFINS ≠ base × rate",
  "nfe.issue.IBS_CBS_VALUE_MISMATCH": "IBS/CBS ≠ base × rate",
  "nfe.invoices.title": "Sample invoices {count}",
  "nfe.invoices.hint": "Newest first. Access key, issue date and issuer CNPJ only.",
  "nfe.invoices.none": "No sample invoices.",
  "nfe.invoices.issuedAt": "Issued",
  "nfe.invoices.emitter": "Issuer CNPJ",
  "nfe.invoices.cpf": "Individual issuer (not stored)",
  "nfe.drafts.title": "Drafts created from this path",
  "nfe.drafts.none": "No draft yet.",
  "nfe.drafts.open": "Open in the draft ruleset",
  "nfe.drafts.publications": "See Publications",
  "nfe.draft.action": "Create proposal draft",
  "nfe.draft.title": "Create a proposal draft from the invoices",
  "nfe.draft.volume": "{invoices} invoices · {items} items",
  "nfe.draft.body":
    "Prepares a draft in the next draft ruleset ({version}) with this observation attached as NF-e corroboration (type NFE_OBSERVATION).",
  "nfe.draft.bodyNoVersion":
    "Prepares a draft in the next draft ruleset with this observation attached as NF-e corroboration (type NFE_OBSERVATION).",
  "nfe.draft.point.corroboration":
    "Invoices are attached as corroboration, never as a legal source.",
  "nfe.draft.point.rates": "Rates stay blank until they are read from the official act.",
  "nfe.draft.point.nothingAutomatic": "Nothing is approved or published automatically.",
  "nfe.draft.evidence":
    "Official legal evidence must still be attached and approved in Documents before the proposal can be approved.",
  "nfe.draft.noDraft":
    'There is no draft ruleset. In Publications, use "Prepare next draft" and come back.',
  "nfe.draft.matches": "This path matches the platform: there is nothing to propose.",
  "nfe.draft.reason": "Reason (optional)",
  "nfe.draft.reasonHint":
    "If given, use at least 10 characters. It stays on the draft and in the audit.",
  "nfe.draft.confirm": "Create draft",
  "nfe.draft.creating": "Creating…",
  "nfe.draft.created": "Draft created in {version}",
  "nfe.draft.existing": "This path already had a draft in {version}",
  "nfe.draft.toastBody":
    "Attach and approve the official evidence in Documents before submitting the proposal.",
  "nfe.draft.open": "Open {version} drafts",
  /* Insights — calculation / lot summary + header inbox */
  "insights.eyebrow": "Insights",
  "insights.title.calculation": "What this calculation tells you",
  "insights.title.lot": "What this lot tells you",
  "insights.headline.driver": "{driver} is {share} of the taxes on {calculated} calculated lines",
  "insights.headline.review.one": "{count} line needs review",
  "insights.headline.review.other": "{count} lines need review",
  "insights.headline.empty": "Waiting for calculated lines with a published rule.",
  "insights.kpi.purchaseTax": "Total purchase tax",
  "insights.kpi.effectiveRate": "Effective rate",
  "insights.kpi.effectiveRateCaption": "over goods value {amount}",
  "insights.kpi.linesCalculated": "Lines calculated",
  "insights.kpi.linesCalculatedValue": "{calculated} / {total}",
  "insights.kpi.valueAtRisk": "Value at risk",
  "insights.kpi.valueAtRiskCaption": "goods value on lines in review",
  "insights.kpi.saleTax": "Taxes on the sale",
  "insights.drivers.title": "Biggest tax drivers",
  "insights.drivers.empty": "No calculated line yet — drivers appear once a line has a rule.",
  "insights.drivers.saleHeading": "On the sale",
  "insights.drivers.onLines.one": "on {count} line",
  "insights.drivers.onLines.other": "on {count} lines",
  "insights.drivers.a11y": "{name}: {amount}, {share}, on {lines} lines",
  "insights.driver.ICMS_ST": "ICMS-ST",
  "insights.driver.IPI": "IPI",
  "insights.driver.FCP": "FCP/FECP",
  "insights.driver.OTHER_PURCHASE": "Other purchase taxes",
  "insights.driver.PIS_COFINS": "PIS/COFINS on the sale",
  "insights.driver.DIFAL": "DIFAL on the sale",
  "insights.review.title": "Needs review",
  "insights.review.reason.NO_RULE": "No rule",
  "insights.review.reason.AMBIGUOUS_RULE": "Ambiguous rule",
  "insights.review.reason.STALE_RULE": "Expired rule",
  "insights.review.reason.UNVERIFIED_DATA": "Unverified data",
  "insights.review.reason.INPUT_DATA": "Input data",
  "insights.review.reason.PENDING_CONFIRMATION": "Pending confirmation",
  "insights.review.reason.OTHER": "Other",
  "insights.review.explain.NO_RULE": "No published rule for this NCM and route",
  "insights.review.explain.AMBIGUOUS_RULE": "More than one rule matches — choose one",
  "insights.review.explain.STALE_RULE": "The rule used has expired for the fiscal date",
  "insights.review.explain.UNVERIFIED_DATA":
    "Data was found but is pending verification — amounts stay unchanged until reviewed",
  "insights.review.explain.INPUT_DATA": "Input data is missing or invalid (NCM, UF, cost or rates)",
  "insights.review.explain.PENDING_CONFIRMATION":
    "A profile or classification needs your confirmation",
  "insights.review.explain.OTHER": "Needs a finance check",
  "insights.review.lines.one": "{count} line",
  "insights.review.lines.other": "{count} lines",
  "insights.review.valueAtRisk": "Value at risk: {amount}",
  "insights.review.action": "Review lines",
  "insights.review.staleNote.one":
    "{count} calculated line uses a rule that has expired for the fiscal date",
  "insights.review.staleNote.other":
    "{count} calculated lines use a rule that has expired for the fiscal date",
  "insights.savings.title": "Savings opportunity",
  "insights.savings.headline": "Up to {amount} less ICMS-ST from a comparable route",
  "insights.savings.row":
    "NCM {ncm} · {origin} → {destination} pays {rate} ST; from {comparable} → {destination} it is {comparableRate}",
  "insights.savings.footnote":
    "Estimate from lines in this calculation with the same NCM and destination; not tax advice.",
  "insights.research.title": "Being researched",
  "insights.research.chip.running": "{count} running",
  "insights.research.chip.queued": "{count} queued",
  "insights.research.chip.found": "{count} found",
  "insights.research.chip.needsReview": "{count} need review",
  "insights.research.chip.notFoundFailed": "{count} not found / failed",
  "insights.research.gap": "{ncm} · {origin} → {destination} — {status}, ETA {eta}",
  "insights.research.status.QUEUED": "queued",
  "insights.research.status.RUNNING": "running",
  "insights.research.idle": "No search running now",
  "insights.research.open": "Open research",
  "insights.revision.title": "What changed in revision {number}",
  "insights.revision.noValueBefore": "No value before",
  "insights.revision.noValueYet": "No value yet",
  "insights.revision.summary":
    "Revision {number} changed {changed} of {total} lines; tax on lines with a value before and after: {delta}.",
  "insights.revision.newlyCalculated.one":
    "{count} line was calculated for the first time ({amount} in tax)",
  "insights.revision.newlyCalculated.other":
    "{count} lines were calculated for the first time ({amount} in tax)",
  "insights.revision.cause.NEW_RULE": "New rule published",
  "insights.revision.cause.RULE_CHANGED": "Rule changed",
  "insights.revision.cause.UNVERIFIED_PENDING": "Data found, pending verification",
  "insights.revision.cause.FACTS_NOT_APPLIED": "Facts compared, not applied",
  "insights.revision.cause.RULESET_UPDATED": "Rule set updated",
  "insights.revision.cause.STATUS_CHANGED": "Status changed",
  "insights.revision.ruleset": "Rules v{before} → v{after}",
  "insights.inbox.trigger": "Insights",
  "insights.inbox.triggerUnread": "Insights, {count} unread",
  "insights.inbox.unread": "Unread",
  "insights.inbox.title": "Insights",
  "insights.inbox.empty": "Nothing new — insights from your calculations appear here.",
  "insights.inbox.generic": "New insight",
  "insights.inbox.atRisk": "{amount} at risk",
  "insights.inbox.badgeMore": "9+",
  "insights.inbox.kind.RECALCULATION_READY.one": "{count} line can be recalculated with new rules",
  "insights.inbox.kind.RECALCULATION_READY.other":
    "{count} lines can be recalculated with new rules",
  "insights.inbox.kind.RESEARCH_FOUND.one": "Research found data for {count} line",
  "insights.inbox.kind.RESEARCH_FOUND.other": "Research found data for {count} lines",
  "insights.inbox.kind.RESEARCH_NEEDS_REVIEW.one": "{count} research result waits for verification",
  "insights.inbox.kind.RESEARCH_NEEDS_REVIEW.other":
    "{count} research results wait for verification",
  "insights.inbox.kind.RESEARCH_RUNNING.one": "{count} search running",
  "insights.inbox.kind.RESEARCH_RUNNING.other": "{count} searches running",
  "insights.inbox.kind.REVIEW_REQUIRED.one": "{count} line needs review",
  "insights.inbox.kind.REVIEW_REQUIRED.other": "{count} lines need review",
  "insights.inbox.kind.RULE_PUBLISHED.one": "New rule published affecting {count} line",
  "insights.inbox.kind.RULE_PUBLISHED.other": "New rule published affecting {count} lines",
  "insights.inbox.kind.SAVINGS_OPPORTUNITY": "Possible saving of {amount}",
  /* Notas fiscais workspace (tax managers) */
  "shell.nav.invoices": "Invoices",
  "inv.title": "Invoices",
  "inv.description":
    "Upload the company's invoices, see them by month, validate each month and read the findings.",
  "inv.upload.open": "Upload invoices",
  "inv.upload.hide": "Close upload",
  "inv.views.label": "Invoice areas",
  "inv.views.months": "Months",
  "inv.views.batches": "Upload batches",
  "inv.batches.hint":
    "An upload can mix months: each invoice goes to the month of its issue date. Here are the batches sent and what happened to each file.",
  "inv.readOnly": "Read-only: reviewing and validating months needs the rule review permission.",
  "inv.empty.title": "No invoices yet",
  "inv.empty.body":
    "Upload the company's XML or ZIP files. They are organised by issue month, issued and received.",
  "inv.empty.readOnly":
    "There are no invoices yet. Someone who can upload files needs to make the first upload.",
  "inv.direction.label": "Direction",
  "inv.direction.ALL": "All invoices",
  "inv.direction.EMITIDA": "Issued",
  "inv.direction.RECEBIDA": "Received",
  "inv.direction.EMITIDA.tag": "Issued",
  "inv.direction.RECEBIDA.tag": "Received",
  "inv.status.NOT_REVIEWED": "Not reviewed",
  "inv.status.IN_REVIEW": "In review",
  "inv.status.VALIDATED": "Validated",
  "inv.severity.HIGH": "High",
  "inv.severity.MEDIUM": "Medium",
  "inv.severity.LOW": "Low",
  "inv.nav.label": "Periods",
  "inv.nav.title": "Periods",
  "inv.nav.change": "Change month",
  "inv.nav.choose": "Choose a month",
  "inv.nav.yearLabel": "Months of {year}",
  "inv.nav.months.one": "{count} month",
  "inv.nav.months.other": "{count} months",
  "inv.nav.pending.one": "{count} to validate",
  "inv.nav.pending.other": "{count} to validate",
  "inv.nav.invoices.one": "{count} invoice",
  "inv.nav.invoices.other": "{count} invoices",
  "inv.nav.diverging.one": "{count} diverges",
  "inv.nav.diverging.other": "{count} diverge",
  "inv.nav.high.one": "{count} high",
  "inv.nav.high.other": "{count} high",
  "inv.nav.reopened": "Reopened",
  "inv.nav.outside.one":
    "{count} invoice on file is neither issued nor received by the company and stays out of this area.",
  "inv.nav.outside.other":
    "{count} invoices on file are neither issued nor received by the company and stay out of this area.",
  "inv.affected.title.one": "The upload touched {count} month",
  "inv.affected.title.other": "The upload touched {count} months",
  "inv.affected.text.one": "{count} new or changed invoice, placed in the month of its issue date.",
  "inv.affected.text.other":
    "{count} new or changed invoices, placed in the month of their issue date.",
  "inv.affected.changed.one": "{count} invoice",
  "inv.affected.changed.other": "{count} invoices",
  "inv.affected.reopened": "Back in review",
  "inv.month.older": "Previous month",
  "inv.month.newer": "Next month",
  "inv.month.openBatch": "View the batch",
  "inv.month.reopened.one":
    "This month was validated and went back to review: an upload on {when} brought {count} new or changed invoice. Review it before validating again.",
  "inv.month.reopened.other":
    "This month was validated and went back to review: an upload on {when} brought {count} new or changed invoices. Review it before validating again.",
  "inv.dashboard.label": "Month figures",
  "inv.dashboard.bothDirections": "issued and received",
  "inv.dashboard.invoices": "Invoices",
  "inv.dashboard.items": "Items",
  "inv.dashboard.value": "Total value",
  "inv.dashboard.cancelled": "Cancelled",
  "inv.dashboard.cancelledScope": "not counted in the other figures",
  "inv.dashboard.cancelledShare": "{share} of the month's invoices",
  "inv.dashboard.paths": "Paths",
  "inv.dashboard.findings": "Findings",
  "inv.dashboard.aiSuggestions.one": "{count} AI suggestion",
  "inv.dashboard.aiSuggestions.other": "{count} AI suggestions",
  "inv.dashboard.byDirection": "By direction",
  "inv.dashboard.itemsCount.one": "{count} item",
  "inv.dashboard.itemsCount.other": "{count} items",
  "inv.validation.title": "Month validation",
  "inv.validation.notReviewed":
    "This month has not been reviewed yet. Start the review to record decisions and validate.",
  "inv.validation.blocked": "Decisions are still missing before the month can be validated.",
  "inv.validation.ready": "Ready to validate: nothing is waiting for a decision.",
  "inv.validation.validated": "Month validated on {when}.",
  "inv.validation.nothingBlocks": "Nothing blocks the validation of this month.",
  "inv.validation.bothDirections":
    "The count covers issued and received, whatever the direction filter says.",
  "inv.validation.blocker.paths.one": "{open} of {total} diverging path without a decision",
  "inv.validation.blocker.paths.other": "{open} of {total} diverging paths without a decision",
  "inv.validation.blocker.findings.one": "{open} of {total} high finding without a decision",
  "inv.validation.blocker.findings.other": "{open} of {total} high findings without a decision",
  "inv.validation.show.paths": "Show paths",
  "inv.validation.show.findings": "Show findings",
  "inv.validation.start": "Start review",
  "inv.validation.validate": "Validate month",
  "inv.validation.blockedReason":
    "Record a decision for every diverging path and every high finding before validating.",
  "inv.validation.reopen": "Reopen month",
  "inv.validation.stale":
    "The month changed since it was loaded. We refreshed the screen; check it and try again.",
  "inv.validation.done.START_REVIEW": "Review of {month} started",
  "inv.validation.done.VALIDATE": "{month} validated",
  "inv.validation.done.REOPEN": "{month} reopened for review",
  "inv.reopen.title": "Reopen {month}",
  "inv.reopen.body":
    "The month goes back to review and must be validated again. The reopening is kept in the history with the reason.",
  "inv.reopen.reason": "Reason for reopening",
  "inv.reopen.confirm": "Reopen month",
  "inv.reopen.saving": "Reopening…",
  "inv.tabs.label": "Month sections",
  "inv.tabs.paths": "Observed paths",
  "inv.tabs.findings": "Findings",
  "inv.tabs.ai": "AI suggestions",
  "inv.tabs.analysis": "Analysis",
  "inv.tabs.history": "History",
  "inv.paths.title": "Paths observed in the month",
  "inv.paths.hint":
    "Each path is a tax treatment seen on the month's invoices, compared with what the platform knows. Divergences need a decision before validation.",
  "inv.paths.decision": "Decision",
  "inv.paths.empty.title": "No paths in this month",
  "inv.paths.empty.body": "When there are invoices in this month, the tax paths show up here.",
  "inv.filter.all": "All",
  "inv.filter.pending": "Pending",
  "inv.filter.decided": "Decided",
  "inv.filter.decision": "Decision",
  "inv.filter.review": "Review",
  "inv.filter.toReview": "To review",
  "inv.filter.dismissed": "Dismissed",
  "inv.filter.severity": "Severity",
  "inv.filter.code": "Check",
  "inv.filter.anyCode": "All checks",
  "inv.findings.title": "Findings from the automatic checks",
  "inv.findings.hint":
    "Fixed checks on the month's invoices, always on. Each finding says what it sees, what to do and how much is at stake.",
  "inv.findings.count.one": "{count} finding",
  "inv.findings.count.other": "{count} findings",
  "inv.findings.empty.title": "No open findings",
  "inv.findings.empty.body": "The automatic checks flagged nothing in this month.",
  "inv.findings.aiPointer.one": "{count} AI suggestion is waiting for review.",
  "inv.findings.aiPointer.other": "{count} AI suggestions are waiting for review.",
  "inv.findings.aiPointerAction": "See suggestions",
  "inv.finding.action": "What to do:",
  "inv.finding.value": "Value at stake",
  "inv.finding.valueUnknown": "Not estimated",
  "inv.finding.invoice": "Invoice",
  "inv.finding.related": "Related invoice",
  "inv.finding.items": "Items",
  "inv.finding.openPath": "View path",
  "inv.code.ICMS_ZERO_RATE_ON_TAXED_CST": "Zero ICMS rate on a taxed CST",
  "inv.code.DIFAL_MISSING_NON_CONTRIBUTOR": "DIFAL missing for a non-contributor",
  "inv.code.INTERSTATE_RATE_INCONSISTENT": "Interstate rate inconsistent with the route",
  "inv.code.ST_CFOP_WITHOUT_ST_GROUP": "ST CFOP without the ST group",
  "inv.code.ST_CST_WITHOUT_ST_VALUES": "ST CST without ST values",
  "inv.code.REDUCTION_WITHOUT_PRED_BC": "Reduction CST without pRedBC",
  "inv.code.PRED_BC_WITHOUT_REDUCTION_CST": "pRedBC on a non-reduction CST",
  "inv.code.ICMS_VALUE_MISMATCH": "ICMS differs from base × rate",
  "inv.code.ICMS_ST_BASE_MISMATCH": "ICMS-ST base outside the formula",
  "inv.code.ICMS_ST_VALUE_MISMATCH": "ICMS-ST value outside the formula",
  "inv.code.OTHER_TAX_VALUE_MISMATCH": "Another tax differs from base × rate",
  "inv.code.PIS_COFINS_ZERO_RATE_CST01": "PIS/COFINS CST 01 at 0%",
  "inv.code.MONOPHASIC_CHARGED_AS_CST01": "Monophasic NCM charged as CST 01",
  "inv.code.POSSIBLE_DUPLICATE_EMITTED": "Possible duplicate on an issued invoice",
  "inv.code.PLATFORM_RULE_DIVERGENCE": "Path diverges from what the platform knows",
  "inv.ack.action": "Record decision",
  "inv.ack.change": "Change decision",
  "inv.ack.pending": "No decision",
  "inv.ack.open": "Open",
  "inv.ack.stale": "Decision out of date",
  "inv.ack.staleHint": "The divergence changed after this decision. Record a new one.",
  "inv.ack.title": "Record a decision",
  "inv.ack.titleAi": "Dismiss AI suggestion",
  "inv.ack.resolution": "What did you decide?",
  "inv.ack.reason": "Reason",
  "inv.ack.reasonHint":
    "Required: {min} to {max} characters. It stays in the month's history. ({count})",
  "inv.ack.submit": "Record decision",
  "inv.ack.saving": "Recording…",
  "inv.ack.convertNote":
    "Creates or reuses a draft rule proposal. It still needs official evidence, review and approval: nothing is published.",
  "inv.ack.conflict":
    "It could not be recorded now: the month's state does not allow this decision.",
  "inv.ack.replaces": "Replaces the decision by {who} on {when}: {resolution}.",
  "inv.ack.done.ACCEPTED_ISSUER_ERROR": "Decision recorded: issuer error",
  "inv.ack.done.ACCEPTED_CORRECT": "Decision recorded: treatment is correct",
  "inv.ack.done.CONVERTED_TO_DRAFT": "Draft proposal created",
  "inv.ack.done.DISMISSED": "Suggestion dismissed",
  "inv.resolution.ACCEPTED_ISSUER_ERROR": "Issuer error",
  "inv.resolution.ACCEPTED_ISSUER_ERROR.short": "Issuer error",
  "inv.resolution.ACCEPTED_ISSUER_ERROR.hint":
    "The invoice is wrong. I record the reason and move on; the platform does not change.",
  "inv.resolution.ACCEPTED_CORRECT": "Treatment is correct",
  "inv.resolution.ACCEPTED_CORRECT.short": "Treatment correct",
  "inv.resolution.ACCEPTED_CORRECT.hint":
    "The invoice is right. I accept the observed treatment as valid this month.",
  "inv.resolution.CONVERTED_TO_DRAFT": "Create a draft rule proposal",
  "inv.resolution.CONVERTED_TO_DRAFT.short": "Draft created",
  "inv.resolution.CONVERTED_TO_DRAFT.hint":
    "Prepares a draft with this path as corroboration. It approves and publishes nothing.",
  "inv.resolution.DISMISSED": "Dismiss suggestion",
  "inv.resolution.DISMISSED.short": "Dismissed",
  "inv.resolution.DISMISSED.hint": "I reviewed it and will not follow this suggestion.",
  "inv.drawer.decision": "Recorded decision",
  "inv.drawer.decisionWhat": "What",
  "inv.drawer.decisionWho": "Who and when",
  "inv.drawer.issuerRoot": "Issuer CNPJ root",
  "inv.ai.title": "AI suggestions — need review",
  "inv.ai.hint":
    "Hypotheses raised by an AI model over the month's aggregated data. They are kept apart from the findings of the automatic checks.",
  "inv.ai.boundary":
    "The model sees only aggregated data with no identification of the invoices. Suggestions are never applied on their own, are not evidence and never become a rule: the legal basis cited is a pointer to verify in an official source.",
  "inv.ai.analyze": "Analyze with AI",
  "inv.ai.running": "Analyzing…",
  "inv.ai.running.reason": "An AI analysis of this month is already in progress.",
  "inv.ai.queued": "AI analysis of {month} queued",
  "inv.ai.lastRun": "Last AI analysis:",
  "inv.ai.neverRun": "This month has not had an AI analysis yet.",
  "inv.ai.cost": "cost {cost}",
  "inv.ai.followUp": "following progress",
  "inv.ai.reason.ARGON_COST_BOUND_UNAVAILABLE":
    "Argon requires Tax capability and pricing qualification before AI analysis.",
  "inv.ai.reason.NOT_DEPLOYED": "AI analysis is not enabled in this environment.",
  "inv.ai.reason.SWITCHED_OFF": "An administrator switched AI analysis off in the settings.",
  "inv.ai.reason.MONTHLY_BUDGET_REACHED": "The monthly AI budget has been reached.",
  "inv.ai.reason.DAILY_CAP_REACHED": "The daily limit of AI analyses has been reached.",
  "inv.ai.empty.title": "No AI suggestions in this month",
  "inv.ai.empty.body":
    "Use “Analyze with AI” to ask for hypotheses about this month. Nothing is applied.",
  "inv.ai.empty.unavailable": "AI analysis is unavailable right now. The automatic checks stay on.",
  "inv.ai.toReview": "To review",
  "inv.ai.dismiss": "Dismiss",
  "inv.ai.kind.CANDIDATE_RULE": "Candidate rule",
  "inv.ai.kind.SUSPECTED_ISSUER_ERROR": "Suspected issuer error",
  "inv.ai.kind.COMPLIANCE_RISK": "Compliance risk",
  "inv.ai.kind.RESEARCH_SUGGESTION": "Research suggestion",
  "inv.ai.confidence": "Confidence stated by the model",
  "inv.ai.confidenceValue": "Confidence {percent}%",
  "inv.ai.confidenceNote": "It is the number the model states, not a probability.",
  "inv.ai.candidate": "Candidate rule (not applied)",
  "inv.ai.candidateNote":
    "A rule only comes from a proposal with official evidence, review and approval.",
  "inv.ai.legal": "Legal basis cited by the model — to verify, not evidence",
  "inv.ai.query": "Suggested search:",
  "inv.settings.open": "AI settings",
  "inv.analysis.title": "Month analysis",
  "inv.analysis.hint":
    "Run the automatic checks again or ask for an AI analysis, and see past runs and their cost.",
  "inv.analysis.rules": "Automatic checks",
  "inv.analysis.rulesText":
    "Fixed rules over every invoice and item of the month. They run whenever invoices arrive and can be repeated here.",
  "inv.analysis.rulesLast": "Last run: {when}",
  "inv.analysis.rulesNever": "Not run in this month yet.",
  "inv.analysis.runRules": "Run checks",
  "inv.analysis.running": "Running…",
  "inv.analysis.rulesDone.one": "Checks run: {count} finding",
  "inv.analysis.rulesDone.other": "Checks run: {count} findings",
  "inv.analysis.ai": "AI analysis",
  "inv.analysis.aiText":
    "Optional. A model reads only the month's aggregated data and raises hypotheses for review.",
  "inv.analysis.runs": "Runs",
  "inv.analysis.runsEmpty": "No runs recorded",
  "inv.analysis.runCount.one": "{count} run",
  "inv.analysis.runCount.other": "{count} runs",
  "inv.run.when": "When",
  "inv.run.kind": "Kind",
  "inv.run.statusLabel": "Status",
  "inv.run.trigger": "Trigger",
  "inv.run.findings": "Findings",
  "inv.run.cost": "Cost",
  "inv.run.tokens": "Tokens (in / out)",
  "inv.run.kind.RULES": "Rules",
  "inv.run.kind.AI": "AI",
  "inv.run.trigger.IMPORT": "Invoice upload",
  "inv.run.trigger.MANUAL": "Manual",
  "inv.run.trigger.AUTO_AFTER_IMPORT": "Automatic after upload",
  "inv.run.status.QUEUED": "Queued",
  "inv.run.status.RUNNING": "Running",
  "inv.run.status.COMPLETED": "Completed",
  "inv.run.status.FAILED": "Failed",
  "inv.run.status.CANCELLED": "Cancelled",
  "inv.history.title": "Month history",
  "inv.history.hint":
    "Who did what, when and why: review, decisions, validation, reopenings and analyses.",
  "inv.history.empty": "Nothing recorded in this month yet.",
  "inv.event.system": "System",
  "inv.event.importer": "Invoice import",
  "inv.event.REVIEW_STARTED": "Review started",
  "inv.event.VALIDATED": "Month validated",
  "inv.event.REOPENED": "Month reopened",
  "inv.event.REOPENED_BY_UPLOAD": "Reopened by an invoice upload",
  "inv.event.ACKNOWLEDGED": "Decision recorded",
  "inv.event.RULES_ANALYSIS_RUN": "Automatic checks run",
  "inv.event.AI_ANALYSIS_REQUESTED": "AI analysis requested",
  "inv.event.AI_ANALYSIS_COMPLETED": "AI analysis completed",
  "inv.event.meta.resolution": "Decision",
  "inv.event.meta.target": "Target",
  "inv.event.meta.code": "Check",
  "inv.event.meta.runId": "Run",
  "inv.event.meta.batchId": "Batch",
  "inv.event.meta.changedInvoices": "Invoices changed",
  "inv.event.meta.findings": "Findings",
  "inv.settings.title": "AI analysis settings",
  "inv.settings.intro":
    "Control of the invoices AI lane: master switch, automatic runs, monthly budget, daily cap and the price table the cost is computed with.",
  "inv.settings.notDeployed":
    "This environment does not carry the AI lane. The settings are saved, but no analysis runs.",
  "inv.settings.enabled": "AI analysis on",
  "inv.settings.enabledHint": "Master switch. Off, nothing is queued and no AI button works.",
  "inv.settings.autoRun": "Run after each upload",
  "inv.settings.autoRunHint":
    "Queues one analysis per affected month after each upload, while there is budget.",
  "inv.settings.budget": "Monthly budget (US$)",
  "inv.settings.budgetHint": "Once reached, AI is unavailable until next month.",
  "inv.settings.cap": "Daily analysis cap",
  "inv.settings.capHint": "From 1 to 1,000 analyses per day.",
  "inv.settings.priceIn": "Input price (US$ per million tokens)",
  "inv.settings.priceOut": "Output price (US$ per million tokens)",
  "inv.settings.spent": "Spent this month / budget",
  "inv.settings.runsToday": "Analyses today / cap",
  "inv.settings.availability": "Right now",
  "inv.settings.available": "Available",
  "inv.settings.save": "Save",
  "inv.settings.saving": "Saving…",
  "inv.settings.saved": "AI settings saved",
  "inv.settings.conflict":
    "The settings changed since they were loaded. We reloaded the values; check them and save again.",
  "nfe.workspaceLink.body":
    "Tax management: organise the company's invoices by month, validate each month and read the findings in the dedicated area.",
  "nfe.workspaceLink.action": "Open Invoices",
  "inv.ft.affected": "{count} items are affected; the values quoted are those of the first.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.explain":
    "CST {cst} states a base of {vBC} but pICMS is 0% on a sale (CFOP {cfop}, NCM {ncm}). A taxed CST with a base and no rate collects no ICMS.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.reference":
    "The reference rate for this operation is {rate}.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.action":
    "Confirm with the issuer whether the operation is taxed. If it is, ask for a corrective invoice or recompute; if it is exempt or not taxed, the CST should be 40/41 (or the benefit stated in cBenef).",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.explain.nonContributor":
    "CFOP {cfop} (NCM {ncm}) to a non-contributor recipient (indIEDest 9) has no ICMSUFDest group. EC 87/2015 makes the destination share (DIFAL) due; the operation should use CFOP 6108 or 6107 with the ICMSUFDest fields.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.explain.finalConsumer":
    "CFOP {cfop} (NCM {ncm}) to a final consumer (indFinal 1) has no ICMSUFDest group. EC 87/2015 makes the destination share (DIFAL) due; the operation should use CFOP 6108 or 6107 with the ICMSUFDest fields.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.rates":
    "pICMS stated: {stated}; reference internal rate of the destination: {internal}.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.action":
    "Check the operation type: for a non-contributor or final consumer, issue (or ask for) the invoice with CFOP 6108/6107 and the DIFAL group; otherwise confirm the recipient's indIEDest.",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.explain.NATIONAL_AT_4":
    "pICMS of {pICMS} is the imported-goods rate (Res. SF 13/2012) but orig {orig} is not 1, 2, 3 or 8. National goods take {expected} on the {from} → {to} route (Res. SF 22/89).",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.explain.OTHER":
    "pICMS of {pICMS} was charged where {expected} applies on the {from} → {to} route ({basis}).",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.basis.imported": "Res. SF 13/2012, imported goods",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.basis.route":
    "Res. SF 22/89, route table: 7% from South/Southeast except ES to the others, otherwise 12%",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.action":
    "Check the goods origin (orig) and the route. A wrong rate on the issuer's side changes the credit the company can take; ask for a corrective invoice when it is an error.",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.explain":
    "CFOP {cfop} ({role}) was issued with {group} CST {cst}, which does not carry ICMS-ST. Either the CFOP or the ICMS group is wrong.",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.role.substitute": "substitute, ST retained",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.role.substituted": "substituted, ST already retained",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.action":
    "Check whether the goods are under ICMS-ST for this route. For x403 the issuer is the substitute and must state the ST group and values (CST 10/30/70); for x405 the goods were already retained (CST 60 / CSOSN 500).",
  "inv.ft.ST_CST_WITHOUT_ST_VALUES.explain":
    "{group} with CST/CSOSN {cst} retains ICMS-ST but the item has no ST base (vBCST) and no ST value (vICMSST).",
  "inv.ft.ST_CST_WITHOUT_ST_VALUES.action":
    "Ask the issuer whether ST was retained. If it was, the invoice must state vBCST and vICMSST; if it was not, the CST is wrong.",
  "inv.ft.REDUCTION_WITHOUT_PRED_BC.explain":
    "CST {cst} is a reduced-base CST but the item states no pRedBC, so the reduction cannot be checked.",
  "inv.ft.REDUCTION_WITHOUT_PRED_BC.action":
    "Ask the issuer for the reduction percentage (pRedBC) and the legal basis of the reduction.",
  "inv.ft.PRED_BC_WITHOUT_REDUCTION_CST.explain":
    "pRedBC of {pRedBC} is stated but the CST is {cst}, not a reduced-base CST (20, 70 or 90).",
  "inv.ft.PRED_BC_WITHOUT_REDUCTION_CST.action":
    "Check whether the base was really reduced. If it was, the CST should be 20 (or 70 with ST); if not, drop pRedBC.",
  "inv.ft.ICMS_VALUE_MISMATCH.explain":
    "vICMS of {vICMS} differs from vBC {vBC} × pICMS {pICMS} (= {expected}) beyond rounding.",
  "inv.ft.ICMS_VALUE_MISMATCH.action":
    "Compare with the DANFE and ask the issuer for a corrective invoice if the value is wrong.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.explain":
    "vBCST of {vBCST} differs from (vProd + IPI + freight + insurance + other − discount) × (1 + MVA {pMVAST}) = {expected} beyond tolerance.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.reduction":
    "pRedBCST of {pRedBCST} is stated: some ERPs apply it to the MVA-adjusted base, others to the operation value, and some state it without having applied it to vBCST; confirm which convention the issuer used.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.action":
    "Recompute the ST base with the destination's MVA (adjusted MVA on interstate operations) and ask the issuer to confirm.",
  "inv.ft.ICMS_ST_VALUE_MISMATCH.explain":
    "vICMSST of {vICMSST} differs from vBCST {vBCST} × pICMSST {pICMSST} minus the own ICMS {vICMS} (= {expected}).",
  "inv.ft.ICMS_ST_VALUE_MISMATCH.action":
    "Ask the issuer for a corrective invoice if the ST value is wrong.",
  "inv.ft.OTHER_TAX_VALUE_MISMATCH.explain":
    "{issues}: the stated value differs from its base × rate beyond rounding.",
  "inv.ft.OTHER_TAX_VALUE_MISMATCH.action":
    "Compare with the DANFE; ask the issuer for a corrective invoice only if the amount matters.",
  "inv.ft.PIS_COFINS_ZERO_RATE_CST01.explain":
    "PIS CST {pisCst} ({pisRate}) and COFINS CST {cofinsCst} ({cofinsRate}): a taxable CST at a zero rate collects nothing.",
  "inv.ft.PIS_COFINS_ZERO_RATE_CST01.action":
    "Check the contribution regime and whether the goods are taxed at a zero rate, monophasic or suspended; correct the CST or the rate with the issuer.",
  "inv.ft.MONOPHASIC_CHARGED_AS_CST01.explain":
    "NCM {ncm} ({act}) is in the monophasic regime, but this resale (CFOP {cfop}) charges PIS/COFINS with CST 01. After the concentrated collection the resale normally uses CST 04.",
  "inv.ft.MONOPHASIC_CHARGED_AS_CST01.action":
    "Confirm that the seller is not the manufacturer or importer of the goods. If it is a reseller, the contributions were already collected: ask for a corrective invoice (CST 04) and review what was paid. The NCM table is a reviewed list, not a legal opinion.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.one":
    "Same items, values and totals ({total}) as another issued invoice {days} day earlier, on {date} (30-day window). The recipient is not stored: it can also be a legitimate repeat sale.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.other":
    "Same items, values and totals ({total}) as another issued invoice {days} days earlier, on {date} (30-day window). The recipient is not stored: it can also be a legitimate repeat sale.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.sameDay":
    "Same items, values and totals ({total}) as another issued invoice on the same day, {date}. The recipient is not stored: it can also be a legitimate repeat sale.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.action":
    "Check whether the earlier invoice was meant to be replaced or cancelled, or whether the sale genuinely repeated. If it is a duplicate, cancel it within the SEFAZ deadline or issue the matching adjustment.",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.explain":
    "In this month, {invoices} and {items} state {details}. The platform value comes from {source}.",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.detail": "{field} {observed} where the platform has {expected}",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.action":
    "Decide whether the issuer made an error, whether the platform is out of date (open a draft proposal from the path) or whether the invoice is right for a case the platform does not model. A decision on the path records it.",
  "lotMap.field.descricao": "Product description",
  "lotMap.field.margem_alvo": "Target margin (on the price)",
  "lotMap.field.markup": "Markup (on cost)",
  "lotMap.field.expected_landed": "Expected landed cost per unit",
  "lotMap.field.expected_own_icms": "Expected inbound ICMS per unit",
  "lotMap.field.expected_purchase_pis_cofins": "Expected purchase PIS/COFINS per unit",
  "lotMap.field.expected_workbook_cost": "Expected workbook cost per unit",
  "lotMap.field.expected_sale_price": "Expected sale price with TR per unit",
  "lotMap.field.expected_sale_icms": "Expected own ICMS on the sale per unit",
  "lotMap.field.expected_sale_pis_cofins": "Expected PIS/COFINS on the sale per unit",
  "lotMap.field.expected_sale_st_fcp": "Expected ICMS-ST and FCP-ST on the sale invoice per unit",
  "lotMap.field.expected_buyer_invoice": "Expected buyer sale invoice per unit",
  "lotMap.field.ref_cfop": "CFOP (reference only)",
  "lotMap.field.ref_mva": "MVA / IVA-ST (reference only)",
  "lotMap.field.ref_aliq_ipi": "IPI rate (reference only)",
  "lotMap.field.ref_aliq_icms": "ICMS rate (reference only)",
  "lotMap.field.ref_pis_cofins": "PIS/COFINS rate (reference only)",
  "lotMap.field.ref_frete": "Freight (reference only)",
  "wb.where.sheet": "Sheet “{sheet}”",
  "wb.where.row": "row {row}",
  "wb.where.column": "column {column}",
  "wb.where.columnHeader": "column {column} ({header})",
  "wb.detail.expected": "Expected: {value}",
  "wb.detail.found": "Found: {value}",
  "wb.expected.ncm-8-digits": "an 8-digit NCM, for example 1905.90.20",
  "wb.expected.cest-single": "a single CEST like 17.056.02",
  "wb.expected.uf-code": "the 2-letter state code, for example SP",
  "wb.expected.amount-brl": "an amount in BRL, not negative, with up to 2 decimals",
  "wb.expected.unit-cost": "the unit cost in BRL",
  "wb.expected.quantity-whole-positive": "a whole number above zero",
  "wb.expected.margin-percent": "a percentage between 0 and 100 (or a fraction between 0 and 1)",
  "wb.expected.markup-fraction": "a fraction between 0 and 1, for example 0.5 for 50%",
  "wb.expected.ncm-and-unit-cost-columns": "an NCM column and a unit cost column",
  "wb.expected.uf-column-or-fallback": "a UF column or a fallback UF",
  "wb.issues.label": "Problems found in the spreadsheet",
  "wb.issues.sheetLabel": "Notes for sheet {sheet}",
  "wb.issues.workbookNotes": "{count} notes about the file as a whole.",
  "calc.error.workbook.title": "The spreadsheet could not be read",
  "calc.error.workbook.body":
    "Nothing was stored and no calculation started. Fix what is shown and upload it again.",
  "calc.error.howToFix": "How to fix it",
  "calc.error.chooseAnother": "Upload another file",
  "calc.error.supportLabel": "Support code",
  "calc.error.supportHint":
    "If you need help, send this code to support: it identifies this attempt.",
  "wb.issue.INVALID_WORKBOOK.steps":
    "Open the file in Excel. If it does not open, ask the sender for a new copy.\nUse File → Save As → Excel Workbook (.xlsx), or export the sheet as .csv.\nUpload the saved file.",
  "wb.issue.ENCRYPTED_WORKBOOK.steps":
    "Open the file in Excel with its password.\nUnder File → Info → Protect Workbook, remove the password.\nSave and upload it again.",
  "wb.issue.LEGACY_XLS.steps":
    "Open the .xls file in Excel.\nUse File → Save As → Excel Workbook (.xlsx).\nUpload the .xlsx file.",
  "wb.issue.HTML_AS_XLS.steps":
    "This file came from a web system: it has a spreadsheet name but is a web page inside.\nOpen it in Excel and use File → Save As → Excel Workbook (.xlsx).\nUpload the saved file.",
  "wb.issue.ZIP_NO_WORKBOOK.steps":
    "Unzip the file on your computer.\nUpload the .xlsx file that was inside.",
  "wb.issue.FILE_TOO_LARGE.title": "The file is too large to read",
  "wb.issue.FILE_TOO_LARGE.hint":
    "The limit is {expected}. Remove sheets or rows you do not need to calculate and upload it again.",
  "wb.issue.INVALID_WORKBOOK.title": "The file is damaged or is not a spreadsheet",
  "wb.issue.INVALID_WORKBOOK.hint":
    "Open it in Excel, save it again as .xlsx (or export the sheet as .csv) and upload it again.",
  "wb.issue.ENCRYPTED_WORKBOOK.title": "The workbook is password-protected (encrypted)",
  "wb.issue.ENCRYPTED_WORKBOOK.hint":
    "Open it in Excel, remove the password (File > Info > Protect Workbook), save it and upload it again.",
  "wb.issue.LEGACY_XLS.title": "This is an old Excel 97-2003 file (.xls)",
  "wb.issue.LEGACY_XLS.hint":
    "Open it in Excel, save it again as .xlsx (or export the sheet as .csv) and upload it again.",
  "wb.issue.TOO_MANY_SHEETS.title": "The workbook has too many sheets",
  "wb.issue.TOO_MANY_SHEETS.hint":
    "Keep at most {expected} sheets (delete them, hiding is not enough) and upload again.",
  "wb.issue.TOO_MANY_COLUMNS.title": "The sheet has too many columns ({found})",
  "wb.issue.TOO_MANY_COLUMNS.hint":
    "A sheet can have up to {expected} columns. Delete empty or helper columns and upload again.",
  "wb.issue.TOO_MANY_ROWS.title": "The sheet is over the limit of 5,000 product rows",
  "wb.issue.TOO_MANY_ROWS.hint":
    "Each sheet can have up to 5,000 product rows, plus the header. Split the sheet into smaller parts and upload each one separately.",
  "wb.issue.WORKSHEET_NOT_FOUND.title": "The chosen sheet is not in the file",
  "wb.issue.WORKSHEET_NOT_FOUND.hint": "Choose a sheet from the list and try again.",
  "wb.issue.HEADER_ROW_OUT_OF_RANGE.title": "The header row is outside the sheet",
  "wb.issue.HEADER_ROW_OUT_OF_RANGE.hint": "Choose a header row between 1 and {expected}.",
  "wb.issue.COLUMN_MAPPING_OUT_OF_RANGE.title": "A chosen column is not in the sheet",
  "wb.issue.COLUMN_MAPPING_OUT_OF_RANGE.hint": "Choose columns up to {expected}.",
  "wb.issue.NO_DATA_ROWS.title": "There are no data rows below the header",
  "wb.issue.NO_DATA_ROWS.hint":
    "Check that the header row is the one with the column names and that products follow it.",
  "wb.issue.TOO_MANY_DATA_ROWS.title": "More than 5,000 rows to calculate ({found})",
  "wb.issue.TOO_MANY_DATA_ROWS.hint":
    "Split the sheet into smaller parts and upload each one separately.",
  "wb.issue.SHEET_NOT_CONVERTIBLE.title": "This sheet cannot be calculated",
  "wb.issue.SHEET_NOT_CONVERTIBLE.hint":
    "A calculable sheet has one row per product with its NCM and unit cost.",
  "wb.issue.ROWS_SKIPPED.title": "{count} rows without product data were skipped",
  "wb.issue.ROWS_SKIPPED.hint":
    "Rows with no NCM, SKU, description or identifier are treated as blank or total rows.",
  "wb.issue.INVALID_CSV.title": "The CSV file could not be read",
  "wb.issue.INVALID_CSV.hint": "Check quotes and separators, or export it again from Excel as CSV.",
  "wb.issue.CACHED_ERROR_VALUE.title": "Excel stored the error {error} in this column",
  "wb.issue.CACHED_ERROR_VALUE.hint":
    "This usually happens when the sheet was copied out of its workbook and its formulas lost their source. Upload the full workbook, or copy the cells and paste them back as values (Paste special → Values), then upload again.",
  "wb.issue.FORMULA_NOT_CACHED.title": "Formula saved without a result",
  "wb.issue.FORMULA_NOT_CACHED.hint":
    "Open the file in Excel, let it recalculate, save it and upload it again.",
  "wb.issue.FORMULA_REVIEW_REQUIRED.title": "The value comes from a formula",
  "wb.issue.FORMULA_REVIEW_REQUIRED.hint":
    "Tick “Use the values Excel saved for formulas” to calculate with what Excel displayed.",
  "wb.issue.COLUMN_REQUIRED.title": "A required column is missing",
  "wb.issue.COLUMN_REQUIRED.hint": "Choose the matching column in the field list.",
  "wb.field.ncm": "NCM",
  "wb.field.custo": "unit cost",
  "wb.field.origem_mercadoria": "goods origin",
  "wb.field.marca": "brand",
  "wb.field.familia": "family",
  "wb.field.ean": "EAN",
  "wb.field.peso": "weight",
  "wb.issue.COLUMN_NOT_DETECTED.title": "We could not find the {field} column",
  "wb.issue.COLUMN_NOT_DETECTED.hint":
    "Choose the column in the field list. If the spreadsheet has no such column, add it (for example an 8-digit NCM per product) and upload it again.",
  "wb.issue.COLUMN_LOW_CONFIDENCE.title": "Please confirm this column",
  "wb.issue.COLUMN_LOW_CONFIDENCE.hint":
    "We matched it by a similar name. Check it in the preview or choose another column.",
  "wb.issue.COLUMN_LOW_CONFIDENCE.alternatives.title": "Confirm the column: {field}",
  "wb.issue.COLUMN_LOW_CONFIDENCE.alternatives.hint":
    "Other columns could also feed this field: {found}. Check the preview to see which one is right, and choose it if this one is not.",
  "wb.issue.COLUMN_DUPLICATE.title": "One column cannot feed two fields",
  "wb.issue.COLUMN_DUPLICATE.hint": "Choose a different column for each field.",
  "wb.issue.ROUTE_REQUIRED.title": "The route of this row is incomplete",
  "wb.issue.ROUTE_REQUIRED.hint":
    "Fill in the UF in the sheet, choose the UF columns or declare a fixed route.",
  "wb.issue.ROUTE_COLUMN_REQUIRED.title": "Choose the UF column or a fallback UF",
  "wb.issue.ROUTE_COLUMN_REQUIRED.hint":
    "With a per-row route, each end needs a column or a fallback UF.",
  "wb.issue.ROUTE_OVERRIDDEN.title": "{count} rows had a different UF; the fixed route was used",
  "wb.issue.ROUTE_OVERRIDDEN.hint":
    "A fixed route applies to every row. Use a per-row route if each row has its own.",
  "wb.issue.MISSING_VALUE.title": "Value missing",
  "wb.issue.MISSING_VALUE.hint":
    "No value is filled in by default. Optional missing values remain flagged for review; if a required cell has an error, correct the spreadsheet and upload it again before calculating this row.",
  "wb.issue.INVALID_NCM.title": "The NCM must be one 8-digit code",
  "wb.issue.INVALID_NCM.hint":
    "Fix the NCM in the sheet (one code per product, for example 1905.90.20) and upload it again.",
  "wb.issue.INVALID_CEST.title": "Invalid CEST",
  "wb.issue.INVALID_CEST.hint":
    "Use a single code like 17.056.02 or leave it blank; the row is calculated without a CEST.",
  "wb.issue.INVALID_CEST.zero.title": "CEST 0 read as “no CEST”",
  "wb.issue.INVALID_CEST.zero.hint":
    "In BackChannel spreadsheets, 0 means the product has no CEST. The row is calculated without a CEST; if the product has ST, fill in the 7-digit code.",
  "wb.issue.INVALID_CEST.placeholder.title": "CEST still pending in the spreadsheet ({found})",
  "wb.issue.INVALID_CEST.placeholder.hint":
    "The cell says the CEST has not been set yet. The row is calculated without a CEST; fill in the code once it is validated.",
  "wb.issue.INVALID_CEST.several.title": "More than one CEST in the same cell",
  "wb.issue.INVALID_CEST.several.hint":
    "Leave a single CEST per product. The row is calculated without a CEST until then.",
  "wb.issue.GOODS_ORIGIN_UNREADABLE.title": "Goods origin not read",
  "wb.issue.GOODS_ORIGIN_UNREADABLE.hint":
    "Use 0 to 8, national, imported or foreign, or leave it blank. The row is calculated without an origin.",
  "wb.issue.INVALID_UF.title": "Invalid state (UF)",
  "wb.issue.INVALID_UF.hint": "Use the 2-letter code, for example SP.",
  "wb.issue.INVALID_MONEY.title": "Invalid amount",
  "wb.issue.INVALID_MONEY.hint":
    "Use a positive number with up to 2 decimals, for example 1,234.56.",
  "wb.issue.ZERO_AMOUNT.title": "The unit cost is zero",
  "wb.issue.ZERO_AMOUNT.hint":
    "The row is calculated with zero cost. If the price is missing, fill it in the spreadsheet and upload it again.",
  "wb.issue.AMOUNT_ROUNDED.title":
    "{count} amounts had more than 2 decimals and were rounded to cents",
  "wb.issue.AMOUNT_ROUNDED.hint": "The original file is kept with the exact value.",
  "wb.issue.INVALID_QUANTITY.title": "The quantity must be a whole number above zero",
  "wb.issue.INVALID_QUANTITY.hint":
    "Fix the quantity in the sheet. If it is left blank the row is calculated per unit.",
  "wb.issue.INVALID_RATE.title": "The margin or markup was not understood",
  "wb.issue.INVALID_RATE.hint":
    "Use a percentage between 0 and 100. The value was ignored on this row.",
  "wb.issue.INVALID_EXPECTED_AMOUNT.title": "The comparison amount is not valid",
  "wb.issue.INVALID_EXPECTED_AMOUNT.hint":
    "Use a per-unit amount, not negative, with up to 2 decimals, or unassign the comparison column.",
  "wb.issue.DUPLICATE_ITEM_ID.title": "Repeated identifier",
  "wb.issue.DUPLICATE_ITEM_ID.hint": "Each row needs a different identifier.",
  "wb.issue.INVALID_ITEM.title": "The row could not be read",
  "wb.issue.INVALID_ITEM.hint": "Check the values on this row in the sheet.",
  "wb.route.title": "Route of this file",
  "wb.route.help":
    "Say where the goods go from and to. One route can apply to every row, or each row can state its own.",
  "wb.route.fixed": "One route for the whole file",
  "wb.route.fixedHelp": "Choose the origin and destination state.",
  "wb.route.dynamic": "Each row has its own route",
  "wb.route.dynamicHelp": "Read the origin and destination from the UF columns.",
  "wb.route.origin": "Origin state",
  "wb.route.destination": "Destination state",
  "wb.route.choose": "Choose a state",
  "wb.route.originColumn": "Origin state column",
  "wb.route.destinationColumn": "Destination state column",
  "wb.route.originFallback": "Origin when a row has none",
  "wb.route.destinationFallback": "Destination when a row has none",
  "wb.route.noFallback": "None (block the row)",
  "wb.route.requiredFixed": "Choose the origin and destination state to continue.",
  "wb.route.requiredDynamic": "For each end of the route, choose a UF column or a fallback UF.",
  "wb.route.detected": "Suggested from {source}.",
  "wb.route.source.COLUMN": "the UF columns",
  "wb.route.source.SHEET_NAME": "the sheet name",
  "wb.route.source.HEADER_BLOCK": "the cells above the table",
  "wb.route.source.PARAMETER_SHEET": "a parameters sheet",
  "wb.route.source.NONE": "We could not detect the route in this sheet. Choose it above.",
  "wb.route.perRow": "route per row",
  "wb.picker.title": "Sheets in this file",
  "wb.picker.help":
    "Choose the product lists to convert. Each chosen sheet becomes its own calculation.",
  "wb.picker.select": "Convert sheet {sheet}",
  "wb.picker.kind.SCENARIO": "Product list",
  "wb.picker.kind.CLIENT_SIMULATION": "Client simulation",
  "wb.picker.kind.PARAMETERS": "Parameters",
  "wb.picker.kind.AUXILIARY": "Support sheet",
  "wb.picker.kind.UNKNOWN": "Not recognised",
  "wb.picker.hidden": "hidden",
  "wb.picker.confidence": "{percent}% sure",
  "wb.picker.confidenceHelp": "How sure we are about this type of sheet.",
  "wb.picker.errors": "{count} to fix",
  "wb.picker.warnings": "{count} to check",
  "wb.picker.incomplete": "needs attention",
  "wb.picker.noScenarios":
    "No sheet looks like a product list with NCM and cost. Open one of the sheets below and choose the columns.",
  "wb.picker.others": "Other sheets ({count})",
  "wb.picker.othersHelp":
    "Client simulations, parameters and support sheets have no NCM and cost per product. You can still open them and choose columns.",
  "wb.picker.parameters": "Premises read from parameter sheets",
  "wb.picker.parametersHelp":
    "For review only. These values never become a tax rule: rules always come from the published ruleset.",
  "wb.picker.notConvertible.SCENARIO": "This sheet needs an NCM column and a unit cost column.",
  "wb.picker.notConvertible.CLIENT_SIMULATION":
    "This is a commercial client simulation: it has no NCM per product, so taxes cannot be calculated here.",
  "wb.picker.notConvertible.PARAMETERS":
    "This is a parameters sheet. Its premises are shown for review but never become a tax rule.",
  "wb.picker.notConvertible.AUXILIARY":
    "This is a support sheet (audit, review or summary) with no product list.",
  "wb.picker.notConvertible.UNKNOWN":
    "We did not recognise this sheet as a product list. Choose the columns manually if it has NCM and cost.",
  "wb.picker.convertMany": "Convert {count} sheets",
  "wb.picker.noneSelected": "Tick at least one sheet to convert.",
  "wb.picker.fixSelected":
    "Complete cost, route and calculation purpose in the marked sheets to continue.",
  "wb.map.confidence": "{percent}% match",
  "wb.map.confidenceHelp": "How well the column name and its values fit this field.",
  "wb.map.manual": "set by you",
  "wb.map.alternatives": "Other candidates: {columns}",
  "wb.map.premises": "Premises above the table ({count})",
  "wb.map.premisesHelp":
    "Values the sheet carries above the table, such as target margin, take rate or destination UF. For review only.",
  "wb.map.reference": "Rates stated in the file (reference only)",
  "wb.map.referenceHelp":
    "CFOP, MVA, IPI, ICMS, PIS/COFINS and freight the sheet states. They appear on the row for review and are never used as a rule or a rate.",
  "wb.coverage.title": "Rule coverage",
  "wb.coverage.hint":
    "Which routes and NCMs in the file the published ruleset can calculate. A route with no rule is never calculated with a default value.",
  "wb.coverage.summary": "{covered} covered · {missing} missing · {stale} out of date",
  "wb.coverage.unidentifiedSummary.one": "{count} row without fiscal identification",
  "wb.coverage.unidentifiedSummary.other": "{count} rows without fiscal identification",
  "wb.coverage.loading": "Checking the rules…",
  "wb.coverage.needVersion": "Choose a published version to see the coverage.",
  "wb.coverage.onlyGaps": "Only gaps",
  "wb.coverage.noRuleset": "There is no published ruleset: every route is missing.",
  "wb.coverage.allCovered": "All {count} route and NCM combinations have a published rule.",
  "wb.coverage.gapNote":
    "{count} rows depend on routes with no valid rule and will stay in review.",
  "wb.coverage.runNote":
    "{count} rows have no valid published rule. They will be marked for review, with no value made up.",
  "wb.coverage.unidentified":
    "{count} rows with no NCM or route could not be checked. Fix them in the sheet.",
  "wb.coverage.unidentifiedAutomatic":
    "The sheet is saved. When you calculate, the system will try to identify products with no NCM and check the available rules. Unresolved items will remain pending in the detail.",
  "wb.coverage.column.route": "Route",
  "wb.coverage.column.ncm": "NCM",
  "wb.coverage.column.cest": "CEST",
  "wb.coverage.column.status": "Status",
  "wb.coverage.column.reason": "Reason",
  "wb.coverage.column.rows": "Rows",
  "wb.coverage.status.COVERED": "Covered",
  "wb.coverage.status.MISSING": "No rule",
  "wb.coverage.status.STALE": "Out of date",
  "wb.coverage.reason.RULE_FOUND": "A published rule is in force.",
  "wb.coverage.reason.NO_RULE_FOR_ROUTE": "There are rules for this NCM, but none for this route.",
  "wb.coverage.reason.NO_RULE_FOR_NCM": "No published rule for this NCM.",
  "wb.coverage.reason.RULE_EXPIRED": "The rule for this route ended before the calculation date.",
  "wb.coverage.reason.RULE_NOT_YET_EFFECTIVE":
    "The rule for this route only starts after the calculation date.",
  "wb.coverage.reason.AMBIGUOUS_RULES":
    "More than one rule fits and the CEST is missing to choose.",
  "wb.coverage.reason.RULESET_EMPTY": "The ruleset has no fiscal rules.",
  "wb.coverage.status.NEEDS_REVIEW": "Needs review",
  "wb.coverage.reason.RULE_FOUND_ANY_ORIGIN":
    "Covered by a valid rule for any origin (destination {destination}).",
  "wb.coverage.reason.RULE_FOUND_ANY_ROUTE":
    "Covered by a valid rule for any origin and destination.",
  "wb.coverage.reason.ICMS_NOT_PUBLISHED": "Only IPI (TIPI): ICMS is not published for this route.",
  "wb.coverage.reason.DESTINATION_ST_DERIVED":
    "Derived from the {destination} ST rule (origin {origin}): same MVA and internal rate, Res. SF 22/89 interstate rate {rate}.",
  "wb.coverage.leg.SALE": "Sale {origin}→{destination}: {reason}",
  "wb.coverage.reason.GENERAL_RULE_NO_ST":
    "General rule (no ST): Res. SF 22/89 interstate rate (or verified internal rate), NCM proven outside ST.",
  "wb.coverage.reason.INTERSTATE_RATE_MISMATCH":
    "The rule in force states interstate ICMS of {stated}, but Res. SF 22/89 sets {expected} for {origin} → {destination}. Review the rule.",
  "wb.coverage.viewRule": "View rule",
  "wb.coverage.anyOriginTag": "Rule for any origin",
  "wb.coverage.summaryReview": " · {count} to review",
  "wb.coverage.reviewNote":
    "{count} rows use a rule that needs review: its stated interstate rate does not match the route.",
  "wb.coverage.showAll": "Show {count} more",
  "wb.row.reference": "From the sheet (reference)",
  "wb.run.converting": "Converting sheet {sheet}…",
  "wb.run.template": "Download normalized CSV",
  "wb.run.backToSheets": "Back to sheets",
  "wb.run.notes": "Notes for this sheet ({count})",
  "wb.run.notesLabel": "Conversion notes",
  "wb.run.tabs": "Converted sheets",
  "wb.runAll.label": "Calculate every sheet",
  "wb.runAll.title": "{count} sheets in this file",
  "wb.runAll.tally": "{done} calculated · {running} calculating · {waiting} waiting",
  "wb.runAll.action": "Calculate all ({count})",
  "wb.rows.one": "{count} row",
  "wb.rows.other": "{count} rows",
  "wb.notes.one": "⚠ {count} note",
  "wb.notes.other": "⚠ {count} notes",
  // -- Calculator research ("Buscar com agente?") — begin --
  "research.announce.CANCELLED": "Search cancelled: {route}, NCM {ncm}.",
  "research.announce.FAILED": "The search failed: {route}, NCM {ncm}.",
  "research.announce.FOUND": "Search finished: {route}, NCM {ncm}. Result found.",
  "research.announce.NEEDS_REVIEW":
    "Search finished: {route}, NCM {ncm}. Evidence awaiting review.",
  "research.announce.NOT_FOUND": "Search finished: {route}, NCM {ncm}. Nothing found.",
  "research.announce.QUEUED": "Search queued: {route}, NCM {ncm}.",
  "research.announce.RUNNING": "Search in progress: {route}, NCM {ncm}.",
  "research.ask": "Search with the agent?",
  "research.auto.deferred.one":
    "{count} combination is over the per-spreadsheet limit ({gaps} combinations, {cost}). Use “Search with the agent?” for it.",
  "research.auto.deferred.other":
    "{count} combinations are over the per-spreadsheet limit ({gaps} combinations, {cost}). Use “Search with the agent?” for them.",
  "research.auto.error": "The automatic search could not be started.",
  "research.auto.label": "Automatically search for what is missing",
  "research.auto.launching": "Starting the automatic search for combinations with no rule…",
  "research.auto.note":
    "After the coverage check, the missing combinations go to web research with AI (IOB is not used here). Limit per spreadsheet: {gaps} combinations and up to {cost} estimated; the rest stays with “Search with the agent?”. The result is evidence for review: it does not publish rules.",
  "research.banner.alsoPending": "There are still searches running for this calculation.",
  "research.banner.pending.body":
    "This calculation's result stays as it is until the search finishes.",
  "research.banner.pending.title.one": "{count} search in progress",
  "research.banner.pending.title.other": "{count} searches in progress",
  "research.banner.recalculable.body.one":
    "{count} search finished with usable data. Recalculating creates a new calculation and shows the difference; this one stays as it is.",
  "research.banner.recalculable.body.other":
    "{count} searches finished with usable data. Recalculating creates a new calculation and shows the difference; this one stays as it is.",
  "research.banner.recalculable.title": "New research finished; the previous result is preserved.",
  "research.banner.since": "Since {when}.",
  "research.banner.upToDate.title": "The result already reflects what the research found.",
  "research.banner.waiting.body":
    "Check each request to distinguish inputs needing correction from evidence needing review. The saved calculation keeps its original amounts and ruleset version.",
  "research.banner.waiting.title": "Research follow-up required; see details",
  "research.bar.allLabel": "All combinations with no rule",
  "research.bar.combinations.one": "{count} combination",
  "research.bar.combinations.other": "{count} combinations",
  "research.bar.covered": "Already searched",
  "research.bar.disconnected": "No connection: showing the last confirmed state of the searches.",
  "research.bar.follow": "Research",
  "research.bar.groups": "Combinations with no rule, by route",
  "research.bar.hint":
    "The agent searches the web. The result is evidence for review: it does not publish or change rules.",
  "research.bar.running.one": "{count} searching",
  "research.bar.running.other": "{count} searching",
  "research.bar.title.one": "{count} combination with no rule can be searched",
  "research.bar.title.other": "{count} combinations with no rule can be searched",
  "research.blocked.DAILY_GROUNDED_CAP":
    "The daily web query limit was reached. The request waits.",
  "research.blocked.FEATURE_DISABLED":
    "Agent search is turned off by an administrator. The request waits.",
  "research.blocked.IOB_PAUSED": "The IOB agent is paused. The request waits.",
  "research.blocked.LANES_PAUSED": "Research is paused. The request starts when it resumes.",
  "research.blocked.MONTHLY_BUDGET": "The monthly research budget was reached. The request waits.",
  "research.blocked.WEB_PAUSED": "Web research is paused. The request waits.",
  "research.boundary":
    "The agent only brings evidence. Nothing is published or calculated: a reviewer must approve before it becomes a rule.",
  "research.cancel": "Cancel search",
  "research.cancel.reason": "Cancelled by the operator in the calculator.",
  "research.cell.needsCest": "Provide the CEST",
  "research.cell.open": "View search",
  "research.column": "Research",
  "research.completed": "Finished {when}",
  "research.confirm.back": "Back",
  "research.confirm.cancel.action": "Yes, cancel",
  "research.confirm.cancel.body": "Cancel this search? What was already spent is not refunded.",
  "research.confirm.cancel.shared":
    "This search is shared by {count} origins. Cancelling affects all of them.",
  "research.confirm.cancel.title": "Cancel the search",
  "research.confirm.existing.one":
    "{count} combination already has a running or recent search and will be reused at no new cost.",
  "research.confirm.existing.other":
    "{count} combinations already have a running or recent search and will be reused at no new cost.",
  "research.confirm.follow": "Follow existing search",
  "research.confirm.launching": "Starting…",
  "research.confirm.lead": "{scope} — {combinations}, {rows}.",
  "research.confirm.more.one": "and {count} more",
  "research.confirm.more.other": "and {count} more",
  "research.confirm.newSearches": "New searches",
  "research.confirm.partialEstimate":
    "The estimate covers the first {count} combinations; the rest follow in batches.",
  "research.confirm.retry.action": "Search again",
  "research.confirm.retry.currentBudget":
    "Creates a new investigation with the current individual budget of {cost}. Previous history and evidence are preserved; in-flight calls may exceed the estimated reservation.",
  "research.confirm.retry.body": "Searching again costs up to {cost} (estimate).",
  "research.confirm.retry.title": "Search again",
  "research.confirm.start": "Search",
  "research.cost.actual": "Spent so far",
  "research.cost.estimated": "Research budget allocation",
  "research.created": "Created {when}",
  "research.created.body":
    "The previous calculation was preserved. Review the difference below before adopting the new one as the result.",
  "research.created.dismiss": "Dismiss",
  "research.created.open": "Open new calculation",
  "research.created.title": "New calculation created (revision {number})",
  "research.deferral.AUTO_CAP_COST": "Deferred: spreadsheet cost limit",
  "research.deferral.AUTO_CAP_GAPS": "Deferred: spreadsheet combination limit",
  "research.deferral.UPLOAD_NOT_AUTO": "Deferred: the spreadsheet is not automatic",
  "research.diff.change.AMOUNT": "Amount",
  "research.diff.change.COVERAGE": "Coverage",
  "research.diff.change.FACTS_LEVEL": "Facts level",
  "research.diff.change.RULE": "Rule",
  "research.diff.change.STATUS": "Status",
  "research.diff.col.changes": "Changes",
  "research.diff.col.coverage": "Coverage",
  "research.diff.col.item": "Item",
  "research.diff.col.landed": "Unit cost",
  "research.diff.col.tax": "Taxes",
  "research.diff.coverage.AMBIGUOUS": "Ambiguous",
  "research.diff.coverage.EXACT": "Exact rule",
  "research.diff.coverage.MISSING": "No rule",
  "research.diff.coverage.NCM_UNIQUE": "Rule by NCM",
  "research.diff.deltaNote": "Sums only items that had a value before and after.",
  "research.diff.factsMode": "Facts: {mode}",
  "research.diff.factsNotApplied": "The amount has not changed yet: facts are in shadow mode.",
  "research.diff.noItems": "No item changed.",
  "research.diff.summary.amount": "Amounts",
  "research.diff.summary.changed": "Items changed",
  "research.diff.summary.coverage": "Coverage",
  "research.diff.summary.delta": "Unit cost change",
  "research.diff.summary.unverified": "Unverified evidence only",
  "research.diff.table": "Items that changed",
  "research.diff.title": "Difference in revision {number}",
  "research.diff.unavailable": "Unavailable → calculated",
  "research.diff.unverifiedOnly": "Unverified evidence only: it does not count as coverage.",
  "research.disconnected":
    "No connection to the server. Showing the last confirmed state, at {when}. Searches keep running on the server.",
  "research.empty.body":
    "When you use “Search with the agent?” on a combination with no rule, it shows up here.",
  "research.empty.filtered.body": "Change the status, mode or origin.",
  "research.empty.filtered.title": "No searches match these filters",
  "research.empty.title": "No searches yet",
  "research.eta": "Estimated time",
  "research.etaValue": "≈ {minutes} min",
  "research.event.FOUND_IN_BASE": "Found in the base: no agent was needed",
  "research.event.IOB_LOOKUP_DONE": "IOB lookup finished",
  "research.event.IOB_LOOKUP_STARTED": "IOB lookup started",
  "research.event.LANES_PAUSED": "Research paused",
  "research.event.REQUEST_CANCELLED": "Request cancelled",
  "research.event.REQUEST_FAILED": "Request failed",
  "research.event.REQUEST_FOUND": "Result found",
  "research.event.REQUEST_NEEDS_REVIEW": "Evidence awaiting review",
  "research.event.REQUEST_NOT_FOUND": "Nothing found",
  "research.event.REQUEST_QUEUED": "Request queued",
  "research.event.RESOLVING_GAP": "Re-checking the gap",
  "research.event.WEB_SWEEP_DONE": "Web research finished",
  "research.event.WEB_SWEEP_FAILED": "Web research failed",
  "research.event.WEB_SWEEP_STARTED": "Web research started",
  "research.events.empty": "No events yet.",
  "research.events.title": "Timeline",
  "research.failed.detail": "Attempts: {attempts}.",
  "research.failed.final": "It cannot be repeated automatically.",
  "research.failed.retryable": "It can be repeated.",
  "research.family.ICMS": "ICMS",
  "research.family.ICMS_ST": "ICMS-ST",
  "research.filters.all": "All",
  "research.filters.label": "Research filters",
  "research.filters.mode": "Mode",
  "research.filters.origin": "Origin",
  "research.filters.status": "Status",
  "research.filters.status.active": "In progress",
  "research.filters.status.all": "All",
  "research.filters.status.cancelled": "Cancelled",
  "research.filters.status.failed": "Failed",
  "research.filters.status.found": "Found",
  "research.filters.status.notFound": "Not found",
  "research.filters.status.review": "Awaiting review",
  "research.hideDetail": "Hide details",
  "research.jobs.activeSr.one": "search in progress",
  "research.jobs.activeSr.other": "searches in progress",
  "research.jobs.button": "Research",
  "research.jobs.closeKeeps": "Closing does not cancel any search.",
  "research.jobs.live": "{count} in progress",
  "research.jobs.openPage": "Open the research page",
  "research.jobs.subtitle": "What the agent is looking for on combinations that have no rule.",
  "research.jobs.title": "Agent research",
  "research.lane.eta.estimate": "Estimate made when the search was requested",
  "research.lane.eta.hours": "≈ {value} h",
  "research.lane.eta.minutes": "≈ {value} min",
  "research.lane.eta.rate": "Measured from the units finished so far",
  "research.lane.eta.seconds": "≈ {value} s",
  "research.lane.iob": "IOB",
  "research.lane.openIob": "Open in IOB agent",
  "research.lane.openWeb": "Open in Web research",
  "research.lane.status.DONE": "done",
  "research.lane.status.FAILED": "failed",
  "research.lane.status.NOT_PLANNED": "not planned",
  "research.lane.status.QUEUED": "queued",
  "research.lane.status.RUNNING": "searching",
  "research.lane.status.SKIPPED": "not used",
  "research.lane.units": "{done} of {total} units",
  "research.lane.web": "Web",
  "research.lanes.label": "Sources consulted",
  "research.lanes.unavailable.AVAILABLE": "The {lane} source is available.",
  "research.lanes.unavailable.BUDGET": "The {lane} source budget was reached. The search waits.",
  "research.lanes.unavailable.DAILY_CAP":
    "The {lane} source daily limit was reached. The search waits.",
  "research.lanes.unavailable.DISABLED": "The {lane} source is turned off.",
  "research.lanes.unavailable.PAUSED":
    "The {lane} source is paused. The search waits until it resumes.",
  "research.launched.announce.one": "Search started for {count} combination.",
  "research.launched.announce.other": "Search started for {count} combinations.",
  "research.launched.follow": "Follow",
  "research.launched.shared":
    "Some already had a running or recent search and were reused at no new cost.",
  "research.launched.title.one": "Search started · {count} combination",
  "research.launched.title.other": "Search started · {count} combinations",
  "research.mode.ASK": "Manual",
  "research.mode.AUTO": "Automatic",
  "research.more": "Showing the 100 most recent.",
  "research.origin.CALCULATION": "Calculation",
  "research.origin.UPLOAD": "Spreadsheet",
  "research.origin.launched": "started the search",
  "research.origins.title": "Used by",
  "research.page.description":
    "Every “Search with the agent?” request in the organisation, with status, step and cost.",
  "research.page.title": "Agent research",
  "research.page.unavailable": "Agent search is not available in this environment.",
  "research.panel.all.one": "View the search",
  "research.panel.all.other": "View all {count} searches",
  "research.panel.gaps.one": "{count} combination in this calculation has not been searched yet.",
  "research.panel.gaps.other":
    "{count} combinations in this calculation have not been searched yet.",
  "research.panel.scope": "This calculation",
  "research.panel.loadError":
    "Could not refresh the research status. The saved calculation is unchanged. Try again.",
  "research.panel.title": "Research for this calculation",
  "research.recalculate": "Recalculate",
  "research.recalculating": "Recalculating…",
  "research.reconnect": "Try now",
  "research.resolution.applied":
    "A result is available for this combination. Recalculate to use it in the calculation.",
  "research.resolution.cancelled": "Search cancelled. The combination still has no rule.",
  "research.resolution.failed": "The search did not finish. The combination still has no rule.",
  "research.resolution.needsReview": "Evidence found — awaiting review.",
  "research.resolution.notApplied":
    "A result was found, but the amount does not change yet: facts are in shadow mode.",
  "research.resolution.notFound":
    "Nothing found in the sources consulted. The combination still has no rule.",
  "research.resolution.queued": "Waiting its turn in the queue.",
  "research.resolution.running": "Searching the sources…",
  "research.resolution.unverified":
    "Unverified research evidence; its review is still pending. This evidence alone does not establish a fiscal rule.",
  "research.resolution.webUnverified":
    "Evidence found on the web; its verification is still pending. This evidence alone does not establish a fiscal rule.",
  "research.retry": "Search again",
  "research.revision.chain": "Revisions",
  "research.revision.number": "Revision {number}",
  "research.revision.openLatest": "Open revision {number}",
  "research.revision.original": "Original",
  "research.revision.ownDiff": "Differences in revision {number}",
  "research.rows.one": "{count} row",
  "research.rows.other": "{count} rows",
  "research.scope.calculation": "Showing only this calculation's searches.",
  "research.scope.clear": "Show all",
  "research.scope.upload": "Showing only this spreadsheet's searches.",
  "research.shared": "Shared by {count} origins: the result applies to all.",
  "research.showDetail": "Show details",
  "research.status.BLOCKED": "Paused",
  "research.status.CANCELLED": "Cancelled",
  "research.status.FAILED": "Failed",
  "research.status.FOUND": "Found",
  "research.status.NEEDS_REVIEW": "Awaiting review",
  "research.status.NOT_FOUND": "Not found",
  "research.status.QUEUED": "Queued",
  "research.status.RUNNING": "Searching",
  "research.step.DONE": "Done",
  "research.step.IOB": "IOB",
  "research.step.PLANNING": "Plan",
  "research.step.RESOLVING": "Resolving",
  "research.step.WEB": "Web",
  "research.stepState.blocked": "paused",
  "research.stepState.current": "in progress",
  "research.stepState.done": "done",
  "research.stepState.failed": "failed",
  "research.stepState.pending": "pending",
  "research.stepState.skipped": "not used",
  "research.stepState.stopped": "stopped",
  "research.steps.label": "Research steps",
  "research.summary":
    "{active} in progress · {review} awaiting review · {found} found · {failed} failed · spent {cost}",
  "research.updated": "Updated {when}",
  // -- Repair spreadsheet --
  "repair.title": "Repair spreadsheet",
  "repair.intro.one": "We found {count} value that blocks rows on this sheet.",
  "repair.intro.other": "We found {count} values that block rows on this sheet.",
  "repair.safe":
    "Nothing is applied without your confirmation. A confirmed repair changes only the value that is read, never the original file, and is recorded with your name, the date and the previous value.",
  "repair.counter": "{done} of {total} repairs confirmed",
  "repair.acceptSuggestions": "Accept suggestions ({count})",
  "repair.acceptSuggestions.help":
    "Accepts only what leaves no doubt: a catalog NCM well ahead of the others, an NCM's leading zero, a very close UF and a single cost column. Typed values are never included.",
  "repair.undoAll": "Undo all",
  "repair.loading": "Looking for values that can be repaired…",
  "repair.refreshing": "Updating suggestions…",
  "repair.error":
    "Repairs could not be looked up right now. You can convert the sheet without them.",
  "repair.catalogUnchecked":
    "The NCM catalog could not be consulted: the codes below were checked by format only.",
  "repair.pendingNote.one":
    "{count} repair not confirmed: the affected rows are left out of the conversion.",
  "repair.pendingNote.other":
    "{count} repairs not confirmed: the affected rows are left out of the conversion.",
  "repair.kind.NCM_PICK": "More than one NCM in the cell",
  "repair.kind.NCM_LEADING_ZERO": "NCM missing its leading zero",
  "repair.kind.UF_REPLACE": "Not a valid UF",
  "repair.kind.CEST_REPLACE": "CEST that does not match the NCM",
  "repair.kind.NCM_REPLACE": "NCM column holds product text",
  "repair.kind.COST_ALTERNATIVE_COLUMN": "Cost with an Excel error",
  "repair.kind.COST_MANUAL": "Cost with an Excel error and no other column",
  "repair.kindShort.NCM_PICK": "NCM picked",
  "repair.kindShort.NCM_LEADING_ZERO": "NCM leading zero",
  "repair.kindShort.NCM_REPLACE": "Official-table NCM",
  "repair.kindShort.UF_REPLACE": "UF replaced",
  "repair.kindShort.COST_ALTERNATIVE_COLUMN": "Cost from another column",
  "repair.kindShort.COST_MANUAL": "Typed cost",
  "repair.column": "Column {column} · {header}",
  "repair.original": "Current value",
  "repair.rowsMore": "and {count} more",
  "repair.choose.ncm": "Which NCM applies to these rows?",
  "repair.choose.uf": "Which UF applies to these rows?",
  "repair.choose.costManual": "What is the cost of these rows?",
  "repair.choose.cost": "Where should the cost come from?",
  "repair.badge.inCatalog": "in the catalog",
  "repair.badge.notInCatalog": "not in the catalog",
  "repair.badge.unchecked": "not checked in the catalog",
  "repair.best": "best suggestion",
  "repair.noDescription": "No catalog description",
  "repair.uf.other": "Choose another UF",
  "repair.uf.pick": "Select a UF",
  "repair.uf.noCandidates": "No UF looks like this value. Choose the right one.",
  "repair.cost.coverage": "{rows} of {total} rows",
  "repair.cost.partial": "Rows with no amount in this column stay unrepaired and blocked.",
  "repair.cost.manual": "Type a value",
  "repair.cost.manualLabel": "Unit cost (R$)",
  "repair.cost.manualHelp":
    "The value is yours and is recorded as typed. Use a comma or a dot, with up to 2 decimals.",
  "repair.cost.manualError": "Use numbers only, with up to 2 decimals (for example 12.50).",
  "repair.scope": "Apply to",
  "repair.scope.all": "Apply to all {count} rows with this value",
  "repair.scope.first": "Only row {row}",
  "repair.apply": "Apply",
  "repair.undo": "Undo",
  "repair.confirmed": "Repair confirmed",
  "repair.willApply.one": "Applies to {count} row",
  "repair.willApply.other": "Applies to {count} rows",
  "repair.willApply.none": "No row has a value in this column",
  "repair.result.one": "{count} repair confirmed",
  "repair.result.other": "{count} repairs confirmed",
  "repair.audit.title": "Confirmed repairs",
  "repair.audit.help":
    "Values a person corrected before the conversion. The original file was not changed.",
  "repair.audit.what": "What",
  "repair.audit.where": "Where",
  "repair.audit.change": "From → To",
  "repair.audit.who": "Confirmed by",
  "repair.audit.when": "When",
  "repair.audit.table": "Repairs confirmed on this file",
  "repair.recovered.title": "File recovered: check the data",
  "repair.recovered.body":
    "The file was damaged and was rebuilt from the parts that could still be read. Check names, values and row counts before converting.",
  "repair.recovered.lost": "Sheets that could not be recovered and do not appear here: {sheets}.",
  "wb.issue.FILE_RECOVERED.title": "The file was damaged and was recovered",
  "wb.issue.FILE_RECOVERED.hint":
    "Check the data before converting: parts of the file may have been lost. If anything looks wrong, open it in Excel, save it again as .xlsx and send it again.",
  "wb.issue.FILE_RECOVERED.sheetLost.title": "The sheet “{sheet}” could not be recovered",
  "wb.issue.FILE_RECOVERED.sheetLost.hint":
    "The file was damaged and this sheet was lost. Ask for an intact copy or export the sheet again from Excel.",
  "wb.issue.REPAIR_REJECTED.title": "A confirmed repair was refused: {reason}",
  "wb.issue.REPAIR_REJECTED.many.title":
    "{count} confirmed repairs were refused; the first: {reason}",
  "wb.issue.REPAIR_REJECTED.hint":
    "Nothing was imported. Go back to the mapping, review the repairs and confirm again.",
  "wb.repairReject.SHEET_MISMATCH": "the repair belongs to another sheet",
  "wb.repairReject.FIELD_NOT_MAPPED": "the repair's column is no longer mapped to that field",
  "wb.repairReject.CELL_MISSING": "the cell does not exist in the file",
  "wb.repairReject.CELL_CHANGED": "the cell's value changed since the suggestion",
  "wb.repairReject.DUPLICATE": "the same cell was repaired twice",
  "wb.repairReject.VALUE_NOT_ALLOWED": "the new value is not allowed for this kind of repair",
  "wb.repairReject.SOURCE_UNUSABLE": "the source column has no usable value on this row",
  "wb.repairReject.NOT_IN_CATALOG": "the resulting NCM is not in the catalog",
  // -- Calculator research — end --
  "nav.uploadFailures": "Failed uploads",
  "uploadFailures.title": "Failed uploads",
  "uploadFailures.description":
    "Calculator uploads that failed, with what the operator saw and the original file.",
  "uploadFailures.denied": "Only platform administrators can see failed uploads.",
  "uploadFailures.filter.search": "Support code",
  "uploadFailures.filter.placeholder": "Paste the code here",
  "uploadFailures.filter.reviewed": "Review",
  "uploadFailures.filter.from": "From",
  "uploadFailures.filter.to": "To",
  "uploadFailures.filter.operator": "Operator",
  "uploadFailures.filter.operatorPlaceholder": "Operator e-mail or id",
  "uploadFailures.filter.errorCode": "Error code",
  "uploadFailures.filter.anyError": "All errors",
  "uploadFailures.filter.kind": "File content",
  "uploadFailures.filter.anyKind": "All kinds",
  "uploadFailures.filter.stage": "Stage",
  "uploadFailures.filter.anyStage": "All",
  "uploadFailures.filter.range": "Period",
  "uploadFailures.reviewed.all": "All",
  "uploadFailures.reviewed.pending": "Pending",
  "uploadFailures.reviewed.done": "Reviewed",
  "uploadFailures.stage.INSPECT": "Read",
  "uploadFailures.stage.IMPORT": "Import",
  "uploadFailures.stage.REPAIR": "Repair",
  "uploadFailures.kind.xlsx": "Excel (.xlsx)",
  "uploadFailures.kind.xls": "Old Excel (.xls)",
  "uploadFailures.kind.csv": "CSV",
  "uploadFailures.kind.zip": "Zip",
  "uploadFailures.kind.html": "HTML",
  "uploadFailures.kind.unknown": "Unknown",
  "uploadFailures.column.when": "When",
  "uploadFailures.column.operator": "Operator",
  "uploadFailures.column.file": "File",
  "uploadFailures.column.kind": "Content",
  "uploadFailures.column.stage": "Stage",
  "uploadFailures.column.error": "Main error",
  "uploadFailures.column.code": "Support code",
  "uploadFailures.column.reviewed": "Review",
  "uploadFailures.status.reviewed": "Reviewed",
  "uploadFailures.status.pending": "Pending",
  "uploadFailures.open": "Open {name}",
  "uploadFailures.noName": "Unnamed file",
  "uploadFailures.nameSays": "named .{extension}",
  "uploadFailures.unknownOperator": "Operator without e-mail",
  "uploadFailures.summary": "{count} on this page",
  "uploadFailures.summaryMore": "{count} on this page · more available",
  "uploadFailures.empty.title": "No failed uploads",
  "uploadFailures.empty.body":
    "When a calculator upload fails, it appears here with the code the operator saw.",
  "uploadFailures.searchHint":
    "Also accepts a request id or correlation id. Exact match; from 8 characters, by prefix.",
  "uploadFailures.drawer.subtitle": "{operator} · {relative}",
  "uploadFailures.drawer.notFoundTitle": "Upload not found",
  "uploadFailures.drawer.notFound": "No failure has the code {code}. Check the pasted code.",
  "uploadFailures.section.detected": "What the server detected",
  "uploadFailures.section.errors": "Errors",
  "uploadFailures.section.technical": "Technical details",
  "uploadFailures.section.versions": "Versions",
  "uploadFailures.section.original": "Original file",
  "uploadFailures.section.review": "Review",
  "uploadFailures.finding.OOXML_WORKBOOK": "A valid Excel workbook (.xlsx)",
  "uploadFailures.finding.OOXML_MACRO_WORKBOOK": "A macro-enabled Excel workbook (.xlsm)",
  "uploadFailures.finding.OOXML_ENCRYPTED": "Password-protected (encrypted) xlsx",
  "uploadFailures.finding.LEGACY_XLS_BIFF": "Old xls (BIFF, Excel 97-2003)",
  "uploadFailures.finding.OLE2_OTHER": "Another Office document (OLE2), not a workbook",
  "uploadFailures.finding.HTML_DISGUISED": "The file is HTML disguised as .xls/.xlsx",
  "uploadFailures.finding.ZIP_WITHOUT_WORKBOOK": "Zip with no workbook (no xl/workbook.xml)",
  "uploadFailures.finding.ZIP_DAMAGED": "Damaged zip (the archive directory could not be read)",
  "uploadFailures.finding.DELIMITED_TEXT": "Delimited text (CSV)",
  "uploadFailures.finding.PDF": "The file is a PDF, not a workbook",
  "uploadFailures.finding.EMPTY": "The file is empty (0 bytes)",
  "uploadFailures.finding.TEXT_UNKNOWN": "Text that is not a table",
  "uploadFailures.finding.BINARY_UNKNOWN": "Binary of an unknown format",
  "uploadFailures.finding.NOT_RECEIVED": "The bytes never reached the server",
  "uploadFailures.detected.magic": "Signature (magic bytes)",
  "uploadFailures.detected.noMagic": "No binary signature (text content or not received)",
  "uploadFailures.detected.extension": "Name extension",
  "uploadFailures.detected.contentType": "Detected content",
  "uploadFailures.detected.mismatch": "The name says .{extension}, but the content is {detected}.",
  "uploadFailures.detected.sheets": "Sheets read",
  "uploadFailures.detected.noSheets": "No sheet could be read",
  "uploadFailures.detected.zipEntries": "Zip entries",
  "uploadFailures.detected.noExtension": "no extension",
  "uploadFailures.errors.response": "HTTP {status} · {code}",
  "uploadFailures.errors.detail": "Technical API message",
  "uploadFailures.errors.none":
    "The API returned no violations for this upload; see the technical message.",
  "uploadFailures.errors.field": "Field",
  "uploadFailures.tech.more": "Technical data (MIME, browser, hashes)",
  "uploadFailures.tech.supportCode": "Support code",
  "uploadFailures.tech.requestId": "Request id",
  "uploadFailures.tech.correlationId": "Correlation id",
  "uploadFailures.tech.httpStatus": "HTTP status",
  "uploadFailures.tech.problemCode": "Problem code",
  "uploadFailures.tech.userAgent": "Browser (user agent)",
  "uploadFailures.tech.sha256": "SHA-256",
  "uploadFailures.tech.size": "Size",
  "uploadFailures.tech.declaredContentType": "Type the name declares",
  "uploadFailures.tech.stage": "Stage",
  "uploadFailures.tech.createdAt": "Received at",
  "uploadFailures.tech.operator": "Operator",
  "uploadFailures.versions.app": "App",
  "uploadFailures.versions.engine": "Calculation engine",
  "uploadFailures.versions.parser": "Workbook reader",
  "uploadFailures.versions.ruleset": "Ruleset",
  "uploadFailures.original.status.STORED": "Stored",
  "uploadFailures.original.status.PENDING": "Being stored",
  "uploadFailures.original.status.NOT_RECEIVED": "Not received",
  "uploadFailures.original.status.TOO_LARGE": "Too large",
  "uploadFailures.original.status.STORE_FAILED": "Storage failed",
  "uploadFailures.original.status.EXPIRED": "Expired",
  "uploadFailures.original.explain.STORED":
    "Available to administrators during the 30-day retention.",
  "uploadFailures.original.explain.PENDING":
    "The file is still being stored. Try again in a moment.",
  "uploadFailures.original.explain.NOT_RECEIVED":
    "The bytes never reached the server; only metadata was recorded.",
  "uploadFailures.original.explain.TOO_LARGE":
    "The file was over the upload limit and was not stored; only metadata was recorded.",
  "uploadFailures.original.explain.STORE_FAILED":
    "Storage was unavailable; only metadata was recorded.",
  "uploadFailures.original.explain.EXPIRED":
    "The file was deleted at the end of the 30-day retention.",
  "uploadFailures.original.expiresAt": "Expires at",
  "uploadFailures.original.expiredAt": "Expired at",
  "uploadFailures.original.download": "Download original file",
  "uploadFailures.original.downloading": "Downloading…",
  "uploadFailures.toast.downloaded": "File downloaded · {name}",
  "uploadFailures.toast.downloadFailed": "Could not download {name}",
  "uploadFailures.review.pending": "Not reviewed yet.",
  "uploadFailures.review.done": "Reviewed by {by} on {date}.",
  "uploadFailures.review.markReviewed": "Mark as reviewed",
  "uploadFailures.review.reopen": "Reopen",
  "uploadFailures.review.note": "Review note",
  "uploadFailures.review.notePlaceholder": "What was found and what the operator was told",
  "uploadFailures.review.noteCount": "{count} of {max} characters",
  "uploadFailures.review.saveNote": "Save note",
  "uploadFailures.review.saving": "Saving…",
  "uploadFailures.toast.reviewed": "Marked as reviewed · {name}",
  "uploadFailures.toast.reopened": "Reopened · {name}",
  "uploadFailures.toast.noteSaved": "Note saved · {name}",
  "uploadFailures.toast.reviewFailed": "Could not save the review",
  "uploadFailures.copyCode": "Copy code",
  "wb.issue.HTML_AS_XLS.title": "This file is a web page (HTML) with a spreadsheet name",
  "wb.issue.HTML_AS_XLS.hint":
    "Open it in Excel and use Save As → Excel Workbook (.xlsx), then upload it again.",
  "wb.issue.ZIP_NO_WORKBOOK.title": "This .zip does not contain an Excel workbook",
  "wb.issue.ZIP_NO_WORKBOOK.hint": "Upload the .xlsx file itself, not compressed.",
  "nav.infraCost": "Infrastructure cost",
  "infraCost.title": "Estimated infrastructure cost",
  "infraCost.description":
    "What the platform costs per month on Google Cloud, by service, with usage scenarios and where to save.",
  "infraCost.denied": "Only platform administrators can see the estimated infrastructure cost.",
  "infraCost.estimateLabel": "Estimate, not an invoice",
  "infraCost.loading": "Loading the estimate",
  "infraCost.banner.title": "An estimate, not an invoice.",
  "infraCost.banner.body":
    "Public list prices for {region} checked on {date}, with no discounts, credits, committed use or taxes. What is actually charged is in Cloud Billing.",
  "infraCost.scenario.legend": "Scenario",
  "infraCost.scenario.IDLE": "Idle",
  "infraCost.scenario.TYPICAL": "Typical",
  "infraCost.scenario.HIGH": "High load",
  "infraCost.scenario.IDLE.summary":
    "Nobody using it: only minimum instances, the database, VMs, schedulers and storage.",
  "infraCost.scenario.TYPICAL.summary":
    "Today's usage: lots, rows and AI spend from the last 30 days recorded in the app.",
  "infraCost.scenario.HIGH.summary":
    "About 2,000 concurrent users, AI at its budget cap and Cloud SQL sized for the load.",
  "infraCost.totals.label": "Scenario totals",
  "infraCost.totals.usd": "Monthly total (US$)",
  "infraCost.totals.brl": "Monthly total (R$)",
  "infraCost.totals.perMonth": "per month",
  "infraCost.totals.perMonthShort": "/month",
  "infraCost.totals.perYear": "≈ {value} per year",
  "infraCost.totals.rate": "US$ 1 = R$ {rate} · PTAX sell rate of {date}",
  "infraCost.totals.fixed": "Fixed costs",
  "infraCost.totals.variable": "Usage-based costs",
  "infraCost.totals.share": "{share} of the total",
  "infraCost.totals.fixedHint": "paid even with no usage",
  "infraCost.totals.variableHint": "grow with usage",
  "infraCost.kind.FIXED": "Fixed",
  "infraCost.kind.VARIABLE": "Usage-based",
  "infraCost.byService.title": "Cost by service",
  "infraCost.byService.tooltip": "{service}: fixed {fixed}, usage-based {variable}",
  "infraCost.split.title": "Fixed vs usage-based",
  "infraCost.split.hint": "in the chosen scenario",
  "infraCost.split.aria": "Fixed {fixed}, usage-based {variable}",
  "infraCost.split.fixedHint": "Minimum instances, Cloud SQL, VMs, NAT, storage and schedulers.",
  "infraCost.split.variableHint": "Requests, job CPU, Gemini tokens, egress and logs.",
  "infraCost.drivers.title": "Top cost drivers",
  "infraCost.drivers.hint": "the 5 most expensive items",
  "infraCost.compare.title": "Scenarios",
  "infraCost.compare.hint": "pick one to see the detail",
  "infraCost.compare.shown": "Shown",
  "infraCost.compare.fixed": "Fixed",
  "infraCost.compare.variable": "Usage-based",
  "infraCost.compare.requests": "Requests/month",
  "infraCost.compare.rows": "Rows/month",
  "infraCost.compare.ai": "AI (Gemini)",
  "infraCost.table.title": "Breakdown by item",
  "infraCost.table.hint": "{scenario} scenario",
  "infraCost.table.showAll": "Show all {count} items",
  "infraCost.table.showLess": "Show fewer",
  "infraCost.table.item": "Item",
  "infraCost.table.service": "Service",
  "infraCost.table.kind": "Type",
  "infraCost.table.quantity": "Quantity/month",
  "infraCost.table.basis": "Basis",
  "infraCost.table.usd": "US$/month",
  "infraCost.table.brl": "R$/month",
  "infraCost.basis.TERRAFORM": "Terraform",
  "infraCost.basis.RECORDED": "Recorded in the app",
  "infraCost.basis.MODELED": "Assumption",
  "infraCost.service.CLOUD_RUN": "Cloud Run (services)",
  "infraCost.service.CLOUD_RUN_JOBS": "Cloud Run (jobs)",
  "infraCost.service.CLOUD_SQL": "Cloud SQL",
  "infraCost.service.COMPUTE_ENGINE": "Compute Engine (VMs)",
  "infraCost.service.NETWORKING": "Networking (NAT, IPs, egress)",
  "infraCost.service.API_GATEWAY": "API Gateway",
  "infraCost.service.CLOUD_STORAGE": "Cloud Storage",
  "infraCost.service.ARTIFACT_REGISTRY": "Artifact Registry",
  "infraCost.service.PUBSUB": "Pub/Sub",
  "infraCost.service.CLOUD_SCHEDULER": "Cloud Scheduler",
  "infraCost.service.SECRET_MANAGER": "Secret Manager",
  "infraCost.service.CLOUD_LOGGING": "Cloud Logging",
  "infraCost.service.FIREBASE_HOSTING": "Firebase Hosting",
  "infraCost.service.VERTEX_AI": "Vertex AI (Gemini)",
  "infraCost.line.runMinInstances": "Always-on APIs",
  "infraCost.lineDetail.runMinInstances":
    "1 minimum instance of the admin API (2 vCPU, 2 GiB, CPU always allocated, instance-based rate) and the runtime API (2 vCPU, 2 GiB, idle rate).",
  "infraCost.line.runServiceRequests": "API requests",
  "infraCost.lineDetail.runServiceRequests":
    "CPU and memory while serving, plus US$ 0.40 per million.",
  "infraCost.line.runWorkers": "Fetch and extraction workers",
  "infraCost.lineDetail.runWorkers":
    "Fetcher and extractor (1 vCPU, 1 GiB) per processed document.",
  "infraCost.line.jobsScheduledTicks": "Scheduled job runs",
  "infraCost.lineDetail.jobsScheduledTicks":
    "Every tick starts an execution even with no work: lot queue every minute, calculator research every 2 min, web research, NF-e and the agent every 5 min.",
  "infraCost.line.jobsLotRows": "Lot row calculation",
  "infraCost.lineDetail.jobsLotRows": "Lot runner CPU per calculated row.",
  "infraCost.line.jobsWebResearch": "Web research runs",
  "infraCost.lineDetail.jobsWebResearch":
    "Hours of the research job (2 vCPU, 2 GiB) with active sweeps.",
  "infraCost.line.sqlInstance": "Cloud SQL instance",
  "infraCost.lineDetail.sqlInstance":
    "Postgres Enterprise db-custom-1-3840 (1 vCPU, 3.75 GB), zonal, 24 h.",
  "infraCost.line.sqlStorage": "Cloud SQL disk",
  "infraCost.lineDetail.sqlStorage": "25 GB SSD with automatic growth.",
  "infraCost.line.sqlBackups": "Cloud SQL backups",
  "infraCost.lineDetail.sqlBackups": "14 daily backups and 7 days of point-in-time recovery.",
  "infraCost.line.vmBrowserAgent": "Browser agent VM",
  "infraCost.lineDetail.vmBrowserAgent":
    "e2-standard-4 (4 vCPU, 16 GB) on 24 h, plus 80 GiB of disk: 60 for boot and 20 for the profile.",
  "infraCost.line.vmTwingate": "Twingate connector VM",
  "infraCost.lineDetail.vmTwingate": "e2-micro on 24 h, plus 10 GB of disk.",
  "infraCost.line.natGateways": "Cloud NAT gateways",
  "infraCost.lineDetail.natGateways": "Two NATs (workers and Twingate), billed per VM behind them.",
  "infraCost.line.natData": "Traffic through NAT",
  "infraCost.lineDetail.natData": "Data the workers and the agent download from the internet.",
  "infraCost.line.externalIps": "External IPs",
  "infraCost.lineDetail.externalIps": "Workers' fixed egress IP and the Twingate NAT IP.",
  "infraCost.line.egress": "Internet egress",
  "infraCost.lineDetail.egress": "API responses and downloads leaving São Paulo.",
  "infraCost.line.apiGateway": "API Gateway calls",
  "infraCost.lineDetail.apiGateway": "Browser calls to the admin API, US$ 3 per million.",
  "infraCost.line.gcsStorage": "Cloud Storage buckets",
  "infraCost.lineDetail.gcsStorage":
    "Evidence, normalized text, calculations, uploads and agent frames.",
  "infraCost.line.registryStorage": "Artifact Registry images",
  "infraCost.lineDetail.registryStorage": "Immutable images from every deploy, no cleanup policy.",
  "infraCost.line.pubsub": "Pub/Sub messages",
  "infraCost.lineDetail.pubsub": "Discovery, fetched and normalized documents, DLQ and research.",
  "infraCost.line.scheduler": "Cloud Scheduler jobs",
  "infraCost.lineDetail.scheduler": "8 schedules at US$ 0.10 per month each.",
  "infraCost.line.secretManager": "Secrets",
  "infraCost.lineDetail.secretManager": "Active versions of 12 secrets and their accesses.",
  "infraCost.line.logging": "Log ingestion",
  "infraCost.lineDetail.logging": "Above the 50 GiB free per project.",
  "infraCost.line.firebaseHosting": "Firebase Hosting",
  "infraCost.lineDetail.firebaseHosting": "Web app transfer above 360 MB per day.",
  "infraCost.line.geminiResearch": "Web research Gemini",
  "infraCost.lineDetail.geminiResearch":
    "Grounded searches and Gemini 2.5 Flash tokens, as the app records them per batch.",
  "infraCost.line.geminiNfe": "NF-e analysis Gemini",
  "infraCost.lineDetail.geminiNfe": "Gemini 2.5 Flash tokens recorded per run.",
  "infraCost.line.geminiBrowserAgent": "Browser agent Gemini",
  "infraCost.lineDetail.geminiBrowserAgent": "Estimated tokens per agent step.",
  "infraCost.savings.title": "Where to save",
  "infraCost.savings.hint": "up to {total}/month on the typical scenario",
  "infraCost.savings.perMonth": "−{value}/month",
  "infraCost.saving.browserAgentSmallerVm.title": "Agent VM on e2-standard-2",
  "infraCost.saving.browserAgentSmallerVm.detail":
    "Half the CPU and memory. Or stop it outside business hours with a schedule.",
  "infraCost.saving.apiMinInstancesZero.title": "No minimum instance on the APIs",
  "infraCost.saving.apiMinInstancesZero.detail":
    "min_instance_count 0 on the admin and runtime APIs (api_min_instances in the platform module).",
  "infraCost.saving.cloudSqlCommittedUse.title": "Cloud SQL committed use",
  "infraCost.saving.cloudSqlCommittedUse.detail":
    "25% off vCPU and memory with a 1-year commitment.",
  "infraCost.saving.taskRunnerEveryFiveMinutes.title": "Lot queue every 5 minutes",
  "infraCost.saving.taskRunnerEveryFiveMinutes.detail":
    "Today the scheduler starts the lot runner every minute, with or without work.",
  "infraCost.saving.calculatorTickEveryFiveMinutes.title": "Calculator research every 5 minutes",
  "infraCost.saving.calculatorTickEveryFiveMinutes.detail":
    "Instant dispatch already covers the urgent case; the scheduler is only the safety net.",
  "infraCost.saving.registryCleanupPolicy.title": "Artifact Registry cleanup",
  "infraCost.saving.registryCleanupPolicy.detail": "Keep only the latest images of each service.",
  "infraCost.tradeoff.COLD_START": "Slower first request (cold start before sign-in).",
  "infraCost.tradeoff.SLOWER_PICKUP": "New work may wait a few more minutes.",
  "infraCost.tradeoff.SLOWER_AGENT": "Slower browser agent.",
  "infraCost.tradeoff.NONE": "No product impact.",
  "infraCost.tradeoff.COMMITMENT": "A 1-year payment commitment.",
  "infraCost.usage.title": "Usage recorded in the app",
  "infraCost.usage.window": "{from} to {to}",
  "infraCost.usage.unavailable":
    "The app's records could not be read right now. The typical scenario uses the documented profile.",
  "infraCost.usage.lots": "Lots",
  "infraCost.usage.lotRows": "Lot rows",
  "infraCost.usage.calculations": "Calculations",
  "infraCost.usage.researchUnits": "Research units",
  "infraCost.usage.groundedCalls": "Grounded searches",
  "infraCost.usage.researchCost": "Research spend (recorded)",
  "infraCost.usage.nfeRuns": "NF-e analyses",
  "infraCost.usage.nfeCost": "NF-e spend (recorded)",
  "infraCost.usage.browserAgentSteps": "Agent steps",
  "infraCost.usage.researchDocuments": "Research documents",
  "infraCost.usage.caps": "Monthly AI caps set in the app: web research {research}, NF-e {nfe}.",
  "infraCost.assumptions.title": "Assumptions and sources",
  "infraCost.assumptions.model": "Model assumptions",
  "infraCost.assumptions.terraformSource": "Sizing read from: {source}.",
  "infraCost.assumption.prices":
    "Public list prices for {region} (São Paulo, pricier than us-central1), checked on {date}.",
  "infraCost.assumption.freeTiers":
    "Billing-account free tiers (Cloud Run, Scheduler, Secret Manager, API Gateway, Artifact Registry) are not subtracted, because the account also pays for other projects. Only the 50 GiB of logs per project is subtracted.",
  "infraCost.assumption.terraform":
    "Fixed sizes (CPU, memory, minimum instances, database tier, VMs, schedules) come from Terraform, model {version}. A test fails when Terraform changes and the model does not.",
  "infraCost.assumption.ticks":
    "Every Cloud Scheduler tick starts a job execution even with no work; we assume 15 to 20 s per empty execution.",
  "infraCost.assumption.requests":
    "The app does not record requests: the typical scenario assumes {requests} per month; high load, 2,000 concurrent users making one call every 20 s, 10 h a day, 22 business days.",
  "infraCost.assumption.ai":
    "Web research and NF-e use the US$ cost the app records (Gemini 2.5 Flash). Research charges every grounded search at US$ 35 per 1,000, but Vertex AI gives 1,500 a day free: the recorded figure is a ceiling.",
  "infraCost.assumption.browserAgent":
    "Browser agent: {input} input and {output} output tokens per step (Gemini 2.5 Flash).",
  "infraCost.assumption.highSql":
    "High load assumes Cloud SQL with 4 vCPU, 16 GB and high availability: the current tier cannot hold thousands of users.",
  "infraCost.assumption.storage":
    "Storage, backup, image, egress and log volumes are estimated; the billing export would give the real figures.",
  "infraCost.assumption.gateway":
    "API Gateway runs in us-east1 (it is not offered in São Paulo); inter-region traffic is not separated.",
  "infraCost.assumption.fx":
    "Exchange rate for display only: Banco Central PTAX sell rate of {date}, US$ 1 = R$ {rate}. The model is in US$.",
  "infraCost.billing.title": "Real billing figures",
  "infraCost.billing.NOT_CONFIGURED":
    "Cloud Billing export to BigQuery is not configured in Terraform, so this page does not use the real invoice.",
  "infraCost.billing.CONFIGURED": "Cloud Billing export to BigQuery is configured.",
  "infraCost.billing.step1":
    "In the console, open Billing → Billing export for the account that pays for backchannel-agent-dolphin (needs Billing Account Administrator).",
  "infraCost.billing.step2":
    "Enable “Detailed usage cost” into a BigQuery dataset, for example billing_export in backchannel-agent-dolphin.",
  "infraCost.billing.step3":
    "Data starts arriving within a few hours; earlier history is not backfilled.",
  "infraCost.billing.step4":
    "Then filter by project.id = backchannel-agent-dolphin and compare with this estimate.",
  "infraCost.billing.docs": "How to set up the export (Google Cloud)",
  "infraCost.sources.title": "Unit prices and sources",
  "infraCost.sources.hint": "public list, in US$",
  "infraCost.sources.sku": "SKU",
  "infraCost.sources.price": "Price",
  "infraCost.sources.scope": "Scope",
  "infraCost.sources.source": "Source",
  "infraCost.sources.checked": "Checked on",
  "infraCost.unit.vCPU-s": "vCPU-s",
  "infraCost.unit.requests": "requests",
  "infraCost.unit.documents": "documents",
  "infraCost.unit.executions": "executions",
  "infraCost.unit.rows": "rows",
  "infraCost.unit.hours": "hours",
  "infraCost.unit.GB-month": "GB-month",
  "infraCost.unit.gateways": "gateways",
  "infraCost.unit.addresses": "addresses",
  "infraCost.unit.GiB": "GiB",
  "infraCost.unit.calls": "calls",
  "infraCost.unit.jobs": "jobs",
  "infraCost.unit.versions": "versions",
  "infraCost.unit.GB": "GB",
  "infraCost.unit.USD": "US$",
  "infraCost.unit.steps": "steps",
  "infraCost.priceUnit.vCPU-second": "vCPU-second",
  "infraCost.priceUnit.GiB-second": "GiB-second",
  "infraCost.priceUnit.million requests": "million requests",
  "infraCost.priceUnit.vCPU-hour": "vCPU-hour",
  "infraCost.priceUnit.GB-hour": "GB-hour",
  "infraCost.priceUnit.GB-month": "GB-month",
  "infraCost.priceUnit.hour": "hour",
  "infraCost.priceUnit.VM-hour": "VM-hour",
  "infraCost.priceUnit.GiB": "GiB",
  "infraCost.priceUnit.million calls": "million calls",
  "infraCost.priceUnit.TiB": "TiB",
  "infraCost.priceUnit.job-month": "job-month",
  "infraCost.priceUnit.version-month": "version-month",
  "infraCost.priceUnit.10,000 operations": "10,000 operations",
  "infraCost.priceUnit.GB": "GB",
  "infraCost.priceUnit.1M tokens": "1M tokens",
  "infraCost.priceUnit.1,000 grounded prompts": "1,000 grounded prompts",
  "infraCost.note.runCpuActive": "southamerica-east1 is a Tier 2 Cloud Run region.",
  "infraCost.note.runCpuIdle":
    "Idle min instances of request-based services bill CPU at the reduced idle rate.",
  "infraCost.note.runJobCpu": "Jobs bill the whole execution, start-up included.",
  "infraCost.note.runCpuInstance":
    "Services with CPU always allocated bill the whole instance lifetime, idle or busy.",
  "infraCost.note.sqlVcpu": "HA (REGIONAL) doubles vCPU, memory and storage prices.",
  "infraCost.note.externalIp": "Internal IP addresses (browser agent, Twingate) are free.",
  "infraCost.note.geminiFlashInput":
    "The app prices research and NF-e runs with its own admin-editable price table; those recorded amounts are used when available.",
  "infraCost.note.groundedPrompt":
    "Vertex AI gives 1,500 grounded prompts a day free (2.0/2.5 Flash family, shared). The app records every grounded call at this price, so recorded research spend is an upper bound.",
  "infraCost.scope.REGIONAL": "São Paulo",
  "infraCost.scope.GLOBAL": "Global",
  "infraCost.scope.OTHER_REGION": "Other region",
  "ncmSearch.label": "Product or NCM",
  "ncmSearch.placeholder": "e.g. cookie or 8471.30.12",
  "ncmSearch.hint": "Type the product name, in Portuguese, Spanish or English, or the 8-digit NCM.",
  "ncmSearch.searching": "Searching the official table…",
  "ncmSearch.error": "Search is unavailable right now. Type the NCM or try again.",
  "ncmSearch.empty": "No NCM found. Try another name, a synonym or the code.",
  "ncmSearch.catalogPending": "The full table is still loading; results may be partial.",
  "ncmSearch.clear": "Clear",
  "ncmSearch.count": "{count} suggestions",
  "ncmSearch.results": "NCM suggestions",
  "ncmSearch.group.catalog": "Official NCM table",
  "ncmSearch.group.history": "Similar products already classified",
  "ncmSearch.reference":
    "Siscomex/TIPI reference. Check the official description; it is not a rate.",
  "ncmSearch.matched": "matched “{term}”",
  "ncmSearch.cestOne": "CEST {cest}",
  "ncmSearch.cestMany": "CEST {cest} +{count}",
  "ncmSearch.spSt": "SP: ST in the published rule",
  "ncmSearch.spNoSt": "SP: no ST in the published rule",
  "ncmSearch.unofficial": "unofficial translation",
  "ncmSearch.officialText": "Official text:",
  "ncmSearch.notInTable": "Not in the current official table",
  "ncmSearch.historySeen.one": "seen on {count} row of your lots",
  "ncmSearch.historySeen.other": "seen on {count} rows of your lots",
  "ncmSearch.illustrative": "illustrative",
  "commandSearch.group.products": "Products → NCM",
  "commandSearch.product.hint": "Calculate with this NCM",
  "repair.ncm.search": "None of these? Search for the product",
  "repair.ncm.searchHint":
    "Choose an NCM from the official table. It replaces the cell only after you apply it.",
  "repair.ncm.chosen": "NCM chosen from the official table",
  "ncmSearch.illustrativeHint":
    "Illustrative: an AI-generated picture of the kind of goods. The NCM and the official text identify it.",
  "rules.chapterDetail.illustration.illustrative":
    "Illustrative · AI-generated image. The chapter's identity is the HS tile and the official Siscomex title.",
  "nav.sessions": "Sessions",
  "sessions.replay.heading": "{name}'s session",
  "sessions.title": "Sessions",
  "sessions.description":
    "See what each operator did: the screen recording and every recorded action.",
  "sessions.denied": "Only a platform administrator can view sessions.",
  "sessions.configure": "Configure recording",
  "sessions.view.legend": "What to show",
  "sessions.view.sessions": "Sessions",
  "sessions.view.activity": "Activity",
  "sessions.filter.operator": "Operator",
  "sessions.filter.operatorPlaceholder": "Email or identifier",
  "sessions.filter.from": "From",
  "sessions.filter.to": "To",
  "sessions.filter.range": "Period",
  "sessions.filter.errors": "Errors",
  "sessions.filter.errors.all": "All",
  "sessions.filter.errors.with": "With errors",
  "sessions.filter.errors.without": "Without errors",
  "sessions.filter.kind": "Action type",
  "sessions.filter.anyKind": "Any type",
  "sessions.filter.outcome": "Outcome",
  "sessions.filter.outcome.all": "All",
  "sessions.filter.outcome.ok": "OK",
  "sessions.filter.outcome.error": "Error",
  "sessions.filter.organization": "Organization",
  "sessions.filter.anyOrganization": "All organizations",
  "sessions.column.operator": "Operator",
  "sessions.column.started": "Started",
  "sessions.column.duration": "Duration",
  "sessions.column.path": "Path",
  "sessions.column.actions": "Actions",
  "sessions.column.errors": "Errors",
  "sessions.column.size": "Size",
  "sessions.column.when": "When",
  "sessions.column.kind": "Type",
  "sessions.column.action": "Action",
  "sessions.column.result": "Outcome",
  "sessions.column.session": "Session",
  "sessions.column.requestId": "requestId",
  "sessions.errors.none": "No errors",
  "sessions.errors.api.one": "{count} API error",
  "sessions.errors.api.other": "{count} API errors",
  "sessions.errors.client.one": "{count} browser error",
  "sessions.errors.client.other": "{count} browser errors",
  "sessions.actions.one": "{count} action",
  "sessions.actions.other": "{count} actions",
  "sessions.summary.one": "{count} session",
  "sessions.summary.other": "{count} sessions",
  "sessions.summaryMore.one": "{count} session · more available",
  "sessions.summaryMore.other": "{count} sessions · more available",
  "sessions.activity.summary.one": "{count} record",
  "sessions.activity.summary.other": "{count} records",
  "sessions.activity.summaryMore.one": "{count} record · more available",
  "sessions.activity.summaryMore.other": "{count} records · more available",
  "sessions.kind.CALCULATION": "Individual calculation",
  "sessions.kind.LOT": "Lot",
  "sessions.kind.SIMULATION": "Lot simulation",
  "sessions.kind.RECALCULATION": "Recalculation",
  "sessions.kind.UPLOAD": "Spreadsheet upload",
  "sessions.kind.IMPORT": "Import",
  "sessions.kind.PROFILE_CONFIRMATION": "Profile confirmation",
  "sessions.kind.PROPOSAL": "Proposal",
  "sessions.kind.EVIDENCE": "Evidence",
  "sessions.kind.API_ERROR": "API error",
  "sessions.kind.CLIENT_ERROR": "Browser error",
  "sessions.kind.NAVIGATION": "Navigation",
  "sessions.kind.OTHER": "Other action",
  "sessions.outcome.ok": "OK",
  "sessions.outcome.error": "Error",
  "sessions.empty.title": "No sessions in this filter",
  "sessions.empty.body": "Adjust the period or the operator to see other sessions.",
  "sessions.activity.empty.title": "No activity in this filter",
  "sessions.activity.empty.body": "Adjust the period, the type, or the outcome.",
  "sessions.action.CALCULATION": "Calculated an operation",
  "sessions.action.LOT": "Processed a lot",
  "sessions.action.SIMULATION": "Simulated a lot",
  "sessions.action.RECALCULATION": "Recalculated an operation",
  "sessions.action.UPLOAD": "Uploaded a spreadsheet",
  "sessions.action.IMPORT": "Imported a spreadsheet",
  "sessions.action.PROFILE_CONFIRMATION": "Confirmed the tax profile",
  "sessions.action.PROPOSAL": "Recorded a proposal",
  "sessions.action.EVIDENCE": "Recorded evidence",
  "sessions.action.API_ERROR": "API error {status} · {code}",
  "sessions.action.CLIENT_ERROR": "Browser error: {message}",
  "sessions.action.NAVIGATION": "Opened {route}",
  "sessions.action.OTHER": "Took another action",
  "sessions.route.sessions": "Sessions",
  "sessions.route.admin": "Administration",
  "sessions.route.calculations": "Calculator",
  "sessions.route.lots": "Lots",
  "sessions.route.rules": "Rules",
  "sessions.route.evidence": "Evidence",
  "sessions.route.proposals": "Proposals",
  "sessions.route.invoices": "Invoices",
  "sessions.route.sources": "Sources",
  "sessions.route.overview": "Overview",
  "sessions.route.unknown": "Unknown path",
  "sessions.path.none": "No path",
  "sessions.settings.title": "Configure recording",
  "sessions.settings.status.deployOn": "Recording is on in this environment.",
  "sessions.settings.status.deployOff":
    "Recording is off in this environment. The organization preference is still saved.",
  "sessions.settings.status.storageOn": "Recording storage is configured.",
  "sessions.settings.status.storageOff": "Recording storage is not configured.",
  "sessions.settings.retention.one": "Records are kept for {count} day.",
  "sessions.settings.retention.other": "Records are kept for {count} days.",
  "sessions.settings.enabled": "Record sessions in this organization",
  "sessions.settings.enabledHint":
    "When this is off, the screen is not recorded. Actions and errors stay in the log.",
  "sessions.settings.sample": "Sample",
  "sessions.settings.sampleHint": "Percentage of sessions that record the screen. 100 records all.",
  "sessions.settings.sampleInvalid": "Enter a percentage from 0 to 100.",
  "sessions.settings.excluded": "Excluded operators",
  "sessions.settings.excludedHint": "These operators do not have their screen recorded.",
  "sessions.settings.excludedPlaceholder": "Paste an identifier or choose an email",
  "sessions.settings.excludedAdd": "Add",
  "sessions.settings.excludedPick": "Choose by email",
  "sessions.settings.excludedInvalid": "Enter a valid identifier or an email from the list.",
  "sessions.settings.excludedEmpty": "No excluded operators.",
  "sessions.settings.excludedRemove": "Remove {name}",
  "sessions.settings.excludedFull": "The list already has 200 operators.",
  "sessions.settings.save": "Save",
  "sessions.settings.saving": "Saving…",
  "sessions.settings.saved": "Recording updated",
  "sessions.settings.saveError": "The recording settings could not be saved.",
  "sessions.settings.note":
    "Activity records (actions and errors) continue even without a screen recording.",
  "sessions.auditNote": "Your access to this recording is recorded in the audit log.",
  "sessions.expires": "Expires on {date}.",
  "sessions.expired": "This recording has expired. The activity is still listed.",
  "sessions.notFound.title": "Session not found",
  "sessions.notFound.body": "This session does not exist or you do not have access to it.",
  "sessions.back": "Back to sessions",
  "sessions.breadcrumb.admin": "Administration",
  "sessions.fact.operator": "Operator",
  "sessions.fact.started": "Started",
  "sessions.fact.duration": "Duration",
  "sessions.fact.browser": "Browser",
  "sessions.fact.unknownBrowser": "Unknown browser",
  "sessions.fact.version": "Version",
  "sessions.fact.screen": "Screen",
  "sessions.fact.screenValue": "{width} × {height}",
  "sessions.fact.expires": "Expires",
  "sessions.player.loading": "Loading recording… {loaded} of {total} parts",
  "sessions.player.empty.title": "No screen recording",
  "sessions.player.empty.body":
    "There is no picture of this session. Activity is still on the timeline.",
  "sessions.player.truncated": "The recording stopped after 400 parts.",
  "sessions.player.play": "Play",
  "sessions.player.pause": "Pause",
  "sessions.player.back": "-5 s",
  "sessions.player.forward": "+5 s",
  "sessions.player.speed": "Speed",
  "sessions.player.skip": "Skip inactivity",
  "sessions.player.elapsed": "{elapsed} of {total}",
  "sessions.player.fullscreen": "Full screen",
  "sessions.player.exitFullscreen": "Exit full screen",
  "sessions.player.scrubber": "Recording position",
  "sessions.player.marker": "Go to {label}",
  "sessions.timeline.legend": "Timeline",
  "sessions.timeline.all": "All",
  "sessions.timeline.errors": "Errors",
  "sessions.timeline.actions": "Actions",
  "sessions.timeline.navigation": "Navigation",
  "sessions.timeline.empty": "No actions in this filter.",
  "sessions.timeline.outside": "outside the recording",
  "sessions.timeline.details": "Technical details",
  "sessions.timeline.method": "Method",
  "sessions.timeline.status": "HTTP status",
  "sessions.timeline.problem": "Code",
  "sessions.timeline.duration": "Duration",
  "sessions.timeline.requestId": "requestId",
  "sessions.timeline.correlationId": "correlationId",
  "sessions.timeline.audit": "Audit",
  "sessions.timeline.uploadFailure": "View spreadsheet with error",
  "sessions.activityTruncated": "The timeline shows the first 2,000 actions.",
  "sessions.link.watch": "View session",
  "sessions.link.noRecording": "Session without a screen recording",
  "sessions.link.activity": "View activity",
  "sessionReplay.notice.title": "Session recorded for support",
  "sessionReplay.notice.body":
    "We record this session's screen and actions for support and quality. Passwords, keys and typed fields are hidden. Kept for {days} days.",
  "sessionReplay.notice.ack": "Got it",
  /* -- Autoaprovação (ADR 0020) ------------------------------------------- */
  "nav.autoApproval": "Auto-approval",
  "autoApproval.title": "Auto-approval",
  "autoApproval.description":
    "Governed automatic approval: each stage has its own switch, criteria and audit trail. Everything starts off.",
  "autoApproval.denied": "Only platform administrators manage auto-approval.",
  "autoApproval.tabs": "Auto-approval sections",
  "autoApproval.tab.stages": "Stages",
  "autoApproval.tab.limits": "Limits",
  "autoApproval.tab.preview": "Preview",
  "autoApproval.tab.report": "Daily report",
  "autoApproval.actorLine": "Acting as {actor} · criteria {policy}",
  "autoApproval.status.allOff": "Off. Nothing is approved or published automatically.",
  "autoApproval.status.killSwitch":
    "Environment kill switch is on (AUTO_APPROVAL_KILL_SWITCH). No stage runs.",
  "autoApproval.status.breaker": "Breaker open",
  "autoApproval.status.off": "Off",
  "autoApproval.status.on": "On",
  "autoApproval.status.killed": "Blocked by the kill switch",
  "autoApproval.status.breakerPill": "Breaker open",
  "autoApproval.stage.PACKAGE": "Import package",
  "autoApproval.stage.PACKAGE.desc":
    "Creates pending proposals from the versioned rule package in the repository, each only once its evidence is approved and the current rule is unchanged.",
  "autoApproval.stage.PACKAGE.criteria":
    "Evidence captured|Evidence approved|Current rule unchanged|Not imported yet|Dependency ready|Group enabled",
  "autoApproval.criterion.PACKAGE_EVIDENCE_READY": "Package evidence approved",
  "autoApproval.criterion.PACKAGE_EVIDENCE_READY.tip":
    "Every evidence document the item cites is approved.",
  "autoApproval.criterion.PACKAGE_EVIDENCE_CAPTURED": "Evidence captured",
  "autoApproval.criterion.PACKAGE_EVIDENCE_CAPTURED.tip":
    "The cited document already exists in Documents (capture the URL if missing).",
  "autoApproval.criterion.PACKAGE_TARGET_CURRENT": "Current rule unchanged",
  "autoApproval.criterion.PACKAGE_TARGET_CURRENT.tip":
    "The rule the item supersedes is still what the package expects.",
  "autoApproval.criterion.PACKAGE_NOT_IMPORTED": "Not imported yet",
  "autoApproval.criterion.PACKAGE_NOT_IMPORTED.tip":
    "The item was not created before (idempotent).",
  "autoApproval.criterion.PACKAGE_DEPENDENCY_READY": "Dependency ready",
  "autoApproval.criterion.PACKAGE_DEPENDENCY_READY.tip":
    "The paired SUPERSEDE was created before the UPSERT.",
  "autoApproval.criterion.PACKAGE_GROUP_ENABLED": "Group enabled",
  "autoApproval.criterion.PACKAGE_GROUP_ENABLED.tip":
    "Optional groups only enter with the option on.",
  "autoApproval.outcome.CREATE": "Would create",
  "autoApproval.done.CREATE": "Created",
  "autoApproval.stage.EVIDENCE": "Evidence",
  "autoApproval.stage.FACTS": "Fiscal facts",
  "autoApproval.stage.PROPOSALS": "Rule proposals",
  "autoApproval.stage.POLICY_SWITCH": "Draft policy",
  "autoApproval.stage.PUBLISH": "Automatic publication",
  "autoApproval.stage.EVIDENCE.desc":
    "Approves new documents from registered, healthy official sources with a stable digest and a supported act type.",
  "autoApproval.stage.FACTS.desc":
    "Certifies unverified fiscal facts when the evidence is approved, an independent source agrees and there is no conflict or drift.",
  "autoApproval.stage.PROPOSALS.desc":
    "Approves pending proposals with approved evidence, a valid simulation, no overlap and within the limits.",
  "autoApproval.stage.POLICY_SWITCH.desc":
    "Switches the draft policy (e.g. tax-family-v2) only with zero readiness violations. Never a side effect of another stage.",
  "autoApproval.stage.PUBLISH.desc":
    "Publishes the draft when the canary passes (golden + replay) and rolls back by itself if the post-publish canary fails.",
  "autoApproval.stage.POLICY_SWITCH.note":
    "Changing the policy (e.g. tax-family-v2) is never automatic while this stage is off.",
  "autoApproval.stage.EVIDENCE.criteria":
    "Source registered|URL in registry|Source healthy|Fetch ok|Digest stable|Act supported",
  "autoApproval.stage.FACTS.criteria":
    "Evidence approved|Independent agreement|No certified conflict|No drift",
  "autoApproval.stage.PROPOSALS.criteria":
    "Evidence approved|Dry-run valid|No overlap|Within caps|Policy unchanged",
  "autoApproval.stage.POLICY_SWITCH.criteria": "Target policy with readiness zero",
  "autoApproval.stage.PUBLISH.criteria":
    "Draft present|Readiness zero|Diff in bounds|Only auto-approved|Cooling off|Canary passed",
  "autoApproval.switch.on": "On",
  "autoApproval.switch.off": "Off",
  "autoApproval.lastChange": "Last change by {name} on {when} — “{reason}”",
  "autoApproval.neverChanged": "Never changed (factory default).",
  "autoApproval.reason.label": "Reason",
  "autoApproval.reason.help": "Required, 10 to 500 characters. Stored in the audit trail.",
  "autoApproval.reason.invalid": "Enter a reason with at least 10 characters.",
  "autoApproval.dialog.enable.title": "Turn on {stage}",
  "autoApproval.dialog.disable.title": "Turn off {stage}",
  "autoApproval.dialog.enable.confirm": "Turn stage on",
  "autoApproval.dialog.disable.confirm": "Turn stage off",
  "autoApproval.dialog.enable.body.EVIDENCE":
    "While this stage is on, NEW documents that pass every criterion are approved by the system actor.",
  "autoApproval.dialog.enable.body.FACTS":
    "While this stage is on, UNVERIFIED facts that pass every criterion are certified.",
  "autoApproval.dialog.enable.body.PROPOSALS":
    "While this stage is on, PENDING_REVIEW proposals that pass every criterion are approved.",
  "autoApproval.dialog.enable.body.POLICY_SWITCH":
    "While this stage is on, the draft may switch to the target policy when readiness is zero.",
  "autoApproval.dialog.enable.body.PUBLISH":
    "While this stage is on, the draft may publish after the canary. A post-publish failure rolls back and opens the breaker.",
  "autoApproval.dialog.disable.body":
    "The stage stops acting on later runs. Already approved items are not undone.",
  "autoApproval.dialog.enable.previewCount": "Today {count} would be approved",
  "autoApproval.run.now": "Run now",
  "autoApproval.run.hint": "Starts a manual run with the stages that are effectively on.",
  "autoApproval.run.disabledTip": "No stage is effectively on.",
  "autoApproval.run.confirmTitle": "Run auto-approval now?",
  "autoApproval.run.confirmBody":
    "The run uses the current effective stages, with an idempotency key. Continue?",
  "autoApproval.run.confirm": "Run",
  "autoApproval.run.resultTitle": "Run result",
  "autoApproval.run.result.status": "Status",
  "autoApproval.run.result.acted": "Acted",
  "autoApproval.run.result.held": "Held",
  "autoApproval.run.result.stageCounts": "{acted} acted · {held} held",
  "autoApproval.runStatus.DISABLED": "Disabled",
  "autoApproval.runStatus.LOCKED": "Locked (another run)",
  "autoApproval.runStatus.RUNNING": "Running",
  "autoApproval.runStatus.COMPLETED": "Completed",
  "autoApproval.runStatus.PARTIAL": "Partial",
  "autoApproval.runStatus.FAILED": "Failed",
  "autoApproval.runStage.SKIPPED": "Skipped",
  "autoApproval.runStage.COMPLETED": "Completed",
  "autoApproval.runStage.FAILED": "Failed",
  "autoApproval.trigger.SCHEDULE": "Schedule",
  "autoApproval.trigger.MANUAL": "Manual",
  "autoApproval.toast.saved": "Settings saved",
  "autoApproval.toast.run": "Run {status}",
  "autoApproval.error.conflict": "Someone else changed the settings. Reload.",
  "autoApproval.error.save": "Could not save. Try again.",
  "autoApproval.done.APPROVE": "Approved",
  "autoApproval.done.CERTIFY": "Certified",
  "autoApproval.done.PUBLISH": "Published",
  "autoApproval.done.SWITCH_POLICY": "Policy switched",
  "autoApproval.done.ROLLBACK": "Rolled back",
  "autoApproval.done.HOLD": "Held",
  "autoApproval.outcome.APPROVE": "Would approve",
  "autoApproval.outcome.CERTIFY": "Would certify",
  "autoApproval.outcome.PUBLISH": "Would publish",
  "autoApproval.outcome.SWITCH_POLICY": "Would switch policy",
  "autoApproval.outcome.ROLLBACK": "Rollback",
  "autoApproval.outcome.HOLD": "Held",
  "autoApproval.limits.group.evidence": "Evidence",
  "autoApproval.limits.group.package": "Package",
  "autoApproval.limits.group.facts": "Facts",
  "autoApproval.limits.group.proposals": "Proposals",
  "autoApproval.limits.group.publish": "Publication",
  "autoApproval.limits.group.policy": "Policy",
  "autoApproval.limits.package.packageId": "Package id",
  "autoApproval.limits.package.packageId.help":
    "Versioned rule package shipped with the API (read-only).",
  "autoApproval.limits.package.includeOptionalGroups": "Include optional groups (8 and 9)",
  "autoApproval.limits.package.includeOptionalGroups.help":
    "Off by default. Groups 8 and 9 only import when this switch is on.",
  "autoApproval.limits.package.maxPerRun": "Maximum per run",
  "autoApproval.limits.package.maxPerRun.help": "Package items evaluated per run in this stage.",
  "autoApproval.package.prerequisites": "Human prerequisites",
  "autoApproval.package.panel.wouldCreate": "{count} would be created",
  "autoApproval.package.panel.held": "{count} held",
  "autoApproval.preview.diagnostics": "{stage} diagnostics (every candidate)",
  "autoApproval.package.panel.title": "Package 2026-10-05",
  "autoApproval.package.panel.imported": "{imported} imported",
  "autoApproval.package.panel.total": "{total} items",
  "autoApproval.package.panel.optional": "Optional",
  "autoApproval.package.panel.plans": "Plans",
  "autoApproval.limits.invalid":
    "Some values are outside the contract limits. Fix them before saving.",
  "autoApproval.limits.save": "Save limits",
  "autoApproval.limits.reset": "Reset to defaults",
  "autoApproval.limits.dirty": "Local changes not saved yet.",
  "autoApproval.limits.confirmTitle": "Save limits?",
  "autoApproval.limits.confirmBody":
    "The new caps apply on the next run. Enter a reason for the audit trail.",
  "autoApproval.limits.evidence.minObservations": "Minimum observations",
  "autoApproval.limits.evidence.minObservations.help":
    "Receipts with the same digest before approval.",
  "autoApproval.limits.evidence.minStableHours": "Minimum stable hours",
  "autoApproval.limits.evidence.minStableHours.help":
    "Or: first seen at least this many hours ago with no change.",
  "autoApproval.limits.evidence.maxPerRun": "Maximum per run",
  "autoApproval.limits.evidence.maxPerRun.help": "Documents evaluated per run in this stage.",
  "autoApproval.limits.evidence.supportedActs": "Supported acts",
  "autoApproval.limits.evidence.supportedActs.help": "Official act kinds this stage may approve.",
  "autoApproval.limits.facts.maxPerRun": "Maximum per run",
  "autoApproval.limits.facts.maxPerRun.help": "Facts evaluated per run.",
  "autoApproval.limits.proposals.maxRateDeltaPp": "Maximum rate delta",
  "autoApproval.limits.proposals.maxRateDeltaPp.help":
    "Largest allowed change in percentage points on rates.",
  "autoApproval.limits.proposals.maxMvaDeltaPp": "Maximum MVA delta",
  "autoApproval.limits.proposals.maxMvaDeltaPp.help":
    "Largest allowed change in percentage points on MVA.",
  "autoApproval.limits.proposals.maxAffectedRules": "Maximum affected rules",
  "autoApproval.limits.proposals.maxAffectedRules.help": "Rules added or changed by one run.",
  "autoApproval.limits.proposals.maxPerRun": "Maximum per run",
  "autoApproval.limits.proposals.maxPerRun.help": "Proposals evaluated per run.",
  "autoApproval.limits.proposals.allowDeletions": "Allow deletions",
  "autoApproval.limits.proposals.allowDeletions.help":
    "Off by default. SUPERSEDE that drops families or fields is held.",
  "autoApproval.limits.proposals.allowNewRules": "Allow new rules",
  "autoApproval.limits.proposals.allowNewRules.help": "If off, new UPSERTs are held.",
  "autoApproval.limits.publish.maxAddedRules": "Maximum added rules",
  "autoApproval.limits.publish.maxAddedRules.help": "Publication diff cap (added).",
  "autoApproval.limits.publish.maxChangedRules": "Maximum changed rules",
  "autoApproval.limits.publish.maxChangedRules.help": "Publication diff cap (changed).",
  "autoApproval.limits.publish.maxRemovedRules": "Maximum removed rules",
  "autoApproval.limits.publish.maxRemovedRules.help": "Publication diff cap (removed). Default 0.",
  "autoApproval.limits.publish.minDraftAgeMinutes": "Minimum draft age",
  "autoApproval.limits.publish.minDraftAgeMinutes.help":
    "Minutes after the newest approval before publishing.",
  "autoApproval.limits.publish.includeHumanApproved": "Include human-approved proposals",
  "autoApproval.limits.publish.includeHumanApproved.help":
    "Off by default. If on, the draft may carry human approvals.",
  "autoApproval.limits.policy.targetPolicyVersion": "Target policy",
  "autoApproval.limits.policy.targetPolicyVersion.help": "Used only when the policy stage is on.",
  "autoApproval.unit.observations": "observations",
  "autoApproval.unit.hours": "hours",
  "autoApproval.unit.documents": "documents",
  "autoApproval.unit.facts": "facts",
  "autoApproval.unit.pp": "pp",
  "autoApproval.unit.rules": "rules",
  "autoApproval.unit.proposals": "proposals",
  "autoApproval.unit.minutes": "minutes",
  "autoApproval.preview.readonly": "Read-only: nothing was changed.",
  "autoApproval.preview.run": "Preview now",
  "autoApproval.preview.generatedAt": "Generated at {when}",
  "autoApproval.preview.empty.title": "No preview yet",
  "autoApproval.preview.empty.body":
    "Run the preview to see what would be approved, certified or held right now.",
  "autoApproval.preview.stats": "Per-stage summary",
  "autoApproval.preview.stat.wouldAct": "would act",
  "autoApproval.preview.stat.scope": "{held} held · {candidates} candidates",
  "autoApproval.preview.truncated": "List truncated by the per-run cap",
  "autoApproval.preview.enabled.on": "Stage on",
  "autoApproval.preview.enabled.off": "Stage off",
  "autoApproval.preview.elapsed": "Elapsed {ms} ms",
  "autoApproval.preview.scenario.legend": "Scenario",
  "autoApproval.preview.scenario.current": "current",
  "autoApproval.preview.scenario.all": "everything on (includes policy)",
  "autoApproval.preview.canary.title": "Canary",
  "autoApproval.preview.canary.passed":
    "Canary passed: golden parity and replay with no unexpected regressions.",
  "autoApproval.preview.canary.failed": "Canary failed. See failures below.",
  "autoApproval.preview.canary.suites": "Golden suites",
  "autoApproval.preview.canary.suite": "Suite",
  "autoApproval.preview.canary.passedTotal": "Passed / total",
  "autoApproval.preview.canary.replay":
    "Replay: {items} items · {unchanged} unchanged · {expected} expected changes · {unexpected} regressions",
  "autoApproval.preview.canary.failures": "Canary failures",
  "autoApproval.preview.canary.case": "Case",
  "autoApproval.preview.canary.kind": "Kind",
  "autoApproval.preview.canary.expectations": "Owner expectations",
  "autoApproval.preview.canary.expectation.label": "Expectation",
  "autoApproval.preview.canary.expectation.expected": "Expected",
  "autoApproval.preview.canary.expectation.actual": "Actual",
  "autoApproval.preview.canary.expectation.status": "Status",
  "autoApproval.preview.canary.expectation.note": "Note",
  "autoApproval.preview.canary.expectation.PASS": "Passed",
  "autoApproval.preview.canary.expectation.FAIL": "Failed",
  "autoApproval.preview.canary.expectation.NOT_APPLICABLE": "Not applicable",
  "autoApproval.canaryKind.GOLDEN_MISMATCH": "Golden mismatch",
  "autoApproval.canaryKind.UNEXPECTED_CHANGE": "Unexpected change",
  "autoApproval.canaryKind.STATUS_DOWNGRADE": "Status downgrade",
  "autoApproval.canaryKind.REPLAY_MISMATCH": "Replay mismatch",
  "autoApproval.preview.items.title": "Evaluated items",
  "autoApproval.preview.items.empty": "No items in this filter",
  "autoApproval.preview.items.emptyBody": "Adjust the stage or outcome filter.",
  "autoApproval.preview.filter.stage": "Stage",
  "autoApproval.preview.filter.all": "All",
  "autoApproval.preview.filter.outcome": "Outcome",
  "autoApproval.preview.col.label": "Item",
  "autoApproval.preview.col.stage": "Stage",
  "autoApproval.preview.col.outcome": "Outcome",
  "autoApproval.preview.col.reasons": "Criteria",
  "autoApproval.report.date": "Date",
  "autoApproval.report.timezone": "Timezone America/Sao_Paulo",
  "autoApproval.report.stats": "Day totals",
  "autoApproval.report.count.evidence": "Evidence approved",
  "autoApproval.report.count.facts": "Facts certified",
  "autoApproval.report.count.proposals": "Proposals approved",
  "autoApproval.report.count.policy": "Policy switches",
  "autoApproval.report.count.published": "Versions published",
  "autoApproval.report.count.rollbacks": "Rollbacks",
  "autoApproval.report.actions.title": "Actions of the day",
  "autoApproval.report.actions.empty": "No actions on this day.",
  "autoApproval.report.actions.time": "Time",
  "autoApproval.report.actions.stage": "Stage",
  "autoApproval.report.actions.outcome": "Outcome",
  "autoApproval.report.actions.label": "Item",
  "autoApproval.report.actions.criteria": "Criteria",
  "autoApproval.report.holds.title": "Holds (grouped)",
  "autoApproval.report.holds.empty": "No current holds.",
  "autoApproval.report.holds.stage": "Stage",
  "autoApproval.report.holds.reason": "Reason",
  "autoApproval.report.holds.count": "Count",
  "autoApproval.report.holds.explanation": "Explanation",
  "autoApproval.report.breakers.title": "Open breakers",
  "autoApproval.report.breakers.empty": "No open breakers.",
  "autoApproval.report.runs.title": "Latest runs",
  "autoApproval.report.runs.empty": "No runs recorded.",
  "autoApproval.report.runs.started": "Started",
  "autoApproval.report.runs.trigger": "Trigger",
  "autoApproval.report.runs.status": "Status",
  "autoApproval.report.runs.acted": "Acted",
  "autoApproval.report.runs.held": "Held",
  "autoApproval.report.runs.errors": "Per-stage errors",
  "autoApproval.status.breakerNotice":
    "Automatic publication stopped: the post-publish canary failed at {date} and the previous version was restored. To resume, turn the stage on again with a reason.",
  "autoApproval.criterion.STAGE_DISABLED": "Stage off",
  "autoApproval.criterion.STAGE_DISABLED.tip": "The stage toggle is off in settings.",
  "autoApproval.criterion.KILL_SWITCH": "Kill switch",
  "autoApproval.criterion.KILL_SWITCH.tip": "The environment kill switch blocks every stage.",
  "autoApproval.criterion.EVALUATION_FAILED": "Evaluation failed",
  "autoApproval.criterion.EVALUATION_FAILED.tip": "Evaluation failed with an internal error.",
  "autoApproval.criterion.LIMIT_REACHED": "Limit reached",
  "autoApproval.criterion.LIMIT_REACHED.tip": "The per-run cap was reached.",
  "autoApproval.criterion.CHANGED_SINCE_EVALUATION": "Changed after evaluation",
  "autoApproval.criterion.CHANGED_SINCE_EVALUATION.tip": "The resource changed after evaluation.",
  "autoApproval.criterion.SOURCE_REGISTERED": "Source registered",
  "autoApproval.criterion.SOURCE_REGISTERED.tip":
    "The source is in the reviewed official registry.",
  "autoApproval.criterion.URL_IN_REGISTRY": "URL in registry",
  "autoApproval.criterion.URL_IN_REGISTRY.tip":
    "The canonical URL matches the source host and path prefix.",
  "autoApproval.criterion.SOURCE_HEALTHY": "Source healthy",
  "autoApproval.criterion.SOURCE_HEALTHY.tip": "The source is ACTIVE (not degraded).",
  "autoApproval.criterion.FETCH_OK": "Fetch ok",
  "autoApproval.criterion.FETCH_OK.tip": "A raw artifact and content_sha256 exist.",
  "autoApproval.criterion.DIGEST_STABLE": "Digest stable",
  "autoApproval.criterion.DIGEST_STABLE.tip":
    "The digest repeated enough times or stayed stable long enough.",
  "autoApproval.criterion.ACT_SUPPORTED": "Act supported",
  "autoApproval.criterion.ACT_SUPPORTED.tip": "The official act kind is on the supported list.",
  "autoApproval.criterion.EVIDENCE_APPROVED": "Evidence approved",
  "autoApproval.criterion.EVIDENCE_APPROVED.tip": "Every linked evidence document is APPROVED.",
  "autoApproval.criterion.INDEPENDENT_AGREEMENT": "Independent agreement",
  "autoApproval.criterion.FULL_VALIDITY_COVERAGE": "Full validity supported",
  "autoApproval.criterion.FULL_VALIDITY_COVERAGE.tip":
    "The supporting sources must cover the entire proposed effective period.",
  "autoApproval.criterion.QUALIFIED_APPLICABILITY": "Applicability qualified",
  "autoApproval.criterion.QUALIFIED_APPLICABILITY.tip":
    "Stored evidence must support the exact product, route, transaction conditions and fiscal parameters. An approved document alone is insufficient.",
  "autoApproval.criterion.INDEPENDENT_AGREEMENT.tip": "An independent source agrees.",
  "autoApproval.criterion.NO_CERTIFIED_CONFLICT": "No certified conflict",
  "autoApproval.criterion.NO_CERTIFIED_CONFLICT.tip": "No certified fact conflicts.",
  "autoApproval.criterion.NO_DRIFT": "No drift",
  "autoApproval.criterion.NO_DRIFT.tip": "Not on the Verification drift list.",
  "autoApproval.criterion.DRY_RUN_VALID": "Dry-run valid",
  "autoApproval.criterion.DRY_RUN_VALID.tip": "Applying it to the draft validates cleanly.",
  "autoApproval.criterion.NO_PENDING_OVERLAP": "No pending overlap",
  "autoApproval.criterion.NO_PENDING_OVERLAP.tip": "No other pending proposal overlaps.",
  "autoApproval.criterion.WITHIN_THRESHOLDS": "Within thresholds",
  "autoApproval.criterion.WITHIN_THRESHOLDS.tip": "Proposal deltas stay within caps.",
  "autoApproval.criterion.RATE_DELTA_WITHIN_CAP": "Rate delta ok",
  "autoApproval.criterion.RATE_DELTA_WITHIN_CAP.tip": "Rate change stays within the cap.",
  "autoApproval.criterion.MVA_DELTA_WITHIN_CAP": "MVA delta ok",
  "autoApproval.criterion.MVA_DELTA_WITHIN_CAP.tip": "MVA change stays within the cap.",
  "autoApproval.criterion.NO_DELETION": "No deletion",
  "autoApproval.criterion.NO_DELETION.tip": "Deletions are disabled in these limits.",
  "autoApproval.criterion.NEW_RULES_ALLOWED": "New rules allowed",
  "autoApproval.criterion.NEW_RULES_ALLOWED.tip": "New UPSERT rules are allowed.",
  "autoApproval.criterion.AFFECTED_RULES_WITHIN_CAP": "Affected rules ok",
  "autoApproval.criterion.AFFECTED_RULES_WITHIN_CAP.tip": "Affected rules fit the per-run cap.",
  "autoApproval.criterion.POLICY_UNCHANGED": "Policy unchanged",
  "autoApproval.criterion.POLICY_UNCHANGED.tip": "The proposal does not need another draft policy.",
  "autoApproval.criterion.WAITING_FOR_DEPENDENCY": "Waiting for dependency",
  "autoApproval.criterion.WAITING_FOR_DEPENDENCY.tip":
    "Waiting for a pending SUPERSEDE in the same run.",
  "autoApproval.criterion.POLICY_SWITCH_REQUIRES_HUMAN": "Policy needs a human",
  "autoApproval.criterion.POLICY_SWITCH_REQUIRES_HUMAN.tip":
    "Switching policy needs stage 5 or a person.",
  "autoApproval.criterion.TARGET_POLICY_READY": "Target policy ready",
  "autoApproval.criterion.TARGET_POLICY_READY.tip":
    "The target policy must have zero readiness violations.",
  "autoApproval.criterion.DRAFT_PRESENT": "Draft present",
  "autoApproval.criterion.DRAFT_PRESENT.tip":
    "A draft with approved proposals and current base exists.",
  "autoApproval.criterion.BASE_CURRENT": "Base current",
  "autoApproval.criterion.BASE_CURRENT.tip": "The draft base is the active version.",
  "autoApproval.criterion.READINESS_ZERO": "Readiness zero",
  "autoApproval.criterion.READINESS_ZERO.tip": "Draft policy readiness has 0 blocking violations.",
  "autoApproval.criterion.DIFF_WITHIN_BOUNDS": "Diff in bounds",
  "autoApproval.criterion.DIFF_WITHIN_BOUNDS.tip": "The draft diff fits publication caps.",
  "autoApproval.criterion.ONLY_AUTO_APPROVED": "Only auto-approved",
  "autoApproval.criterion.ONLY_AUTO_APPROVED.tip": "Only system-approved proposals may ship.",
  "autoApproval.criterion.COOLING_OFF": "Cooling off",
  "autoApproval.criterion.COOLING_OFF.tip":
    "The minimum age after the newest approval has not elapsed.",
  "autoApproval.criterion.CANARY_PASSED": "Canary passed",
  "autoApproval.criterion.CANARY_PASSED.tip": "The canary (golden + replay) passed.",
  "autoApproval.criterion.BREAKER_TRIPPED": "Breaker open",
  "autoApproval.criterion.BREAKER_TRIPPED.tip": "The publication circuit breaker is open.",
  "autoApproval.criterion.POST_PUBLISH_CANARY_PASSED": "Post-publish canary passed",
  "autoApproval.criterion.POST_PUBLISH_CANARY_PASSED.tip":
    "The post-publish canary confirmed the active version.",
  "autoApproval.act.LEI": "LEI",
  "autoApproval.act.LEI_COMPLEMENTAR": "LEI COMPLEMENTAR",
  "autoApproval.act.DECRETO": "DECRETO",
  "autoApproval.act.RICMS": "RICMS",
  "autoApproval.act.PORTARIA": "PORTARIA",
  "autoApproval.act.RESOLUCAO": "RESOLUCAO",
  "autoApproval.act.INSTRUCAO_NORMATIVA": "INSTRUCAO NORMATIVA",
  "autoApproval.act.CONVENIO_ICMS": "CONVENIO ICMS",
  "autoApproval.act.PROTOCOLO_ICMS": "PROTOCOLO ICMS",
  "autoApproval.act.AJUSTE_SINIEF": "AJUSTE SINIEF",
  "autoApproval.act.ATO_COTEPE": "ATO COTEPE",
  "autoApproval.act.DECISAO_NORMATIVA": "DECISAO NORMATIVA",
  "autoApproval.act.COMUNICADO": "COMUNICADO",
  "autoApproval.act.TIPI": "TIPI",
  "driveWatch.title": "Commercial Drive monitor",
  "driveWatch.summary": "Track versions and changes in the commercial reference folder.",
  "driveWatch.boundary":
    "Metadata only. This monitor does not download workbooks or approve or publish tax rules.",
  "driveWatch.disabled":
    "Automatic monitoring is disabled. This folder is not being actively monitored.",
  "driveWatch.scope":
    "Scope: direct children of the folder; nested files are excluded. History before the first scan is unconfirmed.",
  "driveWatch.schedule":
    "Daily check through the research schedule. Monthly reconciliation becomes due on day 1 at 06:00 Brasília time and runs at the next available trigger.",
  "driveWatch.openFolder": "Open reference folder",
  "driveWatch.lastCompleted": "Last complete scan · Brasília",
  "driveWatch.observed": "Files in the last complete scan",
  "driveWatch.nextCheck": "Next eligible check · Brasília",
  "driveWatch.nextMonthly": "Eligible monthly reconciliation · Brasília",
  "driveWatch.lastAttempt": "Last attempt: {date}",
  "driveWatch.retryAt": "Resume from {date}",
  "driveWatch.noRun": "No scan recorded yet. Missing data does not mean zero files.",
  "driveWatch.files": "Metadata from the last complete scan",
  "driveWatch.comparison":
    "{added} newly observed · {changed} metadata changes · {absent} not observed. Absence does not confirm deletion. Content not downloaded.",
  "driveWatch.file": "File ID",
  "driveWatch.version": "Drive version",
  "driveWatch.change": "Comparison",
  "driveWatch.observedAt": "Observed at · Brasília",
  "driveWatch.status.DISABLED": "Disabled",
  "driveWatch.status.FAILED": "Needs attention",
  "driveWatch.status.RUNNING": "Scanning",
  "driveWatch.status.PAUSED": "Awaiting resume",
  "driveWatch.status.ACTIVE": "Monitoring",
  "driveWatch.status.WAITING": "Awaiting first scan",
  "driveWatch.change.NEWLY_OBSERVED": "Newly observed",
  "driveWatch.change.METADATA_CHANGED": "Metadata changed",
  "driveWatch.change.UNCHANGED": "Unchanged",
  "driveWatch.change.NOT_OBSERVED": "Not observed",
  "driveWatch.run.RUNNING": "Running",
  "driveWatch.run.RETRY_PENDING": "Retry pending",
  "driveWatch.run.PAUSED": "Paused",
  "driveWatch.run.COMPLETED": "Completed",
  "driveWatch.run.FAILED": "Failed",
  "driveWatch.run.SUPERSEDED": "Superseded by new configuration",
  "driveWatch.error.PAGE_TOKEN_REJECTED": "Page token rejected; a fresh scan is required",
  "driveWatch.error.CAPACITY_EXCEEDED": "Scan page limit reached; review required",
  "driveWatch.error.AUTHENTICATION_FAILED": "Process authentication unavailable",
  "driveWatch.error.ACCESS_DENIED": "Cannot list the folder",
  "driveWatch.error.NOT_FOUND": "Folder not found",
  "driveWatch.error.API_DISABLED": "Drive API is disabled",
  "driveWatch.error.RATE_LIMITED": "Drive rate limit reached",
  "driveWatch.error.NETWORK_ERROR": "Drive connection failed",
  "driveWatch.error.TIMEOUT": "Drive request timed out",
  "driveWatch.error.INVALID_RESPONSE": "Invalid Drive response",
  "driveWatch.error.PAGINATION_CYCLE": "Repeated pagination; scan stopped",
  "driveWatch.error.INCOMPLETE_SEARCH": "Incomplete listing; comparison not completed",
  "driveWatch.error.LEASE_LOST": "Another process owns the run",
  "driveWatch.error.BUDGET_EXCEEDED": "Run time budget reached",
  "driveWatch.error.INTERNAL_ERROR": "Internal failure; review required",
  "autonomousResearch.title": "Autonomous research",
  "autonomousResearch.summary":
    "Each cycle, the platform picks the most important gaps and researches them on its own, inside the budget. Nothing is approved or published automatically.",
  "autonomousResearch.status.active": "On",
  "autonomousResearch.status.disabled": "Off",
  "autonomousResearch.status.failed": "Last run failed",
  "autonomousResearch.kpi.lastRun": "Last run",
  "autonomousResearch.kpi.nextRun": "Next run",
  "autonomousResearch.kpi.spend": "Estimated spend today",
  "autonomousResearch.kpi.spendOf": "of {cap}",
  "autonomousResearch.kpi.queued": "Items queued",
  "autonomousResearch.kpi.noRun": "No run yet",
  "autonomousResearch.queuedSplit": "Gaps: {gaps} · Web sweeps: {web} · Questions: {questions}",
  "autonomousResearch.rows": "{count} calculation rows",
  "autonomousResearch.forcedHint":
    "Researched again inside the reuse window because the last result was empty or inconclusive.",
  "autonomousResearch.brasiliaTime": "Brasília time",
  "autonomousResearch.nextUnknown": "Next run time is unavailable",
  "autonomousResearch.run.RUNNING": "Running",
  "autonomousResearch.run.COMPLETED": "Completed",
  "autonomousResearch.run.DISABLED": "Queued nothing",
  "autonomousResearch.run.FAILED": "Failed",
  "autonomousResearch.duration.seconds": "{seconds} s",
  "autonomousResearch.duration.minutes": "{minutes} min {seconds} s",
  "autonomousResearch.limits":
    "Up to {max} items per run · backoff after {after} inconclusive results, for {days} days · reuse for {reuse} days",
  "autonomousResearch.disabled":
    "Autonomous research is off at the kill switch. The daily run can still start, but it queues nothing.",
  "autonomousResearch.empty": "There has been no run yet. The first one happens at {when}.",
  "autonomousResearch.emptyNoWhen":
    "There has been no run yet. The first one happens at the next scheduled time.",
  "autonomousResearch.items.title": "Items in this run ({count})",
  "autonomousResearch.items.caption": "Items from the latest run",
  "autonomousResearch.items.empty": "This run recorded no items.",
  "autonomousResearch.items.tier": "Priority",
  "autonomousResearch.items.path": "Path",
  "autonomousResearch.items.target": "Target",
  "autonomousResearch.items.estimate": "Estimate",
  "autonomousResearch.items.outcome": "Outcome",
  "autonomousResearch.tier.PRIORITY_ROUTE": "Priority route",
  "autonomousResearch.tier.LOT_GAP": "Real lot",
  "autonomousResearch.tier.NATIONAL_BASE": "National base",
  "autonomousResearch.path.CALCULATOR_RESEARCH": "Gap",
  "autonomousResearch.path.WEB_RESEARCH_SWEEP": "Web research",
  "autonomousResearch.path.AGENT_QUESTION": "Question",
  "autonomousResearch.outcome.QUEUED": "Queued",
  "autonomousResearch.outcome.REUSED": "Reused",
  "autonomousResearch.outcome.JOINED_ACTIVE": "Already running",
  "autonomousResearch.outcome.SKIPPED_BUDGET": "Out of budget",
  "autonomousResearch.outcome.SKIPPED_MAX_ITEMS": "Item limit",
  "autonomousResearch.outcome.SKIPPED_BACKOFF": "Waiting (backoff until {date})",
  "autonomousResearch.outcome.SKIPPED_UNAVAILABLE": "Unavailable",
  "autonomousResearch.outcome.FAILED": "Failed",
  "autonomousResearch.forced": "forced",
  "autonomousResearch.link.request": "Open request",
  "autonomousResearch.link.sweep": "Open sweep",
  "autonomousResearch.link.task": "Open task",
  "autonomousResearch.history.title": "Recent runs",
  "autonomousResearch.history.date": "Date",
  "autonomousResearch.history.queued": "Queued",
  "autonomousResearch.history.spend": "Estimated spend",
  "autonomousResearch.meter": "Estimated spend today against the daily cap",
  "autonomousResearch.loading": "Loading autonomous research",
  "autonomousResearch.runSpend": "{amount} this run",
  "autonomousResearch.route": "{origin} → {destination}",
  "acquisitionSettings.title": "Acquisition tax regime · SP",
  "acquisitionSettings.description":
    "Policy of the entity purchasing for the São Paulo warehouse. Confirm the regime and credits with accounting; product classification and benefits remain tied to their evidence.",
  "acquisitionSettings.entity": "Entity",
  "acquisitionSettings.chooseEntity": "Select an entity",
  "acquisitionSettings.warehouse": "Purchasing warehouse",
  "acquisitionSettings.regime": "PIS/COFINS regime",
  "acquisitionSettings.regime.UNKNOWN": "Unconfirmed",
  "acquisitionSettings.regime.NON_CUMULATIVE": "Non-cumulative",
  "acquisitionSettings.regime.CUMULATIVE": "Cumulative",
  "acquisitionSettings.credit": "Ordinary acquisition credit",
  "acquisitionSettings.credit.UNCONFIRMED": "Unconfirmed",
  "acquisitionSettings.credit.ELIGIBLE": "Eligible, confirmed by accounting",
  "acquisitionSettings.credit.INELIGIBLE": "Ineligible",
  "acquisitionSettings.creditHint":
    "Ordinary credits require the non-cumulative regime. Product eligibility is also verified during calculation.",
  "acquisitionSettings.validFrom": "Valid from",
  "acquisitionSettings.validTo": "Valid until",
  "acquisitionSettings.validToHint": "Optional. Blank means no declared end date.",
  "acquisitionSettings.reference": "Accounting confirmation reference",
  "acquisitionSettings.referenceHint":
    "Enter the reference and confirmation received from accounting (10–1,000 characters).",
  "acquisitionSettings.revision": "Revision",
  "acquisitionSettings.confirmedAt": "Confirmed at",
  "acquisitionSettings.unconfigured":
    "This entity has no confirmed acquisition policy yet. No regime has been assumed.",
  "acquisitionSettings.save": "Confirm tax policy",
  "acquisitionSettings.saved": "Tax policy confirmed",
  "acquisitionSettings.reload": "Discard edits and reload",
  "acquisitionSettings.conflict":
    "The policy changed while you were editing. Reload the current revision before confirming again.",
  "acquisitionSettings.invalidWindow": "The end date must be on or after the start date.",
  "acquisitionSettings.historyHint":
    "Each confirmation creates a revision and an audit record. Saved calculations retain their original data and values.",
  "publication.form.title": "Calculation purpose",
  "publication.form.intent": "Calculate for",
  "publication.form.taxes": "Taxes and sale scenario",
  "publication.form.purchase": "Publication price (purchase)",
  "publication.form.takeRate": "Offer take rate (%)",
  "publication.form.goodsOriginScope":
    "Fills only items whose spreadsheet omitted this code. This is the goods tax-origin code, separate from the supplier state; existing item codes are preserved.",
  "publication.form.hint":
    "From 0% to less than 100%, without rounding. This offer has zero additional acquisition charges and ST base additions.",
  "publication.form.source":
    "Take rate identified in {cell}; confirm or change it before importing.",
  "publication.form.rateError":
    "Enter a take rate from 0% to less than 100%, with at most 16 decimal places.",
  "publication.form.unitRequired":
    "Declare cost per commercial unit or map the column that states its monetary basis. Publication mode requires UNIT for each product.",
  "publication.form.declarations":
    "This mode declares a merchandise purchase for resale by an ICMS-taxpayer establishment. Confirm the supplier, cost composition, ST status and regime below. Own use and fixed assets require a different calculation.",
  "publication.form.saved":
    "Take rate: {rate}%. Purchase into SP. Additional charges: {charges}; ST base additions: {stBase}. Resale destination and taxes will be handled when a buyer is known.",
  "publication.title": "Acquisition and listing price",
  "publication.scope":
    "Purchase into SP. The listing price includes the stated take rate. Resale taxes depend on the buyer and will be calculated when the destination is known.",
  "publication.supplierIpi.comparison": "Supplier IPI comparison",
  "publication.supplierIpi.incomplete":
    "The declared IPI source is incomplete. For an industry supplier, provide its rate and unit amount in N and O and retain their source cells in the calculation.",
  "publication.supplierIpi.source": "IPI source",
  "publication.supplierIpi.rate": "Declared rate",
  "publication.supplierIpi.amount": "Declared amount",
  "publication.supplierIpi.computed": "Amount from declared rate",
  "publication.supplierIpi.qualifiedRate": "Reference fiscal rate",
  "publication.supplierIpi.rateCell": "Rate cell",
  "publication.supplierIpi.amountCell": "Amount cell",
  "publication.supplierIpi.delta": "Exact difference",
  "publication.supplierIpi.tolerance": "Numeric representation limit",
  "publication.supplierIpi.declared": "Supplier declared",
  "publication.supplierIpi.amountFormula": "Supplier-declared IPI per commercial unit",
  "publication.supplierIpi.rateFormula": "Invoice goods price × declared IPI rate",
  "publication.supplierIpi.comparisonFormula":
    "Compare the declared amount with invoice goods price × rate, retaining the original amount",
  "publication.supplierIpi.conflict":
    "IPI Valor does not match the invoice goods price and declared rate. Correct columns N and O before publishing the price.",
  "publication.supplierIpi.distributorConflict":
    "An ordinary distributor profile does not allow charging IPI. Check the supplier and declared amounts.",
  "publication.supplierIpi.exact": "Values match",
  "publication.supplierIpi.representation":
    "Excel representation difference; declared amount retained",
  "publication.supplierIpi.savedTitle": "Saved IPI declaration",
  "publication.supplierIpi.savedPending":
    "Supplier IPI from the saved input. Fiscal qualification is still pending; these values are not calculated tax or a listing price.",
  "publication.supplierIpi.savedPrecision":
    "Saved input decimals without rounding: rate as a fraction and amount in BRL per commercial unit.",
  "publication.supplierIpi.notice":
    "The IPI used was declared by the supplier. Its rate, amount and source cells are shown in the detail; a reference fiscal rate does not replace this declaration.",
  "publication.pending":
    "Acquisition qualification is incomplete. Listing values will appear once the required fiscal information is resolved.",
  "publication.pending.ncm":
    "The NCM for this product still needs to be identified. This is a classification step, not an additional tax rate.",
  "publication.pending.ipiPredicate":
    "A characteristic of this model may change IPI. The applicable condition must be resolved before using a general rate.",
  "publication.pending.purchaseRule":
    "An applicable ICMS/ST rule is still missing for this purchase. A rule for another origin state cannot replace this route’s rule.",
  "publication.pending.goodsOrigin":
    "Confirm the goods-origin tax code (0–8, the first digit of the Brazilian CST) to calculate the listing price. This code is separate from the purchase’s origin state (UF), such as MG.",
  "publication.principalUnit": "Negotiated price · unit",
  "publication.acquisitionUnit": "Acquisition cost · unit",
  "publication.listingUnit": "Listing price · unit",
  "publication.listingLot": "Listing price · lot",
  "publication.creditUnit": "PIS/COFINS credit · unit",
  "publication.netAfterContributions": "Cost after PIS/COFINS credit · unit",
  "publication.creditUnconfirmed": "Unconfirmed",
  "publication.creditUnconfirmedHint":
    "The PIS/COFINS credit is not yet confirmed. PIS and COFINS amounts are reference calculations under the regime and do not establish a recoverable credit. The listing price uses the acquisition cost and take rate, without deducting credits.",
  "publication.precision":
    "{digits} significant digits, with no intermediate rounding to cents. All saved digits are displayed.",
  "publication.inputs": "Inputs for each step",
  "publication.evidence": "Acquisition evidence",
  "publication.distributorIpi": "Ordinary distributor: no separately charged IPI",
  "publication.formula.fcpNotApplicableToResale":
    "Not applicable to an MG → SP acquisition for resale without ST.",
  "publication.treatment.NOT_APPLICABLE_TO_RESALE": "Not applicable to resale",
  "publication.supplier.INDUSTRY": "Industry",
  "publication.supplier.DISTRIBUTOR": "Distributor",
  "publication.step.ownIcms": "Purchase own ICMS",
  "publication.step.pisCofinsBase": "PIS/COFINS base: principal less ICMS",
  "publication.step.pis": "Purchase PIS",
  "publication.step.cofins": "Purchase COFINS",
  "publication.step.ipi": "IPI on the principal price",
  "publication.step.mva": "Applied MVA",
  "publication.step.stBase": "ICMS-ST base including IPI",
  "publication.step.icmsSt": "Purchase ICMS-ST",
  "publication.step.fcpSt": "Purchase FCP-ST",
  "publication.step.fcp": "Purchase FCP",
  "publication.step.acquisitionCost": "Acquisition cost",
  "publication.step.listingPrice": "Listing price including take rate",
  "publication.input.intraRate": "Internal burden used for adjustment",
  "publication.input.nominalInternalRate": "Nominal internal rate for the ST debit",
  "publication.input.ignoredMaterializedMva": "Unused materialized MVA",
  "publication.input.acquisitionMvaMode": "MVA calculation mode",
  "publication.input.sourcePolicyVersion": "Pinned ruleset policy",
  "publication.input.intraSource": "Internal burden source",
  "publication.input.reason": "Adjustment reason",
  "publication.input.warning": "Warning",
  "publication.mva.mode.EXACT_ACQUISITION": "Full precision acquisition",
  "publication.mva.intraSource.RULE": "Published effective burden",
  "publication.mva.intraSource.NOMINAL_NOT_INFORMED": "Nominal: effective burden not provided",
  "publication.mva.intraSource.NOMINAL_OUT_OF_VALIDITY":
    "Nominal: effective burden outside validity",
  "publication.mva.reason.ADJUSTED": "Internal burden exceeds interstate rate",
  "publication.mva.reason.NOT_INTERSTATE": "Intrastate operation",
  "publication.mva.reason.INTRA_NOT_GREATER_THAN_INTER":
    "Internal burden does not exceed interstate rate",
  "publication.mva.warning.nominalNotInformed":
    "Effective burden not provided; the nominal internal rate is used.",
  "publication.mva.warning.nominalOutOfValidity":
    "Effective burden outside validity; the nominal internal rate is used.",
  "publication.formula.mvaEffectiveIntra":
    "((1 + original MVA) × (1 − interstate rate) ÷ (1 − internal adjustment burden)) − 1",
  "publication.formula.fcpNotApplicableToResaleRoute":
    "Not applicable to {origin} → {destination} resale acquisition without ST.",
  "recalculateLot.change.SUPPLIER_IPI_PUBLICATION":
    "Interstate acquisition into SP with declared IPI and MVA from published treatment, without intermediate rounding; current fiscal authority is still required.",
  "proposals.create.noAdditionalEvidence":
    "No other approved documents on this page. Change the search or browse the following pages.",
  "publication.input.principal": "Principal price",
  "publication.input.ownIcmsRate": "Own ICMS rate",
  "publication.input.ownIcms": "Own ICMS",
  "publication.input.pisCofinsBase": "PIS/COFINS base",
  "publication.input.pisRate": "PIS rate",
  "publication.input.cofinsRate": "COFINS rate",
  "publication.input.ipiRate": "IPI rate",
  "publication.input.ipi": "IPI",
  "publication.input.originalMva": "Original MVA",
  "publication.input.interstateRate": "Interstate rate",
  "publication.input.internalRate": "Internal rate",
  "publication.input.additionalStBase": "Other additions to the ST base",
  "publication.input.appliedMva": "Applied MVA",
  "publication.input.stBase": "ICMS-ST base",
  "publication.input.fcpRate": "FCP rate",
  "publication.input.acquisitionCharges": "Acquisition charges",
  "publication.input.acquisitionCost": "Acquisition cost",
  "publication.input.takeRate": "Take rate",
  "publication.input.icmsSt": "ICMS-ST",
  "publication.input.fcp": "FCP",
  "publication.input.supplierType": "Supplier type",
  "publication.input.legalReference": "Legal basis",
  "publication.input.sourceUrl": "Official source",
  "publication.input.treatment": "Tax treatment",
  "recalculation.basis.RESEARCH": "Recalculated using fiscal information resolved by research",
  "publication.latestTask":
    "A newer calculation exists for this workbook. This record retains the earlier version.",
  "publication.openLatest": "View updated calculation",
  "lotOps.group.publication": "Listing price",
  "publication.summary.title": "From purchase to listing",
  "publication.summary.cost": "Lot acquisition cost",
  "publication.summary.listing": "Listing price with take rate",
  "publication.summary.take": "Take rate amount",
  "publication.summary.counts":
    "{confirmed} calculated · {estimated} estimated · {unpriced} unpriced",
  "publication.summary.split": "Listing: calculated {confirmed} · estimated {estimated}",
  "publication.summary.scope":
    "Purchase quote through SP, including take rate. Estimates include assumptions and are not confirmed taxes. Unconfirmed credits and taxes on the future destination sale are not deducted.",
  "publication.estimate.memory": "Calculation steps for the estimated scenario",
  "publication.estimate.title": "Quote with assumptions",
  "publication.estimate.short": "Estimated",
  "publication.estimate.notice":
    "Estimated quote. The highest price among the evaluated scenarios was selected. The attributes below need confirmation; the fiscal result remains under review.",
  "publication.estimate.cost": "Estimated unit cost",
  "publication.estimate.price": "Estimated unit price including take rate",
  "publication.estimate.range": "Scenario price range",
  "publication.estimate.selection": "Selected scenario",
  "publication.estimate.assumptions": "Assumptions and price impact",
  "publication.estimate.source": "View source",
  "publication.estimate.scenarios": "Quote scenarios",
  "publication.estimate.scenario": "Scenario",
  "publication.estimate.selected": "selected",
  "publication.estimate.tableHint":
    "There are {count} products with estimated prices and explicit assumptions. These values are excluded from confirmed fiscal totals; open the product to compare scenarios.",
};
